window.KJ_REVIEW_WALL_DATA = {
  "source": "Google reviews export generated for Krishna Jewellers",
  "generatedAt": "2026-06-29T11:58:24.916Z",
  "stats": {
    "googleReviewCount": 2144,
    "averageRating": 4.7,
    "photoReviews": 83,
    "textReviews": 2144,
    "uniquePhotoReviews": 47,
    "uniqueAssetFiles": 82,
    "reviewPhotoMappings": 83
  },
  "photoReviews": [
    {
      "id": "photo-001",
      "name": "Praveena Prashanth",
      "rating": 5,
      "date": "2026-04-28",
      "displayDate": "28 Apr 2026",
      "text": "This was my first time shopping with Krishna Jewellers. The customer associates Srikanth Reddy and Pavan were super helpful in guiding me the jewelry and arranging video calls for me to decide. The shopping and shipping to Bangalore was also flawless. I will definitely make more purchases in the future. Overall super happy with the response and product.",
      "image": "kj-review-photo-001.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-002",
      "name": "Sindusha Varma",
      "rating": 5,
      "date": "2026-01-25",
      "displayDate": "25 Jan 2026",
      "text": "Just visited the gold shop and had an amazing experience! The staff were super helpful and knowledgeable about their products Especially Dinakar and Vinod .I got a beautiful piece of jewellery that fits my style perfectly. The quality is top-notch and the prices are reasonable. Highly recommended",
      "image": "kj-review-photo-002.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-003",
      "name": "Rashmi Reddy Vemula",
      "rating": 5,
      "date": "2026-04-29",
      "displayDate": "29 Apr 2026",
      "text": "Always a pleasant experience visiting this place. The team is very helpful and takes the time to suggest options based on your needs. I also had a few items customized, and they turned out beautifully. Special thanks to Satish from the pearl section and Suvarna on the 1st floor for their excellent service.",
      "image": "kj-review-photo-003.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-004",
      "name": "Rashmi Reddy Vemula",
      "rating": 5,
      "date": "2026-04-29",
      "displayDate": "29 Apr 2026",
      "text": "Always a pleasant experience visiting this place. The team is very helpful and takes the time to suggest options based on your needs. I also had a few items customized, and they turned out beautifully. Special thanks to Satish from the pearl section and Suvarna on the 1st floor for their excellent service.",
      "image": "kj-review-photo-004.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-005",
      "name": "Y V G Shankar",
      "rating": 5,
      "date": "2025-11-20",
      "displayDate": "20 Nov 2025",
      "text": "This is my first visit to Krishna Jewellers in Jublee hills where in we purchased few silver jewellery. Abdullah Pasha has patiently shown us all those items the family were interested. Great experience.",
      "image": "kj-review-photo-005.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "photo-006",
      "name": "Y V G Shankar",
      "rating": 5,
      "date": "2025-11-20",
      "displayDate": "20 Nov 2025",
      "text": "This is my first visit to Krishna Jewellers in Jublee hills where in we purchased few silver jewellery. Abdullah Pasha has patiently shown us all those items the family were interested. Great experience.",
      "image": "kj-review-photo-006.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "photo-007",
      "name": "Y V G Shankar",
      "rating": 5,
      "date": "2025-11-20",
      "displayDate": "20 Nov 2025",
      "text": "This is my first visit to Krishna Jewellers in Jublee hills where in we purchased few silver jewellery. Abdullah Pasha has patiently shown us all those items the family were interested. Great experience.",
      "image": "kj-review-photo-007.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "photo-008",
      "name": "Sreerama Kotamraju",
      "rating": 5,
      "date": "2025-11-18",
      "displayDate": "18 Nov 2025",
      "text": "I am a long time customer of this store. They used to ship the jewelry overseas too. Excellent service by the staff. They serve refreshments to clients, which is a nice gesture. This time, I couldn't find any solitaire rings to buy though as they don't have any in stock. They showed other items which are beautiful and I took some pics of them.",
      "image": "kj-review-photo-008.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-009",
      "name": "Sreerama Kotamraju",
      "rating": 5,
      "date": "2025-11-18",
      "displayDate": "18 Nov 2025",
      "text": "I am a long time customer of this store. They used to ship the jewelry overseas too. Excellent service by the staff. They serve refreshments to clients, which is a nice gesture. This time, I couldn't find any solitaire rings to buy though as they don't have any in stock. They showed other items which are beautiful and I took some pics of them.",
      "image": "kj-review-photo-009.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-010",
      "name": "Sreerama Kotamraju",
      "rating": 5,
      "date": "2025-11-18",
      "displayDate": "18 Nov 2025",
      "text": "I am a long time customer of this store. They used to ship the jewelry overseas too. Excellent service by the staff. They serve refreshments to clients, which is a nice gesture. This time, I couldn't find any solitaire rings to buy though as they don't have any in stock. They showed other items which are beautiful and I took some pics of them.",
      "image": "kj-review-photo-010.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-011",
      "name": "Sreerama Kotamraju",
      "rating": 5,
      "date": "2025-11-18",
      "displayDate": "18 Nov 2025",
      "text": "I am a long time customer of this store. They used to ship the jewelry overseas too. Excellent service by the staff. They serve refreshments to clients, which is a nice gesture. This time, I couldn't find any solitaire rings to buy though as they don't have any in stock. They showed other items which are beautiful and I took some pics of them.",
      "image": "kj-review-photo-011.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-012",
      "name": "Suvin s amin",
      "rating": 5,
      "date": "2025-12-15",
      "displayDate": "15 Dec 2025",
      "text": "Visited shop recently and loved the range of collections and the service. Specially to call out J Ramesh, Krishna and Bharathi (supported online). I would strongly recommend to visit here for any type of Jewel purchase, especially Perl. Cheers.",
      "image": "kj-review-photo-012.webp",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-013",
      "name": "Suvin s amin",
      "rating": 5,
      "date": "2025-12-15",
      "displayDate": "15 Dec 2025",
      "text": "Visited shop recently and loved the range of collections and the service. Specially to call out J Ramesh, Krishna and Bharathi (supported online). I would strongly recommend to visit here for any type of Jewel purchase, especially Perl. Cheers.",
      "image": "kj-review-photo-013.webp",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-014",
      "name": "Gayathri Tirumani",
      "rating": 5,
      "date": "2025-12-13",
      "displayDate": "13 Dec 2025",
      "text": "I always love their collection….a big fan of their pearl bangles…. I approached them online…Ms Bharathi came in contact and patiently answered all of my queries…she in turn followed me during my busy days and helped me in buying my bangles. I happily say it’s because of her I got my bangle and gold rate increased so much after that….got a great deal and they made online gold shopping safe and promising 😊",
      "image": "kj-review-photo-014.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-015",
      "name": "jahnavi tummala",
      "rating": 5,
      "date": "2025-12-31",
      "displayDate": "31 Dec 2025",
      "text": "Hi I loved shopping experience in Krishna Jewellers at Jubilee Hills and Mr.Venkat has patiently showed different designs and explained every detail. Once we blocked our product Mr. Venkat has made our payment and billing process easy. I would love shopping at Krishna Jewellers for all my family occasions.",
      "image": "kj-review-photo-015.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-016",
      "name": "Tejashri Datar",
      "rating": 5,
      "date": "2026-05-17",
      "displayDate": "17 May 2026",
      "text": "Krishna Jewellers are excellent variety of jeweller and great customer service. Micheal assisted me very well and also was doing regular follows ups until my jewellery reached in my hand.",
      "image": "kj-review-photo-016.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-017",
      "name": "Suman. R",
      "rating": 5,
      "date": "2026-01-11",
      "displayDate": "11 Jan 2026",
      "text": "I am glad to come to Krishna Jewellers and shop gold jewellery. Mr. R.Sathish at Jubilee Hills is kindest person and very prompt sales person. He is not only knowledgeable about gold jewellery but very jovial as well. This makes me come again and again to Krishna Jewellery. I always get a warm welcome here. Many good wishes to team.",
      "image": "kj-review-photo-017.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-018",
      "name": "Suman. R",
      "rating": 5,
      "date": "2026-01-11",
      "displayDate": "11 Jan 2026",
      "text": "I am glad to come to Krishna Jewellers and shop gold jewellery. Mr. R.Sathish at Jubilee Hills is kindest person and very prompt sales person. He is not only knowledgeable about gold jewellery but very jovial as well. This makes me come again and again to Krishna Jewellery. I always get a warm welcome here. Many good wishes to team.",
      "image": "kj-review-photo-018.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-019",
      "name": "gopal raghavan",
      "rating": 5,
      "date": "2026-02-18",
      "displayDate": "18 Feb 2026",
      "text": "Received the product. It's beautiful. Thank you Pooja for all your support and guidance throughout the process. Had a wonderful experience",
      "image": "kj-review-photo-019.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-020",
      "name": "kiran mayi",
      "rating": 5,
      "date": "2025-04-07",
      "displayDate": "7 Apr 2025",
      "text": "I bought silver pooja items here and had a wonderful experience. Rajalakshmi was extremely friendly and patient, taking the time to show all their collections without any hurry. . The collection is beautifully curated.Highly recommend this store for anyone looking for quality silver jewelry and excellent customer service!",
      "image": "kj-review-photo-020.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-021",
      "name": "kiran mayi",
      "rating": 5,
      "date": "2025-04-07",
      "displayDate": "7 Apr 2025",
      "text": "I bought silver pooja items here and had a wonderful experience. Rajalakshmi was extremely friendly and patient, taking the time to show all their collections without any hurry. . The collection is beautifully curated.Highly recommend this store for anyone looking for quality silver jewelry and excellent customer service!",
      "image": "kj-review-photo-021.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-022",
      "name": "Vamsi Krishna",
      "rating": 5,
      "date": "2025-05-15",
      "displayDate": "15 May 2025",
      "text": "I recently visited Krishna jewellery and had a truly delightful experience. From the moment I stepped in, the ambience was elegant, well-lit, and inviting. The showroom had an impressive collection of jewellery, ranging from exquisite gold pieces to dazzling diamond sets. One of the standout aspects of my visit was the excellent service provided by Pavani. They were not only knowledgeable but also incredibly patient, helping me navigate various designs and suggesting pieces that suited my preferences. Their attention to detail and understanding of jewellery craftsmanship added immense value to the experience. Whether you're looking for a statement piece or a timeless classic, Krishna jewellery is the perfect destination. The quality of their jewellery, combined with the courteous service of their representatives, makes shopping here a pleasure. Highly recommended!",
      "image": "kj-review-photo-022.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-023",
      "name": "Usha Desai",
      "rating": 5,
      "date": "2025-11-19",
      "displayDate": "19 Nov 2025",
      "text": "Late last week, I had placed an online order from Mumbai for a beautiful pair of pearl-coral studs on the website of Krishna Jewellers. My order reached me in no time and the packaging was very beautiful. But ..they had sent a different varient by mistake and I requested for a replacement. Mr Neelam from their e-commerce team who had earlier reached out to me after I'd placed my order, listened to my grievance patiently and assured me that my problem will be resolved satisfactorily asap. And true to his words, I received my actual product within a day! - they are such a charming pair of earrings! 🤩 I am very happy that Krishna Jewellers addressed my concern very swiftly and professionally👏🏻😇 Special Thanks to Mr Neelam🙏🏻👏🏻💐😊 - he was very cordial, patient, helpful and proactive and provided me regular updates regarding my order🤝",
      "image": "kj-review-photo-023.webp",
      "tags": [
        "photo",
        "jewellery",
        "service",
        "gifting"
      ]
    },
    {
      "id": "photo-024",
      "name": "chandana reddy",
      "rating": 5,
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "text": "Jewellery you will fall in love with. Amazing collection, each piece more beautiful than the other. Friendly and helpful team. I had a great experience shopping with them.",
      "image": "kj-review-photo-024.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-025",
      "name": "Laavanya Rs",
      "rating": 5,
      "date": "2025-05-02",
      "displayDate": "2 May 2025",
      "text": "Had a wonderful time shopping here. They have great collection. Sales executive Radha was very patient and helpful with my purchase. Would recommend this store 10/10",
      "image": "kj-review-photo-025.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-026",
      "name": "neloufer ali",
      "rating": 5,
      "date": "2025-06-10",
      "displayDate": "10 Jun 2025",
      "text": "We find kashinath most helpful and hospitable we keep coming here for him. Collection is good.",
      "image": "kj-review-photo-026.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-027",
      "name": "neloufer ali",
      "rating": 5,
      "date": "2025-06-10",
      "displayDate": "10 Jun 2025",
      "text": "We find kashinath most helpful and hospitable we keep coming here for him. Collection is good.",
      "image": "kj-review-photo-027.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-028",
      "name": "neloufer ali",
      "rating": 5,
      "date": "2025-06-10",
      "displayDate": "10 Jun 2025",
      "text": "We find kashinath most helpful and hospitable we keep coming here for him. Collection is good.",
      "image": "kj-review-photo-028.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-029",
      "name": "neloufer ali",
      "rating": 5,
      "date": "2025-06-10",
      "displayDate": "10 Jun 2025",
      "text": "We find kashinath most helpful and hospitable we keep coming here for him. Collection is good.",
      "image": "kj-review-photo-029.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-030",
      "name": "neloufer ali",
      "rating": 5,
      "date": "2025-06-10",
      "displayDate": "10 Jun 2025",
      "text": "We find kashinath most helpful and hospitable we keep coming here for him. Collection is good.",
      "image": "kj-review-photo-030.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-031",
      "name": "neloufer ali",
      "rating": 5,
      "date": "2025-06-10",
      "displayDate": "10 Jun 2025",
      "text": "We find kashinath most helpful and hospitable we keep coming here for him. Collection is good.",
      "image": "kj-review-photo-031.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-032",
      "name": "neloufer ali",
      "rating": 5,
      "date": "2025-06-10",
      "displayDate": "10 Jun 2025",
      "text": "We find kashinath most helpful and hospitable we keep coming here for him. Collection is good.",
      "image": "kj-review-photo-032.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-033",
      "name": "Srujana Chowdary",
      "rating": 5,
      "date": "2026-03-11",
      "displayDate": "11 Mar 2026",
      "text": "I placed an order with Krishna Jewellery, and Venketeshwars was extremely helpful throughout the process. He provided the right information and useful suggestions regarding my order, and he responded to all my queries very quickly. Overall, I’m very satisfied with my purchase and the service I received. Thanks Srujana",
      "image": "kj-review-photo-033.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-034",
      "name": "VC Attota",
      "rating": 5,
      "date": "2025-03-25",
      "displayDate": "25 Mar 2025",
      "text": "I loved complete online purchasing experience from showing to receiving international order from Krishna Jewellers. Thank you sai reddy garu for the seamless experience and your time provided throughout the journey. Thank you Srikanth garu - sales man at shop showing all necessary ornaments online with so much patience as sporadically demanded by my family. -VC Attota",
      "image": "kj-review-photo-034.webp",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-035",
      "name": "Bhaskar C",
      "rating": 5,
      "date": "2025-12-23",
      "displayDate": "23 Dec 2025",
      "text": "Good collection and very polite and patient salesman Mr. Ramesh guided us to select a good pear necklace set !",
      "image": "kj-review-photo-035.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-036",
      "name": "Bhaskar C",
      "rating": 5,
      "date": "2025-12-23",
      "displayDate": "23 Dec 2025",
      "text": "Good collection and very polite and patient salesman Mr. Ramesh guided us to select a good pear necklace set !",
      "image": "kj-review-photo-035.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-037",
      "name": "shanthi sonu",
      "rating": 5,
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "text": "Very huge collection of unique designs and the staff specially SandhyaRani is very passionate about her work and helping customers with great smile 😊 Thank you for awesome receiving",
      "image": "kj-review-photo-036.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-038",
      "name": "Haritha Gundeboyina",
      "rating": 5,
      "date": "2024-12-11",
      "displayDate": "11 Dec 2024",
      "text": "Bought ananthapadbanabha swamy idol, minute detailed of the idol were so keen well carved and very impressive and the idol is too good for its price was so pleased with the product",
      "image": "kj-review-photo-037.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-039",
      "name": "Haritha Gundeboyina",
      "rating": 5,
      "date": "2024-12-11",
      "displayDate": "11 Dec 2024",
      "text": "Bought ananthapadbanabha swamy idol, minute detailed of the idol were so keen well carved and very impressive and the idol is too good for its price was so pleased with the product",
      "image": "kj-review-photo-038.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-040",
      "name": "Haritha Gundeboyina",
      "rating": 5,
      "date": "2024-12-11",
      "displayDate": "11 Dec 2024",
      "text": "Bought ananthapadbanabha swamy idol, minute detailed of the idol were so keen well carved and very impressive and the idol is too good for its price was so pleased with the product",
      "image": "kj-review-photo-039.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-041",
      "name": "Annnit",
      "rating": 5,
      "date": "2025-08-29",
      "displayDate": "29 Aug 2025",
      "text": "Staff Kashinath and Ramesh are patient and friendly. Have a good time here",
      "image": "kj-review-photo-040.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-042",
      "name": "Annnit",
      "rating": 5,
      "date": "2025-08-29",
      "displayDate": "29 Aug 2025",
      "text": "Staff Kashinath and Ramesh are patient and friendly. Have a good time here",
      "image": "kj-review-photo-041.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-043",
      "name": "Preethi Reddy Chinchoud",
      "rating": 5,
      "date": "2025-02-19",
      "displayDate": "19 Feb 2025",
      "text": "Sai Reddy and Srikanth helped me pick my jewelry. I am happy with my purchase and want to thank for their service. They patiently responded to all my questions. I wanted to experience buying jewelry online and get it shipped internationally. They are well experienced and made the process easy for me. I would definitely buy more in future. Thank you and keep up the good work 🙂 -Preethi Reddy Chinchoud",
      "image": "kj-review-photo-042.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-044",
      "name": "Sonali Gupta",
      "rating": 5,
      "date": "2024-07-20",
      "displayDate": "20 Jul 2024",
      "text": "I recently purchased the silver parrot statue and am delighted with its craftsmanship. The detailing is exquisite, capturing the beauty and grace of a parrot in silver form. It makes for a striking addition to my home decor, sitting elegantly on my shelf. The silver finish gleams under the light, adding a touch of sophistication.\"",
      "image": "kj-review-photo-043.webp",
      "tags": [
        "photo",
        "jewellery"
      ]
    },
    {
      "id": "photo-045",
      "name": "Sruthi. Patibandla",
      "rating": 5,
      "date": "2025-10-12",
      "displayDate": "12 Oct 2025",
      "text": "Excellent and wide collection. Pavani and Bheem assisted well with lot of patience. Great collection and Excellent service.",
      "image": "kj-review-photo-044.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-046",
      "name": "Sruthi. Patibandla",
      "rating": 5,
      "date": "2025-10-12",
      "displayDate": "12 Oct 2025",
      "text": "Excellent and wide collection. Pavani and Bheem assisted well with lot of patience. Great collection and Excellent service.",
      "image": "kj-review-photo-045.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-047",
      "name": "Sangeeta Yadav",
      "rating": 5,
      "date": "2024-09-26",
      "displayDate": "26 Sept 2024",
      "text": "\"I recently purchased a stunning pearl set from Krishna Jewellers Pearls and Gems in Hyderabad, and I am absolutely delighted! The craftsmanship is exquisite, and the pearls are of exceptional quality. The team's service was wonderful, offering a smooth and enjoyable shopping experience. Highly recommend this place for anyone looking for beautiful jewelry and excellent customer service!\"",
      "image": "kj-review-photo-046.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-048",
      "name": "Sangeeta Yadav",
      "rating": 5,
      "date": "2024-09-26",
      "displayDate": "26 Sept 2024",
      "text": "\"I recently purchased a stunning pearl set from Krishna Jewellers Pearls and Gems in Hyderabad, and I am absolutely delighted! The craftsmanship is exquisite, and the pearls are of exceptional quality. The team's service was wonderful, offering a smooth and enjoyable shopping experience. Highly recommend this place for anyone looking for beautiful jewelry and excellent customer service!\"",
      "image": "kj-review-photo-047.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-049",
      "name": "KENAZGLOBAL",
      "rating": 5,
      "date": "2025-08-22",
      "displayDate": "22 Aug 2025",
      "text": "Always loved shopping here. Went for shopping this evening for some Jewellery. I am glad! Mr. Ramesh had been very nice, cooperative. Thank you so much!! Shall visit again.",
      "image": "kj-review-photo-048.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "photo-050",
      "name": "Pruthvi Raj",
      "rating": 5,
      "date": "2025-03-16",
      "displayDate": "16 Mar 2025",
      "text": "It was a very good experience in Krishna jewellers in jubilee hills staff was very friendly specially priya garu who helped us throughout our shopping",
      "image": "kj-review-photo-049.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-051",
      "name": "Pruthvi Raj",
      "rating": 5,
      "date": "2025-03-16",
      "displayDate": "16 Mar 2025",
      "text": "It was a very good experience in Krishna jewellers in jubilee hills staff was very friendly specially priya garu who helped us throughout our shopping",
      "image": "kj-review-photo-050.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-052",
      "name": "Pranjal Baruah",
      "rating": 5,
      "date": "2024-08-04",
      "displayDate": "4 Aug 2024",
      "text": "I would like to share my genuine review and experience in this shop . First and foremost I would like to Thank Mr Rajkumar for explaining the details about pearls its shape, size, and colour . I had a very good experience and ended up not one , two but three sets of jewellery.",
      "image": "kj-review-photo-051.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "photo-053",
      "name": "Pradeep Ek",
      "rating": 5,
      "date": "2025-09-20",
      "displayDate": "20 Sept 2025",
      "text": "Authentic shop hyderabad pearls Ambience, service, choices are too good",
      "image": "kj-review-photo-052.webp",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-054",
      "name": "Pradeep Ek",
      "rating": 5,
      "date": "2025-09-20",
      "displayDate": "20 Sept 2025",
      "text": "Authentic shop hyderabad pearls Ambience, service, choices are too good",
      "image": "kj-review-photo-053.webp",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-055",
      "name": "Roshan Belokar",
      "rating": 5,
      "date": "2025-11-12",
      "displayDate": "12 Nov 2025",
      "text": "I am very happy with my purchase. Mr. J. Ramesh made my experience joyful. Thanks.",
      "image": "kj-review-photo-054.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-056",
      "name": "Sravan Nandu",
      "rating": 5,
      "date": "2023-06-16",
      "displayDate": "16 Jun 2023",
      "text": "Best experience while shopping with krishna jewelleries , special thanks to sravan - sales person who helped a lot with wide range of collections, we liked the hospitality what sravan has provided and really special thanks to sravan who really helped us on shopping, he had given us best discount and nice quotation",
      "image": "kj-review-photo-055.webp",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-057",
      "name": "Trupti Rao",
      "rating": 5,
      "date": "2022-03-01",
      "displayDate": "1 Mar 2022",
      "text": "Good collection, wide ranges in all categories. Transparency in billing and transactions. Mr. Shravan is knowledgeable and he is of a great help for every purchase for us. Mr. Nayeem gives us the best deal always. That makes us visit the store again for every purchase.",
      "image": "kj-review-photo-056.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-058",
      "name": "bv v",
      "rating": 5,
      "date": "2024-01-27",
      "displayDate": "27 Jan 2024",
      "text": "Mallika dhuna is best sales man",
      "image": "kj-review-photo-057.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-059",
      "name": "harrish krishna",
      "rating": 4,
      "date": "2026-03-08",
      "displayDate": "8 Mar 2026",
      "text": "The place is great to purchase jewellery & the staff are incredibly friendly providing good service as well with a constant supply of water, hot & cold beverages such as carbonated soda as well. Think the highlight of the time there is the providing of a birthday gift to my grandmother for her 74th birthday by the staff in the place. She was truly ecstatic & overjoyed by the entire experience encountered at the place!",
      "image": "kj-review-photo-058.webp",
      "tags": [
        "photo",
        "jewellery",
        "service",
        "gifting"
      ]
    },
    {
      "id": "photo-060",
      "name": "harrish krishna",
      "rating": 4,
      "date": "2026-03-08",
      "displayDate": "8 Mar 2026",
      "text": "The place is great to purchase jewellery & the staff are incredibly friendly providing good service as well with a constant supply of water, hot & cold beverages such as carbonated soda as well. Think the highlight of the time there is the providing of a birthday gift to my grandmother for her 74th birthday by the staff in the place. She was truly ecstatic & overjoyed by the entire experience encountered at the place!",
      "image": "kj-review-photo-059.webp",
      "tags": [
        "photo",
        "jewellery",
        "service",
        "gifting"
      ]
    },
    {
      "id": "photo-061",
      "name": "vignesh v",
      "rating": 1,
      "date": "2025-01-22",
      "displayDate": "22 Jan 2025",
      "text": "Yesterday I bought this from Krishna pearls, Novotel branch. (HSN code:711311, invoice no:198) Today it's gone. Didn't even used it once, very disappointed with product quality.I lost the trust with Krishna pearls. My mom is unhappy and now I'm also upset. First time I am giving 1 star rating in my google review. Don't trust this kind of brand just for name sick, be careful with products. After 10 days Last 10 days I am trying to change the product but there is no proper response from them. Daily I am wasting my time with them. I realised my Big Mistake.",
      "image": "kj-review-photo-060.webp",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-062",
      "name": "vignesh v",
      "rating": 1,
      "date": "2025-01-22",
      "displayDate": "22 Jan 2025",
      "text": "Yesterday I bought this from Krishna pearls, Novotel branch. (HSN code:711311, invoice no:198) Today it's gone. Didn't even used it once, very disappointed with product quality.I lost the trust with Krishna pearls. My mom is unhappy and now I'm also upset. First time I am giving 1 star rating in my google review. Don't trust this kind of brand just for name sick, be careful with products. After 10 days Last 10 days I am trying to change the product but there is no proper response from them. Daily I am wasting my time with them. I realised my Big Mistake.",
      "image": "kj-review-photo-061.webp",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-063",
      "name": "satish sheku",
      "rating": 5,
      "date": "2025-12-11",
      "displayDate": "11 Dec 2025",
      "text": "Good place very genuinely talked and very politely suggest mr j Ramesh thankew sir for ur valuable time",
      "image": "kj-review-photo-062.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-064",
      "name": "satish sheku",
      "rating": 5,
      "date": "2025-12-11",
      "displayDate": "11 Dec 2025",
      "text": "Good place very genuinely talked and very politely suggest mr j Ramesh thankew sir for ur valuable time",
      "image": "kj-review-photo-063.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-065",
      "name": "Venkat Ramamohan",
      "rating": 5,
      "date": "2023-03-27",
      "displayDate": "27 Mar 2023",
      "text": "Excellent attention to detail and to customer - felt very comfortable, no pressure, Mahesh Kumar was very knowledgeable about the various products and gave us a good deal!! Definitely coming back here again and very good selection!!",
      "image": "kj-review-photo-064.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-066",
      "name": "Venkat Ramamohan",
      "rating": 5,
      "date": "2023-03-27",
      "displayDate": "27 Mar 2023",
      "text": "Excellent attention to detail and to customer - felt very comfortable, no pressure, Mahesh Kumar was very knowledgeable about the various products and gave us a good deal!! Definitely coming back here again and very good selection!!",
      "image": "kj-review-photo-065.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-067",
      "name": "Krishnaveni Gorijavolu",
      "rating": 5,
      "date": "2026-01-08",
      "displayDate": "8 Jan 2026",
      "text": "Lavanya was amazing. The way she helped and showed the jewellery made it easy for me to select and buy. Thank you, Lavanya",
      "image": "kj-review-photo-066.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-068",
      "name": "Krishnaveni Gorijavolu",
      "rating": 5,
      "date": "2026-01-08",
      "displayDate": "8 Jan 2026",
      "text": "Lavanya was amazing. The way she helped and showed the jewellery made it easy for me to select and buy. Thank you, Lavanya",
      "image": "kj-review-photo-067.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-069",
      "name": "Sharada S Shetty",
      "rating": 1,
      "date": "2025-12-13",
      "displayDate": "13 Dec 2025",
      "text": "ONLINE SHOPPING ???BE AWARE!!!! I’ve followed Sri Krishna for five years and always wanted to buy silver gifts from them, but my first experience was extremely disappointing. Their in-store team asked me to book an appointment and then never called—even after I waited for two hours. When I messaged, they casually said they had “forgotten.” Since I had very little time, I placed the order online without seeing the product. When I later wanted to exchange an item, everything became frustrating. The in-store team kept saying, “The website team will update you,” but the update never came. My messages were seen but ignored. The issue was simple: the in-store team never actually forwarded my concern or my number to the online team. Only on the final day when I decided to cancel the product did they finally shared my details. The online team immediately contacted me, apologized, and handled it that same day. So clearly, the lack of response wasn’t from the website team, but from the in-store team not doing their part. I had also clearly requested them not to call my in-laws because it was a surprise gift, yet they still did. This made the whole experience even more disappointing. By the end, I lost trust and cancelled my order. Maybe my transaction was small, but the way the situation was handled felt careless and unprofessional. I won’t be purchasing again.Now I checked their online reviews and saw many customers complaining about poor online service and not getting refunds, which honestly making me even more scared .😢 The staff lacked sympathy and empathy, and they did not know how to properly answer questions over the phone. The female staff's member I spoke to seemed unsure how to respond and repeatedly said “sorry” without actually addressing the questions asked. I strongly feel the store management should kindly look into this matter and provide proper customer service training to their staff so that customers receive clear, helpful, and respectful responses. Update 2: I finally received my refund after 15 days of following up every single day. At first, I was told the refund would come through Razorpay, but there was no transaction or refund ID. Even Razorpay confirmed there was no record. After repeatedly contacting them, I was connected to a staff member named Neelam who promised a refund in 3 days. Later, I was told the money was sent through Shopify, but the screenshot showed Razorpay which looked edited. Eventually, the refund was actually processed through Razorpay, and I received it in one day. Overall, the online process was very tiring and confusing. Anyone purchasing online should be careful and aware.!!!",
      "image": "kj-review-photo-068.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service",
        "gifting"
      ]
    },
    {
      "id": "photo-070",
      "name": "Sharada S Shetty",
      "rating": 1,
      "date": "2025-12-13",
      "displayDate": "13 Dec 2025",
      "text": "ONLINE SHOPPING ???BE AWARE!!!! I’ve followed Sri Krishna for five years and always wanted to buy silver gifts from them, but my first experience was extremely disappointing. Their in-store team asked me to book an appointment and then never called—even after I waited for two hours. When I messaged, they casually said they had “forgotten.” Since I had very little time, I placed the order online without seeing the product. When I later wanted to exchange an item, everything became frustrating. The in-store team kept saying, “The website team will update you,” but the update never came. My messages were seen but ignored. The issue was simple: the in-store team never actually forwarded my concern or my number to the online team. Only on the final day when I decided to cancel the product did they finally shared my details. The online team immediately contacted me, apologized, and handled it that same day. So clearly, the lack of response wasn’t from the website team, but from the in-store team not doing their part. I had also clearly requested them not to call my in-laws because it was a surprise gift, yet they still did. This made the whole experience even more disappointing. By the end, I lost trust and cancelled my order. Maybe my transaction was small, but the way the situation was handled felt careless and unprofessional. I won’t be purchasing again.Now I checked their online reviews and saw many customers complaining about poor online service and not getting refunds, which honestly making me even more scared .😢 The staff lacked sympathy and empathy, and they did not know how to properly answer questions over the phone. The female staff's member I spoke to seemed unsure how to respond and repeatedly said “sorry” without actually addressing the questions asked. I strongly feel the store management should kindly look into this matter and provide proper customer service training to their staff so that customers receive clear, helpful, and respectful responses. Update 2: I finally received my refund after 15 days of following up every single day. At first, I was told the refund would come through Razorpay, but there was no transaction or refund ID. Even Razorpay confirmed there was no record. After repeatedly contacting them, I was connected to a staff member named Neelam who promised a refund in 3 days. Later, I was told the money was sent through Shopify, but the screenshot showed Razorpay which looked edited. Eventually, the refund was actually processed through Razorpay, and I received it in one day. Overall, the online process was very tiring and confusing. Anyone purchasing online should be careful and aware.!!!",
      "image": "kj-review-photo-069.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service",
        "gifting"
      ]
    },
    {
      "id": "photo-071",
      "name": "Sharada S Shetty",
      "rating": 1,
      "date": "2025-12-13",
      "displayDate": "13 Dec 2025",
      "text": "ONLINE SHOPPING ???BE AWARE!!!! I’ve followed Sri Krishna for five years and always wanted to buy silver gifts from them, but my first experience was extremely disappointing. Their in-store team asked me to book an appointment and then never called—even after I waited for two hours. When I messaged, they casually said they had “forgotten.” Since I had very little time, I placed the order online without seeing the product. When I later wanted to exchange an item, everything became frustrating. The in-store team kept saying, “The website team will update you,” but the update never came. My messages were seen but ignored. The issue was simple: the in-store team never actually forwarded my concern or my number to the online team. Only on the final day when I decided to cancel the product did they finally shared my details. The online team immediately contacted me, apologized, and handled it that same day. So clearly, the lack of response wasn’t from the website team, but from the in-store team not doing their part. I had also clearly requested them not to call my in-laws because it was a surprise gift, yet they still did. This made the whole experience even more disappointing. By the end, I lost trust and cancelled my order. Maybe my transaction was small, but the way the situation was handled felt careless and unprofessional. I won’t be purchasing again.Now I checked their online reviews and saw many customers complaining about poor online service and not getting refunds, which honestly making me even more scared .😢 The staff lacked sympathy and empathy, and they did not know how to properly answer questions over the phone. The female staff's member I spoke to seemed unsure how to respond and repeatedly said “sorry” without actually addressing the questions asked. I strongly feel the store management should kindly look into this matter and provide proper customer service training to their staff so that customers receive clear, helpful, and respectful responses. Update 2: I finally received my refund after 15 days of following up every single day. At first, I was told the refund would come through Razorpay, but there was no transaction or refund ID. Even Razorpay confirmed there was no record. After repeatedly contacting them, I was connected to a staff member named Neelam who promised a refund in 3 days. Later, I was told the money was sent through Shopify, but the screenshot showed Razorpay which looked edited. Eventually, the refund was actually processed through Razorpay, and I received it in one day. Overall, the online process was very tiring and confusing. Anyone purchasing online should be careful and aware.!!!",
      "image": "kj-review-photo-070.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service",
        "gifting"
      ]
    },
    {
      "id": "photo-072",
      "name": "Sharada S Shetty",
      "rating": 1,
      "date": "2025-12-13",
      "displayDate": "13 Dec 2025",
      "text": "ONLINE SHOPPING ???BE AWARE!!!! I’ve followed Sri Krishna for five years and always wanted to buy silver gifts from them, but my first experience was extremely disappointing. Their in-store team asked me to book an appointment and then never called—even after I waited for two hours. When I messaged, they casually said they had “forgotten.” Since I had very little time, I placed the order online without seeing the product. When I later wanted to exchange an item, everything became frustrating. The in-store team kept saying, “The website team will update you,” but the update never came. My messages were seen but ignored. The issue was simple: the in-store team never actually forwarded my concern or my number to the online team. Only on the final day when I decided to cancel the product did they finally shared my details. The online team immediately contacted me, apologized, and handled it that same day. So clearly, the lack of response wasn’t from the website team, but from the in-store team not doing their part. I had also clearly requested them not to call my in-laws because it was a surprise gift, yet they still did. This made the whole experience even more disappointing. By the end, I lost trust and cancelled my order. Maybe my transaction was small, but the way the situation was handled felt careless and unprofessional. I won’t be purchasing again.Now I checked their online reviews and saw many customers complaining about poor online service and not getting refunds, which honestly making me even more scared .😢 The staff lacked sympathy and empathy, and they did not know how to properly answer questions over the phone. The female staff's member I spoke to seemed unsure how to respond and repeatedly said “sorry” without actually addressing the questions asked. I strongly feel the store management should kindly look into this matter and provide proper customer service training to their staff so that customers receive clear, helpful, and respectful responses. Update 2: I finally received my refund after 15 days of following up every single day. At first, I was told the refund would come through Razorpay, but there was no transaction or refund ID. Even Razorpay confirmed there was no record. After repeatedly contacting them, I was connected to a staff member named Neelam who promised a refund in 3 days. Later, I was told the money was sent through Shopify, but the screenshot showed Razorpay which looked edited. Eventually, the refund was actually processed through Razorpay, and I received it in one day. Overall, the online process was very tiring and confusing. Anyone purchasing online should be careful and aware.!!!",
      "image": "kj-review-photo-071.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service",
        "gifting"
      ]
    },
    {
      "id": "photo-073",
      "name": "Sreedevi T",
      "rating": 5,
      "date": "2024-09-15",
      "displayDate": "15 Sept 2024",
      "text": "Hi I was looking for diamond haram and visited the shop. I was assisted by Shivaji. He showed me wide collections. I shortlisted couple of them and left. I only got back to them after few weeks. Shivaji patiently waited and answered all the queries and offered competitive pricing. Very very good sales person. He also helped with the customisation of the jewel The shop had such a wide and impressive collection. Lavanya also helped with the lots of haram try with a smile and some genuine feedback Over all happy customer with a beautiful haram in my collection",
      "image": "kj-review-photo-072.webp",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "photo-074",
      "name": "Jagruthi Kappala",
      "rating": 5,
      "date": "2024-03-04",
      "displayDate": "4 Mar 2024",
      "text": "They have amazing deep nakshi jewelry designs. We went there to purchase bangles, and they had some amazing designs. Naga sai helped us with the whole process, Would definitely recommend Krishna jewellers",
      "image": "kj-review-photo-073.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-075",
      "name": "Jagruthi Kappala",
      "rating": 5,
      "date": "2024-03-04",
      "displayDate": "4 Mar 2024",
      "text": "They have amazing deep nakshi jewelry designs. We went there to purchase bangles, and they had some amazing designs. Naga sai helped us with the whole process, Would definitely recommend Krishna jewellers",
      "image": "kj-review-photo-074.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-076",
      "name": "tathagata bhattacharya",
      "rating": 5,
      "date": "2026-04-23",
      "displayDate": "23 Apr 2026",
      "text": "Excellent collection, elegant designs and above all warm staff. Had a great time at Krishna Jewelers. I want to specifically mention the name of Ajay. He is so nice and genuine. He helped me through thick and thin in selecting , finalizing and specifying the designs. At the same time Krishna is also a great salesperson. He’s such a genuine and nice guy always ready to help. He exactly made things as I’d want it to be. Thank you very much to both of you.",
      "image": "kj-review-photo-075.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-077",
      "name": "tathagata bhattacharya",
      "rating": 5,
      "date": "2026-04-23",
      "displayDate": "23 Apr 2026",
      "text": "Excellent collection, elegant designs and above all warm staff. Had a great time at Krishna Jewelers. I want to specifically mention the name of Ajay. He is so nice and genuine. He helped me through thick and thin in selecting , finalizing and specifying the designs. At the same time Krishna is also a great salesperson. He’s such a genuine and nice guy always ready to help. He exactly made things as I’d want it to be. Thank you very much to both of you.",
      "image": "kj-review-photo-076.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-078",
      "name": "Navya Botlagunta",
      "rating": 5,
      "date": "2026-04-22",
      "displayDate": "22 Apr 2026",
      "text": "I bought pear chain set from Krishna Jewellary’s pearls & gems. Mr. Arjun assisted me well and he gave me all designs via what’s app. The purchase and Delivary was smooth.",
      "image": "kj-review-photo-077.webp",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "photo-079",
      "name": "G V M Kiran Babu",
      "rating": 5,
      "date": "2026-05-11",
      "displayDate": "11 May 2026",
      "text": "It’s very good experience and we liked the jewellery what we received and in particular Sandhya helped us to meet our expectations",
      "image": "kj-review-photo-078.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-080",
      "name": "G V M Kiran Babu",
      "rating": 5,
      "date": "2026-05-11",
      "displayDate": "11 May 2026",
      "text": "It’s very good experience and we liked the jewellery what we received and in particular Sandhya helped us to meet our expectations",
      "image": "kj-review-photo-079.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-081",
      "name": "G V M Kiran Babu",
      "rating": 5,
      "date": "2026-05-11",
      "displayDate": "11 May 2026",
      "text": "It’s very good experience and we liked the jewellery what we received and in particular Sandhya helped us to meet our expectations",
      "image": "kj-review-photo-080.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-082",
      "name": "Dharshini Babu",
      "rating": 4,
      "date": "2026-05-08",
      "displayDate": "8 May 2026",
      "text": "I had ordered Terra lustre earring from your website.The product I have gotten is different from the image on the website.If there were mismatches between website and inventory you should have informed the customer to ask if you can proceed to dispatch the order or not.The one in website had a teardrop shape with a small pearl on top, Whereas the one I recieved has an oval shape and no tiny pearl on top.This is not expected from a reputed business.I don't have the energy to return the product.However I will leave the feedback here, so that other customers can be careful while placing orders online. Update on the above: Renuka ma'am from their customer care department reached out to me and offered replacement and shared images of earrings to exchange with. Thank you for taking accountability and taking care of customer satisfaction.I am changing my review to provide higher rating as you value your customers.",
      "image": "kj-review-photo-081.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "photo-083",
      "name": "Dharshini Babu",
      "rating": 4,
      "date": "2026-05-08",
      "displayDate": "8 May 2026",
      "text": "I had ordered Terra lustre earring from your website.The product I have gotten is different from the image on the website.If there were mismatches between website and inventory you should have informed the customer to ask if you can proceed to dispatch the order or not.The one in website had a teardrop shape with a small pearl on top, Whereas the one I recieved has an oval shape and no tiny pearl on top.This is not expected from a reputed business.I don't have the energy to return the product.However I will leave the feedback here, so that other customers can be careful while placing orders online. Update on the above: Renuka ma'am from their customer care department reached out to me and offered replacement and shared images of earrings to exchange with. Thank you for taking accountability and taking care of customer satisfaction.I am changing my review to provide higher rating as you value your customers.",
      "image": "kj-review-photo-082.webp",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    }
  ],
  "textReviews": [
    {
      "id": "stream-0001",
      "name": "Kolahalam Aswini",
      "rating": 5,
      "text": "Sales women Mahalakshmi is very patient in showing variety items.She is very friendly",
      "date": "2026-06-28",
      "displayDate": "28 Jun 2026",
      "relativeDate": "a day ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0002",
      "name": "R venkatachalam",
      "rating": 5,
      "text": "Excellent service by Mahalakshmi at krishna jewellery pearls.She was polite,friendly,professional and very helpful thought out purchase.Highly recommend",
      "date": "2026-06-28",
      "displayDate": "28 Jun 2026",
      "relativeDate": "a day ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0003",
      "name": "John Paul",
      "rating": 5,
      "text": "​I’ve been a regular customer at this Jubilee Hills store for over 5 years now, and honestly, my shopping experience has always been amazing. Their diamond designs are easily some of the best in Hyderabad. What really keeps me coming back is their pricing—it’s super competitive, completely transparent, and they have absolutely no hidden charges, which is really hard to find elsewhere. ​The staff here is incredible and always makes you feel so welcome. A special shout-out to Ajay, Srikanth, and the manager, Shiva. They are always extremely helpful, make the whole buying process stress-free, and always help me get the best possible deal. ​On top of that, parking is completely hassle-free, which is a huge relief in this area. And I have to mention—I absolutely love the sandwiches they serve here!",
      "date": "2026-06-28",
      "displayDate": "28 Jun 2026",
      "relativeDate": "a day ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0004",
      "name": "Sagarika N (It-and-rungirl21)",
      "rating": 5,
      "text": "Great service from Hanuma Naik and R Raju. We got exactly what we were looking for",
      "date": "2026-06-28",
      "displayDate": "28 Jun 2026",
      "relativeDate": "17 hours ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0005",
      "name": "Ramu V",
      "rating": 5,
      "text": "Thank you, Mahalakshmi,for your excellent service.You are very friendly and polite, supportive and helpful us choose the best.Highly recommended",
      "date": "2026-06-28",
      "displayDate": "28 Jun 2026",
      "relativeDate": "a day ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0006",
      "name": "Anuradha Mohan",
      "rating": 5,
      "text": "Mogulaiah was amazing at his service , coming back for him !",
      "date": "2026-06-28",
      "displayDate": "28 Jun 2026",
      "relativeDate": "17 hours ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0007",
      "name": "Narsimha Reddy",
      "rating": 5,
      "text": "We visited Krishna Jew for Some Necklace from the entrance they received every customer with smile and they have huge collection of stock and staff are very supportive",
      "date": "2026-06-28",
      "displayDate": "28 Jun 2026",
      "relativeDate": "17 hours ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0008",
      "name": "lakshmi reddy",
      "rating": 5,
      "text": "Nice collections and over all services was very Good by Govind",
      "date": "2026-06-28",
      "displayDate": "28 Jun 2026",
      "relativeDate": "17 hours ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0009",
      "name": "Kommineni Ugandhar",
      "rating": 5,
      "text": "“I had an excellent experience at Krishna Jewellery. Ms. Rama Devi was very professional, patient, and friendly. She helped me choose the perfect jewellery and explained everything clearly. Her service made the entire purchase smooth and enjoyable. Highly recommended!”",
      "date": "2026-06-28",
      "displayDate": "28 Jun 2026",
      "relativeDate": "18 hours ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0010",
      "name": "Priya Hariharan",
      "rating": 5,
      "text": "Krishna Pearls, in Jubilee Hills is a great destination if you're looking for elegant and high-quality pearl jewellery. They have an excellent collection with designs ranging from timeless classics to contemporary styles. The store has a warm and welcoming atmosphere, and the staff were courteous and attentive throughout our visit. Mr. A. Kalyan, was friendly, patient, and knowledgeable. He took the time to understand our preferences and helped us choose the best pieces.",
      "date": "2026-06-28",
      "displayDate": "28 Jun 2026",
      "relativeDate": "16 hours ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0011",
      "name": "Narayana Srivatsava",
      "rating": 5,
      "text": "We had an amazing experience visiting KJPG. Sathyavati helped us. If you are visiting, please check with her to get best customer experience.",
      "date": "2026-06-27",
      "displayDate": "27 Jun 2026",
      "relativeDate": "a day ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0012",
      "name": "Rahul Raj",
      "rating": 5,
      "text": "good place for gold shopping, many varieties are available and Ramu sales executive very polite and patiently will show all Varieties",
      "date": "2026-06-27",
      "displayDate": "27 Jun 2026",
      "relativeDate": "a day ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0013",
      "name": "sujanitha Reddy",
      "rating": 5,
      "text": "Excellent",
      "date": "2026-06-27",
      "displayDate": "27 Jun 2026",
      "relativeDate": "a day ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0014",
      "name": "B Malli",
      "rating": 5,
      "text": "Collection are excellent gold vaddanams Collection is wery unique yadav and pavani give best service thank you",
      "date": "2026-06-26",
      "displayDate": "26 Jun 2026",
      "relativeDate": "2 days ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0015",
      "name": "Sai Divya",
      "rating": 5,
      "text": "We have had a very good experience with representative Pavani. Keep up the good work",
      "date": "2026-06-26",
      "displayDate": "26 Jun 2026",
      "relativeDate": "Edited 2 days ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0016",
      "name": "Sarika Reddy",
      "rating": 5,
      "text": "I had an excellent experience at Krishna Jewelry & Pearls, Jubilee Hills, thanks to Venkatesh Garu (Online Executive) and Rohit Reddy Garu(In-Store Executive). Both of them were extremely patient, knowledgeable, and genuinely helpful throughout my purchase journey. They helped me choose the right designs, worked hard to get me the best possible price. What impressed me the most was how they handled the customization order of my Jewelry, carefully understood every detail and got the exact same output as I envisioned. I am extremely happy with my purchase and the outstanding service provided by both Venkatesh Garu and Rohit Reddy Garu. Their professionalism, expertise, and customer-first approach made the entire experience seamless. I would highly recommend anyone looking for quality jewelry and exceptional service to visit Krishna Jewelry & Pearls, Jubilee Hills, and seek assistance from Venkatesh Garu and Rohit Reddy Garu. They truly go above and beyond to ensure customer satisfaction.",
      "date": "2026-06-26",
      "displayDate": "26 Jun 2026",
      "relativeDate": "3 days ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0017",
      "name": "sachin bhore",
      "rating": 5,
      "text": "Nice collection short by sai Kumar ❤️✨ Nice shop best worker one of the best shop in hdy",
      "date": "2026-06-25",
      "displayDate": "25 Jun 2026",
      "relativeDate": "3 days ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0018",
      "name": "Raj Bhore",
      "rating": 5,
      "text": "Nice collection short by sai Kumar ❤️💫 nice shop and good worker one of the best Shop in Hyderabad 🤩",
      "date": "2026-06-25",
      "displayDate": "25 Jun 2026",
      "relativeDate": "3 days ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0019",
      "name": "Omkar Bhore",
      "rating": 5,
      "text": "Nice collection short by sai kumar ❤️✨",
      "date": "2026-06-25",
      "displayDate": "25 Jun 2026",
      "relativeDate": "3 days ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0020",
      "name": "Shruthi Prakash",
      "rating": 5,
      "text": "Good collection and quality and Excellent service",
      "date": "2026-06-23",
      "displayDate": "23 Jun 2026",
      "relativeDate": "6 days ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0021",
      "name": "Mrs Rai",
      "rating": 5,
      "text": "I m pleased with my purchase. Amazing customer service provided by Pooja. She answered all my queries professionally and was very helpful. 10/10 for quality and customer service!",
      "date": "2026-06-22",
      "displayDate": "22 Jun 2026",
      "relativeDate": "6 days ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0022",
      "name": "Sirisha Alaparthi",
      "rating": 5,
      "text": "Satish was very helpful and provided the details which were asked and also responded in timely and efficient manner",
      "date": "2026-06-22",
      "displayDate": "22 Jun 2026",
      "relativeDate": "6 days ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0023",
      "name": "Sparsh Raj",
      "rating": 5,
      "text": "Thank you Ramesh for helping us out and giving all possible customisation options . Thanks",
      "date": "2026-06-21",
      "displayDate": "21 Jun 2026",
      "relativeDate": "a week ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0024",
      "name": "Praneetha Polavaram",
      "rating": 5,
      "text": "Japan staff very polite , nice collection",
      "date": "2026-06-21",
      "displayDate": "21 Jun 2026",
      "relativeDate": "a week ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0025",
      "name": "Rudra Moorthy P C (Rupesh)",
      "rating": 5,
      "text": "Patient staff in attemding to the customers. The exchange process is also very smooth and full value is generally given based on gold percentage. Special thanks to Mr.Swami for giving the best prices. Thanks to Sri Lakshmi garu for helping us in the selection.",
      "date": "2026-06-17",
      "displayDate": "17 Jun 2026",
      "relativeDate": "a week ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0026",
      "name": "Sapna Reddy",
      "rating": 5,
      "text": "Collection is unique. Pavani was very helpful and patient and showed hangings based on our needs.",
      "date": "2026-06-15",
      "displayDate": "15 Jun 2026",
      "relativeDate": "a week ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0027",
      "name": "kalyan prasad",
      "rating": 5,
      "text": "Good",
      "date": "2026-06-15",
      "displayDate": "15 Jun 2026",
      "relativeDate": "a week ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0028",
      "name": "saruweshwar reddy",
      "rating": 5,
      "text": "Sai Kumar showed us nice collection",
      "date": "2026-06-14",
      "displayDate": "14 Jun 2026",
      "relativeDate": "2 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0029",
      "name": "ghanta madhavi",
      "rating": 5,
      "text": "Had a great experience with Krishna Jewellers yesterday at JW Marriott Bangalore . The staff was so proactive and very helpful specially Mr. Prakash the sales guy and the manager Mr. Mahesh really helped us in choosing our choice. Loved the experience and would like to visit them again and we would recommend Krishna Jewellers to our family and friends",
      "date": "2026-06-14",
      "displayDate": "14 Jun 2026",
      "relativeDate": "2 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0030",
      "name": "Aparna Patrikar",
      "rating": 5,
      "text": "Proper response, very good behaviour and Etiquette of all representatives. Fully satisfied with service and product as well",
      "date": "2026-06-13",
      "displayDate": "13 Jun 2026",
      "relativeDate": "2 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0031",
      "name": "arun kumar",
      "rating": 5,
      "text": "Nice service by Sai Kumar nice collections",
      "date": "2026-06-13",
      "displayDate": "13 Jun 2026",
      "relativeDate": "2 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0032",
      "name": "Neha Thakur",
      "rating": 5,
      "text": "Wow I love their jewellery designs. It was valuable. Sai Kumar has guided me everything and he gave me in a best price. Thank you so much for helping me.",
      "date": "2026-06-12",
      "displayDate": "12 Jun 2026",
      "relativeDate": "2 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0033",
      "name": "DHANALAKSHMI KT",
      "rating": 5,
      "text": "We visited the Krishna jewellery in JWmarriot hotel .Nice collections and Mr .Jaganath provided very good information and services to us.",
      "date": "2026-06-12",
      "displayDate": "12 Jun 2026",
      "relativeDate": "2 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0034",
      "name": "Thakur Aryan",
      "rating": 5,
      "text": "Krishna jewellers pearls & gems Great collection, genuine products, and excellent customer service. The staff was very helpful and made the shopping experience smooth and enjoyable. Highly recommend Krishna Jewellers Pearls & Gems! All thanks to Sai Kumer",
      "date": "2026-06-12",
      "displayDate": "12 Jun 2026",
      "relativeDate": "2 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0035",
      "name": "sai thakur",
      "rating": 5,
      "text": "Thank u so much. It was great experience sai kumar has guidance as so much Thx to krishna jewellers",
      "date": "2026-06-12",
      "displayDate": "12 Jun 2026",
      "relativeDate": "2 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0036",
      "name": "Nagaraju Esa",
      "rating": 5,
      "text": "Krishna Jewellery is an excellent place to buy jewellery. They have a beautiful collection with many unique designs, and the quality of the jewellery is outstanding. Everything looks elegant and premium. The service provided by Sai Kumar was truly impressive. He was polite, knowledgeable, and took the time to explain different options. His friendly approach made us feel comfortable and helped us choose the perfect jewellery. Overall, we had a wonderful experience and would highly recommend Krishna Jewellery to anyone looking for quality and trustworthy service.",
      "date": "2026-06-11",
      "displayDate": "11 Jun 2026",
      "relativeDate": "2 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0037",
      "name": "swetha karrolla",
      "rating": 5,
      "text": "Sainath and Govind are really helpful in picking up the right design , cost breakdown and stone quality. We really appreciate your help and support during the process of our shopping.",
      "date": "2026-06-08",
      "displayDate": "8 Jun 2026",
      "relativeDate": "2 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0038",
      "name": "Sai sushmita Karri",
      "rating": 5,
      "text": "Great collection, staff was very patient to show everything. Sri Lakshmi garu was really great in understanding our needs.",
      "date": "2026-06-03",
      "displayDate": "3 Jun 2026",
      "relativeDate": "3 weeks ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0039",
      "name": "ASM",
      "rating": 5,
      "text": "I had a wonderful experience at Krishna Jewellers! The sales executive (Mr Ramesh) was incredibly helpful and attentive throughout my visit. Even though I tried on a wide variety of jewellery, he remained perfectly patient and took the time to explain the details of each piece to me. Overall, I am very happy with my purchase experience and the exceptional customer service. Highly recommended!",
      "date": "2026-06-02",
      "displayDate": "2 Jun 2026",
      "relativeDate": "3 weeks ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0040",
      "name": "Ramesh M",
      "rating": 5,
      "text": "Good service",
      "date": "2026-06-02",
      "displayDate": "2 Jun 2026",
      "relativeDate": "3 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0041",
      "name": "Aishwarya Aishu",
      "rating": 5,
      "text": "Nice collection Good services by Govind Rao",
      "date": "2026-06-01",
      "displayDate": "1 Jun 2026",
      "relativeDate": "Edited 4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0042",
      "name": "Rajesh",
      "rating": 5,
      "text": "We visited krishna jewellers and gems hear we have seen lot of collection they were excellent and the service was awesome especially by Balaji sir and done shopping hear and we visit again also",
      "date": "2026-05-31",
      "displayDate": "31 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0043",
      "name": "Jyoti Shukla",
      "rating": 5,
      "text": "Nice collections, good service by Balaji",
      "date": "2026-05-31",
      "displayDate": "31 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0044",
      "name": "Suresh Chowhan",
      "rating": 5,
      "text": "Awesome collection, nice service from balaji",
      "date": "2026-05-31",
      "displayDate": "31 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0045",
      "name": "rashmithamalyala reddy",
      "rating": 5,
      "text": "Ramadevi -communication is excellent,has lot of patience .",
      "date": "2026-05-31",
      "displayDate": "31 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0046",
      "name": "Mudavath Rakesh",
      "rating": 5,
      "text": "Awesome collection,good service from balaji",
      "date": "2026-05-31",
      "displayDate": "31 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0047",
      "name": "Kiran Kumar",
      "rating": 5,
      "text": "Excellent sevice by balaji nice collection purchase some pearl malas and matching earrings",
      "date": "2026-05-31",
      "displayDate": "31 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0048",
      "name": "Sujata Kolnure",
      "rating": 5,
      "text": "Good and beautiful collection Sowed by S.Bharat",
      "date": "2026-05-31",
      "displayDate": "31 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0049",
      "name": "Deepak Chaturvedi",
      "rating": 5,
      "text": "Exallent service by balaji",
      "date": "2026-05-31",
      "displayDate": "31 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0050",
      "name": "Abhishek Suryavamshi",
      "rating": 5,
      "text": "Nice collection shown by pawan",
      "date": "2026-05-31",
      "displayDate": "31 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0051",
      "name": "Roja Jatoth",
      "rating": 5,
      "text": "good service 💯 balaji.",
      "date": "2026-05-31",
      "displayDate": "31 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0052",
      "name": "Narendra Garaga",
      "rating": 5,
      "text": "Nice collection and good service by govind",
      "date": "2026-05-30",
      "displayDate": "30 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0053",
      "name": "madhusri ambala",
      "rating": 5,
      "text": "Good service nice collection by govind",
      "date": "2026-05-30",
      "displayDate": "30 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0054",
      "name": "Nprakash Rao",
      "rating": 5,
      "text": "I Loved the collections mr bharat was so humble and nice person, loved the service 💖",
      "date": "2026-05-29",
      "displayDate": "29 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0055",
      "name": "nimmagadda sweety",
      "rating": 5,
      "text": "They have huge and unique collections in gold and diamond jewellery",
      "date": "2026-05-29",
      "displayDate": "29 May 2026",
      "relativeDate": "Edited a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0056",
      "name": "Harshinareddy Bathina",
      "rating": 5,
      "text": "“Had a wonderful experience at Krishna Jewelers. The collection was beautiful and the overall service was excellent. Special thanks to *Govind* for being so patient, friendly, and helpful throughout the purchase. He explained everything clearly and helped us choose the perfect design without any pressure. The staff was welcoming and the atmosphere was very comfortable. Truly satisfied with the quality, pricing, and customer service. Highly recommended for anyone looking for genuine jewelry and a pleasant shopping experience.” Thank you",
      "date": "2026-05-29",
      "displayDate": "29 May 2026",
      "relativeDate": "Edited 4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0057",
      "name": "swarna geetha",
      "rating": 5,
      "text": "We purchased gold necklace Pavani show very well service is good",
      "date": "2026-05-29",
      "displayDate": "29 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0058",
      "name": "Uma Devi",
      "rating": 5,
      "text": "We purchased necklace pavani show very well service is good",
      "date": "2026-05-29",
      "displayDate": "29 May 2026",
      "relativeDate": "4 weeks ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0059",
      "name": "Swetaholic Cooking & Arts",
      "rating": 5,
      "text": "Mr Bharat was so kind and nice person 🙂",
      "date": "2026-05-28",
      "displayDate": "28 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0060",
      "name": "Raji Sunkavalli",
      "rating": 5,
      "text": "Had a wonderful experience with Pavani. She was friendly, knowledgeable, and helped us choose the perfect gold jewelry. Highly recommended.",
      "date": "2026-05-28",
      "displayDate": "28 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0061",
      "name": "Srinivasulu naidu Malapati",
      "rating": 5,
      "text": "Yadav has shown great designs with patience",
      "date": "2026-05-28",
      "displayDate": "28 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0062",
      "name": "11mlt U.Shireesha",
      "rating": 5,
      "text": "Chinna babu very good seals Man good communication good job",
      "date": "2026-05-26",
      "displayDate": "26 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0063",
      "name": "Nikhitha A Koppal Koppal",
      "rating": 5,
      "text": "Collection at this store is really good and the staff Satish and Roja assisted us well at the store 😊",
      "date": "2026-05-25",
      "displayDate": "25 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0064",
      "name": "Sahaja A",
      "rating": 5,
      "text": "My experience with Krishna Jewellers Pearls & Gems was truly wonderful. Ms. Suvarna patiently showed us a wide variety of ornaments and gave us ample time to choose what we liked without any pressure. Ms. Sandhya and all the other staff members were extremely cordial and helpful, right from guiding us to the appropriate sections, serving snacks and drinks, ensuring hassle-free billing, smooth scheme redemption, purity checks, old gold exchange, and everything else throughout the process. The staff across the gold and diamond sections were very patient and attentive in showing collections that perfectly matched our preferences and requirements. I was also happy to receive loyalty points that can be redeemed during future purchases. Overall, the entire shopping experience was smooth, satisfying, and delightful. My satisfaction level is truly 100%, and I would strongly recommend Krishna Jewellers Pearls & Gems to anyone looking for a pleasant and trustworthy jewellery shopping experience.",
      "date": "2026-05-24",
      "displayDate": "24 May 2026",
      "relativeDate": "a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0065",
      "name": "Meena Wakode",
      "rating": 5,
      "text": "Very satisfied with our visit. The jewellery designs are stunning and pricing is reasonable. Big thanks to Sai Kumar for the friendly support and honest suggestions.",
      "date": "2026-05-24",
      "displayDate": "24 May 2026",
      "relativeDate": "a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0066",
      "name": "Sonu Navare",
      "rating": 5,
      "text": "Sai kumar and karthik and are the best employees. Their hard work, dedication, and teamwork always stand out. Proud to have them on the team.",
      "date": "2026-05-24",
      "displayDate": "24 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0067",
      "name": "Mahidhar Reddy",
      "rating": 5,
      "text": "Sai Kumar has been very good with his collections he has showed very good collections",
      "date": "2026-05-24",
      "displayDate": "24 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0068",
      "name": "Prathmesh Bhore",
      "rating": 5,
      "text": "Sai kumar shoid as nice neckeles and haram in gold",
      "date": "2026-05-24",
      "displayDate": "24 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0069",
      "name": "Jeevika Navarkhele",
      "rating": 5,
      "text": "Sai kumar short nice collections",
      "date": "2026-05-24",
      "displayDate": "24 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0070",
      "name": "Devika Bhore",
      "rating": 5,
      "text": "Sai Kumar nice collections annual experience",
      "date": "2026-05-24",
      "displayDate": "24 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0071",
      "name": "Neha Bhore",
      "rating": 5,
      "text": "Sai Kumar gave nice service",
      "date": "2026-05-24",
      "displayDate": "24 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0072",
      "name": "veeresham pol",
      "rating": 5,
      "text": "Sai Kumar nicesarvice",
      "date": "2026-05-24",
      "displayDate": "24 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0073",
      "name": "BHAGWAN Chowdhury",
      "rating": 5,
      "text": "Nice sale of sai kumar sir",
      "date": "2026-05-24",
      "displayDate": "24 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0074",
      "name": "Boddapati Padmaja",
      "rating": 5,
      "text": "Good service for srilakshmi & good coloctions",
      "date": "2026-05-23",
      "displayDate": "23 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0075",
      "name": "prasanna lakshmi",
      "rating": 5,
      "text": "Good service by Srilakshmi good",
      "date": "2026-05-22",
      "displayDate": "22 May 2026",
      "relativeDate": "Edited a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0076",
      "name": "Lakshmi KSR",
      "rating": 5,
      "text": "Good service by Loknath dutt excellent collect friendly atmosphere",
      "date": "2026-05-21",
      "displayDate": "21 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0077",
      "name": "Tejashri Datar",
      "rating": 5,
      "text": "Krishna Jewellers are excellent variety of jeweller and great customer service. Micheal assisted me very well and also was doing regular follows ups until my jewellery reached in my hand.",
      "date": "2026-05-17",
      "displayDate": "17 May 2026",
      "relativeDate": "a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0078",
      "name": "Shirisha pasupuleti",
      "rating": 5,
      "text": "Excellent, Micheal garu is the reason to visit store, kashinath garu helped me for selection, very patience and helpful. Jagannath reddy helped with new collection.. thank u.. will surely visit again.. pearls collection is awsome",
      "date": "2026-05-17",
      "displayDate": "17 May 2026",
      "relativeDate": "a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0079",
      "name": "Raghuram Thackalapatti",
      "rating": 5,
      "text": "I bought one pearls chain it’s looks beautiful I didn’t expect that much nice thank u very much for serviced one mr Krishna",
      "date": "2026-05-12",
      "displayDate": "12 May 2026",
      "relativeDate": "a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0080",
      "name": "G V M Kiran Babu",
      "rating": 5,
      "text": "It’s very good experience and we liked the jewellery what we received and in particular Sandhya helped us to meet our expectations",
      "date": "2026-05-11",
      "displayDate": "11 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0081",
      "name": "Varsha Pattipati",
      "rating": 5,
      "text": "Great collection and great service. Was assisted by Mr. Mogulaiah who was patient and attentive. Made a good purchase and will visit again!",
      "date": "2026-05-08",
      "displayDate": "8 May 2026",
      "relativeDate": "a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0082",
      "name": "Dharshini Babu",
      "rating": 4,
      "text": "I had ordered Terra lustre earring from your website.The product I have gotten is different from the image on the website.If there were mismatches between website and inventory you should have informed the customer to ask if you can proceed to dispatch the order or not.The one in website had a teardrop shape with a small pearl on top, Whereas the one I recieved has an oval shape and no tiny pearl on top.This is not expected from a reputed business.I don't have the energy to return the product.However I will leave the feedback here, so that other customers can be careful while placing orders online. Update on the above: Renuka ma'am from their customer care department reached out to me and offered replacement and shared images of earrings to exchange with. Thank you for taking accountability and taking care of customer satisfaction.I am changing my review to provide higher rating as you value your customers.",
      "date": "2026-05-08",
      "displayDate": "8 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0083",
      "name": "Daedeepya",
      "rating": 5,
      "text": "Yadav garu one of the senior most person shown amazing and unique products and had patience with handing customers.",
      "date": "2026-05-04",
      "displayDate": "4 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0084",
      "name": "Jyothirmayee Sorapalli",
      "rating": 5,
      "text": "Fine designs value adds to gold",
      "date": "2026-05-04",
      "displayDate": "4 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0085",
      "name": "vasu srikakulapu",
      "rating": 5,
      "text": "My name is Vasundhara srikakulapu and I live in the U.S. I recently purchased a gold necklace, and I would like to share my experience. Initially there was some confusion when the original sales associate left abruptly but the team handled the situation very well and ensured everything moved forward smoothly. Michael was extremely helpful throughout the process. He did an outstanding job coordinating everything after the transition, communicated clearly didn’t feel I was doing with online and all virtually he guided me through billing and made sure the entire process was seamless. His attention to detail and willingness to help truly stood out. I would also like to recognize Sateesh, who provided me with a very good discount, which I truly appreciate. His professionalism and customer-focused approach made a big difference. Additionally the team ensured that the necklace was delivered safely and with great care, which gave me a lot of confidence and satisfaction. Overall, I am very happy with my purchase and the excellent service I received. Special thanks to Michael and Sateesh for their support and dedication. I truly appreciate their efforts and look forward to continuing as a customer. I will definitely recommend your service to my friends and family. Great job to the entire team!",
      "date": "2026-05-03",
      "displayDate": "3 May 2026",
      "relativeDate": "a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0086",
      "name": "Tripura Kaligotla",
      "rating": 5,
      "text": "Swamy Garu, Pawan garu, Mahesh Garu, did a fantastic job! They explained everything clearly and patiently, making the entire experience very comfortable. I actually walked in without any intention to buy, but their professionalism, knowledge, and genuine approach really stood out. They took the time to answer all my questions, guided me through the options, and gave me the best possible price. Because of their excellent service, I felt confident and happy to go ahead with the purchase. Had a memorable experience. Truly appreciate their effort—highly recommend!",
      "date": "2026-05-03",
      "displayDate": "3 May 2026",
      "relativeDate": "a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0087",
      "name": "Usha Y",
      "rating": 5,
      "text": "I had an absolutely wonderful experience with Prakash at Krishna Jewellery, even while shopping remotely from the USA. Buying gold jewelry online can feel overwhelming, but Prakash made the entire process smooth and truly enjoyable. He was incredibly patient and took the time to show me a wide variety of beautiful designs, explaining each piece in detail without ever rushing me. Despite the significant time difference, he was very accommodating and made himself available at hours that worked for me, which I truly appreciated. What stood out the most was his honesty, professionalism, and deep knowledge of the jewelry. He carefully understood my preferences and guided me toward pieces that perfectly matched my taste and budget. Thanks to his thoughtful assistance, I was able to confidently purchase a stunning haram and a set of bangles that I absolutely love. Prakash’s customer service goes above and beyond—he made me feel valued and comfortable throughout the entire process. His attention to detail, friendly nature, and dedication to customer satisfaction are truly commendable. I highly recommend Krishna Jewellery to anyone looking for a trustworthy and exceptional jewelry shopping experience, whether in-store or online. I will definitely be returning for future purchases!",
      "date": "2026-05-03",
      "displayDate": "3 May 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0088",
      "name": "neelima sudershan",
      "rating": 5,
      "text": "We found a truly beautiful neck piece, and the entire experience made it even more special. Prakash offered exceptional service. He’s attentive, patient, and genuinely invested in helping us choose the perfect piece. Krishna jeweler’s stands out not just for its stunning and extraordinary collection, but also for its warm hospitality and attention to detail. What makes it even better is the pricing. It’s very reasonable for the quality and uniqueness of the pieces. Absolutely a must-visit if you’re looking for elegance, value, and a memorable experience.",
      "date": "2026-04-30",
      "displayDate": "30 Apr 2026",
      "relativeDate": "a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0089",
      "name": "JESHU REDDY",
      "rating": 5,
      "text": "Had a great experience at Krishna Jewellery. Special thanks to Pavan for his excellent customer service, patience, and guidance",
      "date": "2026-04-30",
      "displayDate": "30 Apr 2026",
      "relativeDate": "a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0090",
      "name": "Krishna Khanapurna gyanoba",
      "rating": 5,
      "text": "Visited to krishna jewellers Good collections and Good services by Govind",
      "date": "2026-04-30",
      "displayDate": "30 Apr 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0091",
      "name": "Akshay Reddy",
      "rating": 5,
      "text": "Excellent service by pavan",
      "date": "2026-04-30",
      "displayDate": "30 Apr 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0092",
      "name": "Meena Patil",
      "rating": 5,
      "text": "Nice collection, Showed all the veriety of designs Good sevice by Govind",
      "date": "2026-04-30",
      "displayDate": "30 Apr 2026",
      "relativeDate": "Edited a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0093",
      "name": "Rashmi Reddy Vemula",
      "rating": 5,
      "text": "Always a pleasant experience visiting this place. The team is very helpful and takes the time to suggest options based on your needs. I also had a few items customized, and they turned out beautifully. Special thanks to Satish from the pearl section and Suvarna on the 1st floor for their excellent service.",
      "date": "2026-04-29",
      "displayDate": "29 Apr 2026",
      "relativeDate": "Edited a month ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0094",
      "name": "suma latha",
      "rating": 5,
      "text": "super collection and very good hospitality and well behaved staff",
      "date": "2026-04-29",
      "displayDate": "29 Apr 2026",
      "relativeDate": "Edited a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0095",
      "name": "ashish",
      "rating": 5,
      "text": "Nice collection Good services by Govind",
      "date": "2026-04-29",
      "displayDate": "29 Apr 2026",
      "relativeDate": "a month ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0096",
      "name": "Praveena Prashanth",
      "rating": 5,
      "text": "This was my first time shopping with Krishna Jewellers. The customer associates Srikanth Reddy and Pavan were super helpful in guiding me the jewelry and arranging video calls for me to decide. The shopping and shipping to Bangalore was also flawless. I will definitely make more purchases in the future. Overall super happy with the response and product.",
      "date": "2026-04-28",
      "displayDate": "28 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0097",
      "name": "nagireddy sumathi",
      "rating": 5,
      "text": "I had a wonderful gold jewellery shopping experience and excellent service provided by Rohit Reddy and Dinakar. Both of them were very patient, professional, and attentive throughout the process. They had huge collection of beautiful and trendy jewellery designs to choose from, which made our shopping experience even better. Rohit Reddy clearly explained the designs, pricing, and quality details without any rush, with his friendly approach and helped us explore a wide range of options that suited our preferences perfectly. They didn’t just focus on selling but truly cared about giving us the right guidance. Special thanks to Pinky as well for doing an excellent customization for ear rings and delivering it perfectly on time, which made the entire experience even more satisfying. Overall, it was a smooth, pleasant, and trustworthy shopping experience. Highly recommend their service to anyone looking for gold jewellery with great service.",
      "date": "2026-04-28",
      "displayDate": "28 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0098",
      "name": "Siddeswari Katikala",
      "rating": 5,
      "text": "Good collection Prasad service is good",
      "date": "2026-04-26",
      "displayDate": "26 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0099",
      "name": "Rashmi Pattar",
      "rating": 5,
      "text": "Went to Krishna Pearls and jewellary got a very good customer service from Mohith. He was very helpful in finding what I was looking for",
      "date": "2026-04-25",
      "displayDate": "25 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0100",
      "name": "tathagata bhattacharya",
      "rating": 5,
      "text": "Excellent collection, elegant designs and above all warm staff. Had a great time at Krishna Jewelers. I want to specifically mention the name of Ajay. He is so nice and genuine. He helped me through thick and thin in selecting , finalizing and specifying the designs. At the same time Krishna is also a great salesperson. He’s such a genuine and nice guy always ready to help. He exactly made things as I’d want it to be. Thank you very much to both of you.",
      "date": "2026-04-23",
      "displayDate": "23 Apr 2026",
      "relativeDate": "Edited 2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0101",
      "name": "AKHILESH TIWARY",
      "rating": 4,
      "text": "Most trusted pearl shop in hyderabad.",
      "date": "2026-04-22",
      "displayDate": "22 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0102",
      "name": "Vemanadha Reddy Mudiyala",
      "rating": 5,
      "text": "Excellent service done by rama lakshmi",
      "date": "2026-04-22",
      "displayDate": "22 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0103",
      "name": "Navya Botlagunta",
      "rating": 5,
      "text": "I bought pear chain set from Krishna Jewellary’s pearls & gems. Mr. Arjun assisted me well and he gave me all designs via what’s app. The purchase and Delivary was smooth.",
      "date": "2026-04-22",
      "displayDate": "22 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "stream-0104",
      "name": "Harsha Devarakonda",
      "rating": 5,
      "text": "Excellent service by Rohith Reddy at Krishna Jewellers! Very prompt, professional, and managed everything smoothly despite the time zone difference with the US. Communication was clear and timely, and the product was delivered safely. Truly a hassle-free experience highly recommended!",
      "date": "2026-04-21",
      "displayDate": "21 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0105",
      "name": "Sheethal Arya",
      "rating": 5,
      "text": "I had a great time shopping at the comfort of home online . the product is also superb . n the processing was also well co- ordinated",
      "date": "2026-04-21",
      "displayDate": "21 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0106",
      "name": "Nisha M",
      "rating": 5,
      "text": "I liked the anklet.Miss Rakshitha helped me to get through the buying process neatly.Thank you",
      "date": "2026-04-21",
      "displayDate": "21 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0107",
      "name": "Navya R",
      "rating": 5,
      "text": "Good place to look at sliver and Sunitha was best person ever interacted",
      "date": "2026-04-20",
      "displayDate": "20 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0108",
      "name": "Rekha Navya",
      "rating": 5,
      "text": "Sunitha is fantabulous in showcasing the gold items and best place",
      "date": "2026-04-20",
      "displayDate": "20 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0109",
      "name": "sanju munna",
      "rating": 5,
      "text": "Sunitha was quite in showing the ornaments and good place in designs",
      "date": "2026-04-20",
      "displayDate": "20 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0110",
      "name": "Thrinatha Prudhvi Kadali",
      "rating": 5,
      "text": "Diamond collection is marvellous and sunitha was good in show casing them",
      "date": "2026-04-20",
      "displayDate": "20 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0111",
      "name": "Jyothi Radhakrishnan",
      "rating": 5,
      "text": "I had to get a silver statue of Shankaracharya. It was beautifully created by Krishna House Of Silver. They are very professional and kept updating on every step of the development. Really happy with the service they have provided.",
      "date": "2026-04-19",
      "displayDate": "19 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0112",
      "name": "Mankala Manasa Devi",
      "rating": 5,
      "text": "I really liked the Pearl set I purchased. Thank you, Mr. Satish, for your patience and for explaining every detail so clearly. You’ve been an excellent salesperson throughout the process. I truly appreciate you and the jewellers for making the entire experience smooth and trustworthy ✨ I will definitely recommend your jewellers to others too 😊😇",
      "date": "2026-04-14",
      "displayDate": "14 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0113",
      "name": "Devipriya Yakkala",
      "rating": 5,
      "text": "Amazing designs and good hospitality by ramya pavani and lakshmi prasana",
      "date": "2026-04-11",
      "displayDate": "11 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0114",
      "name": "sowmya “Sweety”",
      "rating": 5,
      "text": "It is so good to be at shubhalagnam exhibition at Krishna jewellers ,jubilee hills. The wide variety of designs are astonishing. The service is good accompanied by Lakshmi Prasanna. Looking forward to forward to shop again Thank you .",
      "date": "2026-04-10",
      "displayDate": "10 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0115",
      "name": "honey honey",
      "rating": 5,
      "text": "I have visited krishna jewellery for my wedding.The collection is unique and authentic in all gold , diamonds and polkis with wide range of varieties of collections Ramya Pavani assisted me to select the jewellery .she gave me the best price. Professional and genuine and also helpful staff.",
      "date": "2026-04-09",
      "displayDate": "9 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0116",
      "name": "neeraja vanama",
      "rating": 5,
      "text": "👌 models We can see plenty of stock Excellent jewellers",
      "date": "2026-04-06",
      "displayDate": "6 Apr 2026",
      "relativeDate": "Edited 2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0117",
      "name": "New Newr",
      "rating": 4,
      "text": "In store the staff and manager behavior is good. They have greeted me well. I loved most of the jeweller designs. Anil have a lot of patience he has shown me lot of jeweller designs.",
      "date": "2026-04-05",
      "displayDate": "5 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0118",
      "name": "aeredla gopalreddy",
      "rating": 5,
      "text": "Collection is great. Thank you pavani garu",
      "date": "2026-04-03",
      "displayDate": "3 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0119",
      "name": "Nikhitha Reddy",
      "rating": 5,
      "text": "Fantastic collection. Thankyou Pavani garu for the fabulous service",
      "date": "2026-04-03",
      "displayDate": "3 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0120",
      "name": "Vishnu Priya Kalyanam",
      "rating": 5,
      "text": "I am extremely satisfied with my first online purchase from Krishna Jewellers. The piece is absolutely beautiful and exactly what I was looking for. A huge thank you to Rohith Reddy he was incredibly responsive and helpful throughout. The entire process was smooth and the delivery was surprisingly quick. I’ll definitely be a returning customer and highly recommend them to anyone looking to buy gold online!",
      "date": "2026-04-02",
      "displayDate": "2 Apr 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0121",
      "name": "ALEKHYA RALLAPALLI",
      "rating": 5,
      "text": "Very good collection and staff are humble Thanks to Mr Pasha and Mrls Ramalakshmi for their service",
      "date": "2026-04-01",
      "displayDate": "1 Apr 2026",
      "relativeDate": "Edited 2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0122",
      "name": "MANI MODEL",
      "rating": 5,
      "text": "Krishna Jewellery is a great place to buy jewellery with beautiful designs and good quality at reasonable prices. The staff is very friendly and helpful. A special mention to Sai Kumar for his excellent service—he was polite, patient, and made the whole shopping experience smooth and enjoyable. I’m very happy with my purchase and would definitely recommend this store to others.",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0123",
      "name": "G. KUMAR",
      "rating": 5,
      "text": "Krishna Jewellery is a very nice place to buy jewelry. The designs are beautiful and there are many options to choose from. The quality of the jewelry is very good and looks premium. The service by Sai Kumar was excellent. He was very friendly, patient, and helped in choosing the best jewelry according to our needs. His behavior made the shopping experience even better. Overall, it is a great place for anyone looking for stylish and trustworthy jewelry.",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0124",
      "name": "Sunaina Jaiswal",
      "rating": 5,
      "text": "It was a very good experience in Krishna.. we'll sai Kumar showed us beautiful jewelleries....",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0125",
      "name": "Santosh",
      "rating": 4,
      "text": "The collection here is very good. Govind and team has showed us the best collection and customized the designs as per our vision",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0126",
      "name": "Lakhan Navarkele",
      "rating": 5,
      "text": "Sai kumar have showed us very pretty jwellery and we had so many options in jwellery it was good experience in krishna.",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0127",
      "name": "Gore Rekha",
      "rating": 5,
      "text": "It was my second experience for Krishna jewellery sales person Bheem has attend he was very polite and service was good",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0128",
      "name": "Swathi reddy K",
      "rating": 5,
      "text": "Good service and very nice collection by Govind",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0129",
      "name": "Charan Yerravelli",
      "rating": 5,
      "text": "Really Good experience at krishna jewellers nice collection Good service by Govind",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0130",
      "name": "Vinisha Ninekar",
      "rating": 5,
      "text": "Beautiful collections 🤗",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0131",
      "name": "Varalaxmi Vs",
      "rating": 5,
      "text": "Good collection good service by govind",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0132",
      "name": "Rajashekhar Gajula",
      "rating": 5,
      "text": "Well explained good product knowledge and well communication skill for srilakshmi",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0133",
      "name": "Anil Kumar",
      "rating": 5,
      "text": "Good service nice collections good explanation with peace mind for srilakshmi",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0134",
      "name": "Rambothu Jyothsna",
      "rating": 5,
      "text": "Good collection Good service by govind",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0135",
      "name": "Hanuman Kommasani",
      "rating": 5,
      "text": "Good patiency and excellent service for srilakshmi",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0136",
      "name": "Navarkhela Suryakanth",
      "rating": 5,
      "text": "Sai kumar collection is very nice he is nice person he gave service nice 👍",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0137",
      "name": "Patilambika Ambika",
      "rating": 5,
      "text": "Nice collection and Good services by Govind",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "Edited 2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0138",
      "name": "Ashok Navarkhele",
      "rating": 5,
      "text": "Krishna have nice collection and sai kumar show has very nice collection in gold chain",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0139",
      "name": "Rajput Rohitsingh",
      "rating": 1,
      "text": "Srivce nice by sai Kumar anna",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0140",
      "name": "Thati Shailu",
      "rating": 5,
      "text": "Good collection Good service by Govind",
      "date": "2026-03-31",
      "displayDate": "31 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0141",
      "name": "Duvvuru Gangadhar",
      "rating": 5,
      "text": "Sunitha has given good detailed view on the collection",
      "date": "2026-03-30",
      "displayDate": "30 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0142",
      "name": "Siree B",
      "rating": 5,
      "text": "Sunitha is a good human being and explained very well my friend has referred to a good store",
      "date": "2026-03-30",
      "displayDate": "30 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0143",
      "name": "srujan reddy",
      "rating": 5,
      "text": "Sunitha was good sales person and explained all the items very clear",
      "date": "2026-03-30",
      "displayDate": "30 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0144",
      "name": "Jaya Shree",
      "rating": 5,
      "text": "Very nice collection, with various options and price ranges . Good staff assistance by Govind, highly recommend this store for bridal shopping.",
      "date": "2026-03-30",
      "displayDate": "30 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0145",
      "name": "Malli karjun G",
      "rating": 5,
      "text": "Great collection and Sunitha was good human being infact explained all properly",
      "date": "2026-03-30",
      "displayDate": "30 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0146",
      "name": "UDAY KUMAR",
      "rating": 5,
      "text": "R Satish garu very polite , excellent customer service and very good communication with us. Overall we are very happy with his interaction today.",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0147",
      "name": "Abhiram Kandhikanti",
      "rating": 5,
      "text": "Pavan has been very helpfull and patient throughout the selection process guiding us in finalizing the item that we actually wanted instead of being pushy nice to have such sales person",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0148",
      "name": "Rave Naver",
      "rating": 5,
      "text": "It was really awesome experience in krishna and Mr. Sai kumar showed us very beautiful collection 😀",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0149",
      "name": "B.Kavya Sri",
      "rating": 5,
      "text": "The collections are cool and good talking to sanitha",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0150",
      "name": "Sonu Navare",
      "rating": 5,
      "text": "Karthik and Sai are outstanding employees at Krishna Jewelleries, known for their dedication and excellent work.",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0151",
      "name": "KANUMILLI.G.S.RAVINDRANATH Chowdary",
      "rating": 5,
      "text": "Thank you for the best ganesha and thank you Satish for helping me through the process",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0152",
      "name": "Nithin Navare",
      "rating": 5,
      "text": "Sai Kumar , it was a great experience to have an conversation about gold and diamond with him . he has a gentleman character 😉",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0153",
      "name": "M Priyanka",
      "rating": 5,
      "text": "I had a wonderful experience at Krishna Jewellery , thanks to govind he was extremely kind, patient, and helpful throughout the process. he explained everything clearly and made me feel comfortable and confident with my purchase. Truly appreciated his warm service and professionalism. Highly recommend!",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0154",
      "name": "Nikhil Navare",
      "rating": 5,
      "text": "Krishna have nice collection and sai kumar show has very nice collection in gold chain",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0155",
      "name": "SAI KUMAR REDDY DOKKUPALLI",
      "rating": 5,
      "text": "Sales team Sunitha was very good in explains the models and collection was awesome 😎",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0156",
      "name": "Sangeeta Naverkhale",
      "rating": 5,
      "text": "Sai Kumar showed us very nice collection 👌 it was a good experience in krishna 😀",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0157",
      "name": "Nihar Sreeram",
      "rating": 5,
      "text": "Collection is really great and customer service by Mrs pavani was top notch",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0158",
      "name": "Yuvraj Navare",
      "rating": 5,
      "text": "Sai kumar he gave us nice explation and a good service",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0159",
      "name": "Heerekar Rohith",
      "rating": 5,
      "text": "sai and karthik are good employe they behave very will",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0160",
      "name": "prathyusha lanka",
      "rating": 5,
      "text": "Great service. Good collections of light weight and beads jewellery",
      "date": "2026-03-29",
      "displayDate": "29 Mar 2026",
      "relativeDate": "2 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0161",
      "name": "Amukta",
      "rating": 5,
      "text": "I rarely write reviews but i was so impressed with the patience and dedication of all the staff even at closing hours. We went just an hour before closing to get an idea and purchase later. Mr. Bharath have shown short necklaces patiently so we could try and come back again. Coming to designs, i could see all of my pinteresty designs in the store. They have wide range of classy designs which make u feel buy all of them!!",
      "date": "2026-03-28",
      "displayDate": "28 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0162",
      "name": "Vijay Paruchuri",
      "rating": 5,
      "text": "We purchased chowker service is awesome pavani help very well thank you collection is goodthank you",
      "date": "2026-03-28",
      "displayDate": "28 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0163",
      "name": "sandhya namballa",
      "rating": 5,
      "text": "Thank you so much for beautiful products...very good response by pooja mam... delivered my product the second day I ordered and was so safely sent by them...❣️",
      "date": "2026-03-27",
      "displayDate": "27 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0164",
      "name": "Nitish Saketh",
      "rating": 5,
      "text": "Good service done by pawan",
      "date": "2026-03-26",
      "displayDate": "26 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0165",
      "name": "Naresh Pulamti",
      "rating": 5,
      "text": "Nice design and politely staff Pawan",
      "date": "2026-03-26",
      "displayDate": "26 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0166",
      "name": "Anitha Karanam",
      "rating": 5,
      "text": "Great collection and great assistance by Mrs. Meenakshi and Rajeshree they have shown the entire collection with lots of patience and shared the images through online too beautiful collection and friendly staff",
      "date": "2026-03-24",
      "displayDate": "24 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0167",
      "name": "Asha vasireddy",
      "rating": 5,
      "text": "Collections are awesome we purchased nai pendent the design were pretty pavani help very well thanks to krishna jewellery",
      "date": "2026-03-23",
      "displayDate": "23 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0168",
      "name": "Nanditha reddy",
      "rating": 4,
      "text": "Good collection",
      "date": "2026-03-23",
      "displayDate": "23 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0169",
      "name": "shirisha thupaki",
      "rating": 5,
      "text": "kishore ambati provided good service with patiance .Thank you.",
      "date": "2026-03-21",
      "displayDate": "21 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0170",
      "name": "SHIPRA UPPAL",
      "rating": 5,
      "text": "Mr Satish helped a lot in selecting the items",
      "date": "2026-03-21",
      "displayDate": "21 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0171",
      "name": "Kalal Kousalya",
      "rating": 5,
      "text": "I am very happy with my purchase from Krishna Pearls and Jewellery shop. The silver items were of good quality, and the customer service was outstanding. Mr.Satish assisted me very well and made the shopping experience pleasant.",
      "date": "2026-03-16",
      "displayDate": "16 Mar 2026",
      "relativeDate": "Edited 3 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0172",
      "name": "Venkateswara rai Chitturi",
      "rating": 5,
      "text": "Collection was good models are awesome we purchased bangels and hanging pavani help so much the collection and thank sto krishna jewellery",
      "date": "2026-03-15",
      "displayDate": "15 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0173",
      "name": "Sreevana Reddy",
      "rating": 5,
      "text": "I had a wonderful experience at this jewellery shop. The collection of gold jewellery is beautiful and unique. The staff were very polite Venkatesh garu and prakash garu helped me choose the perfect design. The quality and finishing of the jewellery are excellent. Highly recommended",
      "date": "2026-03-15",
      "displayDate": "15 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0174",
      "name": "Amruta Chafekar",
      "rating": 4,
      "text": "It was a good experience and very quick and easy. Satish was very helpful and answered all my queries happily and promptly. Thanks!",
      "date": "2026-03-13",
      "displayDate": "13 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0175",
      "name": "Ramya Dronavalli",
      "rating": 5,
      "text": "Excellent service and beautiful collection ,we had a wonderful experience at krishna jewellers,pavani garu was extremely courteous ,patient,friendly and knowledgeable .",
      "date": "2026-03-13",
      "displayDate": "13 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0176",
      "name": "Srujana Chowdary",
      "rating": 5,
      "text": "I placed an order with Krishna Jewellery, and Venketeshwars was extremely helpful throughout the process. He provided the right information and useful suggestions regarding my order, and he responded to all my queries very quickly. Overall, I’m very satisfied with my purchase and the service I received. Thanks Srujana",
      "date": "2026-03-11",
      "displayDate": "11 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0177",
      "name": "harrish krishna",
      "rating": 4,
      "text": "The place is great to purchase jewellery & the staff are incredibly friendly providing good service as well with a constant supply of water, hot & cold beverages such as carbonated soda as well. Think the highlight of the time there is the providing of a birthday gift to my grandmother for her 74th birthday by the staff in the place. She was truly ecstatic & overjoyed by the entire experience encountered at the place!",
      "date": "2026-03-08",
      "displayDate": "8 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service",
        "gifting"
      ]
    },
    {
      "id": "stream-0178",
      "name": "Chandu Meghana Alle",
      "rating": 5,
      "text": "Good collection and great service by sri lakshmi",
      "date": "2026-03-08",
      "displayDate": "8 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0179",
      "name": "Divya Darshini",
      "rating": 5,
      "text": "Great collection and great experience.",
      "date": "2026-03-08",
      "displayDate": "8 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0180",
      "name": "Ar Reddy",
      "rating": 5,
      "text": "Great place to shop for jewelry, unique designs. I dealt with Srikanth Reddy online and was connected with Pawan at the store. Both were friendly and helpful. They gave me the best price for the old jewelry too. I definitely recommend this store",
      "date": "2026-03-04",
      "displayDate": "4 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0181",
      "name": "Monika Sultania",
      "rating": 4,
      "text": "Very cooperative n good service",
      "date": "2026-03-02",
      "displayDate": "2 Mar 2026",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0182",
      "name": "anusha pudota",
      "rating": 5,
      "text": "Had a good experience here and Pavani has been very good with showing us designs and hospitality Krishna jwellers",
      "date": "2026-03-01",
      "displayDate": "1 Mar 2026",
      "relativeDate": "3 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0183",
      "name": "Deepa Rao",
      "rating": 4,
      "text": "First time customer . Krishna Jewellers pearls store provided good customer service (Bharathi, Satish) and trust reliability . Bharathi followed up well . Collection was limited though ,",
      "date": "2026-02-27",
      "displayDate": "27 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0184",
      "name": "Sarika Tekale",
      "rating": 4,
      "text": "Amit Agarwal is very helpful , loved the shopping experience",
      "date": "2026-02-27",
      "displayDate": "27 Feb 2026",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0185",
      "name": "Surya Prasanthi",
      "rating": 5,
      "text": "Simply stated , Great variety of products and an excellent service. Very pleased with the way Ramya Pavani got a sense of what I was looking for and patiently provided with the options available. My shopping experience was smooth thanks to her prompt work at helping me find what I like. Appreciate Shiva Kumar for providing the details and breakup for all the billing clarifications.",
      "date": "2026-02-24",
      "displayDate": "24 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0186",
      "name": "shalini b99",
      "rating": 5,
      "text": "Excellent Service and Beautiful Collection! We had a wonderful experience at Krishna Jewelers. Ramadevi garu was extremely courteous, patient, friendly, and knowledgeable. She took the time to understand our preferences and guided us thoughtfully without any pressure, which we truly appreciated. The collection is impressive, offering a great variety of both traditional and modern designs. The craftsmanship is top-notch, and the quality and transparency clearly reflect their commitment to excellence. It made us feel completely confident and comfortable with our purchase. Overall, it was a smooth and pleasant experience from start to finish. We highly recommend Krishna Jewelers to anyone looking for exceptional service and an elegant jewelry collection.",
      "date": "2026-02-24",
      "displayDate": "24 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0187",
      "name": "madhu sri",
      "rating": 5,
      "text": "Had a wonderful shopping experience at Krishna Jewellers. The collections were beautiful and reasonably priced. Special thanks to Ms. Ramadevi for her patience and excellent customer service. She explained every detail clearly and helped me choose the perfect jewellery. Highly recommend!",
      "date": "2026-02-24",
      "displayDate": "24 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0188",
      "name": "surya teja",
      "rating": 5,
      "text": "Collection is awesome models are good the Pavani help full for purchase and service is good she show very patience and we loved shopping thanks to Krishna jewellers",
      "date": "2026-02-24",
      "displayDate": "24 Feb 2026",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0189",
      "name": "srijjen vamsi krishna",
      "rating": 5,
      "text": "We had a great experience. We were taken care really well. Pavani Ramya helped us in selection.",
      "date": "2026-02-24",
      "displayDate": "24 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0190",
      "name": "surya prakash babu boggarapu",
      "rating": 5,
      "text": "We came to purchase neckalce the collection is awesome models are good pavani show very well and she help me lot and we happy with the service she give thanks to krishna jewellers",
      "date": "2026-02-24",
      "displayDate": "24 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0191",
      "name": "Soujanya Ivaturi",
      "rating": 5,
      "text": "I have been purchasing from Krishna Jewelers for few years now. The collection is always amazing and we were able to get all the jewelry needed for my Sister in Laws wedding, my son’s Dhoti Function. Special call out to Ramadevi for always working with us and going above and beyond to address our needs.",
      "date": "2026-02-24",
      "displayDate": "24 Feb 2026",
      "relativeDate": "Edited 4 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0192",
      "name": "Harshita Garg",
      "rating": 5,
      "text": "Very helpful and friendly staff! Showed beautiful jewellery. It was my first visit and super happy with it! Thanks M. jaganath for all your help :)",
      "date": "2026-02-23",
      "displayDate": "23 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0193",
      "name": "Akbar Syed",
      "rating": 5,
      "text": "Good place and awesome collection Sunitha was very generous and shown good models to us",
      "date": "2026-02-21",
      "displayDate": "21 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0194",
      "name": "Krithiga K K",
      "rating": 5,
      "text": "I recently liked a ruby antique product online from Krishna Jewellers and placed an order. The product I received was amazing. Everyone loved it. Simple and beautiful. Rajashri helped me through the entire process, and it was smooth. She responded patiently and shared a wide range of collections. She is definitely an asset to the team. Thank you!",
      "date": "2026-02-19",
      "displayDate": "19 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0195",
      "name": "gopal raghavan",
      "rating": 5,
      "text": "Received the product. It's beautiful. Thank you Pooja for all your support and guidance throughout the process. Had a wonderful experience",
      "date": "2026-02-18",
      "displayDate": "18 Feb 2026",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "stream-0196",
      "name": "Seema Rani",
      "rating": 5,
      "text": "Hello, I just wanted to sincerely thank you for the beautiful bangles. I received them and I absolutely loved them! They are even prettier than expected, and the design and quality are truly wonderful. It’s clear that a lot of care has gone into making them. We really appreciate your excellent work and service. Thank you for bringing such happiness with your lovely creation! Warm regards 🌸",
      "date": "2026-02-17",
      "displayDate": "17 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0197",
      "name": "LAXMI Telu",
      "rating": 5,
      "text": "All staff are very cooperative. Designs are unlimited. Prices are reasonable. Mrs. Kavitha and Mrs. Ramalaxmi both are giving excellent customer service. Last 2 months I visited 6 to 7 times for purchased silver items and Gold jewellery.",
      "date": "2026-02-11",
      "displayDate": "11 Feb 2026",
      "relativeDate": "Edited 4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0198",
      "name": "Veena Subash",
      "rating": 5,
      "text": "Pooja has been very helpful in buying the Ganesha with Umbrella. It has been a great customer experience. Thank you for her help and patience in choosing the best product 😃",
      "date": "2026-02-10",
      "displayDate": "10 Feb 2026",
      "relativeDate": "Edited 12 minutes ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0199",
      "name": "Chanti Chanti",
      "rating": 5,
      "text": "Wide variety and unique collection, I saw a product in some video and approached Krishna jewellers Rohith Reddy came in contact and helped me in knowing more about the product,when I visited the store Sandhya made our purchase smooth. Thank you",
      "date": "2026-02-08",
      "displayDate": "8 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0200",
      "name": "Aadhya.m.n.",
      "rating": 5,
      "text": "Loved shopping at Krishna Jewlwers and pearls, this was my first time online shopping jewels from Bangalore Absolutely loved the service and cooperation from Rohith reddy and their team, so smooth procedures and very quick delivery Can’t wait to shop more during their jewellery exhibition and visits to Hyderabad",
      "date": "2026-02-06",
      "displayDate": "6 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0201",
      "name": "Deepika Praveen",
      "rating": 5,
      "text": "It was a great experience. Sri Lakshmi has been really amazing and helped a lot. She showed so many designs and didn’t compromised until we got what we liked.",
      "date": "2026-02-05",
      "displayDate": "5 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0202",
      "name": "Sri Parvathi Bavisetti",
      "rating": 1,
      "text": "They quoted 20k extra cost. Actually it costs 38k but they quoted 58k I have knowledge on gold & silver because I buy regularly so I raised y that much difference, IMPORTANT POINT: SCAM in both gold & silver pricing Check 3-4 times",
      "date": "2026-02-05",
      "displayDate": "5 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0203",
      "name": "Sai Manasa Veluru",
      "rating": 5,
      "text": "Unique collection.. Mahalakshmi is very friendly and helpful.. she helped me to get a good necklace to match my long haram and within the price i was comfortable.. staff is very helpful here.. hospitality is good.. would recommend everyone to visit this place",
      "date": "2026-02-04",
      "displayDate": "4 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0204",
      "name": "bharath kumar",
      "rating": 5,
      "text": "We had a great experience at Krishna jewellery has multiple jewellery collections The staff and the managers are very cooperative, especially Sunitha sales executive have good knowledge of jewellers and diamonds. The way she explaining about Gold was phenomenal. Thank you Sunitha for spending time with us",
      "date": "2026-02-01",
      "displayDate": "1 Feb 2026",
      "relativeDate": "Edited 4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0205",
      "name": "Maithreyi varma",
      "rating": 5,
      "text": "Great collection with beautiful designs. Truly appreciate the service and the patience shown by Yadav. Had a pleasant shopping experience overall.",
      "date": "2026-02-01",
      "displayDate": "1 Feb 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0206",
      "name": "Venkatesh Chary",
      "rating": 5,
      "text": "Had a great experience purchasing jewelry from Krishna Jewellery. The collection is beautiful and the quality is excellent. Special thanks to Bheem for his friendly, honest, and patient service—he made the entire process smooth and enjoyable. Highly recommended!”",
      "date": "2026-01-31",
      "displayDate": "31 Jan 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0207",
      "name": "Pavan Chary",
      "rating": 5,
      "text": "I had an excellent experience purchasing jewelry from Krishna Jewellery. The collection is beautiful, unique, and of outstanding quality. A special thanks to salesman Bheem, who was extremely polite, patient, and knowledgeable. He guided me honestly, explained every detail clearly, and helped me choose the perfect piece without any pressure. The pricing was fair, service was smooth, and overall experience was truly satisfying. I highly recommend Krishna Jewellery and especially Bheem for anyone looking for a trustworthy and pleasant jewelry shopping experience.",
      "date": "2026-01-31",
      "displayDate": "31 Jan 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0208",
      "name": "Padma Chary",
      "rating": 5,
      "text": "Great experience at Krishna Jewellery! Excellent gold collection and very professional service. Special thanks to Bheem for his helpful and courteous support. Highly satisfied with my purchase.",
      "date": "2026-01-31",
      "displayDate": "31 Jan 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0209",
      "name": "Shashikanth Shashi",
      "rating": 5,
      "text": "Very good collections and spacious showroom. Polite and helpful staff Sandhya Rani , my favorite shopping destination hereafter. Happy with the purchase and would highly recommend for anyone who looks for good designs and fair price",
      "date": "2026-01-31",
      "displayDate": "31 Jan 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0210",
      "name": "krishna megavath",
      "rating": 5,
      "text": "I will visit again if want to buy again, sales executive sandhya helped us finding the right one for us and showcased a wide range of collections i really appreciate for perfection at work",
      "date": "2026-01-31",
      "displayDate": "31 Jan 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0211",
      "name": "Ramu Ch",
      "rating": 5,
      "text": "Had well experience with Sandhya garu beautiful services and well explained about items and we are happy with Sandhya garu",
      "date": "2026-01-31",
      "displayDate": "31 Jan 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0212",
      "name": "Amith Singh",
      "rating": 5,
      "text": "Awesome collection, and very good hospitality, moreover I want to thank you especially Mr. Govind he gave the awesome service.",
      "date": "2026-01-31",
      "displayDate": "31 Jan 2026",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0213",
      "name": "Vamshi Yadav",
      "rating": 5,
      "text": "Wonderful gold ornaments collections with a clear and detailed explanation. Good productivity shown. Great work, Sandhaya garu",
      "date": "2026-01-31",
      "displayDate": "31 Jan 2026",
      "relativeDate": "4 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0214",
      "name": "Dharm Kumar",
      "rating": 5,
      "text": "A wide range of latest trendy collection of jewellery the place have,nice staff and overall service.Sandhya Rani helped us throughout the process,she was very patient,smartly understood our collection",
      "date": "2026-01-31",
      "displayDate": "31 Jan 2026",
      "relativeDate": "4 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0215",
      "name": "rohith gamer",
      "rating": 5,
      "text": "Really impressed with the selling skills of Mr.Kasinath at Krishna pearls ...i had a great experience in shopping.The collection is beautiful and the quality is excellent ..and also Kanakadurga were extremely helpful in helping us choose pearls jewellery.....",
      "date": "2026-01-30",
      "displayDate": "30 Jan 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0216",
      "name": "Kushi Shravan",
      "rating": 5,
      "text": "Maha Lakshmi",
      "date": "2026-01-30",
      "displayDate": "30 Jan 2026",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0217",
      "name": "kandula Prathyusha",
      "rating": 5,
      "text": "Had a wonderful experience at Krishna Pearls and Gems! Sree Lakshmi showed me some stunning designs with great patience, She helped me find the perfect piece with her excellent taste and her service is top-notch.. happy with their overall service. Highly recommend",
      "date": "2026-01-29",
      "displayDate": "29 Jan 2026",
      "relativeDate": "4 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0218",
      "name": "siromani Ch",
      "rating": 5,
      "text": "రమాదేవి గుడ్ service",
      "date": "2026-01-28",
      "displayDate": "28 Jan 2026",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0219",
      "name": "Sindusha Varma",
      "rating": 5,
      "text": "Just visited the gold shop and had an amazing experience! The staff were super helpful and knowledgeable about their products Especially Dinakar and Vinod .I got a beautiful piece of jewellery that fits my style perfectly. The quality is top-notch and the prices are reasonable. Highly recommended",
      "date": "2026-01-25",
      "displayDate": "25 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0220",
      "name": "Keerthi Pradeep Vadlamuri",
      "rating": 5,
      "text": "We had great experience shopping Gold here. Chandu was very patient and helpful. They keep serving snacks and drinks with great hospitality.",
      "date": "2026-01-25",
      "displayDate": "25 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0221",
      "name": "Ch Gaurav",
      "rating": 5,
      "text": "Guru raj",
      "date": "2026-01-25",
      "displayDate": "25 Jan 2026",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0222",
      "name": "Snigdha Nandipati",
      "rating": 5,
      "text": "Had a wonderful experience shopping here Everyone took such good care of us, not only answering our questions but also showing us all varieties of bridal jewelry to help us get to what we were looking for. Sateesh sir and Lavanya maam were both exceptional to work with. They stayed with us for 5+ hours throughout the whole process of selecting and trying on jewelry, even finding matching saris to use as a sample drape for the Jewelry. The customer service here is unmatched, and the designs of the jewelry are quite unique and one of a kind. Definitely recommend shopping here at Jubilee Hills",
      "date": "2026-01-21",
      "displayDate": "21 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0223",
      "name": "Sindhu Reddy",
      "rating": 5,
      "text": "The store has a very good collection of Nakshi jewellery long & short haarams, bangles and earrings. The executives Ramya Pavani & Ramakanth were very friendly and patient right from showing the products to the final purchase of the product.",
      "date": "2026-01-21",
      "displayDate": "21 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0224",
      "name": "Krishnarao Nandipati",
      "rating": 5,
      "text": "Sateesh is the most talented person at Krishna Jewellers. He is so patient and knowledgeable about temple jewlery.",
      "date": "2026-01-21",
      "displayDate": "21 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0225",
      "name": "Vineel Reddy",
      "rating": 1,
      "text": "I took a friend who was visiting from Europe, who wanted to buy something local to Krishna Pearls. The staff were friendly but the tactic one of the sales guy used there was shady and I'm sad the impression it created for someone visiting new to the city. My friend had initially selected a pearl set costing 9k and by the time of finalizing pricing they smartly replaced the one with a very similar looking one which costed around 14k and try to convince that, it was the one he initially saw and selected. It was not a misunderstanding because my friend had clearly stated to show things in the price range not exceeding 10k.",
      "date": "2026-01-19",
      "displayDate": "19 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0226",
      "name": "Mahavash Fatima",
      "rating": 5,
      "text": "Had a wonderful experience at this jewellery shop. The collection is beautiful, quality is excellent, and the staff is very polite and patient. They explained everything clearly and helped us choose the perfect piece. Prices are transparent and trust-worthy. Highly recommended! Special thanks to Ramya Pavani and Nayeem for being extremely helpful and for giving their best support. Truly appreciate it!",
      "date": "2026-01-18",
      "displayDate": "18 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0227",
      "name": "Prithwi Sarkar",
      "rating": 5,
      "text": "Fully satisfied with store room experience. Mr Sai Chandu helped us getting the best pearl ornaments within our budget and we are satisfied with it. Sure will visit again.",
      "date": "2026-01-17",
      "displayDate": "17 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0228",
      "name": "Suman. R",
      "rating": 5,
      "text": "I am glad to come to Krishna Jewellers and shop gold jewellery. Mr. R.Sathish at Jubilee Hills is kindest person and very prompt sales person. He is not only knowledgeable about gold jewellery but very jovial as well. This makes me come again and again to Krishna Jewellery. I always get a warm welcome here. Many good wishes to team.",
      "date": "2026-01-11",
      "displayDate": "11 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0229",
      "name": "Meenu Tripathi",
      "rating": 5,
      "text": "My experience was good at Krishna Jewellers royals and gems jublee hills. R Satheesh was very supportive and patience while selecting the jewellery.",
      "date": "2026-01-11",
      "displayDate": "11 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0230",
      "name": "Chahat Kataria",
      "rating": 5,
      "text": "Yadav Ji and Priyanshu were very patient and kind and helped us with all our requirements for designs.",
      "date": "2026-01-11",
      "displayDate": "11 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0231",
      "name": "sai aparna",
      "rating": 5,
      "text": "Visited the store for the first time , and the staff was really accomodative , patiently showed all the models and also have a great collections . Especially Yadav and lavanya have been a great and welcoming .",
      "date": "2026-01-11",
      "displayDate": "11 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0232",
      "name": "bhavagna bhimaraju",
      "rating": 5,
      "text": "The service was veryy goodd was assisted by great staff members like yadav and lavanya making it a very memorable experience for us .they also have great collection",
      "date": "2026-01-11",
      "displayDate": "11 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0233",
      "name": "Advaita Reddy",
      "rating": 4,
      "text": "Came here for wedding shopping and found a good amount of collections and finish.. the service was very good.. Vinod and Lavanya helped us with all their patience",
      "date": "2026-01-11",
      "displayDate": "11 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0234",
      "name": "Anjana Balaji",
      "rating": 5,
      "text": "Ramya Pavani showed me and my husband diamond pendants . She patiently showed us the options and We liked the fact that she was not pushy to make us purchase since we took our time and got back Thank you",
      "date": "2026-01-10",
      "displayDate": "10 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0235",
      "name": "Bodhadeep Karmakar",
      "rating": 5,
      "text": "Mata Swaraswati Coments: No Coments I am very much Happy",
      "date": "2026-01-10",
      "displayDate": "10 Jan 2026",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0236",
      "name": "Venkat Raja",
      "rating": 5,
      "text": "Excellent service and beautiful collection! Had a wonderful experience at Krishna Jewelers. The staff is extremely courteous, patient, and knowledgeable—they took the time to understand our preferences and guided us without any pressure. The collection is impressive, with a great variety of traditional and modern designs, and the craftsmanship is top-notch. Quality and transparency were clearly a priority, which made us feel confident in our purchase. Overall, a smooth and pleasant experience from start to finish. Highly recommend Krishna Jewelers for anyone looking for great service and an elegant jewelry collection.",
      "date": "2026-01-08",
      "displayDate": "8 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0237",
      "name": "Krishnaveni Gorijavolu",
      "rating": 5,
      "text": "Lavanya was amazing. The way she helped and showed the jewellery made it easy for me to select and buy. Thank you, Lavanya",
      "date": "2026-01-08",
      "displayDate": "8 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0238",
      "name": "Deepthi Deepu",
      "rating": 1,
      "text": "I never saw this type of class fraud These people quoted 4.2lakhs for 36grams necklece in previous December where the gold price of one gram is 7040rupees only That time we really have zero knowledge on gold pricing These people made cash from our innocence They happily given 5gramms silver coin for our purchase That time we also felt very happy Now we have our own gold smith in our own hands Now we got to know the fraud which they did So people who are visiting first time to this big frauds Please be careful",
      "date": "2026-01-08",
      "displayDate": "8 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0239",
      "name": "Valli K",
      "rating": 5,
      "text": "Vinod had been exceptional. He was willing to help us with the designs and collections. He was extremely patient with us. He demonstrated willingness to help us thoroughly in getting our desired product. Truly cared about the customer satisfaction. Swamy garu was very helpful and courteous with us. He ensured that we were happy about the purchase and ensured that we were extremely satisfied. I would definitely come back to Krishna Jewellers for my future purchases. I would surely recommend everyone to purchase from Krishna Jewellers.",
      "date": "2026-01-05",
      "displayDate": "5 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0240",
      "name": "Reddy",
      "rating": 5,
      "text": "Sreelakshmi is the most enthusiastic, knowledgeable and kind woman who shows exquisite jewellery and ensures the customer is not only fully satisfied with the product but also the price. Thank you Sreelakshmi😊",
      "date": "2026-01-05",
      "displayDate": "5 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0241",
      "name": "Likhitha mudunuri",
      "rating": 5,
      "text": "Ramadevi",
      "date": "2026-01-05",
      "displayDate": "5 Jan 2026",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0242",
      "name": "Nanda Kishore T",
      "rating": 5,
      "text": "My purchase experience here started with a routine enquiry about a unique product design which eventually led to a store visit. Both Rajeshree and Ramakanth were very thorough helping me understand the pros and cons of every design and my wife was very impressed with their professionalism and depth of knowledge. Thank you for being so patient and helping us get a good product",
      "date": "2026-01-03",
      "displayDate": "3 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0243",
      "name": "Alekhya Reddy Akki",
      "rating": 5,
      "text": "Wide variety of unique collections and work well the customers on pricing. Very polite and soft spoken staff. Loknath garu is a very good person and extremely supportive",
      "date": "2026-01-01",
      "displayDate": "1 Jan 2026",
      "relativeDate": "5 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0244",
      "name": "jahnavi tummala",
      "rating": 5,
      "text": "Hi I loved shopping experience in Krishna Jewellers at Jubilee Hills and Mr.Venkat has patiently showed different designs and explained every detail. Once we blocked our product Mr. Venkat has made our payment and billing process easy. I would love shopping at Krishna Jewellers for all my family occasions.",
      "date": "2025-12-31",
      "displayDate": "31 Dec 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "stream-0245",
      "name": "Bruce Lee Karunakaran",
      "rating": 5,
      "text": "I am from Southern part of Tamilnadu, I made four purchases in Krishna Jewellers within a span of three months. I am proud to be one of the happiest customers of Krishna Jewellers. Krishna Jewellers have stunning designs, excellent craftsmanship. Great customer service are there both, in-store and back office. The staffs are friendly, patient and knowledgeable. They only deal with quality gems and metals. Exchange of old gold and Customisation of new Jewelleries are also done. A fair pricing and clear bills are provided. Highly recommend and busiest store in Hyderabad.",
      "date": "2025-12-29",
      "displayDate": "29 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0246",
      "name": "harshita bhilwaria",
      "rating": 1,
      "text": "Bought pearl necklace a year ago from this store. But it was fake pearls. The colour/coating came off in just 3-5 uses",
      "date": "2025-12-29",
      "displayDate": "29 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0247",
      "name": "Manjula Adhi",
      "rating": 5,
      "text": "Had a wonderful and productive experience with Maha Lakshmi! Always a good experience to visit Krishna.",
      "date": "2025-12-29",
      "displayDate": "29 Dec 2025",
      "relativeDate": "5 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0248",
      "name": "Sath Reddy",
      "rating": 5,
      "text": "Krishna has really good collection of gold and diamond jewellery with good prices. Their service specially stands out. Yadav garu has especially made the experience very easy by understanding the requirement and helping out by bringing in requested collection from all their stores and making sure we find the right one.",
      "date": "2025-12-28",
      "displayDate": "28 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0249",
      "name": "aditya srirama",
      "rating": 5,
      "text": "Very vast collections with great pricing range. We were assisted by GS Yadav garu for our shopping - he was very patient and helped us in finalizing the best deal.",
      "date": "2025-12-28",
      "displayDate": "28 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0250",
      "name": "Akshita Bh",
      "rating": 5,
      "text": "Very much satisfied with the service.Thank you Yadav and Lakshmi Prasanna for the service and patiently showing the items.Nice collection Thank you",
      "date": "2025-12-28",
      "displayDate": "28 Dec 2025",
      "relativeDate": "Edited 6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0251",
      "name": "Sita Polisetti",
      "rating": 5,
      "text": "Sales excutive Sandhya Rani's service was very good. She showed us a wide variety of products. Showroom ambience is very good with refreshments in between.",
      "date": "2025-12-28",
      "displayDate": "28 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0252",
      "name": "Charitha Ambati",
      "rating": 5,
      "text": "Very very patience staff. Yadav garu handled our purchase and he was great with us through out the whole time.",
      "date": "2025-12-28",
      "displayDate": "28 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0253",
      "name": "Chandra Babu",
      "rating": 5,
      "text": "Thank you @SandhyaRani for your patience, and spending time with us. We never forget such a wonderful person who always smile and glory and nice receiving with the customer.",
      "date": "2025-12-27",
      "displayDate": "27 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0254",
      "name": "Harsh Chandra",
      "rating": 4,
      "text": "Good jewellery selection. Service is a bit slow. Attention to customer seems to be lacking. For very small changes I have to wait 1-2 hours to finally know that any change will be possible the next day. Internal communication needs to improve. Also their sandwich is excellent!",
      "date": "2025-12-27",
      "displayDate": "27 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0255",
      "name": "Vashiv",
      "rating": 4,
      "text": "Pavan, He understands his responsibilities well and delivers quality work on time. Thank you for the support",
      "date": "2025-12-26",
      "displayDate": "26 Dec 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0256",
      "name": "pranavi",
      "rating": 5,
      "text": "Loknath was extremely patient, knowledgeable, and a pleasure to work with. He took the time to answer all my questions without any pressure and made the experience very enjoyable. Highly recommend!",
      "date": "2025-12-25",
      "displayDate": "25 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0257",
      "name": "Prachi Tyagi",
      "rating": 5,
      "text": "One of the best jewellery designs in the city Hyderabad. The sales agent R.Sateesh was excellent and extremely polite. Because of his excellent service we bought many other items as well. Well done.",
      "date": "2025-12-24",
      "displayDate": "24 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0258",
      "name": "Bhaskar C",
      "rating": 5,
      "text": "Good collection and very polite and patient salesman Mr. Ramesh guided us to select a good pear necklace set !",
      "date": "2025-12-23",
      "displayDate": "23 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0259",
      "name": "Vanitha",
      "rating": 5,
      "text": "Very good collection. Mrs.Ramadevi had all the patience to show the collection and was very pleasant to talk to. Thank you.",
      "date": "2025-12-21",
      "displayDate": "21 Dec 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0260",
      "name": "Sangram haritha",
      "rating": 5,
      "text": "Love there collections and provides good service.Pavani there sales executive had showed everything with good patience and was having a good knowledge and understands customers choice nicely..everyone in the store is friendly and helpful.Completely satisfied with the purchase.",
      "date": "2025-12-21",
      "displayDate": "21 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0261",
      "name": "Arun Manivannan",
      "rating": 5,
      "text": "We had a wonderful experience at the store thanks to Satish's attentive service. He took the time to understand what we were looking for and showed us a great selection of designs that matched our preferences perfectly. Satish was knowledgeable, patient, and made the entire experience enjoyable without being pushy. His eye for design and willingness to explore different options really helped us make the right choice. Highly recommend asking for Satish if you visit!",
      "date": "2025-12-19",
      "displayDate": "19 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0262",
      "name": "chandu Yellanki",
      "rating": 5,
      "text": "There is a lot of collection and the service was wonderful. Ramadevi garu is very polite and patiently showed us wide variety. Happy to be there.",
      "date": "2025-12-18",
      "displayDate": "18 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0263",
      "name": "Suvin s amin",
      "rating": 5,
      "text": "Visited shop recently and loved the range of collections and the service. Specially to call out J Ramesh, Krishna and Bharathi (supported online). I would strongly recommend to visit here for any type of Jewel purchase, especially Perl. Cheers.",
      "date": "2025-12-15",
      "displayDate": "15 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0264",
      "name": "Gayathri Tirumani",
      "rating": 5,
      "text": "I always love their collection….a big fan of their pearl bangles…. I approached them online…Ms Bharathi came in contact and patiently answered all of my queries…she in turn followed me during my busy days and helped me in buying my bangles. I happily say it’s because of her I got my bangle and gold rate increased so much after that….got a great deal and they made online gold shopping safe and promising 😊",
      "date": "2025-12-13",
      "displayDate": "13 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0265",
      "name": "TANGUDU SAI MANIKANTA",
      "rating": 5,
      "text": "I purchased a gold haram and earrings from this shop, and I am very happy with the experience. The sales executive Mr. Ch. Venkat was very responsive, polite, and provided excellent service throughout. The items are of very good quality, with beautiful designs and excellent polishing. The shop has a wide range of attractive models. Overall, it was a very pleasant shopping experience.",
      "date": "2025-12-13",
      "displayDate": "13 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0266",
      "name": "Seenivasulu R Adapala",
      "rating": 5,
      "text": "Sandhya , I felt very overwhelmed by the sheer amount of hand made pieces.Each one was beautifully crafted and it was very clear that each necklace or earing was very precious to them. Sandya was our representative and she helped us navigate through all the items to find the perfect one in our budget while keeping the richness intact.Without her we would have not been able to find the necklace we did today.Overall if your looking for affordable while high end quality you must go here.",
      "date": "2025-12-13",
      "displayDate": "13 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0267",
      "name": "Sharada S Shetty",
      "rating": 1,
      "text": "ONLINE SHOPPING ???BE AWARE!!!! I’ve followed Sri Krishna for five years and always wanted to buy silver gifts from them, but my first experience was extremely disappointing. Their in-store team asked me to book an appointment and then never called—even after I waited for two hours. When I messaged, they casually said they had “forgotten.” Since I had very little time, I placed the order online without seeing the product. When I later wanted to exchange an item, everything became frustrating. The in-store team kept saying, “The website team will update you,” but the update never came. My messages were seen but ignored. The issue was simple: the in-store team never actually forwarded my concern or my number to the online team. Only on the final day when I decided to cancel the product did they finally shared my details. The online team immediately contacted me, apologized, and handled it that same day. So clearly, the lack of response wasn’t from the website team, but from the in-store team not doing their part. I had also clearly requested them not to call my in-laws because it was a surprise gift, yet they still did. This made the whole experience even more disappointing. By the end, I lost trust and cancelled my order. Maybe my transaction was small, but the way the situation was handled felt careless and unprofessional. I won’t be purchasing again.Now I checked their online reviews and saw many customers complaining about poor online service and not getting refunds, which honestly making me even more scared .😢 The staff lacked sympathy and empathy, and they did not know how to properly answer questions over the phone. The female staff's member I spoke to seemed unsure how to respond and repeatedly said “sorry” without actually addressing the questions asked. I strongly feel the store management should kindly look into this matter and provide proper customer service training to their staff so that customers receive clear, helpful, and respectful responses. Update 2: I finally received my refund after 15 days of following up every single day. At first, I was told the refund would come through Razorpay, but there was no transaction or refund ID. Even Razorpay confirmed there was no record. After repeatedly contacting them, I was connected to a staff member named Neelam who promised a refund in 3 days. Later, I was told the money was sent through Shopify, but the screenshot showed Razorpay which looked edited. Eventually, the refund was actually processed through Razorpay, and I received it in one day. Overall, the online process was very tiring and confusing. Anyone purchasing online should be careful and aware.!!!",
      "date": "2025-12-13",
      "displayDate": "13 Dec 2025",
      "relativeDate": "Edited 6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service",
        "gifting"
      ]
    },
    {
      "id": "stream-0268",
      "name": "satish sheku",
      "rating": 5,
      "text": "Good place very genuinely talked and very politely suggest mr j Ramesh thankew sir for ur valuable time",
      "date": "2025-12-11",
      "displayDate": "11 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "stream-0269",
      "name": "Harini Jujjavarapu",
      "rating": 5,
      "text": "Buying a piece of jewellery online is such a hassle, but this time, with Krishna jewellers & their amazing staff, especially Vinod, made it super easy & very smooth experience for me! Right from the start to the end, regular follow ups, N number of video calls, handling all my queries with lots & lots of patience, Vinod has been a super star ⭐️, every customer will be 100% satisfied if service is this good. I highly recommend this amazing store. They have wide range of gorgeous collections to choose from, and the plus point is they are available with us 24/7 and make us feel super valued.",
      "date": "2025-12-08",
      "displayDate": "8 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0270",
      "name": "Josyula Deepika",
      "rating": 5,
      "text": "We visited the showroom in JB. R Sateesh helped us and it was a wonderful experience. He was patient, knowledgeable and was able to pivot based on our needs and make a good selection. It was a very pleasant experience.",
      "date": "2025-12-08",
      "displayDate": "8 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0271",
      "name": "Mohan mKona",
      "rating": 5,
      "text": "Mr. LOKNATH",
      "date": "2025-12-08",
      "displayDate": "8 Dec 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0272",
      "name": "Shashank Reddy Bikkem",
      "rating": 5,
      "text": "I recently visited Krishna Jewellers and had an amazing experience! The collection here is exquisite with a wide range of beautiful designs. Lalepa, Lavanya, Kranthi and Manager Swamy were extremely helpful and made our purchase smooth and enjoyable. They patiently guided us through the selections and explained the offers in detail, which made the entire process even better. The service, hospitality, and deals provided were truly impressive. Highly recommend Krishna Jewellers for anyone looking for quality, trust, and great customer experience!",
      "date": "2025-12-07",
      "displayDate": "7 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0273",
      "name": "Raghava Deekshitula",
      "rating": 5,
      "text": "Great collection with excellent quality and outstanding customer service. The sales team was patient and gave us the space and confidence to make our decision without any pressure. They were also very thoughtful, offering refreshments regularly, we didn’t even realize how much time we had spent there. Overall, a very pleasant and comfortable experience.",
      "date": "2025-12-07",
      "displayDate": "7 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0274",
      "name": "Viswa Teja Mulukutla",
      "rating": 5,
      "text": "Bought a beautiful pearls chain for my wife. The showroom experience was excellent—friendly staff, helpful service, and a great selection. Especially, Ramesh the sales executive was very helpful from the time we entered the showroom until we exited, Highly recommend to others!",
      "date": "2025-12-07",
      "displayDate": "7 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0275",
      "name": "Drithi P",
      "rating": 5,
      "text": "Bought a pair of earrings from Krishna Jewellers and I’m really happy with my choice. The collection was beautiful, and Sandhya was very helpful throughout. Highly recommended!",
      "date": "2025-12-06",
      "displayDate": "6 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0276",
      "name": "raogovind G",
      "rating": 4,
      "text": "Loknath, is a nice person, provided good service. His rating 5 stars. Prices in this show room seems little bit high and rated 4 stars.",
      "date": "2025-12-06",
      "displayDate": "6 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0277",
      "name": "Sandeep Bhogavilli",
      "rating": 5,
      "text": "Happy to shop at Krishna. Mr. Bheem helped us choose the best design for our budget.",
      "date": "2025-12-06",
      "displayDate": "6 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0278",
      "name": "B Tejasvi",
      "rating": 5,
      "text": "I recently purchased this mangalsutra and I’m extremely happy with it! The design is elegant, the quality of the black and gold beads is excellent, and the center pendant adds a beautiful, classy touch. It feels lightweight yet premium, and looks even better in person. Truly worth the purchase — highly recommended! Krishna Jewlers sales team - Mrs. Mahalakshmi.",
      "date": "2025-12-05",
      "displayDate": "5 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0279",
      "name": "Ramya Nekkanti",
      "rating": 5,
      "text": "I had a wonderful experience at this jewelry store. The designs are beautiful, prices are reasonable, and Bheem provided exceptional service. He took time to understand what I wanted and helped me choose the perfect piece. Truly impressed",
      "date": "2025-12-05",
      "displayDate": "5 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0280",
      "name": "praveena reddy",
      "rating": 5,
      "text": "A wonderful online shopping experience at Krishna Jewellers. Dinakar garu was very proactive in understanding what we were looking for and very patient in showing us different designs in different budgets. A go to shop for all your jewellery needs.",
      "date": "2025-12-05",
      "displayDate": "5 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0281",
      "name": "rachana reddy",
      "rating": 5,
      "text": "Amazing store amazing collection Sri Lakshmi has guided me to find my wedding jewellery. Great place, must visit.",
      "date": "2025-12-05",
      "displayDate": "5 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0282",
      "name": "satyanarayanan ganeshan",
      "rating": 5,
      "text": "recently visited Krishna Pearls, and I had an excellent experience. The collection was authentic, well-crafted, and offered at fair prices. A special mention to Mr. Krishna, the salesperson who assisted me. He was extremely knowledgeable about the products, patiently explained the details of each piece, and helped me choose exactly what I was looking for. His customer service was genuine, courteous, and professional throughout. Overall, a smooth and satisfying shopping experience. Highly recommended for anyone looking for quality pearls and great service.",
      "date": "2025-12-01",
      "displayDate": "1 Dec 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0283",
      "name": "Gnaneshwer Baswapuram",
      "rating": 5,
      "text": "Very excellent customer dealing, with full patience showing all varieties and guiding customers to full satisfactory levels. V. Meenakshi madam is excellent and put lot efforts to show all types of varieties available in the store.",
      "date": "2025-12-01",
      "displayDate": "1 Dec 2025",
      "relativeDate": "6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0284",
      "name": "chandana reddy",
      "rating": 5,
      "text": "Jewellery you will fall in love with. Amazing collection, each piece more beautiful than the other. Friendly and helpful team. I had a great experience shopping with them.",
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0285",
      "name": "shanthi sonu",
      "rating": 5,
      "text": "Very huge collection of unique designs and the staff specially SandhyaRani is very passionate about her work and helping customers with great smile 😊 Thank you for awesome receiving",
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0286",
      "name": "Lilha Ssayi babu",
      "rating": 5,
      "text": "That's wonderful to hear you had a great experience! Govind Patil sounds like an excellent salesperson, providing good service and patiently explaining the wide range of collocation options at Krishna jewellery",
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0287",
      "name": "durga ande subrahmanyam",
      "rating": 5,
      "text": "I had a wonderful experience at Krishna Jewellers. Appreciate the excellent service provided by Mr.S.Bharat They were very nice and friendly to us and showed us very good quality jewelry pieces . Also appreciate Mr.S.Bharat for their customer service .",
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0288",
      "name": "Amar Bhosle",
      "rating": 5,
      "text": "I am very much happy with service by bheem .He gave the best experience with exchange thanks for the service when I will come again definitely reach out to bheem",
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "relativeDate": "6 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0289",
      "name": "Venkata Ramana",
      "rating": 5,
      "text": "Bheem",
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0290",
      "name": "Gayatri Amar Bhosle",
      "rating": 5,
      "text": "I received good service from bheem they were patient with me and my Aunt as we went through many different designs and shared with them my requirement for my preference accessories.",
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "relativeDate": "Edited 6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0291",
      "name": "Naresh Checharla",
      "rating": 5,
      "text": "I purchased gold from here for my wedding. I really loved the kasumala It is antique and very unique. I was hosted by Mr.S.Bharat, they did provide great service and comfort. Much recommended for unique and heritage collections",
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "relativeDate": "6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0292",
      "name": "Struti Kalla",
      "rating": 5,
      "text": "I had a wonderful experience at Krishna Jewellers pearls & gems. The store offers an excellent and unique collection of jewellery, with beautiful designs and models that truly stand out. The service of Mr.S.Bharat was outstanding—every staff member was courteous, patient, and helpful throughout my visit.",
      "date": "2025-11-30",
      "displayDate": "30 Nov 2025",
      "relativeDate": "6 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0293",
      "name": "Mounika Reddy",
      "rating": 5,
      "text": "We loved the experience at this store! They have a wide collection with the latest models, truly a one‑stop shop. We bought jewelry for the whole family and were very happy with the choices. The quality is great. Dinaker and Guravaiah from the sales team showed us the collection and explained everything clearly, which made the shopping easy and enjoyable. The staff were friendly and helpful.",
      "date": "2025-11-29",
      "displayDate": "29 Nov 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0294",
      "name": "Samya Reddy",
      "rating": 5,
      "text": "Krishna Jewellers always has trendy and unique designs. Yadav garu has been incredibly helpful every time, understanding exactly what I need and making the shopping experience smooth and satisfying. Always a pleasure visiting this store!",
      "date": "2025-11-28",
      "displayDate": "28 Nov 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0295",
      "name": "bhagya lakshmi",
      "rating": 4,
      "text": "It was good experience collection was good and also sales person Prakash was very patience and showed us the designs we wanted. Thanks to prakash",
      "date": "2025-11-28",
      "displayDate": "28 Nov 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0296",
      "name": "sharadamohan anne",
      "rating": 5,
      "text": "Pawan’s professionalism and warm behaviour at Krishna Jewellers stood out. He was attentive, gave honest guidance, and helped us pick the perfect piece without any pressure. Highly appreciate his service.",
      "date": "2025-11-27",
      "displayDate": "27 Nov 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0297",
      "name": "Padmavathi Rayapati",
      "rating": 5,
      "text": "Ramadevi good service",
      "date": "2025-11-26",
      "displayDate": "26 Nov 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0298",
      "name": "Anand Yargole",
      "rating": 5,
      "text": "We visited this store after we heard a lot from our friends and families . We are really delighted the kind of attention given by Prakash and show cases all the necklaces on video call. Although we are in USA he provided us all attention and showed all the possible collections for jwellery, We really liked the customer service and extremely happy by Prakash services Definitely recommend Krishna Jewellers and Especially Praskash for his service",
      "date": "2025-11-26",
      "displayDate": "26 Nov 2025",
      "relativeDate": "Edited 7 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0299",
      "name": "ANJALI MEESALA",
      "rating": 5,
      "text": "I came here to shop for my brother's engagement, had a great shopping experience. Our sales executive Suneetha was really supportive and helpful throughout. Would definitely recommend people to shop here",
      "date": "2025-11-25",
      "displayDate": "25 Nov 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0300",
      "name": "SaiPraveen Thoom",
      "rating": 4,
      "text": "nice products and great sales team @ramesh great job",
      "date": "2025-11-22",
      "displayDate": "22 Nov 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0301",
      "name": "Lavanya Swarna",
      "rating": 5,
      "text": "Great experience today at Krishna pearls and jewels store. Huge thanks to C.H. Venkat and M. Raju for providing details very patiently for all our questions. Highly recommend visiting this store at Jubilee hills for the splendid collection both in diamonds and gold. Thanks!",
      "date": "2025-11-21",
      "displayDate": "21 Nov 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0302",
      "name": "Bekele Ashagire",
      "rating": 4,
      "text": "The shopping experiance was good including when you diacuss with employees and the manager.",
      "date": "2025-11-21",
      "displayDate": "21 Nov 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0303",
      "name": "Y V G Shankar",
      "rating": 5,
      "text": "This is my first visit to Krishna Jewellers in Jublee hills where in we purchased few silver jewellery. Abdullah Pasha has patiently shown us all those items the family were interested. Great experience.",
      "date": "2025-11-20",
      "displayDate": "20 Nov 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0304",
      "name": "Usha Desai",
      "rating": 5,
      "text": "Late last week, I had placed an online order from Mumbai for a beautiful pair of pearl-coral studs on the website of Krishna Jewellers. My order reached me in no time and the packaging was very beautiful. But ..they had sent a different varient by mistake and I requested for a replacement. Mr Neelam from their e-commerce team who had earlier reached out to me after I'd placed my order, listened to my grievance patiently and assured me that my problem will be resolved satisfactorily asap. And true to his words, I received my actual product within a day! - they are such a charming pair of earrings! 🤩 I am very happy that Krishna Jewellers addressed my concern very swiftly and professionally👏🏻😇 Special Thanks to Mr Neelam🙏🏻👏🏻💐😊 - he was very cordial, patient, helpful and proactive and provided me regular updates regarding my order🤝",
      "date": "2025-11-19",
      "displayDate": "19 Nov 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service",
        "gifting"
      ]
    },
    {
      "id": "stream-0305",
      "name": "Sreerama Kotamraju",
      "rating": 5,
      "text": "I am a long time customer of this store. They used to ship the jewelry overseas too. Excellent service by the staff. They serve refreshments to clients, which is a nice gesture. This time, I couldn't find any solitaire rings to buy though as they don't have any in stock. They showed other items which are beautiful and I took some pics of them.",
      "date": "2025-11-18",
      "displayDate": "18 Nov 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0306",
      "name": "Roshan Belokar",
      "rating": 5,
      "text": "I am very happy with my purchase. Mr. J. Ramesh made my experience joyful. Thanks.",
      "date": "2025-11-12",
      "displayDate": "12 Nov 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "stream-0307",
      "name": "Ramya Sinha",
      "rating": 4,
      "text": "Awesome collection and services",
      "date": "2025-11-02",
      "displayDate": "2 Nov 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0308",
      "name": "Yashwanth Vungarala",
      "rating": 5,
      "text": "I had an amazing experience with Vinodh! He was extremely professional, patient, and genuinely helped me choose the right gold without any pressure. His knowledge about purity, designs, and pricing was very impressive, and he explained everything clearly so I could make the best decision. He made the whole process smooth, transparent, and comfortable. I really appreciate his service and friendly nature. I will definitely come back in the future and highly recommend Vinodh to anyone looking to buy gold at Krishna jwellers jublee hills.",
      "date": "2025-11-02",
      "displayDate": "2 Nov 2025",
      "relativeDate": "7 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0309",
      "name": "NITIN ARORA",
      "rating": 5,
      "text": "Had another amazing experience at Krishna Pearls. Every visit reminds me why I love this place so much — the collection, the quality, and the service are truly exceptional. Special thanks to N. Jagannathan and U Krish for their outstanding hospitality and attention to detail. Highly recommend this store for anyone looking for timeless and elegant pieces.",
      "date": "2025-11-01",
      "displayDate": "1 Nov 2025",
      "relativeDate": "7 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0310",
      "name": "sanjay reddy",
      "rating": 5,
      "text": "M. Raju and sarvesh were brilliant",
      "date": "2025-10-31",
      "displayDate": "31 Oct 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0311",
      "name": "Anitha Kore",
      "rating": 5,
      "text": "Gururaj",
      "date": "2025-10-31",
      "displayDate": "31 Oct 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0312",
      "name": "Sowmya Reddy",
      "rating": 5,
      "text": "“My recent purchase experience with Krishna Jewellers … Thanks to Mr. Yadav, who was very attentive to my requests/wishes and he was helpful, knowledgeable about products, patient with answering questions and proactive in showing me the latest designs. He patiently took the time to listen to what I was looking for in terms of design and guided me through a selection without any rush or pressure. His knowledge about the materials, craftsmanship, and the jewellery-making process was impressive, and it helped me make a confident decision. Entire staff were friendly and provided great hospitality. And Mr. Nayeem ji, GM of the store is extremely humble and such a nice person. Their collection was exquisite and trendy. I would definitely visit again to shop.” Thank you once again, Mr. Yadav and Mr. Nayeem ji for your assistance, patience and integrity. You have set a high standard for what customer-service should be in the jewellery business. Looking forward for future purchases—and hoping that you’ll be there to assist. Warm regards, Sowmya Reddy",
      "date": "2025-10-30",
      "displayDate": "30 Oct 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0313",
      "name": "Jaya Raju",
      "rating": 5,
      "text": "People say this jewellery store offers a wide variety of unique and elegant designs including gold and silver, diamonds. I recently visited krishna jewellers sales executive Gururaj was very patient and helpful my purchase.thanks for krishna jewellers and my doctor features planning",
      "date": "2025-10-30",
      "displayDate": "30 Oct 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0314",
      "name": "Kavya Kummari",
      "rating": 4,
      "text": "Good service from PAVAN and the store nice collection in the gold & pearls,gems jewellery thankyou so much",
      "date": "2025-10-30",
      "displayDate": "30 Oct 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0315",
      "name": "Vijay Kumar",
      "rating": 5,
      "text": "I had a wonderful experience at Krishna Jewelers Pearl and Gems. Pavan was very patient, shared all product details and responded to every question. He was understanding during price discussions and made the whole buying process easy and comfortable. Thank you so much Pavan for your support.",
      "date": "2025-10-30",
      "displayDate": "30 Oct 2025",
      "relativeDate": "7 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0316",
      "name": "T M",
      "rating": 5,
      "text": "Great experience! The team at Krishna Jewellers is just amazing! I did a video call, and the whole experience was great! Satish was very responsive to all questions, prompt at shipping the item and follow ups to ensure best customer satisfaction! I will be buying more in the future!",
      "date": "2025-10-30",
      "displayDate": "30 Oct 2025",
      "relativeDate": "7 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0317",
      "name": "VEERENDRA veeren",
      "rating": 5,
      "text": "Had a wonderful experience at Krishna Jewellers! Special thanks to G.S. Yadav — he is the best person there. He patiently explained everything and helped me pick the perfect piece. Truly appreciate his service and professionalism!",
      "date": "2025-10-29",
      "displayDate": "29 Oct 2025",
      "relativeDate": "7 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0318",
      "name": "Vinutna Ch",
      "rating": 5,
      "text": "Love the shopping experience here always. They have wide range of collections. Ramadevi garu showed us with great patience. Looking forward to visit again.",
      "date": "2025-10-27",
      "displayDate": "27 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0319",
      "name": "srini capt",
      "rating": 5,
      "text": "Been a long day but satisfied and leaving with more jwellery than what we thought we'd find. Bheem, sandeep and swamy manager took us through the process patiently. Hospitality at best morning till we came out in the evening.",
      "date": "2025-10-26",
      "displayDate": "26 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0320",
      "name": "Uthra Thikshaja",
      "rating": 5,
      "text": "The shop has a wide selection of all products. Staff are very warm and friendly. We visited their pearl and silver section and they had an amazing collection. Praveen, our sales representative was very helpful and kind. Overall it was a very pleasant experience.",
      "date": "2025-10-25",
      "displayDate": "25 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0321",
      "name": "Ashita Kanna",
      "rating": 5,
      "text": "Rama Devi from Krishna Jewellers, the best sales person ever! Showed us the best Jewellery with extreme patience. She is the best Sales Person I have ever come across! Thank you Rama Devi Garu ❤️",
      "date": "2025-10-22",
      "displayDate": "22 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0322",
      "name": "Cooper 6777",
      "rating": 5,
      "text": "This Krishna jewellers has good jewellery collection and staff are good. Mainly Mahalaxmi garu helped us pick best necklace with her guidance. Thnq Krishna jewellers",
      "date": "2025-10-17",
      "displayDate": "17 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0323",
      "name": "Harini reddy Gaddam",
      "rating": 5,
      "text": "I had a very good experience with krishna jewellers.The collection is very good and staff receiving is also very nice.Mr.bharath helped us in selecting ornament by showing very patiently.overll the hospitality is very good . Thank you.",
      "date": "2025-10-16",
      "displayDate": "16 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0324",
      "name": "Netflix Gmail",
      "rating": 5,
      "text": "I recently visited Krishna Jewellers, and I had a wonderful experience! The store has a beautiful collection, and the service was excellent. Sai Kumar, the sales person who assisted me, was very patient, polite, and knowledgeable. He helped me find exactly what I was looking for and made the entire process smooth and pleasant. I’d definitely recommend Krishna Jewellers to anyone looking for quality jewellery and great customer service!",
      "date": "2025-10-16",
      "displayDate": "16 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0325",
      "name": "Narmada Manukonda",
      "rating": 5,
      "text": "Mr. Srikanth Reddy and Ms. Rekha served us and was very helpful and patient by accommodating our needs. For my online query, I got a quick response and provided with the information needed. I am very happy with the purchase and surely will be my future gold shopping store. Good hospitality as well. Thank you 😊 🙏.",
      "date": "2025-10-14",
      "displayDate": "14 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0326",
      "name": "sharmila adhikari",
      "rating": 5,
      "text": "I had a wonderful experience purchasing diamond jewelry at Krishna Jewelers Pearl and Gems online. Sai Reddy was very patient, shared all product details and pictures clearly and responded promptly to every question. He was understanding during price discussions and made the whole buying process easy and comfortable. The sales team sent detailed pictures (showing weight details), certifications, and bills of purchased products through WhatsApp and delivery was insured and prompt. I’m really happy with my purchase! The overall process was smooth and h ighly recommended!",
      "date": "2025-10-14",
      "displayDate": "14 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0327",
      "name": "batladinne saroja",
      "rating": 5,
      "text": "I had a great experience at krishna jewellery Rekha was really helpful and friendly. She took the time to show me different gold pieces and explained everything clearly. I ended up finding the perfect bangles..Highly recommend this shop and Rekha for great service..",
      "date": "2025-10-13",
      "displayDate": "13 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0328",
      "name": "Sruthi. Patibandla",
      "rating": 5,
      "text": "Excellent and wide collection. Pavani and Bheem assisted well with lot of patience. Great collection and Excellent service.",
      "date": "2025-10-12",
      "displayDate": "12 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0329",
      "name": "chandana makkapati",
      "rating": 5,
      "text": "Collection are very pretty design s are awesome we purchased vaddanam pavani and bheem very help full thank you",
      "date": "2025-10-12",
      "displayDate": "12 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0330",
      "name": "mounika poreddy",
      "rating": 5,
      "text": "Very nice collection they have and staff is really good and polite . Sunitha helped me to choose the good necklace with much patience thanks a lot and dinakar thanks for the latest exhibition updates and support",
      "date": "2025-10-11",
      "displayDate": "11 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0331",
      "name": "Spoorthi Samala",
      "rating": 5,
      "text": "Collection is good, service is also very nice. Pavani showed us all the collection and guided us. Overall good experience.",
      "date": "2025-10-08",
      "displayDate": "8 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0332",
      "name": "Sravani Reddy",
      "rating": 5,
      "text": "I have been visiting this store for over a year now, and I must say my experience has always been wonderful — all thanks to Rekha and Sandeep. Rekha has been consistently helping me with picking, finalizing, and following up on my jewellery orders. She is patient, attentive, and has a great sense of understanding. Despite there being many salespersons at the store, I always prefer going to her because she makes the entire shopping experience effortless and enjoyable. Sandeep has also been extremely helpful and professional whenever I needed assistance. Both of them truly stand out for their friendly attitude, attention to detail, and genuine care for customers. Thank you, Rekha and Sandeep, for making every visit such a pleasant one. You both are an asset to the store!",
      "date": "2025-10-06",
      "displayDate": "6 Oct 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0333",
      "name": "revathi rasamsetty",
      "rating": 5,
      "text": "They have very good and plenty of pearl collections . Ramesh sir helped us by addressing all our queries and providing best deal possible . Thank you so much !",
      "date": "2025-10-06",
      "displayDate": "6 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0334",
      "name": "Manda RISHIKA REDDY",
      "rating": 5,
      "text": "Gururaj has helped us show casing all the products with utmost patience. He gave a detailed breakdown of the pricing and gave us the best price possible.",
      "date": "2025-10-05",
      "displayDate": "5 Oct 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0335",
      "name": "Anil Kumar Patra",
      "rating": 4,
      "text": "I am very much happy with service by Sai Kumar. He gave the best experience with exchange. I was having some problems with valuation of item I bought 7 years back, but he handled with maturity, gave the best valuation. Thank you for service. When I will come again definitely reach out to Sai kumar.",
      "date": "2025-10-05",
      "displayDate": "5 Oct 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0336",
      "name": "Veeru",
      "rating": 5,
      "text": "I had a wonderful experience shopping at Krishna Jewellers.The showroom offers a wide variety of elegant and traditional designs that cater to all kinds of preferences. ✨ Special mention to Miss Sandhya, the sales executive, who made our visit truly pleasant. Her professionalism, patience, and deep knowledge of the jewellery collections stood out.Her courteous nature and genuine approach made the entire shopping experience smooth and enjoyable.",
      "date": "2025-09-30",
      "displayDate": "30 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0337",
      "name": "ganth kanth",
      "rating": 5,
      "text": "At Krishna pearls and Jewellers, the product quality and designs are very attractive, and the service is good. I'm very happy with their designs. I bought a gold chain, and the design and price are good when compared with other jewellery... Thank for help our gold purchase sandhya Rani garu",
      "date": "2025-09-30",
      "displayDate": "30 Sept 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0338",
      "name": "Veera Valli",
      "rating": 5,
      "text": "I recently visited krishna jewelry and had a truly delightful experience from the moment. The showroom had an impressive collection of jewellery, ranging from exquisite gold pieces to dazzling diamond set excellent Sales executive gururaj was very patient and helpful with my purchase.",
      "date": "2025-09-30",
      "displayDate": "30 Sept 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0339",
      "name": "Shravan Yerabati",
      "rating": 5,
      "text": "Krishna Jewellery provides an extensive selection of gold, silver, diamonds, and gems, always ensuring quality and trust. Their representatives are courteous, well-informed, and attentive to customer requirements. A special appreciation to Ms. Rekha, whose professionalism, product expertise, and customer-focused approach make her an asset to the brand.",
      "date": "2025-09-30",
      "displayDate": "30 Sept 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0340",
      "name": "Kothakonda Manjula",
      "rating": 5,
      "text": "Sarvesh good service",
      "date": "2025-09-30",
      "displayDate": "30 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0341",
      "name": "Keerthana Peddireddy",
      "rating": 5,
      "text": "I have seen a very good collection in Krishna jewellers when compared to other stores in the same area.I have bought a navaratna kanti here. The staff are also very friendly, especially Pavani , the one who showed us the jewellery is very good.",
      "date": "2025-09-29",
      "displayDate": "29 Sept 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0342",
      "name": "Divya Sumanth Reddy Anupalli",
      "rating": 5,
      "text": "Krishna Jewellery, a place to value for Items they provide to end customers, gold, silver, gems and diamonds. And their representative are very well groomed, knowledgeable on product to explain and deliver. Ms Kaliwalr Rekha she has very impressive , patience in listening to customer needs and good at Product knowledge, Depth on Product, and customer service.",
      "date": "2025-09-29",
      "displayDate": "29 Sept 2025",
      "relativeDate": "8 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0343",
      "name": "Lavanya Vanamala",
      "rating": 5,
      "text": "Good service Srikanth garu",
      "date": "2025-09-29",
      "displayDate": "29 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0344",
      "name": "Rajesh Gande",
      "rating": 5,
      "text": "Good Srikanth garu",
      "date": "2025-09-29",
      "displayDate": "29 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0345",
      "name": "Sai nath vale Sai nath vale",
      "rating": 5,
      "text": "Guru raj Good service",
      "date": "2025-09-29",
      "displayDate": "29 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0346",
      "name": "KAMALAPALLY RAJKUMAR",
      "rating": 5,
      "text": "Guru Raj good service",
      "date": "2025-09-29",
      "displayDate": "29 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0347",
      "name": "Kirti Biradar",
      "rating": 5,
      "text": "I had a wonderful experience at Krishna Jewellers, Jubilee Hills. The collection is beautiful, with a wide variety of unique and elegant designs. Special thanks to Bharat Sir, who assisted me with great patience and professionalism. He explained every detail clearly, gave me the best suggestions, and made the entire shopping experience smooth and pleasant. Truly appreciate his friendly nature and excellent customer service. I would highly recommend Krishna Jewellers and especially Bharat Sir for anyone looking for quality jewellery and a delightful shopping experience.",
      "date": "2025-09-28",
      "displayDate": "28 Sept 2025",
      "relativeDate": "9 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0348",
      "name": "likhitha kosuru",
      "rating": 4,
      "text": "Very happy with the service provided by Srikantha Designs are good but expecting more loght weight collections",
      "date": "2025-09-28",
      "displayDate": "28 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0349",
      "name": "Neelima Kadimi",
      "rating": 5,
      "text": "Excellent collection. Very patient and courteous staff, they were equally invested as we were in finding the right pieces as per our taste and requirement. Bharath and Sandeep were very helpful. Wide range of collection too.",
      "date": "2025-09-27",
      "displayDate": "27 Sept 2025",
      "relativeDate": "9 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0350",
      "name": "Rits M",
      "rating": 5,
      "text": "Great experience at the store. Govind was very patient and helpful, and his knowledge about different designs really stood out. U.Durga was very sweet and helpful too. B. Lakshmi & M. Raju also assisted well. Thanks to Govind and the team for making the process so smooth!",
      "date": "2025-09-27",
      "displayDate": "27 Sept 2025",
      "relativeDate": "9 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0351",
      "name": "Indian public",
      "rating": 5,
      "text": "Collection was to good I liked very much even I did shopping in short time sale's men Pawan was to good to show the collection",
      "date": "2025-09-27",
      "displayDate": "27 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0352",
      "name": "Saritha T",
      "rating": 5,
      "text": "We had a very great experience with Krishna jewellers . The team is very soft and very patient with the customers especially to highlight, Govind has understood the requirements of customer and then spent time in showing the beautiful sets which we were looking for .thanks Govind ..",
      "date": "2025-09-27",
      "displayDate": "27 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0353",
      "name": "Shona Nivedita Chakravarti",
      "rating": 5,
      "text": "Mr.Krishna and his colleagues ensured that I was able to select some peal designs and have them delivered for a last minute baby shower present (despite the rain) and the whole process took less than 30 mins; grateful for The kindness, excellent product and ofcourse excellent packaging and behaviour.",
      "date": "2025-09-27",
      "displayDate": "27 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "gifting"
      ]
    },
    {
      "id": "stream-0354",
      "name": "priyanka janapati",
      "rating": 4,
      "text": "We have purchased diamond jewellery recently, quality and service is top-notch. I would highly recommend to purchase in this shop",
      "date": "2025-09-27",
      "displayDate": "27 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0355",
      "name": "kondaveeti sai prasanna",
      "rating": 5,
      "text": "We saw a wide and unique collection of gold necklaces. Yadav patiently showed us the entire collection and explained everything very clearly. Highly recommended.",
      "date": "2025-09-25",
      "displayDate": "25 Sept 2025",
      "relativeDate": "9 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0356",
      "name": "Dinesh Dinesh",
      "rating": 5,
      "text": "The ambiance of the shop was welcoming, neat, and well-organized, making it easy to browse comfortably. They also offered customization services, which is perfect for anyone looking for something special and personal.",
      "date": "2025-09-24",
      "displayDate": "24 Sept 2025",
      "relativeDate": "9 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0357",
      "name": "datta laake",
      "rating": 5,
      "text": "A delightful visit and such a wealth of jewelry available. Pavan kumar provided outstanding service and helped me select a simple yet elegant bracelet and ring that will help make my memories wonderful!❣️ You will enjoy your time spent at this business and find something perfect for you!!💫 He is an amazing nothing is too much trouble.🫰🏽 Thank you🥰",
      "date": "2025-09-24",
      "displayDate": "24 Sept 2025",
      "relativeDate": "9 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0358",
      "name": "Pradeep Ek",
      "rating": 5,
      "text": "Authentic shop hyderabad pearls Ambience, service, choices are too good",
      "date": "2025-09-20",
      "displayDate": "20 Sept 2025",
      "relativeDate": "9 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0359",
      "name": "Naga Lakshmi",
      "rating": 5,
      "text": "Ramadevi nice service",
      "date": "2025-09-20",
      "displayDate": "20 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0360",
      "name": "D BHAVANI",
      "rating": 5,
      "text": "I am extremely thankful to Meenakshi madam for her wonderful guidance in helping me choose my diamond long haram and earrings. With her patience and support, I was able to explore almost all price ranges in the store and finally select the pieces that suit me the best. A special thanks to Nayeem sir for his immense help with the calculations, and once again to Meenakshi madam for clearly explaining them to me. With their dedicated support, I was able to purchase my entire diamond set from Krishna Jewellers. Both of them went above and beyond to make this experience memorable and truly special in my life. I sincerely thank Nayeem sir and Meenakshi madam once again for helping me choose the best jewellery.",
      "date": "2025-09-16",
      "displayDate": "16 Sept 2025",
      "relativeDate": "9 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0361",
      "name": "Roque Soares",
      "rating": 5,
      "text": "We had a very good experience at the store. Good staff and a great variety in ornaments and designs. Bheem assisted us in doing our purchases. He is a very good salesman",
      "date": "2025-09-16",
      "displayDate": "16 Sept 2025",
      "relativeDate": "9 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0362",
      "name": "Sandhya Reddie",
      "rating": 4,
      "text": "Staff is very kind and good. Srilakshmi showed everything with utmost patience",
      "date": "2025-09-13",
      "displayDate": "13 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0363",
      "name": "Shailu Reddy",
      "rating": 4,
      "text": "Very good service given by Pavani",
      "date": "2025-09-11",
      "displayDate": "11 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0364",
      "name": "Harika Jetti",
      "rating": 5,
      "text": "I had a wonderful experience shopping here for all my wedding jewelry. They have a huge collection and showed me so many beautiful pieces with great patience. Special thanks to Srikanth who helped me throughout and guided me very well. The staff is very polite and made the whole process easy and comfortable. Excellent service and great quality jewels. Highly recommend this shop for anyone looking for wedding jewelry.",
      "date": "2025-09-09",
      "displayDate": "9 Sept 2025",
      "relativeDate": "9 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0365",
      "name": "supriya Chiranjeevi",
      "rating": 5,
      "text": "R.Satheesh",
      "date": "2025-09-03",
      "displayDate": "3 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0366",
      "name": "Srija Dharmapuri",
      "rating": 5,
      "text": "Krishna Jewellers Pearls and Gems, Jubilee Hills, has a truly beautiful collection with a wide range of unique pieces that feel like they’re made just for you. The designs are elegant and crafted with remarkable attention to detail. The shop is welcoming, well-organized, and reflects the same elegance as its jewellery. I highly recommend it to anyone looking for something timeless and exclusive.😊",
      "date": "2025-09-01",
      "displayDate": "1 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0367",
      "name": "Galipally Naveenkumar",
      "rating": 5,
      "text": "Good service sarvesh",
      "date": "2025-09-01",
      "displayDate": "1 Sept 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0368",
      "name": "Annnit",
      "rating": 5,
      "text": "Staff Kashinath and Ramesh are patient and friendly. Have a good time here",
      "date": "2025-08-29",
      "displayDate": "29 Aug 2025",
      "relativeDate": "9 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "stream-0369",
      "name": "Rithika Erumadi",
      "rating": 5,
      "text": "I had an amazing experience purchasing jewelry here! Rama provided absolutely outstanding service — patient, knowledgeable, and so friendly. She helped me find exactly what I was looking for and made the whole process smooth and enjoyable. The jewelry quality is stunning, and I really appreciate the care and attention Rama gave me. I’ll definitely be coming back and highly recommend this store to anyone looking for both beautiful pieces and excellent service. 💎✨",
      "date": "2025-08-24",
      "displayDate": "24 Aug 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0370",
      "name": "Giridharbabu Vemuri",
      "rating": 5,
      "text": "Ms. Sunita is an active rep. From your show room. I am very much happy with her behaviour and patience.",
      "date": "2025-08-24",
      "displayDate": "24 Aug 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0371",
      "name": "Kavitha Rajashekaran",
      "rating": 5,
      "text": "Sales person-Mohan,Helper- Ravi, Patwa- Sudheer & Durgesh - they had explained very well",
      "date": "2025-08-23",
      "displayDate": "23 Aug 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0372",
      "name": "KENAZGLOBAL",
      "rating": 5,
      "text": "Always loved shopping here. Went for shopping this evening for some Jewellery. I am glad! Mr. Ramesh had been very nice, cooperative. Thank you so much!! Shall visit again.",
      "date": "2025-08-22",
      "displayDate": "22 Aug 2025",
      "relativeDate": "10 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0373",
      "name": "kanduru spandana",
      "rating": 5,
      "text": "Pavani : collection isGood 😊",
      "date": "2025-08-22",
      "displayDate": "22 Aug 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0374",
      "name": "Manonmai",
      "rating": 4,
      "text": "Shopped at Krishna jewellers. The collection is amazing. Bharath has been very patient and supportive in assisting us. Would love to comeback to shop more",
      "date": "2025-08-19",
      "displayDate": "19 Aug 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0375",
      "name": "E Elamathi",
      "rating": 5,
      "text": "I am from Singapore and have been a loyal customer of Krishna Silver Shop for the past two years. This is my second time placing an order through a video call, and I must say the experience was again excellent. The customer service was outstanding, and I truly appreciate Ms. Rashitha's sense of responsibility and dedication. Her support made the entire process smooth and satisfying. I look forward to exploring and purchasing more of your beautiful collections. Thank you so much for your accountability and exceptional service!",
      "date": "2025-08-06",
      "displayDate": "6 Aug 2025",
      "relativeDate": "10 months ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0376",
      "name": "Kabothu Mani Mohan",
      "rating": 5,
      "text": "I had a wonderful experience at Krishna jewellers pearls and gems.The store has a beautiful and welcoming ambience that makes shopping a delight. The product collection is impressive with a wide variety of elegant designs to choose from. A special thanks to Chandu for their exceptional service, he was extremely patient, knowledgeable, and made sure I was comfortable throughout the process. He guided me through the selections and handled the entire billing smoothly. Truly great customer service and a memorable shopping experience",
      "date": "2025-07-31",
      "displayDate": "31 Jul 2025",
      "relativeDate": "10 months ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0377",
      "name": "Payal Verma",
      "rating": 5,
      "text": "Yaha ka collection bohot acha he or Mr Bharat ne bohot help ki or politely samjhaya ..",
      "date": "2025-07-31",
      "displayDate": "31 Jul 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0378",
      "name": "Narendra babu",
      "rating": 5,
      "text": "Excellent service by Sri Sarvesh,Smt.Ramadevi,Sri.Praveen",
      "date": "2025-07-31",
      "displayDate": "31 Jul 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0379",
      "name": "Eeshika Gorthi",
      "rating": 5,
      "text": "R. Satheesh",
      "date": "2025-07-23",
      "displayDate": "23 Jul 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0380",
      "name": "A.Rajendraprasad Reddy",
      "rating": 4,
      "text": "Good experience ... Sathish explained well ...",
      "date": "2025-07-18",
      "displayDate": "18 Jul 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0381",
      "name": "Urmila Jadhav",
      "rating": 4,
      "text": "Visited Krishna Jewellers Pearls and Gems recently, and we were impressed with their wide variety of pearls and diamond collections. Pawan assisted us patiently, explained the designs clearly, and guided us to choose a beautiful set within our budget.",
      "date": "2025-06-30",
      "displayDate": "30 Jun 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0382",
      "name": "Rekha Jadhav",
      "rating": 4,
      "text": "We had a wonderful shopping experience at Krishna Jewellers Pearls and Gems. Pawan was very patient and showed us many beautiful collections until we found what we liked.",
      "date": "2025-06-30",
      "displayDate": "30 Jun 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0383",
      "name": "Girish Kumar",
      "rating": 5,
      "text": "Sai Kumar.",
      "date": "2025-06-28",
      "displayDate": "28 Jun 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0384",
      "name": "Vagdevi G",
      "rating": 5,
      "text": "Very good designs and very good service. We have been shopping at Krishna for a few years now both in person and virtually and have always had exceptional experience with their team and smooth transaction with transparency. Coming to our sales person- Rekha is so sweet and very patient and thorough in what she does. Thank you Rekha for helping me and taking my countless calls and responding to my any message I send.",
      "date": "2025-06-27",
      "displayDate": "27 Jun 2025",
      "relativeDate": "Edited a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0385",
      "name": "Niranjan Velagapudi",
      "rating": 5,
      "text": "Your employee Rama Devi service is exceptional. Every time we come here we prefer her because she is very knowledgeable and takes time to make customer comfortable. I give five stars for her heartfelt care and service.",
      "date": "2025-06-25",
      "displayDate": "25 Jun 2025",
      "relativeDate": "a year ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0386",
      "name": "Sunil Dusa",
      "rating": 4,
      "text": "Sales Representative Mrs. Meenskshi has shown excellent customer service.",
      "date": "2025-06-14",
      "displayDate": "14 Jun 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0387",
      "name": "kalyani Naramsetty",
      "rating": 5,
      "text": "Visited krishna jewellers in Kokapet and Jubilee hills branch for the first time. They have very beautiful and many collections in Diamond Jewellery. Very happy with my decision of taking diamond jewellery here. Also the staff are very polite. Beautiful stores in ambience too. Thank you Krishna jewelllers. Regards, Kalyani",
      "date": "2025-06-13",
      "displayDate": "13 Jun 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0388",
      "name": "neloufer ali",
      "rating": 5,
      "text": "We find kashinath most helpful and hospitable we keep coming here for him. Collection is good.",
      "date": "2025-06-10",
      "displayDate": "10 Jun 2025",
      "relativeDate": "a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0389",
      "name": "Shruti",
      "rating": 5,
      "text": "Absolutely loved my experience at this jewellery store! The designs are incredibly beautiful, elegant, and thoughtfully crafted — perfect for both special occasions and everyday wear. Each piece reflects attention to detail and traditional charm with a modern touch. A special mention to Pawan, our sales executive, who was extremely patient, knowledgeable, and helpful throughout. He took the time to understand what we were looking for and showed us a wide range of options without ever rushing us. His insights and suggestions made the entire process smooth and enjoyable. Truly appreciate the hospitality and professionalism. Highly recommend visiting if you’re looking for timeless and tasteful jewellery!",
      "date": "2025-06-01",
      "displayDate": "1 Jun 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0390",
      "name": "Moram Rajeev",
      "rating": 4,
      "text": "It’s really great . Krishna has showed everything with lot of patience",
      "date": "2025-05-30",
      "displayDate": "30 May 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0391",
      "name": "Sadhana V",
      "rating": 5,
      "text": "I had a great experience at this jewelry shop! I really liked the beautiful and unique designs they offer, and they even have models available to help visualize how the pieces look when worn. Sai Kumar who helped me was extremely patient and very helpful throughout the process. Highly recommend for anyone looking for quality jewelry and excellent customer service!",
      "date": "2025-05-28",
      "displayDate": "28 May 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0392",
      "name": "SAHITYA VEMPATI",
      "rating": 5,
      "text": "This is the first time i have visited Krishna jeweller's, The collection was fantastic and the staff Sunitha is very kind and showing wide variety of models till we satisfied. We are so happy with the item we have purchased highly recommend for brides.",
      "date": "2025-05-27",
      "displayDate": "27 May 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0393",
      "name": "Maha Lakshmi",
      "rating": 4,
      "text": "I purchased silver Amman idol online. Mr Satish coordinated well from purchase to deliver. I am very much satisfied with his polite and prompt support.",
      "date": "2025-05-27",
      "displayDate": "27 May 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0394",
      "name": "Gnan",
      "rating": 5,
      "text": "I had a great experience at Krishna Jewellers. Their collection is beautiful and offers a wide range of designs to choose from. A special thanks to Mr.Yadav, who was very helpful and patient in showing me the designs and helping me pick the perfect piece. Highly recommend visiting if you're looking for quality and elegant jewellery!",
      "date": "2025-05-23",
      "displayDate": "23 May 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0395",
      "name": "Dr Srujana GopiReddy",
      "rating": 4,
      "text": "Received by Sandhya Rani… service is good",
      "date": "2025-05-18",
      "displayDate": "18 May 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0396",
      "name": "Vamsi Krishna",
      "rating": 5,
      "text": "I recently visited Krishna jewellery and had a truly delightful experience. From the moment I stepped in, the ambience was elegant, well-lit, and inviting. The showroom had an impressive collection of jewellery, ranging from exquisite gold pieces to dazzling diamond sets. One of the standout aspects of my visit was the excellent service provided by Pavani. They were not only knowledgeable but also incredibly patient, helping me navigate various designs and suggesting pieces that suited my preferences. Their attention to detail and understanding of jewellery craftsmanship added immense value to the experience. Whether you're looking for a statement piece or a timeless classic, Krishna jewellery is the perfect destination. The quality of their jewellery, combined with the courteous service of their representatives, makes shopping here a pleasure. Highly recommended!",
      "date": "2025-05-15",
      "displayDate": "15 May 2025",
      "relativeDate": "a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0397",
      "name": "Seshan K",
      "rating": 5,
      "text": "Sainath, good customer service.",
      "date": "2025-05-14",
      "displayDate": "14 May 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0398",
      "name": "Laavanya Rs",
      "rating": 5,
      "text": "Had a wonderful time shopping here. They have great collection. Sales executive Radha was very patient and helpful with my purchase. Would recommend this store 10/10",
      "date": "2025-05-02",
      "displayDate": "2 May 2025",
      "relativeDate": "a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0399",
      "name": "Noopur Bhalchandra",
      "rating": 5,
      "text": "I ordered a custom jaladhari for Narmadeshwar linga and they did a really great job just from the pictures I sent for reference. Pooja from their team helped make the process smooth. Really happy with the product. I am a returning customer and I highly recommend them.",
      "date": "2025-04-18",
      "displayDate": "18 Apr 2025",
      "relativeDate": "a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0400",
      "name": "kiran mayi",
      "rating": 5,
      "text": "I bought silver pooja items here and had a wonderful experience. Rajalakshmi was extremely friendly and patient, taking the time to show all their collections without any hurry. . The collection is beautifully curated.Highly recommend this store for anyone looking for quality silver jewelry and excellent customer service!",
      "date": "2025-04-07",
      "displayDate": "7 Apr 2025",
      "relativeDate": "a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0401",
      "name": "VC Attota",
      "rating": 5,
      "text": "I loved complete online purchasing experience from showing to receiving international order from Krishna Jewellers. Thank you sai reddy garu for the seamless experience and your time provided throughout the journey. Thank you Srikanth garu - sales man at shop showing all necessary ornaments online with so much patience as sporadically demanded by my family. -VC Attota",
      "date": "2025-03-25",
      "displayDate": "25 Mar 2025",
      "relativeDate": "Edited a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0402",
      "name": "Pruthvi Raj",
      "rating": 5,
      "text": "It was a very good experience in Krishna jewellers in jubilee hills staff was very friendly specially priya garu who helped us throughout our shopping",
      "date": "2025-03-16",
      "displayDate": "16 Mar 2025",
      "relativeDate": "a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "stream-0403",
      "name": "papineni swathi",
      "rating": 5,
      "text": "Ramadevi",
      "date": "2025-03-16",
      "displayDate": "16 Mar 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0404",
      "name": "Shruthi Keerthana Reddy",
      "rating": 5,
      "text": "Excellent Bheem",
      "date": "2025-03-07",
      "displayDate": "7 Mar 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0405",
      "name": "bharathi byrisetti",
      "rating": 5,
      "text": "Ramadevi helping very nice",
      "date": "2025-02-27",
      "displayDate": "27 Feb 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0406",
      "name": "Preethi Reddy Chinchoud",
      "rating": 5,
      "text": "Sai Reddy and Srikanth helped me pick my jewelry. I am happy with my purchase and want to thank for their service. They patiently responded to all my questions. I wanted to experience buying jewelry online and get it shipped internationally. They are well experienced and made the process easy for me. I would definitely buy more in future. Thank you and keep up the good work 🙂 -Preethi Reddy Chinchoud",
      "date": "2025-02-19",
      "displayDate": "19 Feb 2025",
      "relativeDate": "a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0407",
      "name": "sri charan beeraka",
      "rating": 4,
      "text": "They have good collections, and Sunita the representative was good and dealt us with good care and offered us good discounts",
      "date": "2025-02-15",
      "displayDate": "15 Feb 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0408",
      "name": "Prabhavathi A",
      "rating": 5,
      "text": "Pavani Collection very good",
      "date": "2025-02-06",
      "displayDate": "6 Feb 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0409",
      "name": "Vakshika .M",
      "rating": 4,
      "text": "I had a great experience at Krishna Jewellers. The models are unique, and Yadav was very patient.",
      "date": "2025-02-06",
      "displayDate": "6 Feb 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0410",
      "name": "Sujatha G",
      "rating": 5,
      "text": "Ramya Pavani helped with the products I purchased today. Excellent service and top-quality gold! The transaction was smooth, secure, and delivered on time. Their professionalism and honesty made the experience outstanding. Highly recommend!",
      "date": "2025-01-25",
      "displayDate": "25 Jan 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0411",
      "name": "Sunitha Veerayyagari",
      "rating": 5,
      "text": "Amazing products and amazing service. Bheem garu, sai nitin garu and Lavanya garu were very helpful.",
      "date": "2025-01-25",
      "displayDate": "25 Jan 2025",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0412",
      "name": "vignesh v",
      "rating": 1,
      "text": "Yesterday I bought this from Krishna pearls, Novotel branch. (HSN code:711311, invoice no:198) Today it's gone. Didn't even used it once, very disappointed with product quality.I lost the trust with Krishna pearls. My mom is unhappy and now I'm also upset. First time I am giving 1 star rating in my google review. Don't trust this kind of brand just for name sick, be careful with products. After 10 days Last 10 days I am trying to change the product but there is no proper response from them. Daily I am wasting my time with them. I realised my Big Mistake.",
      "date": "2025-01-22",
      "displayDate": "22 Jan 2025",
      "relativeDate": "Edited a year ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0413",
      "name": "Haritha Gundeboyina",
      "rating": 5,
      "text": "Bought ananthapadbanabha swamy idol, minute detailed of the idol were so keen well carved and very impressive and the idol is too good for its price was so pleased with the product",
      "date": "2024-12-11",
      "displayDate": "11 Dec 2024",
      "relativeDate": "a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "stream-0414",
      "name": "haritha sri sai",
      "rating": 4,
      "text": "Had good experience shopping at Krishna jewellers. The staff member who assisted was Loknath. He was very good in providing all the details and had honest conversation.",
      "date": "2024-12-02",
      "displayDate": "2 Dec 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0415",
      "name": "Hanish Banala",
      "rating": 5,
      "text": "Great service loved the collection thanks to Ramadevi garu",
      "date": "2024-12-01",
      "displayDate": "1 Dec 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0416",
      "name": "kalyan kumar",
      "rating": 4,
      "text": "Great collection and Amazing staff support in showing different models as per our taste and budget especially from Ramadevi garu",
      "date": "2024-11-30",
      "displayDate": "30 Nov 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0417",
      "name": "Shakti Samanta",
      "rating": 4,
      "text": "The experience with the store was very good. Mr Pasha and staff helped us to display multiple products with patience",
      "date": "2024-11-21",
      "displayDate": "21 Nov 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0418",
      "name": "Avanthi Reddy Gutha",
      "rating": 4,
      "text": "Great collection and elegant designs. Good service",
      "date": "2024-11-14",
      "displayDate": "14 Nov 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0419",
      "name": "Sangeeta Yadav",
      "rating": 5,
      "text": "\"I recently purchased a stunning pearl set from Krishna Jewellers Pearls and Gems in Hyderabad, and I am absolutely delighted! The craftsmanship is exquisite, and the pearls are of exceptional quality. The team's service was wonderful, offering a smooth and enjoyable shopping experience. Highly recommend this place for anyone looking for beautiful jewelry and excellent customer service!\"",
      "date": "2024-09-26",
      "displayDate": "26 Sept 2024",
      "relativeDate": "a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0420",
      "name": "Bhargava Padmala",
      "rating": 5,
      "text": "Dedicated staff Thank you Krishna Pearls Bhavani garu and Rajkumar garu",
      "date": "2024-09-16",
      "displayDate": "16 Sept 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0421",
      "name": "Sreedevi T",
      "rating": 5,
      "text": "Hi I was looking for diamond haram and visited the shop. I was assisted by Shivaji. He showed me wide collections. I shortlisted couple of them and left. I only got back to them after few weeks. Shivaji patiently waited and answered all the queries and offered competitive pricing. Very very good sales person. He also helped with the customisation of the jewel The shop had such a wide and impressive collection. Lavanya also helped with the lots of haram try with a smile and some genuine feedback Over all happy customer with a beautiful haram in my collection",
      "date": "2024-09-15",
      "displayDate": "15 Sept 2024",
      "relativeDate": "a year ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0422",
      "name": "Pranjal Baruah",
      "rating": 5,
      "text": "I would like to share my genuine review and experience in this shop . First and foremost I would like to Thank Mr Rajkumar for explaining the details about pearls its shape, size, and colour . I had a very good experience and ended up not one , two but three sets of jewellery.",
      "date": "2024-08-04",
      "displayDate": "4 Aug 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "photo",
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0423",
      "name": "Sudha Rudraiah",
      "rating": 4,
      "text": "Dropped into the store as I happened to be in the city for other reasons an da friend had spoken of it! Found vast collections which were beautiful, was attended by a very courteous staff and they even couriered the item to my hometown! A great shopping place, especially for weddings!",
      "date": "2024-07-30",
      "displayDate": "30 Jul 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0424",
      "name": "Sonali Gupta",
      "rating": 5,
      "text": "I recently purchased the silver parrot statue and am delighted with its craftsmanship. The detailing is exquisite, capturing the beauty and grace of a parrot in silver form. It makes for a striking addition to my home decor, sitting elegantly on my shelf. The silver finish gleams under the light, adding a touch of sophistication.\"",
      "date": "2024-07-20",
      "displayDate": "20 Jul 2024",
      "relativeDate": "a year ago",
      "source": "KJ reviews .xlsx + Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery"
      ]
    },
    {
      "id": "stream-0425",
      "name": "MVP VEERENDRA",
      "rating": 4,
      "text": "Nice collections..good communication with Mr.Mallikarjun",
      "date": "2024-07-06",
      "displayDate": "6 Jul 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0426",
      "name": "Hindu Priya",
      "rating": 5,
      "text": "Mr loknath sir thanku. We are satisfied",
      "date": "2024-07-03",
      "displayDate": "3 Jul 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0427",
      "name": "Chaitanyaa Finetech",
      "rating": 5,
      "text": "M.SUNITHA",
      "date": "2024-07-03",
      "displayDate": "3 Jul 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0428",
      "name": "KONERU NIHEETH",
      "rating": 5,
      "text": "Fast proceedings from Mallikarjun garu.",
      "date": "2024-07-02",
      "displayDate": "2 Jul 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0429",
      "name": "Pravalika Dondapati",
      "rating": 4,
      "text": "I have visited Krishna jewellery at Jubilee Hills.there assistant Pavani.she has shown us nicely and jewellery was so nice",
      "date": "2024-05-09",
      "displayDate": "9 May 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0430",
      "name": "ASHISH GOEL",
      "rating": 4,
      "text": "Pathetic service...they just like to keep customer waiting for billing and all Edit: So this is my second review about Krishna jewellers...initially I was highly disappointed but later Mr Rohit from Krishna jewellers really helped me out and he really understands the value of customer satisfaction...thumbs up!",
      "date": "2024-05-07",
      "displayDate": "7 May 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0431",
      "name": "Swetha V",
      "rating": 4,
      "text": "The collection is awesome.sravan salesman is extremely good,very patient and humble.very nice collection.",
      "date": "2024-04-17",
      "displayDate": "17 Apr 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0432",
      "name": "Charishma reddy",
      "rating": 4,
      "text": "Collection was too good I liked very much .even I did shopping with in hour .sale men shivaji was too good in showing the Collection.",
      "date": "2024-03-29",
      "displayDate": "29 Mar 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0433",
      "name": "Leela Donthineni",
      "rating": 5,
      "text": "Bharath Chandra giri బాగా ఓపిక గా చూపించారు good service",
      "date": "2024-03-27",
      "displayDate": "27 Mar 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0434",
      "name": "naveen vazeer",
      "rating": 5,
      "text": "good sales women sandaya rani",
      "date": "2024-03-12",
      "displayDate": "12 Mar 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0435",
      "name": "kiran kumar",
      "rating": 4,
      "text": "Executive priya is so friendly and patiently shown lot of designs",
      "date": "2024-03-11",
      "displayDate": "11 Mar 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0436",
      "name": "Jagruthi Kappala",
      "rating": 5,
      "text": "They have amazing deep nakshi jewelry designs. We went there to purchase bangles, and they had some amazing designs. Naga sai helped us with the whole process, Would definitely recommend Krishna jewellers",
      "date": "2024-03-04",
      "displayDate": "4 Mar 2024",
      "relativeDate": "2 years ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0437",
      "name": "Sirisha Sanagala",
      "rating": 4,
      "text": "Good showroom with huge collection. Excellent customer service by MR. Guravaiah, he is very patient and understands customer requirements to show interested models.",
      "date": "2024-03-03",
      "displayDate": "3 Mar 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0438",
      "name": "Madhuri K",
      "rating": 5,
      "text": "Suraj Kumar",
      "date": "2024-03-02",
      "displayDate": "2 Mar 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0439",
      "name": "K M",
      "rating": 4,
      "text": "Vide variety of products. Priya dealt with us and was good in communication and convincing.",
      "date": "2024-03-01",
      "displayDate": "1 Mar 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0440",
      "name": "Kavitha Guddeti",
      "rating": 5,
      "text": "Good Naga Sai",
      "date": "2024-02-27",
      "displayDate": "27 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0441",
      "name": "anchal sahni",
      "rating": 4,
      "text": "While I had a bad online experience with Krishna Pearls, one of their employee, Neelam helped in getting my query resolved with proper professionalism & kept me updated everyday. My order was returned a month ago & I wasn’t getting any proper help until Neelam got involved & helped in getting my refund sorted. He is an asset to Krishna Pearls. Thankyou Neelam for your support!",
      "date": "2024-02-27",
      "displayDate": "27 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0442",
      "name": "Sree V",
      "rating": 5,
      "text": "Pavani excellent service",
      "date": "2024-02-23",
      "displayDate": "23 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0443",
      "name": "Sreedevi Gudapareddy",
      "rating": 5,
      "text": "రమాదేవి good service",
      "date": "2024-02-22",
      "displayDate": "22 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0444",
      "name": "Shruthi Karunanithi",
      "rating": 4,
      "text": "I liked the ring models and the person Kushal showed us good models and was satisfied.",
      "date": "2024-02-14",
      "displayDate": "14 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0445",
      "name": "sanjana reddy",
      "rating": 5,
      "text": "Mallikarjuna",
      "date": "2024-02-13",
      "displayDate": "13 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0446",
      "name": "Rajashekar Surabi",
      "rating": 5,
      "text": "Pavani ,Sarvice and caring was very good 👍",
      "date": "2024-02-11",
      "displayDate": "11 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0447",
      "name": "Pallavi sekar Reddy",
      "rating": 4,
      "text": "Impressed with various and unique jewellery designs in insta and facebooks posts by Krishna Jewellers Pearls and Gems, I made up my mind to purchase a diamond set . Connected with the staff especially Guruvaiah over the phone . They are really friendly . The process of placing order over the phone until delivery to home was very smooth .A first deal with them and my experience is completely good. Quite happy with the product and the service",
      "date": "2024-02-06",
      "displayDate": "6 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0448",
      "name": "Venkata Narasimha Reddy Guduru",
      "rating": 4,
      "text": "They have a very good collection of ornaments. The atmosphere is very nice and Mr. Mallikharjuna has provided a good service. Would definitely recommend this to people.",
      "date": "2024-02-04",
      "displayDate": "4 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0449",
      "name": "uzma oshin konduru",
      "rating": 4,
      "text": "I liked the store especially the detailing and finishing of each ornament.Mallikarjuna is very cooperative and friendly.nice shopping",
      "date": "2024-02-03",
      "displayDate": "3 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0450",
      "name": "Nandini6",
      "rating": 5,
      "text": "Great salesmen mallikarjun",
      "date": "2024-02-02",
      "displayDate": "2 Feb 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0451",
      "name": "manu upadhayay",
      "rating": 5,
      "text": "Ramya pavani and prakash are good sales person",
      "date": "2024-01-28",
      "displayDate": "28 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0452",
      "name": "bv v",
      "rating": 5,
      "text": "Mallika dhuna is best sales man",
      "date": "2024-01-27",
      "displayDate": "27 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "stream-0453",
      "name": "Padma priya Mente",
      "rating": 5,
      "text": "Good products and latest collections At annanda inn convention hall in bhimavaram Nice staff Mr ratna raju gari assisted well",
      "date": "2024-01-26",
      "displayDate": "26 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0454",
      "name": "usha namburi",
      "rating": 5,
      "text": "Namdev more Nice calashion super shoping",
      "date": "2024-01-26",
      "displayDate": "26 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0455",
      "name": "Umapurna Manthena",
      "rating": 5,
      "text": "Nam dev , Rahul explanation.good",
      "date": "2024-01-26",
      "displayDate": "26 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0456",
      "name": "Swathi",
      "rating": 4,
      "text": "The collection was good. More of traditional varieties. Could include more fancy and daily wear items. Thankyou Somesh garu",
      "date": "2024-01-26",
      "displayDate": "26 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0457",
      "name": "SUNITHA V",
      "rating": 5,
      "text": "nyc collection..workmanship was good. tx to ramakanth garu",
      "date": "2024-01-25",
      "displayDate": "25 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0458",
      "name": "PRASUNA",
      "rating": 5,
      "text": "Very nice collection Ratna Raj and somesh gave good service in vishakapatnam exhibition in fortune sreekanya",
      "date": "2024-01-21",
      "displayDate": "21 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0459",
      "name": "Bhargavi Reddy",
      "rating": 5,
      "text": "Tirupati-Namdev",
      "date": "2024-01-06",
      "displayDate": "6 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0460",
      "name": "amrutha sadu",
      "rating": 4,
      "text": "Hi,,I am purchasing a pair of antique bangles, Mr Namdev explained properly 👌,,nice gesture by all staff",
      "date": "2024-01-06",
      "displayDate": "6 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0461",
      "name": "Nagamani reddy",
      "rating": 5,
      "text": "Good collection Thanks to namdev -tirupati",
      "date": "2024-01-05",
      "displayDate": "5 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0462",
      "name": "Marisetty Kushalini",
      "rating": 4,
      "text": "Namdev at Tirupati was very patient and did a great job.",
      "date": "2024-01-05",
      "displayDate": "5 Jan 2024",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0463",
      "name": "padma alla",
      "rating": 5,
      "text": "Good కలెక్షన్ బై కృష్ణ జ్యువలరీ అత్త vijayawada నోవాటల్ ఎక్సభిషన్ good రెస్పాన్స్ ఫ్రొం అల్ స్టాఫ్",
      "date": "2023-12-24",
      "displayDate": "24 Dec 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0464",
      "name": "Sireesha Tailam",
      "rating": 5,
      "text": "Loknath",
      "date": "2023-12-18",
      "displayDate": "18 Dec 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0465",
      "name": "devi Lavanyad",
      "rating": 4,
      "text": "We want to have your elegant collections of different kinds in Gold ,silver n pearls to be in banglore as we are fond of your great n unique collection.",
      "date": "2023-12-16",
      "displayDate": "16 Dec 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0466",
      "name": "Bhagyasri Karni",
      "rating": 5,
      "text": "Lokhnath",
      "date": "2023-12-15",
      "displayDate": "15 Dec 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0467",
      "name": "Saritha GV",
      "rating": 4,
      "text": "Excellent collection...good service by mallikarjuna/shiva kumar but takes lot of time for billing process",
      "date": "2023-12-13",
      "displayDate": "13 Dec 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0468",
      "name": "Ch madhulatha",
      "rating": 5,
      "text": "Great service mallikarjun",
      "date": "2023-12-12",
      "displayDate": "12 Dec 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0469",
      "name": "Uma Devi",
      "rating": 5,
      "text": "Mallikarjun good talking",
      "date": "2023-12-05",
      "displayDate": "5 Dec 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0470",
      "name": "ksai virinchi",
      "rating": 4,
      "text": "Amazing experience. There were variety of designs to choose from and swamy guided us very well throughout our shopping experience",
      "date": "2023-11-18",
      "displayDate": "18 Nov 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0471",
      "name": "Banothu harichandana",
      "rating": 5,
      "text": "Very good - Ramya pavani",
      "date": "2023-10-01",
      "displayDate": "1 Oct 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0472",
      "name": "Nareshnrnrnr Nareshnrnrnr",
      "rating": 5,
      "text": "Nagarjuna good survice",
      "date": "2023-08-21",
      "displayDate": "21 Aug 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0473",
      "name": "mounika bobburi",
      "rating": 4,
      "text": "Mallikarjun is the concern sales person here is patient explaining all the designs. I hope they come up with more simple wear jewellary for the daily use.",
      "date": "2023-08-19",
      "displayDate": "19 Aug 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0474",
      "name": "chandrika chandu",
      "rating": 4,
      "text": "Good experience at krishna jewellers. Staff is helpful and polite, thanks to Mr. Mallikarjun.",
      "date": "2023-08-19",
      "displayDate": "19 Aug 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0475",
      "name": "prasad naik",
      "rating": 5,
      "text": "Great service mallikarjun",
      "date": "2023-08-03",
      "displayDate": "3 Aug 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0476",
      "name": "G.Prabhaker Reddy",
      "rating": 5,
      "text": "PAVANI Happy Shopping",
      "date": "2023-07-30",
      "displayDate": "30 Jul 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0477",
      "name": "roja cherukuri",
      "rating": 5,
      "text": "Pavani.",
      "date": "2023-07-28",
      "displayDate": "28 Jul 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0478",
      "name": "sridivya madhuri",
      "rating": 4,
      "text": "I have known the jewellery shop through contacts and visited the shop, the sales person Mallikarjuna and Nagarjuna has shown great hospitality while showing the jewellery designs",
      "date": "2023-07-24",
      "displayDate": "24 Jul 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0479",
      "name": "Naresh Eedara",
      "rating": 4,
      "text": "I have nice experience and Sales person Mallikarjuna and Nagarjuna has shown great hospitality while showing the jewellery",
      "date": "2023-07-24",
      "displayDate": "24 Jul 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0480",
      "name": "Sarala Chandrika",
      "rating": 4,
      "text": "The jewellery designs are very nice. Pavani give great service",
      "date": "2023-07-08",
      "displayDate": "8 Jul 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0481",
      "name": "Arjun SuthaPalli",
      "rating": 4,
      "text": "I am so happy with their service and I really had a good experience with them, they really have wide range of collection. I was assisted by Sandeep , he is so friendly and patient.Thank you ...",
      "date": "2023-06-30",
      "displayDate": "30 Jun 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0482",
      "name": "Raja Raj",
      "rating": 4,
      "text": "Awesome Collection , Mr.Sandeep has very gud product knowledge and very kind to customers and made my shopping easy.",
      "date": "2023-06-30",
      "displayDate": "30 Jun 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0483",
      "name": "sreevishnu",
      "rating": 4,
      "text": "Very gud collection and super response by the staff, especially Mr. Sandeep",
      "date": "2023-06-30",
      "displayDate": "30 Jun 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0484",
      "name": "LAXMIKANTH JELLA",
      "rating": 5,
      "text": "Great service Mallikarjun",
      "date": "2023-06-27",
      "displayDate": "27 Jun 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0485",
      "name": "Sravan Nandu",
      "rating": 5,
      "text": "Best experience while shopping with krishna jewelleries , special thanks to sravan - sales person who helped a lot with wide range of collections, we liked the hospitality what sravan has provided and really special thanks to sravan who really helped us on shopping, he had given us best discount and nice quotation",
      "date": "2023-06-16",
      "displayDate": "16 Jun 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "photo",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0486",
      "name": "Praaneeth Reeddy",
      "rating": 5,
      "text": "Venkatesh done great job Thanku",
      "date": "2023-06-15",
      "displayDate": "15 Jun 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0487",
      "name": "Krishna Indyala",
      "rating": 5,
      "text": "Sravan ..Nice support",
      "date": "2023-06-12",
      "displayDate": "12 Jun 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0488",
      "name": "raju rao",
      "rating": 4,
      "text": "Good customer service by guravaiha suggest the product as per budget as per present gold rates.",
      "date": "2023-05-28",
      "displayDate": "28 May 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service",
        "gifting"
      ]
    },
    {
      "id": "stream-0489",
      "name": "srinivas nayani",
      "rating": 5,
      "text": "Nagarjuna",
      "date": "2023-05-22",
      "displayDate": "22 May 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0490",
      "name": "Anu Koppula",
      "rating": 5,
      "text": "Mallikarjuna",
      "date": "2023-05-10",
      "displayDate": "10 May 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0491",
      "name": "Laxmi Borra",
      "rating": 5,
      "text": "Good service by mallikarjun",
      "date": "2023-05-05",
      "displayDate": "5 May 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0492",
      "name": "Sathish Gayakwad",
      "rating": 5,
      "text": "Great sarvis by malikarjun",
      "date": "2023-05-01",
      "displayDate": "1 May 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0493",
      "name": "Pramoda Guduri",
      "rating": 4,
      "text": "Had a good experience shopping at Krishna Jwellers Sarvesh is my go to person when ever we visit their store",
      "date": "2023-05-01",
      "displayDate": "1 May 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0494",
      "name": "Balu Balaji",
      "rating": 5,
      "text": "ShivAji",
      "date": "2023-04-30",
      "displayDate": "30 Apr 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0495",
      "name": "Sivaprasad Kasireddi",
      "rating": 4,
      "text": "Awesome collection. Really loved the store. Nice hospitality and nice staff with good product knowledge. Especially Sandeep special in product knowledge and helped me a lot in finalising my item.",
      "date": "2023-04-30",
      "displayDate": "30 Apr 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0496",
      "name": "venky suthapalli",
      "rating": 4,
      "text": "Very gud collection and hospitality is super. Mr.Sandeep is very friendly and helping to choose the best products in less time.",
      "date": "2023-04-30",
      "displayDate": "30 Apr 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0497",
      "name": "Kavya Mondem",
      "rating": 4,
      "text": "Naresh called in time for the appointment and shared all the models as per my requirement. He is polite and easy to talk to and clarify my doubts. Appreciate Krishna Jewellers and Naresh for the help.",
      "date": "2023-04-23",
      "displayDate": "23 Apr 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0498",
      "name": "Pradeep Kumar",
      "rating": 5,
      "text": "Mallikarjun garu such a great service such a nice staff",
      "date": "2023-04-22",
      "displayDate": "22 Apr 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0499",
      "name": "Jessy maa",
      "rating": 5,
      "text": "Pavani garu chala opika ga prathee design chupinchaaru and best price ichharu, Maku chinnadaina,pedda occasion Aina our favourite is krishna jewellers.thankq so much.",
      "date": "2023-04-18",
      "displayDate": "18 Apr 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0500",
      "name": "mounika reddy",
      "rating": 5,
      "text": "Sales man shivaji Chala opikaga collection antha chupinchari daimond and gold collection Really am very happy",
      "date": "2023-04-17",
      "displayDate": "17 Apr 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0501",
      "name": "Anitha Jasti",
      "rating": 5,
      "text": "Good - Sandhya Rani",
      "date": "2023-04-08",
      "displayDate": "8 Apr 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0502",
      "name": "rama krishnam raju rudraraju",
      "rating": 5,
      "text": "PAVANI",
      "date": "2023-04-02",
      "displayDate": "2 Apr 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0503",
      "name": "power Star",
      "rating": 5,
      "text": "Pavani Excellent",
      "date": "2023-04-01",
      "displayDate": "1 Apr 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0504",
      "name": "Tanmayee C",
      "rating": 4,
      "text": "Very good designs. Yadav has been very nice, he was patiently showing us the latest designs. Overall good collection",
      "date": "2023-03-30",
      "displayDate": "30 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0505",
      "name": "Venkat Ramamohan",
      "rating": 5,
      "text": "Excellent attention to detail and to customer - felt very comfortable, no pressure, Mahesh Kumar was very knowledgeable about the various products and gave us a good deal!! Definitely coming back here again and very good selection!!",
      "date": "2023-03-27",
      "displayDate": "27 Mar 2023",
      "relativeDate": "3 years ago",
      "source": "Reviews (1)final with photos.csv",
      "tags": [
        "photo",
        "service"
      ]
    },
    {
      "id": "stream-0506",
      "name": "anuradha balivada",
      "rating": 5,
      "text": "Sai Kumar and mallikarjun great service",
      "date": "2023-03-26",
      "displayDate": "26 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0507",
      "name": "Sravya Reddy",
      "rating": 4,
      "text": "We have many models here for diamond jewellery in the store. Meenakshi and Nisha helped us showing many varieties of chokers here",
      "date": "2023-03-24",
      "displayDate": "24 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0508",
      "name": "madhuri Kasukurthi",
      "rating": 4,
      "text": "Good variety and Mr.Yadav has been very patient and helpful.",
      "date": "2023-03-21",
      "displayDate": "21 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0509",
      "name": "Sowbhagya Sowbhagyaagnurkar",
      "rating": 4,
      "text": "Nitesh sir showed good designs and i have seen polki collection good explanation tq looking forward to shop more",
      "date": "2023-03-19",
      "displayDate": "19 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0510",
      "name": "Hyma Anpur",
      "rating": 5,
      "text": "Great service by mallikarjun and saikumar",
      "date": "2023-03-18",
      "displayDate": "18 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0511",
      "name": "anpur chintu",
      "rating": 4,
      "text": "Good experience visiting the shop and having made a purchase. The customer service was very good and cooperative. The staff member named Mallikarjuna has helped us in choosing the best design and choosing the good product. Visit the store for best design and good shopping experience.",
      "date": "2023-03-18",
      "displayDate": "18 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0512",
      "name": "Venkatesh Jonna",
      "rating": 5,
      "text": "Great collection and service by Bharath, Yadav and Loknath Garu",
      "date": "2023-03-17",
      "displayDate": "17 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0513",
      "name": "Vijaya Lakshmi",
      "rating": 5,
      "text": "Very satisfied Thanks,Sravan, mallikarjuna",
      "date": "2023-03-17",
      "displayDate": "17 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0514",
      "name": "singaiah rayapaneni",
      "rating": 4,
      "text": "Very helpful staff, good variety of designs and awesome customer service.. special shout out pavani",
      "date": "2023-03-14",
      "displayDate": "14 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0515",
      "name": "John moshe Dondapati",
      "rating": 5,
      "text": "Thank you Mallikarjuna garu...",
      "date": "2023-03-09",
      "displayDate": "9 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0516",
      "name": "madhava rao kolli",
      "rating": 5,
      "text": "Great service by Mallikarjuna and nagarguna",
      "date": "2023-03-06",
      "displayDate": "6 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0517",
      "name": "Karthik Kolli",
      "rating": 5,
      "text": "Nagarjuna Mallikarjuna",
      "date": "2023-03-06",
      "displayDate": "6 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0518",
      "name": "jhansi rani Cherukuri",
      "rating": 5,
      "text": "Rajesh and Mallikarjun great service",
      "date": "2023-03-03",
      "displayDate": "3 Mar 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0519",
      "name": "Krishna Kagita",
      "rating": 5,
      "text": "Superr jewellers chilukoti Venkat gud service",
      "date": "2023-02-28",
      "displayDate": "28 Feb 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0520",
      "name": "Venturi Kishore",
      "rating": 5,
      "text": "Good sarvesh",
      "date": "2023-02-28",
      "displayDate": "28 Feb 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0521",
      "name": "siva kumar",
      "rating": 4,
      "text": "The saleman Mr Sarvesh is very helpful to select the ornaments. He showing way the ornaments good. He gave good service.",
      "date": "2023-02-28",
      "displayDate": "28 Feb 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0522",
      "name": "Sirisha Chowdary",
      "rating": 5,
      "text": "Nithesh & Kushal nice service",
      "date": "2023-02-26",
      "displayDate": "26 Feb 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0523",
      "name": "nandikonda anusha",
      "rating": 4,
      "text": "Good designs are available in few categories like guttapusalu, stone work. Mr Nitesh has been of great help in getting a good deal. However the please clarify the logic on initial estimations provided as they include GST in the daily gold rate (base price) & also to the final price which is quite confusing for the customer's. Overall the store has great designs for every budget.",
      "date": "2023-02-04",
      "displayDate": "4 Feb 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0524",
      "name": "Surekha Reddy",
      "rating": 5,
      "text": "Good service Sarvesh thank u",
      "date": "2023-01-31",
      "displayDate": "31 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0525",
      "name": "sandoori supriya",
      "rating": 5,
      "text": "Good service sarvesh",
      "date": "2023-01-31",
      "displayDate": "31 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0526",
      "name": "ravi kumar",
      "rating": 5,
      "text": "Good service sarvesh",
      "date": "2023-01-31",
      "displayDate": "31 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0527",
      "name": "Leo Beri",
      "rating": 5,
      "text": "Good service sarvesh",
      "date": "2023-01-31",
      "displayDate": "31 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0528",
      "name": "Mara Prabhaker",
      "rating": 5,
      "text": "Sarvesh",
      "date": "2023-01-31",
      "displayDate": "31 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0529",
      "name": "Nagadeepthi Kothapalli",
      "rating": 4,
      "text": "Nice experience here. Especially with sarvesh he is very patient in showing the jewellery. Liked the way they treated the customers. Will visit again for sure.",
      "date": "2023-01-31",
      "displayDate": "31 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0530",
      "name": "Umar Shareef",
      "rating": 5,
      "text": "Sarveesh verry good hospishalaty good explan",
      "date": "2023-01-29",
      "displayDate": "29 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0531",
      "name": "Achyuth Chowdhary",
      "rating": 5,
      "text": "Nagarjuna",
      "date": "2023-01-28",
      "displayDate": "28 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0532",
      "name": "Sahasra",
      "rating": 4,
      "text": "I have booked an video call for viewing necklaces I have seen in live shows run by Krishna jewellers. Naresh patiently shown me everything I liked and went further to show other products of my interest. Regards Sahasra",
      "date": "2023-01-20",
      "displayDate": "20 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0533",
      "name": "Mohanrao Kaluva",
      "rating": 5,
      "text": "Eellellent service by mallikarjun",
      "date": "2023-01-06",
      "displayDate": "6 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0534",
      "name": "Manasa manu",
      "rating": 5,
      "text": "For nagarjuna garu",
      "date": "2023-01-05",
      "displayDate": "5 Jan 2023",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0535",
      "name": "ANDAPALLI SAI THULASI",
      "rating": 5,
      "text": "R Pavani",
      "date": "2022-12-31",
      "displayDate": "31 Dec 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0536",
      "name": "kunaparaju usha rani",
      "rating": 5,
      "text": "వన్ అఫ్ ది బెస్ట్ కస్టమర్ సర్వీసెస్ అండ్ ది బెస్ట్ కలెక్షన్, కృషల్ రియల్లీ హెల్పేడ్ అస్ విత్ జ్యువలరీ కలెక్షన్స్, ఎవరీ వన్ హస లాట్ అఫ్ పేషెన్స్ అత్త ది స్టోర్",
      "date": "2022-12-30",
      "displayDate": "30 Dec 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0537",
      "name": "SRIKANTH RATHOD",
      "rating": 4,
      "text": "The representative Bharath was so Cooperative and maintained healthy conversation. He has explained well and provided the valued service with a good experience.",
      "date": "2022-12-28",
      "displayDate": "28 Dec 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0538",
      "name": "Haritha Alla",
      "rating": 5,
      "text": "Prasana too good",
      "date": "2022-12-24",
      "displayDate": "24 Dec 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0539",
      "name": "Divya Reddy",
      "rating": 5,
      "text": "Very nice. Guruvaya",
      "date": "2022-12-20",
      "displayDate": "20 Dec 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0540",
      "name": "S N",
      "rating": 4,
      "text": "Yadav has been very patient and has shown all the varieties, as per budget along with latest designs. Good collection",
      "date": "2022-12-19",
      "displayDate": "19 Dec 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0541",
      "name": "Pranavi Yellapragada",
      "rating": 4,
      "text": "Satisfied with products and service. Good designs. Sandeep",
      "date": "2022-12-17",
      "displayDate": "17 Dec 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0542",
      "name": "chappidi pravalika",
      "rating": 5,
      "text": "Good collection and thank you sarvesh garu",
      "date": "2022-12-16",
      "displayDate": "16 Dec 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0543",
      "name": "Manoj Kumar",
      "rating": 4,
      "text": "Had the most wonderful experience here.Service excellent throughout. Sarvesh is amazing guy . He helped a lot thought buying process 😊. A must visit place. Thank you.",
      "date": "2022-12-13",
      "displayDate": "13 Dec 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0544",
      "name": "Veere Gowdu",
      "rating": 5,
      "text": "Good service sarvesh thanku",
      "date": "2022-12-02",
      "displayDate": "2 Dec 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0545",
      "name": "swathi padma",
      "rating": 4,
      "text": "We really like their diamond collection , bhavani is the one who helped us throughout our shopping .",
      "date": "2022-11-29",
      "displayDate": "29 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0546",
      "name": "c Archana",
      "rating": 5,
      "text": "Mallikarjun gari service chala bagundi... We are glad to shop here",
      "date": "2022-11-26",
      "displayDate": "26 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0547",
      "name": "Amancha venkat rajam",
      "rating": 5,
      "text": "Sai kumar",
      "date": "2022-11-26",
      "displayDate": "26 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0548",
      "name": "kareem khan",
      "rating": 5,
      "text": "Nagraju",
      "date": "2022-11-25",
      "displayDate": "25 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0549",
      "name": "Srivalli Kerthana",
      "rating": 5,
      "text": "Nagaraja",
      "date": "2022-11-25",
      "displayDate": "25 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0550",
      "name": "Shareef Khan",
      "rating": 5,
      "text": "Nagraju",
      "date": "2022-11-25",
      "displayDate": "25 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0551",
      "name": "UDAY TUDI",
      "rating": 5,
      "text": "నైస్ డీసెన్స్ అండీ గుడ్ సర్వీస్ krishna jewellers సేల్స్ పర్సన్ vinayak",
      "date": "2022-11-24",
      "displayDate": "24 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0552",
      "name": "Nampalli Rajitha",
      "rating": 5,
      "text": "Nagaraju",
      "date": "2022-11-22",
      "displayDate": "22 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0553",
      "name": "Busybee Bindu",
      "rating": 5,
      "text": "Thank u sir Mallikarjua garu very nice andi☺️☺️",
      "date": "2022-11-20",
      "displayDate": "20 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0554",
      "name": "Vernika Kundhavaram",
      "rating": 5,
      "text": "Mallikarjun Very good service",
      "date": "2022-11-19",
      "displayDate": "19 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0555",
      "name": "Jagadeeswara Reddy",
      "rating": 4,
      "text": "Nice experience with today purchase. Thank you Rajesh for helping us to select best design.",
      "date": "2022-11-19",
      "displayDate": "19 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0556",
      "name": "Anusha Meka",
      "rating": 5,
      "text": "Mallikarjun and Yadav great service",
      "date": "2022-11-18",
      "displayDate": "18 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0557",
      "name": "Nirosha Baddam",
      "rating": 5,
      "text": "Sai kumar",
      "date": "2022-11-18",
      "displayDate": "18 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0558",
      "name": "radha reddy",
      "rating": 5,
      "text": "Mallikarjun service is great",
      "date": "2022-11-18",
      "displayDate": "18 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0559",
      "name": "V",
      "rating": 4,
      "text": "good collection of models. The sales executive Nagarjuna showed with at most patience.",
      "date": "2022-11-18",
      "displayDate": "18 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0560",
      "name": "Vijayendar Reddy Donooru",
      "rating": 5,
      "text": "Sai kumar",
      "date": "2022-11-16",
      "displayDate": "16 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0561",
      "name": "Rajashekar Reddy",
      "rating": 5,
      "text": "Sai Kumar",
      "date": "2022-11-16",
      "displayDate": "16 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0562",
      "name": "Abdul Jabbar Moseen Mohammad",
      "rating": 5,
      "text": "Nagaraju",
      "date": "2022-11-14",
      "displayDate": "14 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0563",
      "name": "gopikrishna e",
      "rating": 5,
      "text": "Sai Kumar",
      "date": "2022-11-13",
      "displayDate": "13 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0564",
      "name": "alekhya reddy",
      "rating": 5,
      "text": "Sai kumar",
      "date": "2022-11-13",
      "displayDate": "13 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0565",
      "name": "Mannem Anusha",
      "rating": 5,
      "text": "Nagaraju",
      "date": "2022-11-13",
      "displayDate": "13 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0566",
      "name": "lakshmi lasavya",
      "rating": 5,
      "text": "By nagaraju",
      "date": "2022-11-13",
      "displayDate": "13 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0567",
      "name": "Vamshi Reddy",
      "rating": 5,
      "text": "Mallikarjun great service",
      "date": "2022-11-10",
      "displayDate": "10 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0568",
      "name": "Sai Pooja",
      "rating": 4,
      "text": "Varieties of collection in the store wanted to visit the store again. Mallikarjun is the coordinator staff for me he was not that great he was not having much knowledge about the items in the store he needs more experience",
      "date": "2022-11-09",
      "displayDate": "9 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0569",
      "name": "Anu G",
      "rating": 4,
      "text": "Good Collection of gold rings. Service provided by Vinayak was good experience.",
      "date": "2022-11-05",
      "displayDate": "5 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0570",
      "name": "Kota Ramchandra Reddy",
      "rating": 5,
      "text": "Akshya sales Good",
      "date": "2022-11-02",
      "displayDate": "2 Nov 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0571",
      "name": "MadhavaRao Katta",
      "rating": 5,
      "text": "Aksha",
      "date": "2022-10-31",
      "displayDate": "31 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0572",
      "name": "Samanvitha jalgam",
      "rating": 4,
      "text": "Iam very happy to visit Krishna pearls and jwellery specially satisfied with Rekha service for explaining details about jwellery good communication thank you for rekha service",
      "date": "2022-10-30",
      "displayDate": "30 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0573",
      "name": "ramagiri vijay",
      "rating": 5,
      "text": "Good Experience 😊 nice staff 👍 Pavani Madum & Mr Mahesh .",
      "date": "2022-10-29",
      "displayDate": "29 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0574",
      "name": "Ram Prasad Reddy",
      "rating": 5,
      "text": "Sravan gave good discount•",
      "date": "2022-10-29",
      "displayDate": "29 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0575",
      "name": "Uma Rani",
      "rating": 5,
      "text": "Good service sarvesh.",
      "date": "2022-10-25",
      "displayDate": "25 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0576",
      "name": "Santanu Sen",
      "rating": 5,
      "text": "Akshya sarvice very good",
      "date": "2022-10-23",
      "displayDate": "23 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0577",
      "name": "raksha nimal",
      "rating": 5,
      "text": "Malikarjun good service",
      "date": "2022-10-22",
      "displayDate": "22 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0578",
      "name": "Rama Lakshmi",
      "rating": 5,
      "text": "Good service loknadh/ ramadevi",
      "date": "2022-10-21",
      "displayDate": "21 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0579",
      "name": "Parvati K",
      "rating": 5,
      "text": "Sarvesh.",
      "date": "2022-10-21",
      "displayDate": "21 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0580",
      "name": "vandana Reddy",
      "rating": 5,
      "text": "Pavani",
      "date": "2022-10-19",
      "displayDate": "19 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0581",
      "name": "sai chand",
      "rating": 5,
      "text": "Sai Kumar",
      "date": "2022-10-16",
      "displayDate": "16 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0582",
      "name": "Haritha Nadella",
      "rating": 5,
      "text": "Kushal",
      "date": "2022-10-16",
      "displayDate": "16 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0583",
      "name": "bunny harish",
      "rating": 5,
      "text": "Sarvesh was good service",
      "date": "2022-10-16",
      "displayDate": "16 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0584",
      "name": "Sheetal Thakur",
      "rating": 4,
      "text": "Hi Krishna Jewellerz., it’s been wonderful experience shopping with your store. Bhavani has been a great help in showing all the pieces in the store. Thank you Bhavani 😇",
      "date": "2022-10-16",
      "displayDate": "16 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0585",
      "name": "padmavathi dandu",
      "rating": 5,
      "text": "Good service sarvesh . Thanku",
      "date": "2022-10-15",
      "displayDate": "15 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0586",
      "name": "Madhavi kokatam",
      "rating": 5,
      "text": "Mallikarjun and shakeela good service",
      "date": "2022-10-15",
      "displayDate": "15 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0587",
      "name": "Kavita Bezawada",
      "rating": 4,
      "text": "Naresh is a very good sales executive and has been very helpful and explained in detail . Always available answering all questions and clarifications. I recommend very highly as he provides a good customer experience.",
      "date": "2022-10-15",
      "displayDate": "15 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0588",
      "name": "Gayathri Kanumuri",
      "rating": 4,
      "text": "Had a good experience with Krishna Jewellers. Rajesh from Jubilee hills branch has showed us products according to our taste. Would definitely wanna keep going back.",
      "date": "2022-10-15",
      "displayDate": "15 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0589",
      "name": "Akhila Thalasani",
      "rating": 5,
      "text": "Pavani and mallikarjun very good staff and great service",
      "date": "2022-10-14",
      "displayDate": "14 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0590",
      "name": "k prasanna",
      "rating": 5,
      "text": "Yadav and mallikarjun was very good service",
      "date": "2022-10-14",
      "displayDate": "14 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0591",
      "name": "Nekkanti Rama",
      "rating": 5,
      "text": "Yadhav & Mallikarjun Good Service",
      "date": "2022-10-14",
      "displayDate": "14 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0592",
      "name": "Anand Hardi",
      "rating": 4,
      "text": "Very good collection and courteous staff. Sales executive Pavani showed us all the collections very patiently. Friendly staff. Unlike other showrooms, Gold value displayed here includes 3% GST. We purchased a necklace. Ear rings were securely delivered by courier after required modification.",
      "date": "2022-10-14",
      "displayDate": "14 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0593",
      "name": "Robin Bobby",
      "rating": 5,
      "text": "Loknath & Mahesh good service",
      "date": "2022-10-13",
      "displayDate": "13 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0594",
      "name": "Viji Narayanaswamy",
      "rating": 4,
      "text": "Good collection and designs. Naresh who helped in seeing collection was very patient and respectful. He explained it well and did not any pressure in the selection process. Would recommend for the service.",
      "date": "2022-10-13",
      "displayDate": "13 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0595",
      "name": "MOUNIKA M",
      "rating": 5,
      "text": "Good demo by Swapna",
      "date": "2022-10-12",
      "displayDate": "12 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0596",
      "name": "Sophia Pallepogu",
      "rating": 5,
      "text": "Tq Mallikarjuna garu",
      "date": "2022-10-11",
      "displayDate": "11 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0597",
      "name": "Satya Parimi",
      "rating": 5,
      "text": "Sarvesh- good service",
      "date": "2022-10-09",
      "displayDate": "9 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0598",
      "name": "madhusudhanrao talluri",
      "rating": 4,
      "text": "Sravan is the person attended and showed the ornaments we filtered and saved our time. Good reception and nice behaviour.",
      "date": "2022-10-09",
      "displayDate": "9 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0599",
      "name": "Harsha vardhini",
      "rating": 5,
      "text": "Vadanam kalakshans supar malikargunagaru chala baga chupincharu",
      "date": "2022-10-07",
      "displayDate": "7 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0600",
      "name": "Suresh Reddy",
      "rating": 5,
      "text": "Exelent vaddanm .neckles rew super mallikarjuna",
      "date": "2022-10-07",
      "displayDate": "7 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0601",
      "name": "Raja Lakshmi",
      "rating": 5,
      "text": "Mallikarjuna gharu. Tysm.",
      "date": "2022-10-04",
      "displayDate": "4 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0602",
      "name": "Mounika",
      "rating": 4,
      "text": "Loved all the designs ,they are very unique from other stores . Special thanks to the staff kushal who understood our requirement patiently showed us all designs .",
      "date": "2022-10-04",
      "displayDate": "4 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0603",
      "name": "Suresh Bolisetti",
      "rating": 5,
      "text": "Rajesh / Prakash",
      "date": "2022-10-03",
      "displayDate": "3 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0604",
      "name": "Venkateshwar reddy Madduri",
      "rating": 5,
      "text": "Sarvesh service is good",
      "date": "2022-10-02",
      "displayDate": "2 Oct 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0605",
      "name": "Rohinish Yelamoni",
      "rating": 5,
      "text": "Good service by nagaraju and mahesh.j",
      "date": "2022-09-30",
      "displayDate": "30 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0606",
      "name": "Uma Mahesh",
      "rating": 4,
      "text": "Very Gud Collection. Simply Superb. Sandeep have good product knowledge, he helped a lot for our shopping.",
      "date": "2022-09-30",
      "displayDate": "30 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0607",
      "name": "sayyed karimunnisa",
      "rating": 4,
      "text": "Awesome collection, Sandeep simply superb and very polite to customers, had a nice shopping.",
      "date": "2022-09-30",
      "displayDate": "30 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0608",
      "name": "Padma Nukala",
      "rating": 5,
      "text": "Collection is too gud Shivaji",
      "date": "2022-09-22",
      "displayDate": "22 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0609",
      "name": "Surya Narayana Akki",
      "rating": 5,
      "text": "Ganesh and Sravan good service",
      "date": "2022-09-20",
      "displayDate": "20 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0610",
      "name": "sowmya sree",
      "rating": 4,
      "text": "I visited the store today for purchasing newborn baby bangles and I am very satisfied with their service. I am happy to visit Krishna jewellers jubilee hills",
      "date": "2022-09-20",
      "displayDate": "20 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0611",
      "name": "sreenija sreenivas",
      "rating": 5,
      "text": "Ganga bhavani gaaru....you are just awesome..... genuine and fast....ila raagane panulu ayyayi Mee valla thank you so much andi",
      "date": "2022-09-18",
      "displayDate": "18 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0612",
      "name": "V.S Akshaya",
      "rating": 4,
      "text": "Different and outstanding workmanship. Assistance was very thoughtful especially of Mr. Kushal and Ankit. Will keep on visiting. Keep it up!",
      "date": "2022-09-18",
      "displayDate": "18 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0613",
      "name": "Massety Avinash",
      "rating": 5,
      "text": "Nice patience by mallikarjun",
      "date": "2022-09-17",
      "displayDate": "17 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0614",
      "name": "surekha dugyala",
      "rating": 5,
      "text": "Good Servees Mallikarjuna",
      "date": "2022-09-12",
      "displayDate": "12 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0615",
      "name": "gowri kallury",
      "rating": 5,
      "text": "Ganga bhavani good service",
      "date": "2022-09-03",
      "displayDate": "3 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0616",
      "name": "Sagili Nikhil Kumar Reddy",
      "rating": 4,
      "text": "I have recently purchased diamond ear rings I highly recommend this showroom and also staffs are good Ganga bhavani mam helped us to purchase",
      "date": "2022-09-03",
      "displayDate": "3 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0617",
      "name": "Neeraja Kanthi",
      "rating": 4,
      "text": "Good collection, great service. Salesman Nagarjuna was patient in showing the collection",
      "date": "2022-09-03",
      "displayDate": "3 Sept 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0618",
      "name": "Geetha Reddy",
      "rating": 4,
      "text": "Good collection and customer service is fabulous sandeep was very good at assisting and very he's very patient and shared all the required information",
      "date": "2022-08-30",
      "displayDate": "30 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0619",
      "name": "roshini dantuluri",
      "rating": 4,
      "text": "Good range of collection! Nagarjuna showed us very patiently🙌🏻",
      "date": "2022-08-30",
      "displayDate": "30 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0620",
      "name": "Bodireddy Supriya",
      "rating": 4,
      "text": "Excellent collection i have not seen that much collection anywhere sales person gangabhavani gave outstanding service and highly recommend that store",
      "date": "2022-08-29",
      "displayDate": "29 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0621",
      "name": "20CSE 1208 Thatireddy revathi",
      "rating": 4,
      "text": "I have first visited in onlinemode gangabhavani helped me to complete the purchase process and explained about the product in a detail way",
      "date": "2022-08-29",
      "displayDate": "29 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0622",
      "name": "Pooja Reddy",
      "rating": 5,
      "text": "Lovely collection and ramadevi Garu helped us a lot.. thank u krishna jewellers",
      "date": "2022-08-28",
      "displayDate": "28 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0623",
      "name": "AADHYAA SEEDS",
      "rating": 5,
      "text": "Sai kumar",
      "date": "2022-08-28",
      "displayDate": "28 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0624",
      "name": "Koinni Sai Krishna",
      "rating": 5,
      "text": "Thanks saikumar.",
      "date": "2022-08-28",
      "displayDate": "28 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0625",
      "name": "G Ravi Teja",
      "rating": 4,
      "text": "It's my second time shopping here. Very good experience. We were associated with Ganga bhavani. He was very polite and kind. Showed us all the collection with lot of patience and a smile on the face. I am always satisfied with Krishna jewellers",
      "date": "2022-08-28",
      "displayDate": "28 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0626",
      "name": "Sneha Lekkala",
      "rating": 4,
      "text": "Super collection Different models and ur sales executivers are also kindly nature and showing goood manner we recently visited and I think her name is ganga bhavani she had received well in good manner",
      "date": "2022-08-28",
      "displayDate": "28 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0627",
      "name": "Sai Shankar",
      "rating": 4,
      "text": "Unique , elegant and impressive styles.went to few other big brand stores but Krishna jewellers stands out not just with their products but with their hospitality.Glad i visited their store , brought a beautiful set. Thanks to Ganga bhavani mam.",
      "date": "2022-08-28",
      "displayDate": "28 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0628",
      "name": "Touheed Fathima",
      "rating": 4,
      "text": "Nice collection with affordable price and with wide varieties of designs and your sales executes I know already Bhavani she helps in selecting product",
      "date": "2022-08-28",
      "displayDate": "28 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0629",
      "name": "Mallikarjun Bodla",
      "rating": 5,
      "text": "నాగార్జున గారు చాలా మంచిగా సెలెక్ట్ చేయించారు, గోల్డ్ వెరైటీస్ బాగున్నాయి",
      "date": "2022-08-27",
      "displayDate": "27 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0630",
      "name": "Cherry king",
      "rating": 4,
      "text": "Thanks to Mallikharjuna rao for the best customer experience. He has good patience in answering all the queries and also showing different models.",
      "date": "2022-08-26",
      "displayDate": "26 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0631",
      "name": "Uma Devi",
      "rating": 5,
      "text": "Mahesh.j",
      "date": "2022-08-25",
      "displayDate": "25 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0632",
      "name": "manjula k",
      "rating": 4,
      "text": "Very good gollection.Good service.Salesman mallikarjuna was very patient, understood our taste and quickly showed all varieties in gold Haram.Very much impressed with the service n collection.",
      "date": "2022-08-24",
      "displayDate": "24 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0633",
      "name": "sindhura tammineedi",
      "rating": 5,
      "text": "Good service by Lokhnath and Nagaraj",
      "date": "2022-08-23",
      "displayDate": "23 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0634",
      "name": "srinivasarao dasari",
      "rating": 5,
      "text": "Excellent services from Sravan and Mallikarjun",
      "date": "2022-08-22",
      "displayDate": "22 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0635",
      "name": "maheshwari reddy",
      "rating": 5,
      "text": "J Mahesh",
      "date": "2022-08-22",
      "displayDate": "22 Aug 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0636",
      "name": "Prameela Rani",
      "rating": 4,
      "text": "Hi My purchase experience with Krishna Jewellers, Jubileehills was extremely satisfied. Thanks to Mr. Mallikharjun who was very attentive to our requests. He was knowledgeable about products, very patiently shown items and explained very well. Entire staff were friendly. I would definitely visit again & suggest to my relatives and friends.",
      "date": "2022-07-26",
      "displayDate": "26 Jul 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0637",
      "name": "Vijaya Lakshmi Emmanni",
      "rating": 4,
      "text": "Krishna jewellers has very good collection. S.Mahesh helped a lot when I tried to see video calls from USA.I appreciate his patience and service.",
      "date": "2022-07-12",
      "displayDate": "12 Jul 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0638",
      "name": "swetha reddy",
      "rating": 5,
      "text": "Ganga bhavani",
      "date": "2022-06-18",
      "displayDate": "18 Jun 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0639",
      "name": "priya ella",
      "rating": 4,
      "text": "Great Customer service. Would highly recommend to online/US based clientele as the staff is extremely helpful in arranging video calls and making sure you find the right pieces. Mr.Riaz and Mr.Dinakar helped me find a piece I found on instagram and the transaction was effortless.",
      "date": "2022-06-08",
      "displayDate": "8 Jun 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0640",
      "name": "Dastagirireddy Ramireddy",
      "rating": 5,
      "text": "Name - Ganga bavani Good service",
      "date": "2022-06-02",
      "displayDate": "2 Jun 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0641",
      "name": "Gouthami E",
      "rating": 4,
      "text": "Wide range of collection, beautiful designs. Staff in the showroom are very humble and patient. Thanks Rekha, Dinakar and Ambika for your help 😊",
      "date": "2022-04-04",
      "displayDate": "4 Apr 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0642",
      "name": "Ooha Reddy",
      "rating": 4,
      "text": "Very welcoming and customer friendly!! Loved there custimized jewelry and looking forward to purchase more jewelry in future.",
      "date": "2022-03-28",
      "displayDate": "28 Mar 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0643",
      "name": "Ateet T",
      "rating": 4,
      "text": "One of the best stores for Pearl's in Hyderabad. Being the city of pearls, its the place we can trust for quality reliability and customer service experience..",
      "date": "2022-03-21",
      "displayDate": "21 Mar 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0644",
      "name": "Preeti Rangaraju",
      "rating": 4,
      "text": "Service is really great.they attended us very patiently.designs are really very beautiful..there are lot of designs available in all categories...",
      "date": "2022-03-05",
      "displayDate": "5 Mar 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0645",
      "name": "Trupti Rao",
      "rating": 5,
      "text": "Good collection, wide ranges in all categories. Transparency in billing and transactions. Mr. Shravan is knowledgeable and he is of a great help for every purchase for us. Mr. Nayeem gives us the best deal always. That makes us visit the store again for every purchase.",
      "date": "2022-03-01",
      "displayDate": "1 Mar 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "photo",
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0646",
      "name": "Dr Visweswara Rao",
      "rating": 4,
      "text": "Very good jewellery shop with latest designs .. very courteous welcome and excellent cooperation of sales executives till we depart…Mr Sandeep and Mr Vinay are too good and have lot of patience to show the designs of ur choice …if u r in Hyderabad , it is a must visit jewellery shop ..",
      "date": "2022-02-25",
      "displayDate": "25 Feb 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0647",
      "name": "keerthana pinisetty",
      "rating": 4,
      "text": "Good collection and unique designs. I have bought jewelry two times through online from USA. They shipped the item securely. Riaz and Mounica helped me patiently through out the purchase processing.",
      "date": "2022-01-06",
      "displayDate": "6 Jan 2022",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0648",
      "name": "sahithi",
      "rating": 4,
      "text": "Ordered two sets of diamond jhumkas through video call.I had them delivered to USA by making payment online. Throughout the video call process and selection process, Riaz Khan helped me out and for placing and tracking the order, making payments, Ajay helped me out. Based on my experience, here are pros and cons: Pros: 1. Extremely good customer service, they try to accommodate video calls as per our time zone. Happy with both the designs. 2.Very quick replies from both Riaz and Ajay, and they try to help you out in selection in all possible ways when shopping via video call. 3. Not to forget, the team did a great job in packing the jewelry very securely despite being International shipping. Cons: 1. I got them shipped online from India to USA. The team needs to do a lot of homework on what type of documents would the US Customs ask. My order was stuck in the US Customs department for almost a week and no one knew why it was stuck. I had to follow-up by myself by calling USPS and US Customs department and provided the required details. If the team is working on International orders, they must know what type of documents have to be provided to pass through the Customs and Duties. This was lacking. 2. They say they do quality check on the jewelry prior to shipping, however one diamond stone was missing in one of the jhumkas. This wouldn't have happened if they did the check properly because any loose diamonds would've easily been identified during the check or if there was already missing diamond prior to shipping the item they should've fixed it. I talked to the team and they said they would fix it for free of charge when I visit their store in the future. Overall, from my experience maybe I would consider online shopping gold jewelry but not diamond jewelry to not lose anymore diamond stones. But would visit their store while in Hyderabad for in-store shopping :)",
      "date": "2021-09-12",
      "displayDate": "12 Sept 2021",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0649",
      "name": "Anjalirao Ponugoti",
      "rating": 4,
      "text": "Just visited the store yesterday,the branch which is located at Jublihills,the atmosphere in the store is very welcoming and the staff members are very kind and polite,Mr.Riaz is the one who guided me through my purchase overall we are very satisfied that we chose this store to shop",
      "date": "2021-05-11",
      "displayDate": "11 May 2021",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0650",
      "name": "sourabhi chandra",
      "rating": 4,
      "text": "I have recently purchased from this store online, I saw a ornament online on instagram for which I wanted the details, When I reached out via WhatsApp they were very responive, one of the online staff Dinaker helped me through with the price breakdowns, even though all the conversations was online and via video calls, he patiently answered all the questions I had about the delivery, Payments and price breakdown. I would surely recommend this store and will come back for future purchases.",
      "date": "2021-03-08",
      "displayDate": "8 Mar 2021",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0651",
      "name": "Spandana Vanukuri",
      "rating": 4,
      "text": "Thank you Rama from Krishna jewellers for an amazing and courteous job well done! It’s not easy job to deal with customers online. I would highly recommend to others. Thanks Spandana V",
      "date": "2021-02-25",
      "displayDate": "25 Feb 2021",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0652",
      "name": "Tejaswi Poludasu",
      "rating": 4,
      "text": "Great designs and very good service. They have very beautiful collection of jhumkas and antique jewellery.",
      "date": "2020-12-30",
      "displayDate": "30 Dec 2020",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0653",
      "name": "Sameera Gandham",
      "rating": 4,
      "text": "Designs are too good and the sales executive was very calm and patience throughout the process. Sales executives venkatesh...",
      "date": "2020-12-25",
      "displayDate": "25 Dec 2020",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0654",
      "name": "chandana suryadevara",
      "rating": 4,
      "text": "We had good experience with krishna jewels for gold and diamond jewellery and very nice collection of models. Received very good hospitality from kushal and praveen and best price too.",
      "date": "2020-07-22",
      "displayDate": "22 Jul 2020",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0655",
      "name": "rebecca renee",
      "rating": 4,
      "text": "Very courteous staff... Feel welcomed and am very satisfied with the purchase. Thank you",
      "date": "2019-08-16",
      "displayDate": "16 Aug 2019",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0656",
      "name": "Shruti Gupta",
      "rating": 4,
      "text": "Good collection. Good quality. The sales persons are also very hospitable.",
      "date": "2019-08-08",
      "displayDate": "8 Aug 2019",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0657",
      "name": "Debarghya Chaudhury",
      "rating": 4,
      "text": "The staff are courteous and the place has a very desirable collection of jewellery and pearls. They also assure you get the best quality and authenticity of their pearls by offering 80% buyback guarantee. The only thing you pay for that is a small premium, but for us it was worth the price !",
      "date": "2019-07-11",
      "displayDate": "11 Jul 2019",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0658",
      "name": "mayuresh kumar",
      "rating": 4,
      "text": "Excellent pearl and jewellery exclusive showroom....Well maintained behaviour and service by sales men ..especially I got the well service from the salesman shoukat ...... Absolutely I would prefer to visit again to this place in future 🤘🏻",
      "date": "2019-06-24",
      "displayDate": "24 Jun 2019",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0659",
      "name": "Sagar Takri",
      "rating": 4,
      "text": "I went to inorbit mall In krishna jewellers pearls and jems i purchased a few earrings for gifts its really great collection with reasonable prices finally happy with prices and products",
      "date": "2017-07-30",
      "displayDate": "30 Jul 2017",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0660",
      "name": "Srav Sree",
      "rating": 4,
      "text": "Awesome collection and great response from the staff, and the manager Nayeem has dealt very well!! superb service!! I refer my friends and family on purchase of jewellery at this Jubilee Hills store!!",
      "date": "2017-05-04",
      "displayDate": "4 May 2017",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0661",
      "name": "simha reddy",
      "rating": 4,
      "text": "Visited krishna pearls at novotel hicc, they have very good collection of pearls jewellery, Mr Shoukath helped me to select the pearls, thank u.",
      "date": "2017-02-23",
      "displayDate": "23 Feb 2017",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0662",
      "name": "Sagar Takri",
      "rating": 4,
      "text": "I went with my family members to in orbit mall.we saw krishna pearls ,having superb collections in pearls and gems We collect a small necklace and earrings.",
      "date": "2016-12-13",
      "displayDate": "13 Dec 2016",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0663",
      "name": "Charan Yerravalli",
      "rating": 4,
      "text": "I have visited at inorbit mall at krishna pearls and gems,actually I am looking ear ringsin yellow gold and pearls.very simple ears rings I get it in my budjet.",
      "date": "2016-12-13",
      "displayDate": "13 Dec 2016",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0664",
      "name": "Shanu Gaur",
      "rating": 4,
      "text": "Excellent jewellery collection with an amiable sales team. I recommend this store to anyone whose looking at a one stop shop for different variety of jewellery.",
      "date": "2016-09-02",
      "displayDate": "2 Sept 2016",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0665",
      "name": "Oindrila Baul",
      "rating": 4,
      "text": "The store has got an amazing and impressive collection of gold, gemstone and diamond jewellery. The neck pieces and earrings were gorgeous.",
      "date": "2016-08-30",
      "displayDate": "30 Aug 2016",
      "relativeDate": "",
      "source": "KJ reviews .xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0666",
      "name": "- - (‪Praveen Kumar Reddy‬)",
      "rating": null,
      "text": "Sravan Good Reception. Had time saving display of the ornaments.",
      "date": "",
      "displayDate": "Edited 9 months ago",
      "relativeDate": "Edited 9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0667",
      "name": "360 degree Earth",
      "rating": null,
      "text": "It sounds like you're saying you received excellent service from a person named Sandhya Rani at a shop, and it made your day! It's great to hear that her service was amazing. If you'd like, you could leave a positive review or share your …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0668",
      "name": "A S Reddy",
      "rating": null,
      "text": "Mrs.Ramadevi sales person has shown different varieties of items. She is very polite and has a lot of patience. She is very talented and deserves an appreciation.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0669",
      "name": "aashitha koripella",
      "rating": null,
      "text": "We purchased jewellery from the store . They have a lot of innovative designs . Mr. Sandeep was very polite and patient in showing the models . We would definitely recommend shopping here.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0670",
      "name": "abarnaa balakrishnan",
      "rating": null,
      "text": "Exquisite collection . Excellent customer service . Sai, Srikanth, Lakshmi gre spent almost entire day with us explaining and showing all the items . Highly recommend this place .",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0671",
      "name": "Abhi rami",
      "rating": null,
      "text": "Collections are good.making and wastage charges are lesser than other stores. Service from sai kumar is also pretty good",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0672",
      "name": "Abhigna Reddy",
      "rating": null,
      "text": "Good collection. Loknath garu showed all the jewellery which we needed with patience.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0673",
      "name": "Abhigna reddy Surapureddy",
      "rating": null,
      "text": "A worthy place to purchase gold and diamonds. Very cordial staff. I am really grateful to Miss Rama devi garu and Mr. Chary garu for offering heartwarming services at the store. Pleasure to be a krishnajewellers customer….",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0674",
      "name": "Abhilash Vulupala",
      "rating": null,
      "text": "Excellent service and amazing collection. Special thanks to sales rep sarvesh at Jubilee hills branch for patiently showing all the latest collection.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0675",
      "name": "ABHINAV GARG",
      "rating": null,
      "text": "Excellent service by G Praveen. Showed some amazing neck pearl",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0676",
      "name": "Abhinav Goud",
      "rating": null,
      "text": "Amazing Service from Yadav! Had a great experience at Krishna Jewellers, all thanks to Yadav! He was super …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0677",
      "name": "Abhishek Malagani",
      "rating": null,
      "text": "⸻ We had a wonderful experience at the store, largely thanks to Govind. From the …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0678",
      "name": "Abhishek Rao Devaraneni",
      "rating": null,
      "text": "Very good description by bharath. Models are completely eye catching. Would recommend",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0679",
      "name": "Abilash R",
      "rating": null,
      "text": "They have a plethora of collection, we bought 2 diamond necklaces and gold ornaments, Pavani (sales exec) is very knowledgeable and showed a ton of varieties with utmost patience. I’d say this is one of the best jewellers store in hyd",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0680",
      "name": "Acharya Satya Krishna",
      "rating": null,
      "text": "We are regular to Krishna Jewellers. Their hospitality is excellent. Mr. Ramesh has shown us with very patience and suggested new varieties. Overall had a great experience.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0681",
      "name": "Adarsh Chidre",
      "rating": null,
      "text": "Nice collection Good services by Govind",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0682",
      "name": "Adib Haque",
      "rating": null,
      "text": "Nice experience. Satish was very nice in showing pearl sets as I wished.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0683",
      "name": "Aditya Reddy",
      "rating": null,
      "text": "Guravaiah provided excellent service and gave great discounts and ensured we made the purchase. Most patient man and will recommend him to all friends.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0684",
      "name": "Adla Sridhar Reddy",
      "rating": null,
      "text": "Great service. Extremely satisfied with the buying experience.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0685",
      "name": "Adya Arlagadda",
      "rating": null,
      "text": "Great experience shopping at Krishna jewelers. Venkat helped us with our selections and was very helpful throughout the process. Will be back for our next shopping trip.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0686",
      "name": "aishu sakthi",
      "rating": null,
      "text": "Good customer service..unique collections..Rajeshree helped us to get the vaddanam and i am very much satisfied for the service she provided..five star for her too...",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0687",
      "name": "Aishwarya Kotla",
      "rating": null,
      "text": "I have a great experience, laleppa representative here at Krishna helped find ours. Really appreaciate the service",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0688",
      "name": "ajay nampelly",
      "rating": null,
      "text": "Mr.Shreekanth( sales executive) I had a wonderful experience at the krishna jwellery. The salesman(SHREEKANTH) was extremely helpful, polite, and knowledgeable. He patiently showed us multiple …",
      "date": "",
      "displayDate": "Edited 11 months ago",
      "relativeDate": "Edited 11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0689",
      "name": "Ajay vaishnavi Ajay vaishnavi",
      "rating": null,
      "text": "Nice collection... Iam so happy with yadav garu.... Good patience, nice bridal collection and Diamond collection , iam so happy with collection by yadav garu....",
      "date": "",
      "displayDate": "Edited 7 months ago",
      "relativeDate": "Edited 7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0690",
      "name": "Akash Barsagade",
      "rating": null,
      "text": "Good Experience! Been here multiple times. Was assisted by Govind, he’s a great guy. Shout out to him☺️",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0691",
      "name": "Akhil Arjun143",
      "rating": null,
      "text": "Best new designs avilable at very good price v god amazing design and different collections mr.s.Bharath is very good saleman..",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0692",
      "name": "Akhil Menon",
      "rating": null,
      "text": "Gold collection is unique, service is good, Pavani helped us a lot in choosing the models that we want, she was very patient and understood our requirement and showed the models that we were looking for. Prices are reasonable too, would love to visit again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0693",
      "name": "Akhila Kandi",
      "rating": null,
      "text": "Amazing Collection! I bought my entire wedding Jewellery from here. Bhavani helped us throughout our shopping and showed us the best collection. Great Diamond and gold collection and great service.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0694",
      "name": "Akhila Mallampati",
      "rating": null,
      "text": "Krishna Jewelers was a great shopping experience with a large collection. It really helped to have Prasanna as our salesperson she was so patient and gave her honest opinion on what looked nice, as well as doing the most to give a reasonable price.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0695",
      "name": "AKHILA PONNAM",
      "rating": null,
      "text": "Great store with great customer service!!! The sales person especially Ramadevi was very proactive and helped me a lot in picking the right designs throughout the purchase, she is very keen on understanding the need of customers and showing the best collection.Had the best shopping experience overall !!",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0696",
      "name": "Akhila Rachaneni",
      "rating": null,
      "text": "I loved the collections here. Especially sales executive Pavani helped me to choose the best jewelry for my wedding. Staff is very friendly and service also too good. Mr. Chary given best discount in the market. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0697",
      "name": "Akhila Somireddy",
      "rating": null,
      "text": "Beautiful collection & Sandeep garu was extremely patient, did a great job in helping us choose the best from wide range of collection. Highly recommended",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0698",
      "name": "Akula Hemanth Kumar",
      "rating": null,
      "text": "Maha lakshmi madam is patient in showing all the jewellery's. I recommend krishna jewellery's they have good collection",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0699",
      "name": "Akulasushma Akula",
      "rating": null,
      "text": "The best jewelry store to visit for any occasion shopping. Personally thanks to Sravan and Mahesh who have helped us all the time to deliver the designers on time and explain details. It is a one stop store to find as many designs any time. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0700",
      "name": "Alekhya Choudhary",
      "rating": null,
      "text": "Collection is great and Yadav garu went beyond with tremendous patience to help us choose the right one.",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0701",
      "name": "alekhya jagarlamudi",
      "rating": null,
      "text": "I got assistance from Dinakar and he is very helpful with the payment and piece selection. He had been there very patiently with whatever request I come up with. Great work!",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0702",
      "name": "Alekhya Reddy",
      "rating": null,
      "text": "Rama devi Very good jewellery selection was shown by Ms Rama devi mam, liked the way of expressing the view of ornaments",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0703",
      "name": "Amit Saxena",
      "rating": null,
      "text": "Enjoyed shopping for gold and diamonds ear rings at Krishna. Me Sravan is very knowledgeable and easy to work with. Great experience over all! Great collection here.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0704",
      "name": "Amma Nanna",
      "rating": null,
      "text": "I cannot praise Lalappa enough! His expertise in handling my diamond and gold jewelry was magnificent. The service was absolutely superb—smooth, trustworthy, and beyond all expectations. He makes the entire process a delight.\"",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0705",
      "name": "ammu ravi",
      "rating": null,
      "text": "At Krishna Pearls hems and jewellers jubilee hills we had wonderful experience. Mr.Kushal who is polite and highly professional helped us in showing different ornaments with patience and explained the workmanship.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0706",
      "name": "Amruta Amit",
      "rating": null,
      "text": "Good service given by mr Yadav",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0707",
      "name": "Amrutha Kanakamedala",
      "rating": null,
      "text": "very excellent customer service. I purchased two diamond pendants and a diamond choker, the way they deal with the customers is just awesome. Also, they are very particular and cautious with delivering the product right to our door step. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0708",
      "name": "Amulya Kantimahanthi",
      "rating": null,
      "text": "I just got a wonderful jhumkas from Krishna jewellers. I was a little worried about the purchase as I was interacting with the team virtually. But Ajay was able to help me out picking the right design and get the order. Thank you so much Ajay for helping me with the purchase. Definitely will come soon for another purchase 😊 …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0709",
      "name": "amulya mettu",
      "rating": null,
      "text": "Very warm staff ,good receiving Very patience good staff venkat patiently showed all options from morning till evening",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0710",
      "name": "Anagha Reddy",
      "rating": null,
      "text": "One of the best jewellery in Telangana I love the designs and quality here with multiple options at very fine prices …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0711",
      "name": "Anand Bazawada",
      "rating": null,
      "text": "Sainath, was very courteous and soft spoken. He took good care of us. Our overall experience at the store a very good. I am 100% satisfied with the service and the product.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0712",
      "name": "Anantha Padmanabhan",
      "rating": null,
      "text": "I recently made an online purchase from Krishna Jewelers jubilee hills and I must say, my experience was nothing short of exceptional, thanks to the outstanding service provided by Sreekanth. From the moment I started browsing their …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0713",
      "name": "Ananya Thotakuri",
      "rating": null,
      "text": "They have an excellent collection here and Srilakshmi garu took good care of us, showing all the available options with great patience. Would highly recommend.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0714",
      "name": "Andapalli Sanjeev Kumar",
      "rating": null,
      "text": "The gold is pretty good and the way they explained about the gld ornaments was good. Last i would like to mention that the models were best and Miss.R Pavani did her best to know about the ornament. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0715",
      "name": "Aneesh Kuppam",
      "rating": null,
      "text": "This is our first time to visit Krishna Jewelry. It was a great experience, they have a vide variety of gold jewelry's and great designs. They have best hospitality and ambiance.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0716",
      "name": "Anie Michelle",
      "rating": null,
      "text": "Very good experience at Krishna jewellers. Govind was assigned to us and was very patient and sweet throughout the time in showing us varient styles.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0717",
      "name": "anil kumar",
      "rating": null,
      "text": "Great experience visiting Krishna Jewellers, unique designs, Bhavani@Krishna Jewellers was very patient showing us different collections. We would definitely recommend the store. Will visit again soon for sure.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0718",
      "name": "Anil Kumar",
      "rating": null,
      "text": "Best place to buy gold ...will save lot of time, Bharath is a nice person ..helped me n spent lot of time ...happy with his services, Manager shiva also very friendly..thank you ..!!",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0719",
      "name": "Anil Kumar Bottu",
      "rating": null,
      "text": "I was suprised by the sales man Rajesh, who has great skills in understanding the customer taste and helping out to find the jewellery. And the store itself had a great hospitality for the customers. I strongly recommend one to visit the Krishna Jewellers at Jubliee Hills, Hyderabad.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0720",
      "name": "Anil Moduga",
      "rating": null,
      "text": "Very nice collection with best rates. We had great experience shopping here. They are very kind and respectful to customers. Especially salesperson Mallikarjun was super helpful to us and guided us well throughout the shopping. Will surely recommend this store.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0721",
      "name": "Anil-Shiva",
      "rating": null,
      "text": "They have best customer service. Pavan and Ajay are so good to understand the customer needs and urgency and they were able to deliver the Jewelry overnight for urgent delivery. Really appreciate their services and they are trustworthy to do the transactions.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0722",
      "name": "Anireddy Prema Latha Reddy",
      "rating": null,
      "text": "I recently visited Krishna Jewellers pearls and gems and I’m absolutely satisfied with my experience! The staff specially Bheem Garu was friendly and knowledgeable, helping me find the perfect piece. The quality of the jewelry is …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0723",
      "name": "anireddy renukareddy",
      "rating": null,
      "text": "Lovely friendly staff(bheem)and very impressed and purchased long and short necklaces. Thank you once again to Krishna Pearls Team!",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0724",
      "name": "anita medasani",
      "rating": null,
      "text": "Mr. Loknath was very patient and showed a variety of pieces which were stunning.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0725",
      "name": "Anita Reddy",
      "rating": null,
      "text": "Best place to buy jewelry in Hyderabad. All the persons there are super friendly and very knowledgeable and suggest the best in selecting products. I appreciate Rama garu in sales department and Nayeem garu branch manager for helping in every way to buy the jewelry.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0726",
      "name": "Anitha Akula",
      "rating": null,
      "text": "Had a great experience with their simple and customer friendly approach. Designs were exquisite. Mr. Mallikharjuna was very helpful in his assistance . Mr.Nayeem was of great help too.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0727",
      "name": "Anitha Reddy",
      "rating": null,
      "text": "Much satisfied with collection and Bharath is very patient in showing designs as per our request…….",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0728",
      "name": "anjali puttawar",
      "rating": null,
      "text": "Nice collections Good service by Govind showed all the verity collections Excellent services by Govind",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0729",
      "name": "Anjaneyulu Thanneru",
      "rating": null,
      "text": "Experience was good and mrs Rama devi dealt friendly and overall experience was delightful and amazing",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0730",
      "name": "Ann S",
      "rating": null,
      "text": "Had an excellent experience shopping by video call and in person at Krishna Jewelers. Riaz was very helpful and provided very good and caring service. Riaz helped us select the perfect jewelry in a short time! Very satisfied and happy with the experience.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0731",
      "name": "Annanyaw Reddy Kasala",
      "rating": null,
      "text": "Visited Krishna jewellers for the first time and got to see amazing collections in diamond chokers. One of my reffered me to visits here. Mr.swamy and Nisha helped us to choose the best. Thank you Krishna jewellers. Highly recommended....",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0732",
      "name": "Annu Sharma",
      "rating": null,
      "text": "I was assisted here by G praveen and ashok and ut was good experience.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0733",
      "name": "Anoohya Maganti",
      "rating": null,
      "text": "I needed some Silver Idols. Rakshita has done a thorough follow up and ensure I recieved everything I needed in same day",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0734",
      "name": "Anu Alla",
      "rating": null,
      "text": "Excellent customer service. Beautiful designs. Ajay and Rama Devi are very proactive in terms or communication and providing the updates for online transaction. I am very happy with my purchase and I highly recommend Krishna Jewellers.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0735",
      "name": "Anupallavi Hanchatey",
      "rating": null,
      "text": "Krishna jewellers have a great collection. Special thanks to Meenakshi who had a lot patience to show a varieties of collection and explained things in details about diamonds",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0736",
      "name": "Anuradha Prasad",
      "rating": null,
      "text": "Krishna jewellers one of the best, reliable and very customer friendly one stop shop for any occasion. The staff at the store is very friendly at all aspects. Mrs. Rama Devi is one such person who made my special event much extravagant. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0737",
      "name": "Anusha Bommakanti",
      "rating": null,
      "text": "You find excellent collection and multiple items here. And staff is just wow. They guide you in all suitable ways. Mainly Ganesh sai gave us good support while buying there collection. Thanks krishna jewellers.",
      "date": "",
      "displayDate": "Edited 4 years ago",
      "relativeDate": "Edited 4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0738",
      "name": "Anusha Chelluri",
      "rating": null,
      "text": "It was a wonderful experience buying jewelry from Krishna Jewellers via online shopping. Riaz was our sales contact and he was very responsive and patient in showing us various models over a video call, answering all our questions - being …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0739",
      "name": "anusha doddapaneni",
      "rating": null,
      "text": "Thank you so much for Mr.Sai Kumar garu for presenting huge varieties of jewellery models with great interest and patience. we spend almost hours but he maintained same smile from first to last. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0740",
      "name": "Anusha k",
      "rating": null,
      "text": "Got to shop at Krishna jewellers, Jubilee Hills.. it was an amazing experience…. Impressed with diamond collections… we are helped by Mr. Lokanath garu., who has explained n showed the pieces with patience and details for each piece… overall had an overwhelming shopping time…",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0741",
      "name": "Anusha Katuru",
      "rating": null,
      "text": "We are a regular customer of this store in Jubilee Hills. We keep coming back because of the high quality and durability of their pieces. Vinayak showed us some excellent collection and variety and understood what we were looking for. Definitely recommend for you to check this out.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0742",
      "name": "Anusha Kotha",
      "rating": null,
      "text": "Prasanna was helpful and really met customer expectations and also showed something in our budget range. Understanding the customer played a major role in buying this product. Thanks for the service will keep visiting again and again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0743",
      "name": "Anusha Pidugu",
      "rating": null,
      "text": "Shopping experience is awesome in krishna jewels. Designs are unique and elegant and have seen such collection nowhere. Especially Mr Mallikarjun garu’s customer service is very good and he helped us in completing our shopping very happily. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0744",
      "name": "Anusha Reddy",
      "rating": null,
      "text": "Very friendly staff…they were very patience.. Appreciate for your patience..they were showing designs until we get satisfied.. customer satisfaction is their first priority.. suraj and saikumar were very friendly who showed jewellery to us..Thank you suraj gaaru😊 …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0745",
      "name": "Anusha Surapaneni",
      "rating": null,
      "text": "Sai kumar is the talented person to showcase designs as per customer choices and very friendly. Overall i am satisfied with the collection",
      "date": "",
      "displayDate": "Edited 5 months ago",
      "relativeDate": "Edited 5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0746",
      "name": "anusha thudimilla",
      "rating": null,
      "text": "We recently had a wonderful experience at Krishna Jewellers. The staff was incredibly knowledgeable and attentive. Meenakshi helped us find the perfect piece of jewelry for my mom. Her deep knowledge of jewelry and her ability to understand …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0747",
      "name": "anusha tummala",
      "rating": null,
      "text": "From the quality, from the Craftsmanship and also from the customer service, we have always been satisfied with Krishna Jewellers. Mr.Sravan was always there for us to help what we need and show what the new colelctions were.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0748",
      "name": "anusha v",
      "rating": null,
      "text": "Excellent place to shop for bridal jewellery. Ramadevi helped us for our shopping. She is very informative and picked the best items for us. Would definitely be in touch with her for our future shopping with Krishna Jewels.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0749",
      "name": "Anusha Venantius",
      "rating": null,
      "text": "Recently purchased a necklace from this store, what an amazing service! Especially by a saleswoman named Rekha. She was so patient and even stayed overtime just to serve us. Thank you for our professionalism and the efficient in which your …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0750",
      "name": "Anvii Reddy Mogula",
      "rating": null,
      "text": "This shop only responds when we want big item , if we ask small items work they simply say we do not have or this is not possible. Beginning 2023 the shop people have respect and now they staff are very head strong and waste of time to go to this shop. I have purchased more than 25 lacks and now I do not want to go to this shop again.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0751",
      "name": "Ap Reddy",
      "rating": null,
      "text": "It was a great experience working with Krishna Jewellers staff for my purchase. Rama and Ramya were very professional and patient to review my request. The jewellery designs and ease of purchase process are the best in hyderbad.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0752",
      "name": "Aparna Menni",
      "rating": null,
      "text": "Sunita's service is good with good collection",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0753",
      "name": "Aparna P L",
      "rating": null,
      "text": "I had a very good experience at the store. Sarvesh did a great job while I was picking jewellery. He showed us many models of jewellery. He also helped us with fixing broken jewellery. Great service!",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0754",
      "name": "Aravind Umakant",
      "rating": null,
      "text": "This is my first experience to visit krishna jewellers Bheem is very good service and very nice collection who was very attentive to my request.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0755",
      "name": "Areefa Vallur",
      "rating": null,
      "text": "Sales executive Mallikarjuna was very professional and showed us lot varieties and beautiful pieces!! He Gave us good price and we are happy with his service! Thank you",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0756",
      "name": "Arihant Jain",
      "rating": null,
      "text": "Brilliant collection.... One of the best i have seen. Wifey was flattered with collection and variety. Must say very unique designs. Sales executive Mr. Loknath is excellent in his approach towards satisfying the customers. If you looking for jewellery in hyderabad then please visit krishna stores....",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0757",
      "name": "Artham Rajesh",
      "rating": null,
      "text": "Thank you very much for your good service Yadav ji nice collection of Jewellery we r very much satisfied.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0758",
      "name": "Arun Dutta",
      "rating": null,
      "text": "Great collection of design, and at very competitive price points. Prakash was very helpful in finding the right article I was looking.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0759",
      "name": "Aruna Gorla",
      "rating": null,
      "text": "R Sathish sale executive is a good person and explained very well on product finally we bought gold",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0760",
      "name": "Aruna Kumari P",
      "rating": null,
      "text": "Great collection in krishna jewellers jubileehills and Yadav sir shows us exclusive collection with reasonable price thank you",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0761",
      "name": "Aruna Teegala",
      "rating": null,
      "text": "Had a good shopping experience at Krishna pearls and jewellers . Especially sales person ( mallikarjuna)is very good in explaining the minute details of ornament.He even helped in negotiating the price with manager. Overall had a good experience",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0762",
      "name": "arundhati surakanti",
      "rating": null,
      "text": "Very good service. Appreciate Mr Venkat’s patience to show varieties and details of different products. Glad to make a purchase of my diamond bangles here at this store",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0763",
      "name": "arvind talary",
      "rating": null,
      "text": "Amazing experience with Krishna jewellers - each piece is crafted to perfection which is nothing less than royalty - so welcoming and great ambience too, staff are wonderful especial mention Riaz who is an absolute star- thank you so much - strongly recommend to visit the showroom quality is at its best.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0764",
      "name": "ASHA SHAINEY",
      "rating": null,
      "text": "Design and service was so beautiful and Pavani saleswomen showed every item patiently... overall collection was good satisfied !",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0765",
      "name": "Ashok Emani",
      "rating": null,
      "text": "Excellent collection and tops it off with amazing service. Writing this review especially to acknowledge professional and patient service …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0766",
      "name": "ashok kurakula",
      "rating": null,
      "text": "Nice collection! Great service! Reasonable prices. We had an amazing experience with sales person Venkatesh! Would definitely recommend this place to all.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0767",
      "name": "Ashwini Kancharla",
      "rating": null,
      "text": "Your customer service is outstanding, especially Prasanna who help me with the purchase of Dimond necklace ,she is very polite ,professional showed me all the latest designs with utmost patience and assisted me till the end. I had a …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0768",
      "name": "Ashwini Samala",
      "rating": null,
      "text": "Excellent collection!! Special thanks to Sai Kumar for being extremely patient and showing us wide collection. it was a wonderful experience shopping for my daughter.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0769",
      "name": "askani katyayani",
      "rating": null,
      "text": "Nice models maha Lakshmi service good",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0770",
      "name": "Asmita Rao",
      "rating": null,
      "text": "We ordered a necklace from Bangalore and we spoke to Naresh about our requirements. Naresh was very helpful , kind and patient with us . …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0771",
      "name": "Asrita k",
      "rating": null,
      "text": "Excellent service was provided by Mr.Kushal. He was very polite and patient and precise about every detail. I’m looking forward to visit again and appreciate his help in our purchase today",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0772",
      "name": "asv puneet",
      "rating": null,
      "text": "Great experience. Huge collection. Lovely ambience and good hospitality. Bheem coordinated very well with us . Helping with our order too good. Our ordered rings came out perfect. Thanks Krishna jewellers.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0773",
      "name": "Aswani naga",
      "rating": null,
      "text": "Diamond collection good here and meenakshi and venkat helped me on selection and explained each and every details in bill.thank you for the support.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0774",
      "name": "ASWARTHA REDDY BADRI",
      "rating": null,
      "text": "staff are friendly and helpful. Very patient enough. R Satish and Lalappa made our purchase smooth",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0775",
      "name": "Avikshath Reddy",
      "rating": null,
      "text": "I came here with my sister watching their video on IG. They received us very well and the customer experience is top notch headed by sales executive Venkatesh. He was patient and humble though we were looking at different designs and taking time. They also made sure we got pretty good discount.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0776",
      "name": "Avula Subha",
      "rating": null,
      "text": "Very good assistance provided to buy silver pooja items, thank you Satish for your patience until final Bill.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0777",
      "name": "AYUSHKA SAHU",
      "rating": null,
      "text": "Awesome service by U Krish. The pearl collection was good. The process was seamless",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0778",
      "name": "B Guntur",
      "rating": null,
      "text": "Store has really good collection. Rama Devi has provided best customer service. She is very helpful, very patient and has presented best products in the store. Highly recommend her.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0779",
      "name": "B Madan Mohan Reddy",
      "rating": null,
      "text": "Good collection And Pavani is the Best sales woman .Nayaem is a good human and best manager.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0780",
      "name": "B Swaroopa",
      "rating": null,
      "text": "Good collections specially salesmen bheem has given good service.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0781",
      "name": "B Thirupathi",
      "rating": null,
      "text": "Recently we purchase one Gold Necklace through video call. Am really so happy for the communication with SRAVAN. He helps me so much for our Gold purchase. He is really clear the things so nicely..Thank U for the team of Krishna Jewellers.",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0782",
      "name": "Babu Kedia",
      "rating": null,
      "text": "Mr.bharath has been a wonderful sales man.. throughout,he showed us the required designs and was very patient throughout loved the experience thank you!!!",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0783",
      "name": "Bala Atharv Kandi",
      "rating": null,
      "text": "I had great experience in the store. Ms. Meenakshi has provided highest quality service and helped in very satisfactory purchase experience. Highly recommend thr store and Ms.Meenakshi for your jewelry purchase needs",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0784",
      "name": "Balakrishna Yarru",
      "rating": null,
      "text": "This is my first visit to the store. Very unique collections and wide varieties are available. Service is amazing and Mr. Venkatesh provided very good service and showed us wide varieties. Would definitely recommend it for everyone.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0785",
      "name": "balla sai mohan",
      "rating": null,
      "text": "Nice response and service from R Sateesh Sales executive",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0786",
      "name": "ban reddy",
      "rating": null,
      "text": "Nice collection Govind showed all variety of collection Thank you",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0787",
      "name": "Bandi Indra Sena Reddy",
      "rating": null,
      "text": "R Sathish patiently shown all the available models in gold and diamond. Very happy with his service.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0788",
      "name": "bandla shalini",
      "rating": null,
      "text": "Priya has been really awesome to deal with. Made our experience so much better. We will comeback and ask for priya again. Overall good collection.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0789",
      "name": "Banerjee Babu R",
      "rating": null,
      "text": "One of the best shopping place for pearls, diamond and gold jewellery. Staff are courteous and jewellery designs are good. Speciality is Designs తీర్చి దిద్దినట్టు ఉన్నాయి. Especially our thanks to Ramadevi Garu for patiently showing designs and helping us in selection",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0790",
      "name": "Banjara hills",
      "rating": null,
      "text": "I had a wonderful experience in Krishna jewellery And S.Bharat was helped so much.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0791",
      "name": "Basanthi Reddy",
      "rating": null,
      "text": "The best jewellery shop in entire telangana I have ever visited. Their collection is amazing. You will want to visit number of times for their hospitality. Price are comparatively very good. A must visit!",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0792",
      "name": "Bejugam Nithish Kumar",
      "rating": null,
      "text": "Experience was very nice and customer service from Pavani was really good and well explained",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0793",
      "name": "Bh Supriya",
      "rating": null,
      "text": "Designs are very nice.Yadav and Lakshmi prasanna service is very good.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0794",
      "name": "Bhanu K",
      "rating": null,
      "text": "I'd always love to come back to Krishna Jewelers. They have a wide variety of jewelry with collection in every budget. Mr. Venkat Ch has assisted us while we were there, he has patiently shown us a variation of diamonds jewelry.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0795",
      "name": "Bhanu Parchuri",
      "rating": null,
      "text": "Good jewellery collection. Pavani garu from sales is very helpful",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0796",
      "name": "bhanu prasanna",
      "rating": null,
      "text": "I have been here at this place for my wedding . Stellar collection .Mr. Gururaj has been very patient in showing the jewellery according to the requirements and now I’m here shopping for my brothers wedding . Very happy with this collection too .Would highly recommend for wedding collection",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0797",
      "name": "Bhanu Priya",
      "rating": null,
      "text": "Awesome Customer service. I got a very good set from Krishna Jewellers. Set was as beautiful as I saw in video call. Dinakar and Rama Devi took very good care of me. They are very helpfull. Looking forward to do more business with …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0798",
      "name": "BHANU PRIYA",
      "rating": null,
      "text": "Loved the designs. Thanks to staff member Govind for his patience and excellent service in showing us a wide collection.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0799",
      "name": "Bhanu Priya Vaidyula",
      "rating": null,
      "text": "Thank you, Pavani, for the exemplary customer service! Pavani is very knowledgeable, customer centric and went above & beyond in getting the models requested. Throughly enjoyed the conversation.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0800",
      "name": "bhanupriya s",
      "rating": null,
      "text": "We had a really great experience at krishna jewellers. Naresh was our sales person and he showed us many designs with lot of patience. Not only their designs are good, their customer service is great and added to that they gave fair …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0801",
      "name": "Bharadwaj Ananthula",
      "rating": null,
      "text": "Though this was our first visit here, we were highly satisfied with the collection and professionalism of the sales men. Bharath and Nisha were extremely patient throughout and showed us multiple products until we were satisfied. Highly recommend",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0802",
      "name": "Bharani Kumar",
      "rating": null,
      "text": "I recently bought a ring here. Thanks for Ramadevi garu for suggesting me the right choice instead of merely selling the item there. Additionally as i was travelling and Ramadevi garu helped me to deliver the ring to my home. Thanks for all the help.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0803",
      "name": "Bharat Babu",
      "rating": null,
      "text": "Loknath has been very helpful in showing all kinds of latest jewellery. Appreciate his patience and we are very happy with our shopping experience with him today. We would love to come back to Krishna Jewellers for our future shopping.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0804",
      "name": "Bharath Bharathpatil",
      "rating": null,
      "text": "Happy with the service by Govind I had Good experienced in Krishna jewellery nice Collections",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0805",
      "name": "Bharath Perumal",
      "rating": null,
      "text": "The collection at this place is very diverse unique and beautiful. The salespeople were very skilled, and they are excellent at customer service. They are extremely patient and went to great lengths to accommodate us. Special mention to salesmen Yadav and Sai Kumar. They also give best prices on the pieces",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0806",
      "name": "BharathReddy KBR",
      "rating": null,
      "text": "So many collections. Love to buy many in future. We preferred video call. Mounika and Ramakanth helped us to show the jewellery in our budget. Just consider this showroom before making any purchase. Have fun. ☺️👍 …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0807",
      "name": "Bhargavi P",
      "rating": null,
      "text": "Nice collection Good services by Govind",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0808",
      "name": "Bhargavi Rayavarapu",
      "rating": null,
      "text": "With a happy happy face and experience, I would recommend anyone and everyone to go shop and Krishna. I can sleepwalk to this store too. And not to forget \"Rekha\" is my goto person and the happiest face at Krishna who will be very patient to help you any time l.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0809",
      "name": "Bhargavi Yadav",
      "rating": null,
      "text": "Had a fantastic experience at Krishna Jewellers! Beautiful designs, excellent craftsmanship, and very helpful staff. The quality and service were top-notch. Highly recommend for anyone looking for elegant and authentic jewellery!",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0810",
      "name": "Bharghavvi Reddy",
      "rating": null,
      "text": "Bridal collection is pretty good and the staff is very polite and patiently gave us time to choose specifically ratna raju helped us in choosing what we want and we are very much satisfied with the collection and price range … overall I would suggest friends and family to have a look definitely u won’t regret …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0811",
      "name": "BHASKARA RAO DAMA",
      "rating": null,
      "text": "Sales woman Priya has shown best ornaments for me. And she can understand what We need. Excellent models.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0812",
      "name": "Bhaskarbabu Alam",
      "rating": null,
      "text": "We had an amazing experience at Krishna Jewellery, thanks to Rama Devi, sales executive. She showed us a fantastic selection of jewelry items with utmost patience and genuine hospitality, making the whole process enjoyable and stress-free. …",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0813",
      "name": "Bhavana C K",
      "rating": null,
      "text": "Our experience has been amazing every time we visit the store, we have been a customer for over a year now and we visited over 6 times and bought jewellery 5 times. We were happy with the models they had and their service has been exemplary …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0814",
      "name": "bhavana mundada",
      "rating": null,
      "text": "Lots of Collection but tooooo muc Cost on pearls and V.A and Making.. They have Wastege chagers plus Making charges.. Too much..",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0815",
      "name": "Bhavana Palala",
      "rating": null,
      "text": "This place has good collection for varied ranges and liking. Yadav was very helpful- he showed us various designs and was pretty patient with us (we were in the store for about 7 hours :) ) He showed us every possible design and helped us curate a whole bridal set. Thanks to Yadav for helping me find my look for my big day! :)",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0816",
      "name": "bhavana pulipati",
      "rating": null,
      "text": "Nice collection, rekha garu showed all the jewellery pieces very patiently. Govind also helped a lot",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0817",
      "name": "Bhavika Veeramachaneni",
      "rating": null,
      "text": "Had exceptional services from the online team and in-store team at Hyderabad for our recent experience from Krishna Pearls. They were very responsive through the entire process and made it a extremely smooth experience.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0818",
      "name": "Bhavya Digumarthi",
      "rating": null,
      "text": "I enjoyed my shopping experience with Sandhya in today's purchase.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0819",
      "name": "Bhavya rao",
      "rating": null,
      "text": "It is really a good experience shopping in krishna jewelers. Rama devi sales person showed the products by understanding our requirement and Nayeem store manager gave us the best price for all the products we purchased.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0820",
      "name": "Bhavya Ratnam",
      "rating": null,
      "text": "Came across there page on insta...been a pearl fan.. was stunned looking at every product . . amazing designs... Purchased a pearl gold stud... Krishna was kind and had lot of patience answering my queries.... finally ordered my product.. and it was very pretty as it looked...",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0821",
      "name": "Bhavya Reddy",
      "rating": null,
      "text": "Very good collection. Sainath was very polite and helped us with amazing collection at reasonable prices. We are very happy with our purchase and looking forward to our next purchase.",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0822",
      "name": "Bheema Naga Samrat Nikkhil",
      "rating": null,
      "text": "I went to buy idols at jublieehills branch, Hanumanth rao sir in Silver section is humble, patient in explaining and showing the various models and got me the required tailored idols from other branch Kokapet, and suggested the best suitable for my purpose. good hospitality. Good service.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0823",
      "name": "Bhogeswara Rao M",
      "rating": null,
      "text": "Very pleasant experience and customer friendly. Sales person Chandu is very helpful thanks for the pleasant shopping experience.",
      "date": "",
      "displayDate": "Edited 4 months ago",
      "relativeDate": "Edited 4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0824",
      "name": "Bhoja Vundyala",
      "rating": null,
      "text": "Very happy with customer service provided by Ramadevi. I will highly recommend her service. She was very courteous. She has lot of patience to show all available choices and provided honest opinion for customers to make decision",
      "date": "",
      "displayDate": "Edited 9 months ago",
      "relativeDate": "Edited 9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0825",
      "name": "Bhoomigari Sanjay Kumar",
      "rating": null,
      "text": "Great customer service Sandhya Rani ,I actually visited all the jewellers, but I did not find any special designs until I went to Krishna jewellers and pearls, where I discovered the latest and upgraded designs along with awesome customer …",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0826",
      "name": "Bhoopal Reddy Daripally",
      "rating": null,
      "text": "We are happy with the service provided by Vinay, he has shown every ornament from their collection, helped us to understand all the components in bill slip which never understood before. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0827",
      "name": "Bill fagi",
      "rating": null,
      "text": "I had a wonderful experience dealing with Nayeem and Sandeep. I made a purchase couple months ago locally and recently was browsing through some pictures and liked another set. They worked with me online showing me many options and later …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0828",
      "name": "Billakanti Narendra",
      "rating": null,
      "text": "Awesome collections in store in all varieties. Especially Mallikarjuna has great knowledge on collections and understands customer requirements properly. He provides best service.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0829",
      "name": "bindhu kallem",
      "rating": null,
      "text": "If you looking for any Antique or temple jewellery please so visit Krishna jewelleries. The collection is so unique. Pavani service was really good..look for her to get good jewellery sets.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0830",
      "name": "Biyyala Venkatesh",
      "rating": null,
      "text": "Wonderful experience with krishna jewellers and very wonderful team to receive customers politely. Salesman Sathish had very good interaction and wonderful piece to piece explanation",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0831",
      "name": "Bobbili Himashyla",
      "rating": null,
      "text": "I had best experience in Krishna jewellers . I purchased pearls and jenes. They are very beautiful and pretty. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0832",
      "name": "boyapati parimala",
      "rating": null,
      "text": "Collection are awesome design are good pavani give great service we purchased bangels for here my friend reference me thank you for Krishna jewellers",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0833",
      "name": "Brahmani Gogineni",
      "rating": null,
      "text": "Exceptional Service and Stunning Jewelry! I recently visited Krishna jewellers, Jubilee hills to make a significant …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0834",
      "name": "Bruhath Meghana Pothula",
      "rating": null,
      "text": "Krishna jewellers ambience and service was too good they were so helpful and patient while showing us the gold ornaments specially Pavani sales person was so helpful and kind towards overall it was a good experience I’m so happy .",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0835",
      "name": "Bucha Reddy",
      "rating": null,
      "text": "Krishna Jewelers has great collection of diamond jewelry with high quality ornaments. Customer service is top notch and has a very friendly staff. Rama Devi Garu helped us through the whole buying process and she was exceptionally the best …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0836",
      "name": "buchireddy yatharla",
      "rating": null,
      "text": "We are extremely satisfied with the services of The Krishna Jewellery, Jubilee Hills. and the way Venkatesh received us is very polite and utmost satisfaction. And here International shipping also provided in this shop.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0837",
      "name": "Bunny Reddy",
      "rating": null,
      "text": "We have gone to Sri Krishna Jewellers visited Yet Again! Bheem and Pavani showed us best and latest collection with the patience. Pavani as usual the best",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0838",
      "name": "C pavan kumar Pavan",
      "rating": null,
      "text": "Dear retailer n MD of krishna jewelleries and pearls hyd jubilee hills I have purchased a lot of jewelry from your esteemed showroom with a trust n in nic. Thanking you for your nice gesture and hospitality shown.e sales man ship of your …",
      "date": "",
      "displayDate": "Edited 6 months ago",
      "relativeDate": "Edited 6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0839",
      "name": "c Taruni",
      "rating": null,
      "text": "They have great collection in all varieties. The staff is very patient and cooperative. Govind helped us with the purchase and has been very understanding with what kind of designs I was looking for. Definitely recommend!",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0840",
      "name": "Caanz Gollapudi",
      "rating": null,
      "text": "Ramya Pavani helped me to select the right product which enhances everything. Collection at Krishna jewellers was awesome and elegant.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0841",
      "name": "Chaitanya Bharati",
      "rating": null,
      "text": "Krishna Jewellers have good collection of antique jewelry. Staff are very professional and Naresh is very patient in showing all designs through video call, answered all the questions and helped a lot to find the items I am looking to buy. They packed it very well delivered to home.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0842",
      "name": "Chaitanya G",
      "rating": null,
      "text": "Collection was good and service was great. Sunita did wonderful job in showing the collection and was of great help with everything. Thank you ! 😊 …",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0843",
      "name": "chaitanya patil",
      "rating": null,
      "text": "The service is great here and Mr.Lokanath helped me with everything with patience",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0844",
      "name": "Chaitanya Vani",
      "rating": null,
      "text": "It was very good experience with Krishna jewellery , in Jubilee Hills. The staff in the store are very nice and showed all the ornaments which I asked with lot of patience. Mr Venkat Ch who assisted me in entire my purchase. Thank you Mr Venkat for your assistance and made my purchase so smoother.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0845",
      "name": "chaitu bond",
      "rating": null,
      "text": "Very good customer service. Guravaiah is very accommodating and patient. They have good designs compared to other sites nearby. Great sandwich too",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0846",
      "name": "Challa Alekya",
      "rating": null,
      "text": "We had a wonderful experience at Krishna Jewellery Store, Jubilee Hills, thanks to Bheem. He was extremely polite, knowledgeable, and patient in helping me find the perfect jewellery. He explained every detail clearly, gave genuine …",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0847",
      "name": "Challa vasavi Reddy",
      "rating": null,
      "text": "We had a wonderful experience at Krishna jewllery store jubileehills,thanks to Mr.Bheem.He was extremely polite, knowledgeable,and patient in helping me find the perfect jewellery.He explained every detail clearly,gave genuine suggestions.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0848",
      "name": "Chandana Cherukuri",
      "rating": null,
      "text": "Wide range of varieties are available in different models. All bridal jewellery is very good. Priya is very good in explaining about the items in detail.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0849",
      "name": "Chandana Donkala",
      "rating": null,
      "text": "Collection is really nice and a great service by Sandeep and govind",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0850",
      "name": "Chandini Chitikela",
      "rating": null,
      "text": "Govind is excel at his service and loyality. I highly recommend and will come back again.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0851",
      "name": "Chandra Sekhar G",
      "rating": null,
      "text": "Very good and plenty of new designs. Bharath was very patiently showed the designs, customer friendly and understood customer requirements. Overall very satisfied with the experience. Must visit and pick your choice.",
      "date": "",
      "displayDate": "Edited 11 months ago",
      "relativeDate": "Edited 11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0852",
      "name": "ChandraSekhar Makkapati",
      "rating": null,
      "text": "Collection is very pretty pavani and bheem show very help full we purchased haram and vadanam thanks for krishna jewllery",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0853",
      "name": "chandrika alaparthi",
      "rating": null,
      "text": "Very patient and friendly staff, especially Meenakshi garu. She is always smiling and helping in every possible way. I will definitely come back here.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0854",
      "name": "chandrika anusha",
      "rating": null,
      "text": "We are very satisfied with collection here. Have been purchasing jewellery here for a very long time. Bheem sir has been very helpful and friendly. Definitely should check the collections here",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0855",
      "name": "Chandrika Meduri",
      "rating": null,
      "text": "It was great expereince at krishna jewellers jubliee hills which i visited for the first time.They have a very good collection of daimond jewellery with beautiful designs …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0856",
      "name": "Charitha Reddy",
      "rating": null,
      "text": "very nice experience and really nice collection of jewellery . Staff is so patient and Pavani helped us lot in choosing the right collection . really happy with the purchase and the overall experience",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0857",
      "name": "Charulatha Katta",
      "rating": null,
      "text": "Recently bought jewellery from this store couple of times online in last two months, Phenomenal customer service, Exceptional designs, Great delivery service on time and with care. Special Thanks to Mr Durgaprasad for keeping them …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0858",
      "name": "Chathroje Bhourao",
      "rating": null,
      "text": "Nice collections Thank you Govind for serivce and showing lot of designs",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0859",
      "name": "chetan singh",
      "rating": null,
      "text": "Wonderful showroom Meets expectation of every one Must visit for your requirement. …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0860",
      "name": "Chetna Poojari",
      "rating": null,
      "text": "Krishna jewellers is my favorite place for several reasons the variety of designs, hospitality and staff. Mr. Yadav understands our taste so well and takes care of our needs and helps us pick exactly what we want. Thank you",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0861",
      "name": "chinna devi",
      "rating": null,
      "text": "Collections are good model s are awesome pavani show very well we are happy with purchase",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0862",
      "name": "Chinna Tadisetty",
      "rating": null,
      "text": "Very nice designs. They have many new patterns compared to other stores. Mr Ganesh garu was awesome. He was very patient and explained the details very well.. Gave us a good deal as well.. he give best services to customers.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0863",
      "name": "Chintu Kundhuru",
      "rating": null,
      "text": "Krishna jewellers I visited resently customer service and sales girl Meenakshi received well...good 👍 …",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0864",
      "name": "Chitra Rajagopalan",
      "rating": null,
      "text": "I am buying so many silver items past one year onwards . All product is super . Online service also excellent. The product workmanship is very good 🙏pooja service is excellent . Very humble reply to customer 🙏karudabalaji super idol. I want thank Pooja. Excellent service 🙏 …",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0865",
      "name": "Chowkat Vainavi",
      "rating": null,
      "text": "Mrs.Rekha is an excellent employer and I like the services they have provided to me in time.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0866",
      "name": "Chowki Arvind",
      "rating": null,
      "text": "Very happy to shop at Krishna Jewellers — absolutely delighted with the service provided by Sales Executive Srikanth.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0867",
      "name": "Chowtala Vinay",
      "rating": null,
      "text": "Nice collection pawan helps a ua to select jewellery",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0868",
      "name": "Click Eat Xplore Yo Live CEXY",
      "rating": null,
      "text": "I have been to Krishna jewellery’s for the first time ditching the chain jewellery brands . Courteously welcomed and made us comfortable. The staff here are well trained on the product and also how to establish a connect and trust with the …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0869",
      "name": "cpo ghmc",
      "rating": null,
      "text": "I’m writing this with full of satisfaction Especially I would appreciate mr ganesh sai who is the one taking care of us assist better more than what we expect… the way his patience, his gesture and over …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0870",
      "name": "D Phani",
      "rating": null,
      "text": "Lots of awesome collections and great service. Especially thanks Yadav for your patience. I will now always consider this brand. And will highly recommend.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0871",
      "name": "Danilo Popovic",
      "rating": null,
      "text": "Great service and very good prices. 😊😊😊 …",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0872",
      "name": "Dasadi Sai",
      "rating": null,
      "text": "Good service by pawan very good collection in diamond and gold i recommend Krishna jewellery jubhills",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0873",
      "name": "dasari rajashree",
      "rating": null,
      "text": "Awsome collection, quality and ambience. Great craftsmanship. Mr. Yadav was very patient and helpful even in this pandemic situation. Special thanks to him and for his great customer service. Neatly sanitised and good precautions are taken. …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0874",
      "name": "Datta Kiran",
      "rating": null,
      "text": "R Sateesh was patient enough to show ample models and helped us through the process. Overall a good experience",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0875",
      "name": "dedipya pasula",
      "rating": null,
      "text": "Wonderful jwellery collection ❤️.....management was too good with the costumers😇 ... Thankyou Jagannath reddy.... …",
      "date": "",
      "displayDate": "3 months ago",
      "relativeDate": "3 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0876",
      "name": "Deepa",
      "rating": null,
      "text": "Had a good experience shopping with Krishna jewellers at Jubilee Hills store. Designs are unique, service is good. Mr.Venkat from video call team was very helpful from the time we asked for video call shopping till we made the purchase and …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0877",
      "name": "Deepika gunda",
      "rating": null,
      "text": "Very bad service..we paid all the amount on time but still didnt received our item on time..we notified salesperson in advance about our pickup date and item they made us wait in the store for 6 hours and didnt delivered the item..never recommend this store",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0878",
      "name": "Deepika Kondaveeti",
      "rating": null,
      "text": "Great designs. The staff is very patient especially yadav has done a fab job in showing various collections. Must visit!",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0879",
      "name": "Deepika P",
      "rating": null,
      "text": "Such a Great Collection and greatly reasonable charges against the Gold purchase. We were very happy to chose, visiting your store. …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0880",
      "name": "Deepika Pudota",
      "rating": null,
      "text": "had a very pleasant experience, GS Yadav was very patient and showed us good collection of Jewellery.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0881",
      "name": "Deepta Raju",
      "rating": null,
      "text": "I have been visiting Krishna Jewellers for past 6 years. The quality and designs of jewellery whether gold or diamond are dazzling. So much variety to chose from. The service of executives like Venkatesh in showing various designs with …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0882",
      "name": "Deepthi A",
      "rating": null,
      "text": "Great service by sai Kumar and Bharath garu, very patient and showed us great collections. Will definitely come back and shop with sai kumar garu. Bharath garu did a great job and helped us in finding best maang tika.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0883",
      "name": "Deepthi Daita",
      "rating": null,
      "text": "Govind showed us excellent collection that there is jubilee hills. Lots of choice for chokers and bangles, spoilt for choice. Good latest and unique collection",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0884",
      "name": "deepthi gk",
      "rating": null,
      "text": "Excellent service.. huge patience levels to show varieties.. thanks a lot Rama Devi… i found good jewellery because of you.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0885",
      "name": "deepthi kollipara",
      "rating": null,
      "text": "We had a great shopping experience at Krishna jewelers . Thanks to Mr. Kushal who was very attentive to our requests/wishes and was proactive in showing us the latest designs. Entire staff were friendly and provided great hospitality. Their collection was exquisite and trendy. I would definitely visit again to shop.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0886",
      "name": "deepthi reddy",
      "rating": null,
      "text": "Very good collection in both gold & diamonds. Ramadevi garu is really patient enough with customers and professional. Rajashree is also helped with details i requested online. Which was really helpful to decide my purchase item.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0887",
      "name": "deepthi reddy",
      "rating": null,
      "text": "1 year back Mr Vinod assisted me online and was very helpful and responded promptly.. I visited store today and it was great ... collection is very good ... my overall experience was great... Will visit again.... thank you Mr Vinod for showing the collection ... and making it easy ...",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0888",
      "name": "Deepthi Reddy",
      "rating": null,
      "text": "We have visited Sri Krishna pearls and jewellers. Rajesh took the initiative and we extremely happy with his service and his patience. Happy to purchase in Sri Krishna pearls and jewellers. Thank you!!",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0889",
      "name": "deepthi seernam",
      "rating": null,
      "text": "Very good Govind has provided very good service",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0890",
      "name": "Deepthi Vankayala",
      "rating": null,
      "text": "Outstanding service! Truly grateful to salesperson Sunita for her patience and keen understanding of our needs. She went above and beyond to ensure we were well taken care of. The store also offers a trendy and diverse collection with something for everyone—making the entire shopping experience even more enjoyable.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0891",
      "name": "Deepthi Vemu",
      "rating": null,
      "text": "We had a good experience with Krishna jewellers. The gold and diamond collection is unique and huge. Thanks to Sandhya Rani and Gururaj for helping us.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0892",
      "name": "Deepti K",
      "rating": null,
      "text": "Having been an old customer to Krishna I have always been extremely satisfied with my purchase . The designs are outstanding and unique when compared to many other stores . Miss Sunita Madiri has very good knowledge and has clearly …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0893",
      "name": "Deevna Reddy",
      "rating": null,
      "text": "Our first visit to this jeweler's shop in Hyderabad was truly remarkable. The team, including Ms. Ramya Pavani who displayed excellent attention to detail and a deep commitment to customer comfort. We felt completely at ease with no …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0894",
      "name": "DERANGULA SHEKHAR",
      "rating": null,
      "text": "Krishna Jewellers Collections are unique and & good quality and also great customer services. Mr.Shravan Explanation was superb & thanks to shravan because he gave good suggestion for us to purchase jwellery finally thanks to Krishna Jewellers",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0895",
      "name": "Devaraj Biradar",
      "rating": null,
      "text": "Thank U Krish, nice customer service.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0896",
      "name": "DEVARAKONDA SRI DEVI",
      "rating": null,
      "text": "Excellent customer service by Sandhyarani. Pocket friendly price point. High standards of quality and purity. Thank you Krishna Jewellers for the good experience, will be coming again and again.",
      "date": "",
      "displayDate": "Edited 11 months ago",
      "relativeDate": "Edited 11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0897",
      "name": "Devaratha",
      "rating": null,
      "text": "Good collection! Prem Teja was helpful and made the entire shopping experience seamless",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0898",
      "name": "Devendra Sali",
      "rating": null,
      "text": "Nice showing products and good service by S.Bharat",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0899",
      "name": "DEVENDRANATH DABBAKUTI",
      "rating": null,
      "text": "It was a painstaking experience to select an ornament from a store like yours because of huge variety and plenty of collection. Ch. Venkat had made it a pleasant one by explaining and demonstrating plenty of models, till we could select one …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0900",
      "name": "Devi Sree",
      "rating": null,
      "text": "Visited the store for first time.. well versed customer service by Mallikarjuna staff member.. Have got vast collection to choose and got our required item satisfactorily.. Thank you for best designs.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0901",
      "name": "devi talluri",
      "rating": null,
      "text": "Excellent and huge collection of jewellery. Service provided by the staff especially Sandeep is very good he showed and explained about the designs of the jewellery with lot of patience. Very happy with my visit to the store.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0902",
      "name": "Dhana lakshmi",
      "rating": null,
      "text": "We had a great shopping experience with Krishna jewellers. This time I bought bangles.they have huge verities and Elegant and spectacular designs in all sections. Then coming to sales executives they were very humble, polite, and very …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0903",
      "name": "dhanush chaitu",
      "rating": null,
      "text": "Good jewellery, unique design chokers, The staff especially, Mallikarjuna, was very courteous and patiently showed us a variety of items, Definitely its a right place to purchase bridal jewellery.Thank you krishna jewellers.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0904",
      "name": "Dhriti Reddy",
      "rating": null,
      "text": "The collection is extraordinary. Contemporary and unique exquisite designs are available. The staff are very kind and engaging. Rajesh especially was very helpful.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0905",
      "name": "Diksha Prakash",
      "rating": null,
      "text": "Had a great experience with Rohit. They have a good pearl collection as well!",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0906",
      "name": "Diksha Shakya",
      "rating": null,
      "text": "Had a good experience with Pavani. She showed all varieties of jewellery patiently and listened to our requirements.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0907",
      "name": "dileep mandali",
      "rating": null,
      "text": "We had great experience at Krishna Jewelers. Meenakshi was very helpful, showed us lot of designs and made sure we are satisfied with the purchase.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0908",
      "name": "Dipika Joshi",
      "rating": null,
      "text": "Satish and Santoshi madam are great. Really appreciate their efforts. Great collection.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0909",
      "name": "Divya Chinna Panuganti",
      "rating": null,
      "text": "Best in class designs and good customer service. Loved the uniqueness of designs here. Sales rep Pawan is the best to deal with. He is keen to details and understood my custom requirements. Happy with the purchase.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0910",
      "name": "Divya Devalla",
      "rating": null,
      "text": "Nice collection service good maha lakshmi",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0911",
      "name": "Divya Medishetty",
      "rating": null,
      "text": "The Jewelry I purchased from Krishna Pearls - Jubilee Hills Store is very classy, yet very reasonably priced. Stunning and Great quality jewelry and the best customer service! Prompt replies to all inquiries. …",
      "date": "",
      "displayDate": "9 years ago",
      "relativeDate": "9 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0912",
      "name": "Divya Peduthala",
      "rating": null,
      "text": "Have been buying with Krishna Jewellers for many years now. They have the best & latest collection of jewelry in both gold and diamonds. Special shout-out to the customer rep Sandeep and store manager Mr. Nayeem who helped us on our very …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0913",
      "name": "Divya R",
      "rating": null,
      "text": "Krishna jewellers has excellent collection , I have been visiting the store since a year and the executives are really helpful . Their executive venkat explained in detailed about all the items and helped us choose the necklace effortlessly",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0914",
      "name": "divya raju",
      "rating": null,
      "text": "Hello , I had a great experience shopping at Krishna Jewellers pearls and gems recently , their timely response made it easy for me to Select my jewellery over a video call and receive it in hand on time . They have …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0915",
      "name": "Divya Reddy",
      "rating": null,
      "text": "Great collection. Sales associate Menakshi helped us a lot and had a lot of patience. Happy with our purchase.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0916",
      "name": "Divya Reddy Manku",
      "rating": null,
      "text": "Great experience and appreciate Ramadevi for service. latest and good designs. We purchased 4 diamond jewelery items.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0917",
      "name": "Divya S Vanka",
      "rating": null,
      "text": "Pleasure purchasing jewelry at Krishna Jewelers. Customer service by Ramadevi was excellent! She was very patient with us throughout the process. Appreciate her diligence and commitment to explain jewelry in details. Will highly recommend …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0918",
      "name": "Divya Santhanam",
      "rating": null,
      "text": "Recently purchased a made to order ring the service and timeliness on delivery was good, they also have variety of designs and options to choose from. Divesh helped from the start to delivery .",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0919",
      "name": "divya shetty",
      "rating": null,
      "text": "I absolutely love the collection at Krishna Jewellers, Jubilee Hills! Their pricing is quite reasonable, making the shopping experience even better. A special mention to Priya, who assists customers with great patience and warmth. Her …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0920",
      "name": "Divya Sree",
      "rating": null,
      "text": "Very unique designs and wide variety of models. The staff is very patient and helpful. Govind has guided us in showing all designs and the billing process was very smooth..",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0921",
      "name": "Divya Tyagi",
      "rating": null,
      "text": "SandhyaRani was of great assistance. She was really helpful and provided us with all the information we needed.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0922",
      "name": "Divya Tyagi",
      "rating": null,
      "text": "It has always been a wonderful experience to purchase jewellery from Krishna Jewellers, Banjara Hills Road no. 10. Yadav understood the designs I was actually looking for and assisted well throughout.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0923",
      "name": "dnsatya",
      "rating": null,
      "text": "Dear Krishna Jewellers, We have received your Diwali greetings along with gift and it is a WOW experience for all of us in the family..We are missing this kind of Jewellery Shop in Vizag. We are happy to Krishna at vizag exibition 😊 …",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "gifting"
      ]
    },
    {
      "id": "stream-0924",
      "name": "donthiri prabhakar reddy",
      "rating": null,
      "text": "great place for wedding jewellery sri lakshmi has helped us find a perfect jewellery.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0925",
      "name": "Dr Chaitanya Tetali",
      "rating": null,
      "text": "Had a very great experience at Krishna jewellers jubileehills...meenakshi was too gud at her work..she has lot of patience and knows what the customer needs...lot of varieties as well...thanks to swamy garu for ur work...love to visit again..",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0926",
      "name": "Dr Chandra Sekhar",
      "rating": null,
      "text": "Great designs and worth the money. Mahesh ji showed us all the designs so patiently. Definitely will come back for more and strongly recommend it to everyone.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0927",
      "name": "Dr G visweswararao",
      "rating": null,
      "text": "From 2014 we r regular customers here.. this shop has excellent collections of gold and diamond jewellery…mr Venkatesh the sales executive is very courteous and make your time of stay very fruitful by showing all designs as per our taste …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0928",
      "name": "Dr. Sathish P",
      "rating": null,
      "text": "I highly recommend Krishna Jewellers as they provide custom design and quality products. Executive Rajesh offered a commendable service and negotiation over the VA & MC. Ultimately, great choice for jewellery purchase.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0929",
      "name": "Dr.P.Ramakrishna Nova Ent clinic",
      "rating": null,
      "text": "Ramadevi was very helpful cheerful and was very courteous.she guided us very well was very happy with the service they provided",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0930",
      "name": "Dr.Pranathi Ravipati",
      "rating": null,
      "text": "Very nice models and service. Would recommend to everyone Especially Mr.Bharath was patient enough to show all the models we asked for.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0931",
      "name": "Dream11 dreams",
      "rating": null,
      "text": "Good varieties & reasonable prices. The best thing about this place is the customer Service(Venkatesh) is fantastic. Reach out for Nayeem (Manager) sir who makes the prices very reasonable and …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0932",
      "name": "Dudam Shravya",
      "rating": null,
      "text": "In search of platinum couple bands we ended up in Sri Krishna jewellers where mrs Ramadevi helped us in execution of our idea they customised our rings within very less time. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0933",
      "name": "Durga bhavani c",
      "rating": null,
      "text": "I loved their collection. Prasanna helped me choose my bridal wear within my budget... and made my day...🙂 service was good and patiently helped us through the whole purchase. Also, amar was also good. I would suggest everyone to visit jubliee hills branch. If u want budget friendly designs …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0934",
      "name": "Durga Gayatri",
      "rating": null,
      "text": "Amazing collection! Ms. Pavani is a really wonderful woman! Helped us well with selection!",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0935",
      "name": "durga parupalli",
      "rating": null,
      "text": "Excellent service by Loknath...good knowledge about product",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0936",
      "name": "durgaprasad varanasi",
      "rating": null,
      "text": "Unique designing and good Customer service. Srikanth and Vinod have been extremely helpful and very patient. Highly recommend anyone for gold n డైమండ్ shopping",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0937",
      "name": "Easha Chowdary Annabathuni",
      "rating": null,
      "text": "Very good service , very nice people , great collection. Mr. R Sateesh was very helpful and hospitable hence got the best customer experience.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0938",
      "name": "Easy Banking",
      "rating": null,
      "text": "Nice ambience and Mr Sai Sudarshan assisted us very well.Good collection as well.Will surely recommend to visit the showroom.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0939",
      "name": "Elvira Byrnes",
      "rating": null,
      "text": "I found these guys on internet, I was totally charmed by their designs and craftsmanship. So I found my favourite - a gorgeous polka and emerald bangle. Viewing and communicating via WhatsApp was brilliant, I picked up a pair of matching …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0940",
      "name": "Emmanuel Shanth Kumar",
      "rating": null,
      "text": "We had a very good experiance and Mr R Satheesh did well in understanding our requirements. Showed us lot of options. Very good hospitality as well. Keep it up 💯 …",
      "date": "",
      "displayDate": "Edited 9 months ago",
      "relativeDate": "Edited 9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0941",
      "name": "Eren Yeager",
      "rating": null,
      "text": "Sai Kumar has good customer service thanks krishna jwellers",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0942",
      "name": "Eshwar Reddy",
      "rating": null,
      "text": "Professional and excellent service by Srikanth at the store. Nice collection and well maintained store. Sai Reddy online customer service was also very helpful and answered all questions pretty well.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0943",
      "name": "etiyala vijitha",
      "rating": null,
      "text": "I've purchased a Diamond necklace from Krishna Jewelers. The necklace is so beautiful. I absolutely loved it, top quality and a great service! …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0944",
      "name": "Faith Faith",
      "rating": null,
      "text": "Guravaiah Online Sales Executive Excellent customer service, very patience and well respected. He made us a life …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0945",
      "name": "Faizaan Khan",
      "rating": null,
      "text": "Krishna jewellery I visited first time good collections in this store and good response coustmer service super sales person very good meenakshi thanks",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0946",
      "name": "G C",
      "rating": null,
      "text": "We loved our experience at Krishna Jewelers! The staff were really attentive, especially RamaDevi who was really helpful. She answered all of our questions & was super accommodating to our requests. Due to her we were able to look at all of the items very easily even though it was through video call!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0947",
      "name": "G Neha Reddy",
      "rating": null,
      "text": "The store has exclusive collection, every piece looks eye catching in this store. The store employer bheem showed us the wide range of collection and explaining everything patiently.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0948",
      "name": "GADDE RAMANA",
      "rating": null,
      "text": "Recently visited this place and was assisted by T Sandhya Rani sales executive.She is very good in showing exquisite ornaments. She is very friendly and showed good collection of jewellery which suited our taste.Highly recommended.",
      "date": "",
      "displayDate": "Edited 10 months ago",
      "relativeDate": "Edited 10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0949",
      "name": "Ganga CN",
      "rating": null,
      "text": "The gift was very good and delicious we are happy We will be buying more need more offers and discount",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "gifting"
      ]
    },
    {
      "id": "stream-0950",
      "name": "ganta padma",
      "rating": null,
      "text": "Customer service is very excellent. Ramya Pavani is very friendly I have finalised all my jewellery in very short duration. She shows the jewellery based on our requirements. This store is budget friendly and affordable.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0951",
      "name": "Gantala Sneha",
      "rating": null,
      "text": "It was a great experience with Nitesh. He has got lot of patience to show all the jewelry and he suggests all to the customers. And gives clear idea of the estimations. Overall it was a good experience with him.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0952",
      "name": "Garikapati Sreenivasu",
      "rating": null,
      "text": "Value for money & Good purity . Infact they treat all their customers and visitors with a homely touch and house guests. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0953",
      "name": "Gaurav Gaba",
      "rating": null,
      "text": "Excellent store and staff. Gangabhawani attended us and took care of us really well. She has gone out of the way to close the deal for us and made us buy what we really wanted .",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0954",
      "name": "gautam gurnani",
      "rating": null,
      "text": "Kushal jadav has helped us well. He is experienced and was very patient with us. Recommend him to all my friends. Give him a promotion.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0955",
      "name": "Gayatri Gupta",
      "rating": null,
      "text": "We are very happy with J.ramesh sir service",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0956",
      "name": "gayatri varma",
      "rating": null,
      "text": "We are very happy with the service , pavani was very helpful and patient and the design options are also very good",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0957",
      "name": "Geetha Gayathri",
      "rating": null,
      "text": "I am very satisfied with my purchase and Bhavani Garu helped us alot with showing me the collection and had a very good time at the store Thanks to the store and the manager nayeem garu.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0958",
      "name": "geetha pinnaka",
      "rating": null,
      "text": "Store has wide range of collection. Shivaji has done excellent customer service. He listens very patiently, understands customer requirements and shows perfect collection. I Highly recommend krishna Jewelers for any gold and diamond purchase.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0959",
      "name": "geetha reddy",
      "rating": null,
      "text": "We visited Krishna jewellers Jubileehills for the first time. Had a great customer experience Riaz showed us different collections in our budget with great patience. He explained about each item in detail and got the item with the best price...love to visit again...",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0960",
      "name": "geetha vemuri",
      "rating": null,
      "text": "Friendly staff Rama Devi helped find our requirement",
      "date": "",
      "displayDate": "3 months ago",
      "relativeDate": "3 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0961",
      "name": "geethanjali avuthu",
      "rating": null,
      "text": "Great experience at the store. Vinod was extremely helpful and made the process so easy. Loved the collection. Will definitely recommend!",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0962",
      "name": "ghanta vijayalakshmi",
      "rating": null,
      "text": "Recently visited to Krishna Jewellers by watching you tube videos. Mr Bharat Sales team shown a lot of varieties within my budget and liked the designs. Finally bought one and Thanks to Krishna Jewellers for so much transperent and wanted to revisit .100% recommended .",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0963",
      "name": "GK Sreekanth",
      "rating": null,
      "text": "Excellent collections here at Krishna Jewellers Jubilee Hills and Mrs.RamaDevi garu has helped a lot in showing great sets of jewelry and also helped us in giving very reasonable pricing on our overall purchase.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0964",
      "name": "Gns Shilpa",
      "rating": null,
      "text": "Thanks to Ms. Pavani who with utmost patience kept on showing us options to choose from. After visiting so many places and coming across so many disinterested people Ms Pavani not only brought light into the darkness, she went out of her …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0965",
      "name": "godavari gaikwad",
      "rating": null,
      "text": "Krishna pearls has a good collection.nd Beem has shown a good collection in our budget.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-0966",
      "name": "Goli Pooja",
      "rating": null,
      "text": "Krishna Jewellery provides smooth delivery, unique designs, and excellent customer service. Their team, especially sunitha, is proactive, polite, and helpful.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0967",
      "name": "Gopi Adusupalle",
      "rating": null,
      "text": "Service was excellent. Mr. R. Satish provided us best service.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0968",
      "name": "gopi D",
      "rating": null,
      "text": "I was there in the store and very happy with the service especially Rama devi did excellent work by explaining all the details and showing us all the collections.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0969",
      "name": "Gopika Tandra",
      "rating": null,
      "text": "\"I had an outstanding experience at Krishna Jewels in Jubilee Hills. The customer service was top-notch, and I'm particularly grateful to Rama Devi Garu,who guided us with exceptional kindness and professionalism. Her courtesy made our shopping experience truly enjoyable, and we look forward to visiting again.\"",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0970",
      "name": "gouri bandaru",
      "rating": null,
      "text": "Mrs. Sandhya spent considerable amount of time eying to understand our needs and accordingly showed all the master pieces available in the store and made sure we got the best piece at the best price that was under our budget range. Highly recommend her from Krishna pearls and gems",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-0971",
      "name": "Govardhan Kartheek Parakal",
      "rating": null,
      "text": "Had a really great purchase experience. They have a huge variety of products and customer service was really good. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0972",
      "name": "Gowrisetty Virupakshi",
      "rating": null,
      "text": "Very nice designs. They have many new patterns compared to other stores. Customer representative Venkatesh was awesome. He was very patient and explained the details very well.. Gave us a good deal as well.. Overall great customer satisfaction . Would come back for sure",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0973",
      "name": "Gowtham Kesa",
      "rating": null,
      "text": "Bheem helped a lot patiently and showed all the products as per our need. He has been cordial throughout the process. Swamy also helped during the process and kind enough during negotiations along with delivery process.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0974",
      "name": "Greeshma Kumbaiah",
      "rating": null,
      "text": "ultimate customer service 24/7 follow up with patience really liked the service",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0975",
      "name": "Greeshma Kvn",
      "rating": null,
      "text": "Very good experience, lot of interesting design and good assistance by Mr. Guravaiah",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0976",
      "name": "greeshma reddy",
      "rating": null,
      "text": "Really impressed by the variety of jewelry designs and quick response from the team. I live in USA and shopped online . S.Mahesh ( sales person) helped me showing wide variety of designs over the video call. He responded quick and very …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0977",
      "name": "GT R",
      "rating": null,
      "text": "Ch. Venkat T is amazing sales person. He assisted us in all the queries related to our purchase. Excellent customer service. In House Food is also very good :)",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0978",
      "name": "gunda sailatha",
      "rating": null,
      "text": "Yadav garu shown us plenty models patiently, good service.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0979",
      "name": "Guru Charan",
      "rating": null,
      "text": "I wanted to take a moment to express my heartfelt appreciation for the wonderful experience I had at Krishna Jewellers. The level of service and the quality of your products truly exceeded my expectations. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0980",
      "name": "gyana sirisha",
      "rating": null,
      "text": "The Quality of the Jewellery and the Staff service is very good, Mr. Yadav has shown us rings for engagement, they are looking forward for the customer satisfaction and we got beautiful quality rings. Thanks to Krishna Jewellerys.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0981",
      "name": "Gyandeep Borah",
      "rating": null,
      "text": "Great collection.. Mr. Ramesh was really helpful and courteous.. would definitely recommend this shop..",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0982",
      "name": "Gyanesh Dharmaprakash",
      "rating": null,
      "text": "Had a fantastic experience purchasing from this jewellery store! The collection was beautiful and the service even better. Huge shoutout to Mr. Swamy for the generous discount and to Mrs. J Maha Lakshmi for her kind assistance throughout. Highly recommend!",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0983",
      "name": "H T",
      "rating": null,
      "text": "Very happy with the customer support. Especially Mr. Mallikarjuna Rao has been such a big help in the selection. He was patient and friendly !! Recommend the store for any Jewellery needs.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0984",
      "name": "H.Bheema Reddy Reddy",
      "rating": null,
      "text": "Had very good experience shoping at Krishna jewlers . Mr Rajesh showed each and every piece we wanted to see in different section kundan , polki , jems and pearls and gold and some varieties with very patience and calm We love to shop here",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0985",
      "name": "Haneesha Kandala",
      "rating": null,
      "text": "Fabulous collection. Been following your Instagram for a while. I came all the way from Bangalore because i was in awe of the collection you have. We bought a pendant for my husband today. Mr. Nagarjuna helped us out. Very amicable reps in the store. I'll definitely come back again. Fantastic experience. Thankyou team.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0986",
      "name": "Haneesha Mannava",
      "rating": null,
      "text": "Models of Krishna jewellers are unique & quality is also good. Especially salesperson Barath helped us patiently with models. His service was very good & carried out the process smoothly till payment. I’ll totally recommend Krishna jewellers pearls & gems.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0987",
      "name": "Hanish Reddy",
      "rating": null,
      "text": "Good variety of silver articles and Good service from kavitha",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0988",
      "name": "Hanisha Ananthula",
      "rating": null,
      "text": "Loknath garu very patiently showed all the designs. Overall it’s a good experience.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0989",
      "name": "Hanumantha Rao Boinipally",
      "rating": null,
      "text": "The collection at Krishna Jewelers is exquisite, and the ambiance of the store added to the overall pleasant experience. The variety of designs and quality of craftsmanship showcased your commitment to offering high-quality jewelry. …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-0990",
      "name": "haranath gayini",
      "rating": null,
      "text": "Best place for wide range of collections and designsans good customer service",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0991",
      "name": "hari b",
      "rating": null,
      "text": "They have very good collection and the staff especially Naresh is very patient and has a great idea of every product they have and good customer service. I would definitely recommend this store.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0992",
      "name": "Hari Kishore",
      "rating": null,
      "text": "The workmanship of every item is fantastic, it is very detailed and that is what makes Krishna Jewelers stand out in the competition. My wife is fascinated about the designs and finishing of their work. I must mention Mr. Swamy, the …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0993",
      "name": "Hari Krishna",
      "rating": null,
      "text": "We had very good experiences with the purchase here. G Sandhya Rani had done a wonderful job in explaining and showing up the models. Thank you.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0994",
      "name": "hari krishna Balla",
      "rating": null,
      "text": "Nice collections shown by yadav tq very much",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0995",
      "name": "Hari Midigudla",
      "rating": null,
      "text": "Priya Sales Executive made us feel as if we are family members of Krishna Jewllers. Priya has the real zeal to serve the customers and satisfy them. Her genuine concern to help the customers gave us immense satisfaction in doing purchases …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-0996",
      "name": "hari ramani",
      "rating": null,
      "text": "Very good experience at Krishna jewellers. Bharat who is the sales executive there was very patient and has shown all the best collection available. We are very happy with his work. Kishna jewellers has the best latest jewellery.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0997",
      "name": "hari slg",
      "rating": null,
      "text": "Customer service is excellent, Great collection. We bought some regular office wear jewellery for trendy outfits. Representative Nagarjuna was polite and patient. We highly recommend this store.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-0998",
      "name": "Harigopal Reddy Maligi",
      "rating": null,
      "text": "Absolutely loved my experience at Krishna Jewellers! The staff (Bharath) is patient , helpful and knowledgeable. The collection is stunning and beautifully crafted.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-0999",
      "name": "harika annapareddy",
      "rating": null,
      "text": "I have been following this place on face book from long time. They always displayed beautiful designs. I saved a lot of jewels from their page. Mallikarjun is the best, very responsive and awesome customer service. He explains everything in …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1000",
      "name": "Harika Baradwaj",
      "rating": null,
      "text": "Dinakar is very detailed and responsive. He makes sure customer is happy and satisfied. I definitely recommend Krishna Jewellers for their collections.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1001",
      "name": "Harika Echuri",
      "rating": null,
      "text": "Krishna Jewellers has a wide variety of jewelry collection with beautiful craftsmanship and design. As an abroad customer, proper communication was really important to me. The team, particularly Srikanth, excelled at communicating with us. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1002",
      "name": "Harika Racha",
      "rating": null,
      "text": "Sandhya Rani always guides perfectly. I am satisfied with jewelry and service.Thank you.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1003",
      "name": "Harika Rao",
      "rating": null,
      "text": "Had a great experience at the store, they’ve many latest collections and Mr. Yadav was very patient and very knowledgeable, he guided us in buying good stuff. Will definitely visit again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1004",
      "name": "harika sai",
      "rating": null,
      "text": "Amazing nakshi and diamond collection. We went there to buy bangles and ended up buying 2 diamond necklaces. Pavani helped us with the whole process, very patient, understood what we are looking for and showed us the best designs. Would definitely recommend",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1005",
      "name": "harika thammu",
      "rating": null,
      "text": "Krishna jewelers pearls and gems jubilee hills branch. We are visiting here since last three years and I must say that the service and ambience here is awesome. I’m happy to shop here. During every visit I see new designs and antique …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1006",
      "name": "Harini Chimakurthi",
      "rating": null,
      "text": "Prakash Sir, service is spectacular and very friendly Designs are fabulous. Thanks for the assistance",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1007",
      "name": "Hariprasad N",
      "rating": null,
      "text": "We visited for the first time to Jubilee hills branch, before that my wife was following them in instagram for 6 months. This store has lot of varieties you can try. And executive Venkatesh garu is very cordial n patient enough to show us all the items and store manager Nayeem was also very cooperative in price negotiations",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1008",
      "name": "Harishraj Yamjala",
      "rating": null,
      "text": "I recently purchased gold jewellery in Krishna jewellery the team service was wonderful offering smoothly and enjoyable shopping experience Pawan help us lot",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1009",
      "name": "Haritha Tallapaneni",
      "rating": null,
      "text": "Krishna Jewelleries- Ganga Bhavani, has given excellent experience and she has showcased excellent items. The way treated us made us very happy and we got very good items. We really felt very happy for the hospitality. Thank you Bhavani.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1010",
      "name": "Haritha Thirunahari",
      "rating": null,
      "text": "R.Satish showed us awesome collections. Very happy with our shopping.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1011",
      "name": "Harsha",
      "rating": null,
      "text": "This place is really good and sales person Rama Devi is excellent. She had answers to all our questions and patiently worked with us. We got what we wanted and we highly recommend this place and her for best experience in this gold shop.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1012",
      "name": "Harsha Ram",
      "rating": null,
      "text": "About product : good looking and nice model and best designe . About service : excellent coordination with customer I deal the with one of your service man rajesh very good coordination with us .",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1013",
      "name": "harshini erumadi",
      "rating": null,
      "text": "I recently purchased jewellery from Krishna Jewellers and super pleased with the service provided by Rama Devi, she was very pleasant and spend quality time in showing the jewelry. Always picked up the call to answer any questions. I would to thank her for her service.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1014",
      "name": "harshini reddy",
      "rating": null,
      "text": "Meenakshi was very enthusiastic to show everything we asked for … great collection in light weight",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1015",
      "name": "harshita j",
      "rating": null,
      "text": "I recently purchased gold from Krishna Jewellers Jubilee Hills. I loved their service, quality,workmanship and designs. Venkatesh was really sweet and helpful. He guided me over the phone about the latest designs and always responded when …",
      "date": "",
      "displayDate": "Edited 6 months ago",
      "relativeDate": "Edited 6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1016",
      "name": "Harshitha Patcha",
      "rating": null,
      "text": "Visiting Krishna since 4 years, they have wide variety of collection and good quality. Would recommend Krishna for any occasion. And sales person Venkatesh showed all the designs very patiently.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1017",
      "name": "harshitha reddy",
      "rating": null,
      "text": "They have a wide range of collections. Sarvesh was incredibly patient and attentive, taking the time to show us a beautiful collection of jewelry. I highly recommend this shop for its excellent customer service and stunning collection. Thank you!\"",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1018",
      "name": "Hasya Rao",
      "rating": null,
      "text": "Had a great experience, there’s good collection of designs and the staff is really helpful and patient, Mr K Venkatesh helped us while we were there he showed us all the designs and was very patient.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1019",
      "name": "Heena Patel",
      "rating": null,
      "text": "Satish, Ashok, and Sonia were extremely helpful and efficient. Great experience.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1020",
      "name": "Hemanth Bathina",
      "rating": null,
      "text": "I was looking to shop for a diamond jewellery necklace set. Then I came across Krishna Jewellers Pearls & Gems where I saw on their online portal various spectacular detachable Diamond Necklaces along with Jhumki in diamonds with innovative …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1021",
      "name": "hemz_ 9697",
      "rating": null,
      "text": "Bought jewelry at Krisha Jewellers, Jubilee Hills, and loved the stunning designs and top-notch ambiance. Special thanks to staff member Sai Kumar for his patience and excellent service in showing us a wide collection.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1022",
      "name": "hethal bakkola",
      "rating": null,
      "text": "Ganga bhavani helped me with my all my questions and she has shown me great collection, she helped me all through my journey to select my wedding jewellery. She also helped me greatly with the exchange policy with her suggestions.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1023",
      "name": "hima bindu",
      "rating": null,
      "text": "This was my first time online jewellery buying and Both Rama garu and Ramya garu excellently co ordinated through out the journey right from jewellery selection, buying and safely delivering it to home. I appreciate their patience in giving details and ensuring safety, quality.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1024",
      "name": "hima bindu",
      "rating": null,
      "text": "Very nice collection , and competitive prices especially in diamond . And liked the way Mr Venkat Garu matches with our interest to show us the collection .Finally one stop destination for all gold n diamond requirements with great finishing",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1025",
      "name": "Himabindu Alapati",
      "rating": null,
      "text": "I would like to extend my hearty thanks to the most patient staff member PAVANI garu who was well knowledgeable and made us feel home when browing through many a designs and explaining every thing in detail. She is an asset to Krishna …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1026",
      "name": "Himaja Rao",
      "rating": null,
      "text": "My first visit to krishna jewellery was awesome. Mr Mallikarjun was a good representative. He has shown us the unique designs. And also helped choose the right ornament.The store also has many unique designs. …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1027",
      "name": "hitesh rana",
      "rating": null,
      "text": "Very pleased to get assisted by Mr M Jaganath. His professional demeanor, competency and service was commendable",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1028",
      "name": "Hitha Meka",
      "rating": null,
      "text": "Wonderful buying experience at Krishna Jewellers where customers are treated with utter respect regardless of the amount purchased. They all have abundant patience especially Mahesh Swamy garu who showed us all the available designs in the …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1029",
      "name": "Hithaishi AL",
      "rating": null,
      "text": "Amazing !! Staffs are so communicative and very helpful I appreciate that ! …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1030",
      "name": "HYMA Reddy",
      "rating": null,
      "text": "Wonderful experience with shri krishna jewellers. Sandhya Rani made us very comfortable and shown their collection",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1031",
      "name": "I N Saikishore Seelamsetty",
      "rating": null,
      "text": "For my niece wedding jewellery shopping, we spent almost 3 - 4 days selecting, ordering many designs and got them delivered in a week. Salespersons Shyam and Srinivas were so helpful and diligent in the whole selection process. To be …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1032",
      "name": "I Naidu07",
      "rating": null,
      "text": "Best experience with krishna jewellers Mr.Kashinath showed with patience and helped us to purchase best pearls.thanku krishna jewellers and we r fully satisfied....",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1033",
      "name": "Idamakanti Harika",
      "rating": null,
      "text": "Had very good experience and yadav gaaru showed all the latest collections very well and very satisfied with collections as well as hospitality.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1034",
      "name": "ILAVANY CHARAN",
      "rating": null,
      "text": "Great experience in krishna jewellery and S.Bharat was showed very nice",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1035",
      "name": "indranielgupta potta",
      "rating": null,
      "text": "Our sales agent Akshaya was great. She was very patient to show us a long list of new collection. Amazing lady she was!!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1036",
      "name": "indrarchitha padukone",
      "rating": null,
      "text": "Impressed with the collection and unique designs. Mallikarjun has been immensely patient and was able to understand our taste. Thank you for making our shopping experience a wonderful one.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1037",
      "name": "Indu Kakumanu",
      "rating": null,
      "text": "My recent experience with Krishna Jewellers was outstanding! From the moment I contacted them whether it was online or in-store shopping , Prakash, Sai Reddy and Loknath did a fantastic job as they knew exactly what I was looking for and …",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1038",
      "name": "Induri srujana",
      "rating": null,
      "text": "Excellent collection and excellent service by Satish garu .. I made an order and he was very responsive and delivered my order before given time.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1039",
      "name": "Ishita Narain",
      "rating": null,
      "text": "Lingaswamy was very polite and humble. He explained all details I needed regarging the quality of pearls and helped me purchase what I wanted. Efficient and good service!",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1040",
      "name": "Ishwarya Gandamsetty",
      "rating": null,
      "text": "Awesome collection, very patient and cooperative staff especially Mr Naga Sai showed us the best collection.Will definitely visit again.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1041",
      "name": "It's Mahesh",
      "rating": null,
      "text": "excellent customer service, unique designs, high-quality products, or a pleasant shopping experience.pavan and sai reddy form online help me lot",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1042",
      "name": "Jagdish Kumar Vinjamuri",
      "rating": null,
      "text": "It was a very nice experience that I had with Krishna Jewellers and a special mention to Riyaz who was working with us for the last 8 months by showing various designs amd patterns with a lot of patience. It was a pleasure working with …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1043",
      "name": "jahnavi kancharla",
      "rating": null,
      "text": "Nice collection,different types of verities are available,excellent hospitality by guravaiah",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1044",
      "name": "Jahnavi Kolla",
      "rating": null,
      "text": "Great customer service, safe n secure delivery. Got a few designs customized by them and the outcome was impressive. Rekha was very accommodating and so customer friendly that she went that extra mile to help my purchase go smoothly. Very …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1045",
      "name": "Jahnavi Mesa",
      "rating": null,
      "text": "Exceptional customer service. Naresh was very patient and helped us with different collections. He made our shopping experience very smooth.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1046",
      "name": "Jahnavi property",
      "rating": null,
      "text": "Had a great interaction with Mr. Yadav. He guided us nicely. Communication was also very appealing. Overall it was a very good experience to shop at Krishna Jewelers.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1047",
      "name": "Jahnavi ram",
      "rating": null,
      "text": "Visited the Krishna jewelry shop today and had a fantastic experience! Kushal was incredibly patient and knowledgeable, guiding me through a wide selection of jewelry including stunning gold chains, elegant nose pins, and beautiful …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1048",
      "name": "Jahnavi Reddy",
      "rating": null,
      "text": "R Satheesh has shown very patiently and great designs",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1049",
      "name": "Jahnavi Vallabhaneni",
      "rating": null,
      "text": "Very good and efficient service by Meenakshi. Was very patient and showed everything I was looking for. Will definitely come back to her.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1050",
      "name": "Jainendra Singh",
      "rating": null,
      "text": "It was a great experience buying here. Mr Kashinath n Mr. Ashok were supportive and were showing patiently. Strongly recommend this place",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1051",
      "name": "janaki devi tati",
      "rating": null,
      "text": "As we are regular customer, they have good designs and ambiance and welcoming made really good and also most important venkatesh garu and chary garu showed best designs in the store super satisfied with their service. Thank you! Would recomend for sure! Happy for your service ☺️",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1052",
      "name": "Janaki Jayanthi Darsi",
      "rating": null,
      "text": "Sandhyarani. Very talented sales person.She understand what the customer need and I got the best. Thank you sandyarani.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1053",
      "name": "Janakiraman ganesan",
      "rating": null,
      "text": "Supposedly famous pearl and jewellery shop. They could care for customer in a better and professional way. Sales guy was disinterested in selling. They should visit jewellers in tamilnadu to learn hospitality. After we decided to buy a …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1054",
      "name": "Janani raj",
      "rating": null,
      "text": "They have very good collection and various designs. Their service was good. We took an online service. One of the staff members Naresh, has assisted us in showing the collection. He was very supportive and been patient in showing the jewellery through video call. We liked the collection and as well as the service.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1055",
      "name": "Janardhan IT Corpz",
      "rating": null,
      "text": "Pavani, shown great designs with excellent demo skills . Very patient . Nice updated collections",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1056",
      "name": "janardhan reddy Rekkala",
      "rating": null,
      "text": "Exquisite collection from this store.. felt very happy with Shivaji who helped us get all contemporary collection and at best price they can offer",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1057",
      "name": "Jashu R",
      "rating": null,
      "text": "Thank you very much Vinod for making my experience great with Krishna Jewellers Pearl & Gems. Looking at the location and brand value that they have, I thought they don’t leave any scope for negotiation but it wasn’t the case. Vinod …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1058",
      "name": "jasti swathi",
      "rating": null,
      "text": "Bharat's customer service was outstanding. I am very pleased with my purchases and the products are wonderful. Great quality and fabulous collections. Bharat helped us throughout my shopping and he is very good at suggesting the right …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1059",
      "name": "Jawahar Ven",
      "rating": null,
      "text": "Krishna jewelers has an extensive collection and we enjoyed shopping here. Loknadh ji helped us a lot. Great patience!! Loved the diamond choker set I bought here for my wife.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1060",
      "name": "Jaya Maddukuri",
      "rating": null,
      "text": "I am a regular customer of this store in jublihills.....i really enjoyed.there are so many silver designs available.they provide gud customer service also.recently rajeshree attend my call. tq mam for u r patience.thanks for krishna house of silver.....providing such a beautiful products......",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1061",
      "name": "Jaya Punati",
      "rating": null,
      "text": "We were assisted by Sandeep and Srinivas. They werepleasant. And derve 5 stars. They knew what we were looking for and shared the right items. Our experience at Krishna jewelers was very pleasant.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1062",
      "name": "Jayachandra Gali",
      "rating": null,
      "text": "Gangabhavani is very active, polite and supportive. She patiently showed many options and explained about the products. We are quite happy while we are shopping.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1063",
      "name": "Jayant Jhamani",
      "rating": null,
      "text": "Very good experience, Our Sales Rep J Mahesh was very nice in handling the customer patiently, I just came to buy one ring but the way staff handled dont know how I bought Multiple, overall good experience",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1064",
      "name": "jayanthi duba",
      "rating": null,
      "text": "My visit to the gold shop turned into a memorable experience, all thanks to Ch. Venkat. I initially planned to buy jewelry worth ₹1 lakh, but his honest advice, detailed explanations, and friendly approach encouraged me to explore more beautiful designs. Highly satisfied with the service.",
      "date": "",
      "displayDate": "Edited 5 months ago",
      "relativeDate": "Edited 5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1065",
      "name": "Jayashree Alamgari",
      "rating": null,
      "text": "Collection was amazing and very beautiful. Staff was very helpful and kind. Kushal was an amazing salesperson who was very helpful. Overall had an amazing experience.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1066",
      "name": "jayasimha nagella",
      "rating": null,
      "text": "Had a good experience there, Mr. Prakash helped nicely with good knowledge, happy to share our experience",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1067",
      "name": "jayavardhan reddy",
      "rating": null,
      "text": "Mr.Loknath was extremely kind and patient. We walked in with an appointment with another sales associate, but in the last moment he handed over the responsibility of customer service to Mr. Loknath garu, and we couldn't be more happier. We …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1068",
      "name": "jeevan sirigineedi",
      "rating": null,
      "text": "We had a great shopping experience at Krishna jewelers today Thanks to Mr.venkatesh who was very responsive for our requests/wishes and was proactive in showing us the latest designs. Their collection was exquisite and trendy. I would definitely visit again to shop.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1069",
      "name": "Jessica",
      "rating": null,
      "text": "Mr. Govind was so polite and sweet, i appreciate the patience, time and effort he put into us. he was also very friendly and kind. :)",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1070",
      "name": "Jhansi Medikonda",
      "rating": null,
      "text": "Good collection, Yadav garu showed us a lot of products patiently. Will definitely visit again in the future!",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1071",
      "name": "Jhansi Munagala",
      "rating": null,
      "text": "I recently purchased an ornament from Krishna Jewelers Pearls and Gems. The intricate details were amazing. They must have spent so much time and care while creating it. I have found very beautiful and unique jewelry there. Salesperson …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1072",
      "name": "Jidige vamshi krishna",
      "rating": null,
      "text": "It's been 5 years since we shopped for jewellery in India. After surfing through different jewellery stores we found Krishna Jewellers had unique antique pieces. We found customer service was exceptional and the staff lookedafter us well. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1073",
      "name": "Jiya Sharma",
      "rating": null,
      "text": "Beautiful products received and specially thanks to Ms Pooja... Very humble very nice thank you so much.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1074",
      "name": "Jo Reddy",
      "rating": null,
      "text": "Great quality and customer service. I have been purchasing here for the past 4 years and Dinakar garu and Guruviah garu have always helped pick the best ones for great prices. Looking forward to purchasing more.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1075",
      "name": "Josephine Polanki",
      "rating": null,
      "text": "Good service by sri Lakshmi. Excellent collections",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1076",
      "name": "jpl kumar",
      "rating": null,
      "text": "It was a pleasant experience shopping with Krishna Jewellers. Models were unique and stylish. Executive Bharath was very cordial and patiently showed all the models. Thank you",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1077",
      "name": "Jyo Peraty",
      "rating": null,
      "text": "Excellent service and super good collection! Sri Lakshmi was super nice!",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1078",
      "name": "Jyothi Mandava",
      "rating": null,
      "text": "Video call shopping experience was great and Mr Naresh was very knowledgeable and patient to show all the collection. Big thanks to him. I really liked the unique collection from Krishna Jewellers & Pearls , and looking forward to shop …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1079",
      "name": "Jyothi Nekkanti",
      "rating": null,
      "text": "Excellent jewelry collection and great service. Bheem was patient , helpful, and made the entire experience smooth. Highly recommend!",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1080",
      "name": "Jyothi Polimetla",
      "rating": null,
      "text": "Ramadevi very polite, humble and we are so happy with the nice and cute jewellery that she has shown to use, we visit again here for jewellery",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1081",
      "name": "Jyothisri Kandimalla",
      "rating": null,
      "text": "I searched for my wedding diamond choker for two weeks but couldn’t find anything that I like in my taste and budget. But Bhavani from Krishna jewelers has shown me according to my taste and helped me in selecting one. I felt that prices are also reasonable. Would definitely recommend to anyone.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1082",
      "name": "jyothsna kunkunuru",
      "rating": null,
      "text": "Superb collections..very much impressed with designs. Mr Srikanth helped us very well",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1083",
      "name": "Jyotsna K",
      "rating": null,
      "text": "It is wonderful experience buying jewellery in this store. Sandeep, sales executive here, made our selection easy by showcasing the jewellery according to our taste. He patiently clarified all our doubts during our purchase.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1084",
      "name": "K BADRI",
      "rating": null,
      "text": "Excellent Bheem, cooperated well. Swamy was helpful too. Much Appreciated",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1085",
      "name": "K G REDDY",
      "rating": null,
      "text": "I had a very nice experience at Krishna jewellers.they have huge collection.the sales man prakash showed me all the collections in my budget very nicely.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1086",
      "name": "K Lekhasree Royal",
      "rating": null,
      "text": "Nice collection & Very good service provided my Mr.Dinkar",
      "date": "",
      "displayDate": "3 months ago",
      "relativeDate": "3 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1087",
      "name": "K TILAK",
      "rating": null,
      "text": "I recently visited Krishna Jewellers Pearls & Gems at Jubilee Hills and was truly impressed by their exquisite collection of gold and diamond jewellery. The designs are elegant, unique, and perfectly crafted. The staff, especially Pawan …",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1088",
      "name": "K.S.S.Rakshitha Reddy",
      "rating": null,
      "text": "Very unique collection is here and rare designs I highly recommend this place also Lokanath garu has shown us recent designs of black bead designs in white gold with black diamonds which is very rare to find thank you.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1089",
      "name": "Kajol Patel",
      "rating": null,
      "text": "Satish took great care for getting me in touch with representative and helping me receive my things orderes",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1090",
      "name": "Kakumani Suman",
      "rating": null,
      "text": "Very nice shop with lot of variety. Friendly staff. Customisation as per customer need and reasonable billing. …",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1091",
      "name": "Kalpana Amilineni",
      "rating": null,
      "text": "Sravan He is Awesome. Very fast . I mean he close the deal totally fast including convincing the customer also in a nic way special thanks to Srinivas also.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1092",
      "name": "Kalpana Grandhisiri",
      "rating": null,
      "text": "Designs are excellent… Ramadevi service is too good …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1093",
      "name": "Kalpana Rowlo",
      "rating": null,
      "text": "Very good collections and thanks mahalakshmi for showing the items patiently which we were looking for.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1094",
      "name": "Kalyan C",
      "rating": null,
      "text": "I visited the store at Jubilee Hills in Hyderabad for the first time. Had a great end to end experience. The staff were very friendly and patient. Mr. Guruvaiah, who assisted us all through our experience was very forthcoming and helpful. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1095",
      "name": "Kalyan Mohan Chakravarthy",
      "rating": null,
      "text": "It was very good experience, felt very happy because of ambiance, staff behavior especially Rajkumar garu with lot of patience also Sri. Nayeem even though i am a new customer to this showroom. Ornaments …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1096",
      "name": "Kalyani Astra",
      "rating": null,
      "text": "Good experience.. nice designs. Nagarjuna garu is very patience in showing all the designs and recommended designs that suits. Overall very good experience in buying black bead chain. Thank you Krishna Jewellers..",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1097",
      "name": "Kalyani Chakravarthy",
      "rating": null,
      "text": "Recently I made a purchase from krishna jewellers and I stay in US, I liked how the jewelry was packaged and shipped to me. Two ladies were in contact with me via whatapps making sure that the purchased product was delivered on time. Thank you Ambika and Mounika for helping me make the best selection from your jewelry collection.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1098",
      "name": "Kalyani Madgula",
      "rating": null,
      "text": "Pavani had done a great service and was very patient in showing us the designs. I will recommend her to anyone who wants to shop here.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1099",
      "name": "Kalyani Veerla",
      "rating": null,
      "text": "Brought Jhumkas and blackheads , venkatesh (gold section ground floor)has provided great service and shown beautiful modles and explained the price break very well, so glad to shop at Krishna jewellers and thanks again Venkatesh for such a great Service",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1100",
      "name": "kamali sai",
      "rating": null,
      "text": "Was a good experience, have wide collections and great designs.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1101",
      "name": "Kancheti Sai Spandana",
      "rating": null,
      "text": "They have amazing collection. Shivaji garu helped us with the collection. He has dealt us with lot of patience and clarified all our doubts. Over all it was a very smooth experience for us. Thanks Krishna Jewellers!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1102",
      "name": "kandakatla Ramesh reddy",
      "rating": null,
      "text": "Your designs are good, Mr Swamy suggested me to buy excellent designs. Service is good. I have seen so many designer collection, good experience. Definitely I will recommend my friends and relatives.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1103",
      "name": "Kankanala Srinivas Reddy",
      "rating": null,
      "text": "Krishna jewellers have very good collection.Hospality and the service was very good.Sales person named Mr.Shivaji shown us designs depending upon our requirement. He is very polite and respectable.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1104",
      "name": "Karandla Srilatha",
      "rating": null,
      "text": "Good customer service And good collection sai kumar was very helpful to selection",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1105",
      "name": "kartheek k",
      "rating": null,
      "text": "Today, we visited the SriKrishna Jewellers Pearls and Gems @ Jubilee hills. we were looking for long harm , as you know all it's difficult to finalize the design and model as it stays with us for long time. we visited many show rooms and …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1106",
      "name": "KARTHIK ENTERPRISES",
      "rating": null,
      "text": "Very good service ch venkat",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1107",
      "name": "Kavali Anil Kumar (King)",
      "rating": null,
      "text": "I had a very good experience in Krishna JewelIers pearls & Gems and I would like to Thank Miss. Sandhya for explaining the details about pearls its shape, size, and colour and also varieties of designs in gold jewelry.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1108",
      "name": "kavi naidu",
      "rating": null,
      "text": "Very unique designs . Good customer service.very happy yo shop at this place . Rajesh has patience and showed us mulitiple options according to our requirement.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1109",
      "name": "kavitha",
      "rating": null,
      "text": "I always so impressed with what Krishna jewellers come up with. I highly recommend the store to anyone because they will leave with a beautiful piece of jewellery.Staff are polite and helpful especially Ramadevi Garu, she understands our requirement and made the selection is easy.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1110",
      "name": "kavitha kavitha",
      "rating": null,
      "text": "Very best collection, especially G.S.Yadava service is good kind and showed the collection.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1111",
      "name": "Kavitha Reddy",
      "rating": null,
      "text": "Happy to purchase at Krishna Jewellers store, the sales person Srikanth here is very patient with us and helped us to find the right piece we wanted.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1112",
      "name": "Kavitha Reddy",
      "rating": null,
      "text": "They have huge collection very good customer service Sandeep garu guided us very well he knows what customers needs we are happy with our puchase n recommend this store to evryone",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1113",
      "name": "Kavya Mm",
      "rating": null,
      "text": "We ordered a lakshmi Haram for my marriage. Naresh garu helped us to make the exact model like how I want. Thanks so much for wonderful customer service and beautiful Haram .",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1114",
      "name": "kedareswari gutta",
      "rating": null,
      "text": "Kushal has lot of patience and understanding about our desire ornaments shows us variety of jewellery. We liked and purchased. Thank you Kushal ji for your warm welcome",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1115",
      "name": "keertanareddy Battula",
      "rating": null,
      "text": "We were received by SAI KUMAR and Manager SHIVA KUMAR. They are very humble and respectful. Great level of patience. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1116",
      "name": "Keerthana",
      "rating": null,
      "text": "I love the collection. And Prakash helped us so much",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1117",
      "name": "Keerthana G",
      "rating": null,
      "text": "My recent purchase experience with Krishna Jewellers, Jubilee Hills, Hyderabad was extremely satisfying. Thanks to Mrs. Ramadevi who was very attentive to our requests/wishes and she was helpful, knowledgeable about products, patient with …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1118",
      "name": "keerthana muppalla",
      "rating": null,
      "text": "Visited store and had a great experience.staff are very patient.RAMA DEVI garu has shown us many models with lots of patience and with a good smile",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1119",
      "name": "Keerthana Reddy",
      "rating": null,
      "text": "Purchased diamond earrings.Gururaj showed us with utmost patience and showed all models. Appreciate his work!",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1120",
      "name": "Keerthi Alluru",
      "rating": null,
      "text": "Visited Krishna jewellers multiple times and had great service from Ramadevi. She showed us many models with patience and the hospitality was very good.",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1121",
      "name": "Keerthi Choudhary",
      "rating": null,
      "text": "Had a fantastic experience. Very polite staff. Very patient and shows you design based on your taste and budget. I would particularly like to mention Mr.Dinakar Garu and Chaitanya garu who helped us.They did a fantastic job. Highly recommend this store.",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1122",
      "name": "Keerthi Meghna",
      "rating": null,
      "text": "Ramesh: Very responding and shown beautiful collection. Loved shopping at Krishna Jewellers....",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1123",
      "name": "keerthika vithanala",
      "rating": null,
      "text": "We are regular to Krishna Jewellers. Mr. Yadav has shown us many items with lots of patience . Their hospitality is excellent. The collection is great and they have many designs. We had a great experience and we would like to come back …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1124",
      "name": "Ketaki Jadhav",
      "rating": null,
      "text": "Good experience- Govind who helped us on the jewellery was good in his work . He had good knowledge about the precious stones . Even the sandwich was yummy 😜 …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1125",
      "name": "Ketki Gadre",
      "rating": null,
      "text": "Krishna jewelers Jubilee Hills never disappoints. Wonderful collection and service. Vinod was very friendly and patient and helped me finalize a gift for my mother via video call. Shiva helped me with the price and made it all fit in my budget. Thank you! I will surely be back.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service",
        "gifting"
      ]
    },
    {
      "id": "stream-1126",
      "name": "Keyur Mehta",
      "rating": null,
      "text": "Made small purchase online Extremely satisfied with service and excellent craftsmanship",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1127",
      "name": "kiran sivapuram",
      "rating": null,
      "text": "Amazing service at Jubilee hills flagship store. Their sales associate Bhavani helped was so patient and friendly and helped us thoroughly with all of our questions. They have more collections than other flagship stores. Completely satisfied and wont hesitate coming back here.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1128",
      "name": "Kiranmayee Dobbali",
      "rating": null,
      "text": "Loved the collection at this store! I have first checked the collection online and then visited the store. They send you pictures of what you wish for and estimation online, and you can visit store if you want to. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1129",
      "name": "Kiranmayi Anupindi",
      "rating": null,
      "text": "I had great experience at the store. Sai Kumar was more than helpful and patient while showing the designs. He understood my requirements and suggested models accordingly. He was very polite and the service felt very professional and good.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1130",
      "name": "kirthi Chintalapuri",
      "rating": null,
      "text": "Nitesh bione was very helpful and fast in showing us great designs and collection in diamonds and gold. Hospitality was good.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1131",
      "name": "kishore koribilli",
      "rating": null,
      "text": "Sivaji sales person is excellent in handling the customers. He has shown the varities jewellery and understood the pulse of customer. A worth visit to shop and will recommend for others too.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1132",
      "name": "Kishore Kumar",
      "rating": null,
      "text": "Took diamond vaddanam from kirishna jewellers and we are very much satisfied with the staff and collection . Staff is very well behaved and receive the customers in a good way.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1133",
      "name": "klaus od",
      "rating": null,
      "text": "Kranthi was very good and patient.",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1134",
      "name": "KLM",
      "rating": null,
      "text": "Krishna Jewellers has very good collection of gold and diamond items. Excellent service by Meenakshi madam. She was very helpful and patient. Great value for money!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1135",
      "name": "Koduri Nehru",
      "rating": null,
      "text": "I had good experience in the store Sandeep is very responsive and showed the wide range of jewellery collection. He was very polite and professional while clarifying our doubts. We are very satisfied with our purchase",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1136",
      "name": "Koduru Rithvik Tagore",
      "rating": null,
      "text": "Designs are very good , receiving customers and showing the designs are also very appreciable , my set has been shown by Meenakshi her receiving and taking care is really very good , her service is super👍 …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1137",
      "name": "Kolachalam kousalya",
      "rating": null,
      "text": "The designs are unique. They have a wide variety of designs be it beaded,Victorian, Gold( Nakshi,pacchi,etc). You name it they have it. Thanks to Mr Yadav for his kind behavior and showing us all designs patiently, explaining the breakup.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1138",
      "name": "Komala M",
      "rating": null,
      "text": "I recently had a pleasure visiting Krishna Jewellers and had a good experience. Naresh, staff member is Incredibly knowledgeable and answered all my questions and helped me finding the perfect piece that suited my preferences and budget. The quality of jewelry is top-notch.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1139",
      "name": "Komali Koneru",
      "rating": null,
      "text": "Visited the Jubilee hills store for the first time and was presently surprised with the quality of service. The team here, especially our sales associate Mallikarjun was very helpful and prompt with his service. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1140",
      "name": "Komali Midabala",
      "rating": null,
      "text": "Beautiful designs. R. Satish garu assisted us with lots of patience and suggested great designs.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1141",
      "name": "Komali Sree",
      "rating": null,
      "text": "Venkatesh and lakshmi along with Sai kumar are the best as always. They will show and suggest the designs considering the client's taste and occasion. Best discounts applied. Thank you so much for the utmost support and patience.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1142",
      "name": "Kommera Laxmi",
      "rating": null,
      "text": "Krishna team Ganga Bhavani of jubileehills branch helped us a lot with our questions on the exchange policy and also with selection of new pieces, she has lots of patience to explain minute details of jewellery and understand the needs and help us. I would recommend her anyday.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1143",
      "name": "Kondal I",
      "rating": null,
      "text": "Best experience with krishna pearls.thanku Mr.Kashinath for helping us to buy best pearls.",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1144",
      "name": "Kondareddy Venna",
      "rating": null,
      "text": "I had a great shopping experience at Krishna jewellers Pearls & Gems, Jubilee hills, Road no-36. Thanks to Mr. Sravan who was very kind & polite to our requests/wishes and was …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1145",
      "name": "koppu rammurthy",
      "rating": null,
      "text": "Sandhya rani The way she greets the customer and the knowledge about the items is very satisfying. Good to see such associates in Krishna.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1146",
      "name": "kotagiri ramachandra",
      "rating": null,
      "text": "K Sai Kumar explained in detail and provided excellent service.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1147",
      "name": "Kowlini Inampudi",
      "rating": null,
      "text": "Mahesh S and Anand both helped make the purchase experience wonderful. They helped me by virtually showing the models when in US and also when I visited the store they showed all the models very patiently. Thankyou.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1148",
      "name": "Kranthi A",
      "rating": null,
      "text": "Recieving is good and sales person Mr.Yadav shown plenty of options with patience in which we can choose and buy. Overall experience is good to nice place to visit lovely experience.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1149",
      "name": "kranthi kaza",
      "rating": null,
      "text": "Sravan showed us different varieties of Jewellery, dealt with dedication and Manager Srinivas is very patient and has given good price markdown. Thanks Krishna Jewellers pearls and gems for good customer service.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1150",
      "name": "kranthi kumar",
      "rating": null,
      "text": "I have found them highly professional and wise in understanding the requirements. I have visited multiple times and received the best hospitality all the time. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1151",
      "name": "Kranthi Sarikonda",
      "rating": null,
      "text": "Yadav was extremely patient and was very cooperative.. showed us complete collection and was very helpful",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1152",
      "name": "kranti pamidi",
      "rating": null,
      "text": "I like the collection here. I worked with Riaz garu and he took really good care of us. Even when buying online or at the store.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1153",
      "name": "krishna chaitanya",
      "rating": null,
      "text": "Nice collection and hospitality was so good. Mr. Rajesh was very proactive and showed all the products with patience. Overall very much satisfied with the purchase.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1154",
      "name": "Krishna Chand Paruchuri",
      "rating": null,
      "text": "Krishna Jewellers has huge collection of Diamond jewelry. We had an awesome experience while shopping here. I highly recommend Sales person Shivaji. He is very patient in showing entire collection and gives best possible price.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1155",
      "name": "Krishna Geetika",
      "rating": null,
      "text": "Over priced and staff not patient",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1156",
      "name": "krishna kolluru",
      "rating": null,
      "text": "The best show room for gold and diamonds. Mr.R.Sateesh has been very patient and assisted all the way from the beginning to the end. I highly recommend this place for its disigns and prices.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1157",
      "name": "Krishna Pasupala",
      "rating": null,
      "text": "Very good collection and Priya (staff) she has very good knowledge regarding the ornaments and she shows a product with very good patience and store has a good collection",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1158",
      "name": "krishna Peetha",
      "rating": null,
      "text": "Collection is very nice. Had good customer experience.Mr.Yadav is good in understanding our requirements and showed us ornaments matching our criteria. Thank you for the service 🙏 …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1159",
      "name": "Krishna Reddy",
      "rating": null,
      "text": "Laleppa & Lavanya & kranthi.. We are happy to have heart full service provided by krishna jewelry .",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1160",
      "name": "Krishna Superstar",
      "rating": null,
      "text": "We received our purchase with great honor and are thrilled with the service! The team ( Mr.S.Bharat) treated us with exceptional care and respect. We're delighted with the quality of the gold jewelry. …",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1161",
      "name": "krishna teja",
      "rating": null,
      "text": "Poloju Shankar did a very well customer service and been very kind and gave us a best product which we were at most satisfied.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1162",
      "name": "Krishna Vamsi",
      "rating": null,
      "text": "R Sateesh, Was very generous and helped us in our selection. Pls do visit for best customer prices",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1163",
      "name": "KrishnaVeni Katakam",
      "rating": null,
      "text": "Krishna jewellers pearls and gems jubilee hills Branch last 6 years come to store unique, elegant & impressive styles. Went to few other big brand store. Glad I visit their store brought a beautiful set. Thanks to venkatesh & Kishore chary.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1164",
      "name": "Krishnaveni Konamaneni",
      "rating": null,
      "text": "Good service, Nagarjuna showed different models in the desired range, best price offered without much negotiation. Overall, happy with the purchase.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1165",
      "name": "Krishnaveni P",
      "rating": null,
      "text": "Ramadevi salesperson who showed us very energeticly understanding our taste and treated us with patience and politely. I liked their wide range of collection.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1166",
      "name": "Kshipra Manjunath",
      "rating": null,
      "text": "I came all the way to Krishna Jewellers in Hydrabad from Bangalore to buy my wedding jewelry, thats how good the collection is! …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1167",
      "name": "Ksms 2021",
      "rating": null,
      "text": "Nice experience at Krishna , this person called showed us the collection as per our requirement . Happy with the service and happy with collection they have . Would suggest everyone to visit at least once for shopping jwellery",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1168",
      "name": "Kukunuri Sanjana reddy",
      "rating": null,
      "text": "Very nice experience and I was a old customer to this showroom and very unique designs.. executive Venkatesh garu has done a very good job with lot of patience.. I refer to visit the showroom and have a look for the new collections..",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1169",
      "name": "Kunuku Swathi",
      "rating": null,
      "text": "Met Guravaiah and has taken a 3 steps chain. It is awesome. price is reasonable and also he had received us well and communicated politely. He is having a lot of patience....",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1170",
      "name": "Kurt Dcruze",
      "rating": null,
      "text": "Kushal has been amazing at understanding our needs in the first instance and patiently addressed all our queries . Very grateful for his service and service .",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1171",
      "name": "laasya varma",
      "rating": null,
      "text": "Govind and lavanya were extremely patient in showing us their amazing collection.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1172",
      "name": "LachiReddy Mulagundla",
      "rating": null,
      "text": "Excellent customer service Genuine product quality Impressive designs …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1173",
      "name": "lakshmi mamidi",
      "rating": null,
      "text": "We have purchased two necklaces for our daughters half saree. They have very good collections in gold, polki and diamond jewellery. Sales executive S Bharath has shown the collections as per our requirement. He has explained all the details with so much of patience. We are very happy with our purchase. Thank you",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1174",
      "name": "lakshmi neeraja",
      "rating": null,
      "text": "Best experience shopping here at Krishna Jewlers Jubilee Hills. Excellent modern and antique jewelry selection, amazing variety at best prices. Staff are extremely friendly and helpful, who can assist with any type of jewelry you have in …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1175",
      "name": "Lakshmi Prathyusha Danthuluri",
      "rating": null,
      "text": "Had a very good experience at Krishna Jewellers. Sarvesh was really very patient and showed all the jewellery with a lot of patience. Highly recommend to purchase from Krishna Jewellers.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1176",
      "name": "Lakshmi Srujana Soppa",
      "rating": null,
      "text": "We had great shopping experience at krishna Jewellers.They have huge number of collections in all varieties.Thank you Ramya for assistance, Thank you Mahesh for your patience in explaining n show casing the ornaments a/c to our requirements.Thank you Srinivas giving us good deal.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1177",
      "name": "Lakshmi Suresh",
      "rating": null,
      "text": "Mallikarjuna in Krishna jewelers is very knowledgeable, passionate & dedicated representative, he showed all the designs patiently & explained the difference in each model, we highly recommend him.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1178",
      "name": "LakshmitejaReddy Yeturu",
      "rating": null,
      "text": "We are very much satisfied with this purchase,very elegant designs thank you DINAKAR SIR for your polite service",
      "date": "",
      "displayDate": "Edited 6 months ago",
      "relativeDate": "Edited 6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1179",
      "name": "Laksmy akondi",
      "rating": null,
      "text": "Rajesh is very cooperative and took lots interest in showing me my things which I need to purchase thx u rajeswari and shiva and kiran for showering lots of love and effection thx u all.... and another fresh review from past 10days Mr …",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1180",
      "name": "lalitha konjeti",
      "rating": null,
      "text": "I visited the store today,sales person pavani she showed some beautiful collections,she responded in a very polite manner and we loved everything and very happy shopping to go with the family 😊 …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1181",
      "name": "Lalithya Sajja",
      "rating": null,
      "text": "It was a wonderful experience buying jewellery from Krishna jewellers. Sandeep was our sales executive, he was patient in showing us various models and answering all our questions. The customer service is excellent. Also, Krishna jeweller's …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1182",
      "name": "Lanka Sri Santhi",
      "rating": null,
      "text": "Jewellery designs are very unique and beautiful. Mr. Sandeep provided an amazing service throughout our shopping. very happy with our purchase.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1183",
      "name": "Lanka Vani",
      "rating": null,
      "text": "Collection is good we purchased long haram and necklace pavani show very well thanks to Krishna jewellery",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1184",
      "name": "Latha",
      "rating": null,
      "text": "We were the first time shoppers at Krishna Jewelers and we were amazed with the latest models and differentiated pieces of gold and diamonds they carry. Previously we shopped in NJ, Chicago and Dallas and a few shops here in HYD. But …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1185",
      "name": "Latha Atluri",
      "rating": null,
      "text": "Very happy with my orders. Bracelet is flawless and very nice quality. Moissanites necklace I order from online picture. Rahul with his team worked with us to remake the model share. Moissanites are good quality. Rahul understands …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1186",
      "name": "Latha Gade",
      "rating": null,
      "text": "Good service by Shivaji Very good collection in diamond jewelry and gold I recommend Krishna Jewellers jubilee hills branch",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1187",
      "name": "Latha P",
      "rating": null,
      "text": "I had a wonderful long distance buying experience with your online sales representative, Mr.Guravaiah. He was very responsive to all my needs and explained everything in great detail about the products he showed and the pricing details. He …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1188",
      "name": "Latha Reddy",
      "rating": null,
      "text": "Krishna jewellers is a amazing shop with wide range of gold varieties. One of the staff Ganga bhavani guided and helped me to pick up the good gold design. It was very nice experience visiting this shop and highly recommend for everyone.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1189",
      "name": "Latha T S",
      "rating": null,
      "text": "I'm happy that I came accross this place through family references. The collection was extremely good and very well satisfied with the necklaces we bought. Thanks to Mr. Nagarjuna for showing us the right collection.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1190",
      "name": "Lavanya Avula",
      "rating": null,
      "text": "Best collection of all kinds. Very friendly staff. Sravan was so helpful to show us everything we meed so patiently. Always wish to come back and will recommend to anyone.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1191",
      "name": "lavanya reddy",
      "rating": null,
      "text": "Am soo impressed by the superb customer service we received from Krishna Jewellers through Ramadevi and Dinaker , I wanted Diamond jhumkis for my daughter, He worked with our price point, was trustworthy, courteous and determined to make …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1192",
      "name": "lavanya vallur",
      "rating": null,
      "text": "Great shopping experience.. Sandhya Rani made it very easy polite.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1193",
      "name": "Laxman Neelam",
      "rating": null,
      "text": "Good service given by yadav nice collection",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1194",
      "name": "laxmi srinija",
      "rating": null,
      "text": "I was attended by Lokanath and the collection was awesome. The product I ordered came out exceptional. I am overall cery happy with his service",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1195",
      "name": "Laya Krishna",
      "rating": null,
      "text": "Amazing collection at krishna jewellers. Their customer experience is great!!sales executive Venkatesh was very patient in showing designs and understanding our tastes. He also showed great interest I suggesting us customisations and also helped us in negotiations. Surely a great place to purchase jewellery of your dreams !",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1196",
      "name": "likhitha reddy",
      "rating": null,
      "text": "Very good experience buying in krishna jewellery. And sales executive Sunitha sis very good at helping in buying jewellery.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1197",
      "name": "Lipika Raj.",
      "rating": null,
      "text": "Recently visited Krishna jewellery It was wonderful shopping here. “Sunitha you have great communication. Thankyou for the amazing service.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1198",
      "name": "Little Star Harini",
      "rating": null,
      "text": "We love collection and hospitality. Prakash garu is very genuine and patience he made us fell comfortable. Thank you Prakash",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1199",
      "name": "lokesh lokesh",
      "rating": null,
      "text": "Sunitha was xtra carring about us and suggested good designs",
      "date": "",
      "displayDate": "3 months ago",
      "relativeDate": "3 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1200",
      "name": "Lover boy Ajay",
      "rating": null,
      "text": "Nice collection! Great service! Reasonable prices. We had an amazing experience with sales Mr.srinivas yadav He have a nice experience in sales and he had a so much …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1201",
      "name": "lucky Dugg",
      "rating": null,
      "text": "I liked the collection and the way they show , patience and interest of showing , especially Mr Vinod helped me in all ways",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1202",
      "name": "Luckysboutique2014",
      "rating": null,
      "text": "fabulous and fantastic collection. Sai Kumar is very patient in listening the requirement and sell what customer looking for .. Very Happy with the service received from his end .",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1203",
      "name": "M a",
      "rating": null,
      "text": "Krishna Jewellers is a one stop place for all kind of jewellery. The staff is very courteous and patiently demonstrates all the requested collection. Rates also very reasonable. We have been buying jewellery from Krishna Jewellers from past …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1204",
      "name": "M Chamlamgari",
      "rating": null,
      "text": "It was a good experience purchasing jewellery from here and the service by sales executive Rekha was very good. She takes time to cater to my requests for showing new designs and also follows up pretty well till the jewellery is handed over.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1205",
      "name": "M Laxman",
      "rating": null,
      "text": "Customer service is very excellent,I finalised my jewelry in very short time, Sandhya is good & experienced staff in krishna jewelry and pearls,we are so happy",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1206",
      "name": "m praveen reddy",
      "rating": null,
      "text": "Great experience, awesome hospitality from the sales team. Collections are good.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1207",
      "name": "M Sai",
      "rating": null,
      "text": "I had a very great experience with Krishna Jewelers. Their service is best so far i have seen especially their sales expert Guravaiah has patiently showed us their best collection. We have been shopping for more than 6 hours and every sales …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1208",
      "name": "M Srividya",
      "rating": null,
      "text": "Shailaja she is very friendly and warm welcoming good service",
      "date": "",
      "displayDate": "3 months ago",
      "relativeDate": "3 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1209",
      "name": "M V ANANDA Kumar",
      "rating": null,
      "text": "The collection at the Jubilee hills store is great with all kind of vintage and modern finish. Saleswoman Priya showed us all the designs with patient and was good.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1210",
      "name": "Maddala Shanmukh",
      "rating": null,
      "text": "I along with my brother purchased jewellery as he recommended jubilee hills branch, I really much satisfy with my purchase. Im thankful to Krishna jewellery and his team(Sravan - Senior sales team ) for guiding me to choose the best and most memorable.",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1211",
      "name": "Madhava Rao Guntur",
      "rating": null,
      "text": "It's a very pleasant and satisfying experience shopping at Sri Krishna Jewellers. Gagan Bhavani did a good job in showing us a good collection and even the negotiations were honest that we ended up taking more than we planned for.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1212",
      "name": "Madhavi Madhu",
      "rating": null,
      "text": "Very good experience with krishna Jewell’s .i am a regular customer.pavani sale executive was very patient n showed lot of collection.they have lovely collection",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1213",
      "name": "Madhavi Pendyala",
      "rating": null,
      "text": "I went to buy a necklace and earrings and had the most pleasant and relaxing experience while looking at the jewellery pieces. Rama Devi who showed us the items was very very knowledgeable, soft spoken and pleasant lady who instantly …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1214",
      "name": "Madhavi Reddy",
      "rating": null,
      "text": "The experience was very nice. Staff mahalakshmi garu was very patient and politer. Would definitely recommend to my family and friends.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1215",
      "name": "Madhavi Reddy",
      "rating": null,
      "text": "Very nice collection and the staff especially Pavani is so helpful and patient. Really happy and I could it's because of such good staff we bought the items .",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1216",
      "name": "Madhu",
      "rating": null,
      "text": "Amazing collection and I had a wonderful shopping experience at Krishna Jewellers. Very respectful staff. Especially S.Mahesh helped me with my plenty of online questions and in store shopping. I will surely shop at this store during my next visit to 🇮🇳. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1217",
      "name": "Madhu Kura",
      "rating": null,
      "text": "I went Krishna jewelries for visiting with my neighbour. I really enjoyed.there are so many design available. They provide good customer service also. Especially Ganesh garu. Thank you sir for your patience. You saw me the best designs. Thank for Krishna jewelries providing such a beautiful products.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1218",
      "name": "Madhu M",
      "rating": null,
      "text": "Krishna Jewellery offers valuable items like gold, silver, gems, and diamonds. Their representatives are well-groomed, knowledgeable, and attentive. Ms. Kaliwalr Rekha impressively listens to customer needs, demonstrating deep product knowledge and excellent customer service.",
      "date": "",
      "displayDate": "Edited 8 months ago",
      "relativeDate": "Edited 8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1219",
      "name": "madhu makam",
      "rating": null,
      "text": "Had a wonderful experience at krishna jewellers, jubilee hills , Mr.R. Satish was very helpful during our purchase.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1220",
      "name": "Madhu Mallu",
      "rating": null,
      "text": "Nice collection!! Outstanding customer service from Mahesh J. He helped us find the Best from the best collection. He showed great positive attitude in explaining the product and usability and exhibited at most patience. Looking forward to visit again and refer the store and him to my friends. Thx",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1221",
      "name": "madhu mitha",
      "rating": null,
      "text": "Excellent jewellery shop ,brought bangles and large kadiyam ,with excellent margin of discount,excellent staff mainly sivaji ,very obident and much patience when showing jewellery, will visit again thanku 😊 brought vaddanam also recently …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1222",
      "name": "madhu potla",
      "rating": null,
      "text": "Mr Loknath senior sales man is very personable knows our taste and shows good jewelry . Show room has very reasonable and good pricing compared other Jewelry stores …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1223",
      "name": "Madhu Singh",
      "rating": null,
      "text": "Had an amazing experience at Krishna Jewellers today. Kranthi was very patient, humble and polite, he has been extremely helpful. Very happy with the purchase :)",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1224",
      "name": "Madhuri Battula",
      "rating": null,
      "text": "We had a great experience at Krishna Jewellers, Jubilee Hills. Special thanks to Mr.Srikanth. We started with video call and Srikanth was very helpful, patient and provided excellent guidance throughout the process, making the experience …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1225",
      "name": "Madhuri Gunapalli",
      "rating": null,
      "text": "Krishna Jewellers, Jubilee hills have unique collections whether it is bridal, pearl or contemporary jewellery. The staff ( Praveen and Vinayak) is very courteous and has utmost patience. You will be kept offering with refreshments so you …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1226",
      "name": "Madhuri Manimala",
      "rating": null,
      "text": "I’m very happy and satisfied with ur awesome collections and nice customer service especially guruvayya he is very patient in showing good collection thank you.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1227",
      "name": "Madhurima Chittineedi",
      "rating": null,
      "text": "Sales person Sunitha showed us all the pieces really well It was a good experience overall",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1228",
      "name": "Madhusudhana Reddy MV",
      "rating": null,
      "text": "I really appreciate Nagarjuna for being patient and help us to decide the product. He is a great asset for your company. I am sure he has a great knowledge on all products than any other employee. Simple instance was that other customers were approaching us and asking the products to try those were shown by Nagarjuna.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1229",
      "name": "Maggie C",
      "rating": null,
      "text": "We visited this store and were received with the utmost attention by the staff. Ganga Bhavani helped us with the Jewellry selection and we purchased a diamond necklace and earrings. Their collection is very good and they provide certificate …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1230",
      "name": "Mahender N",
      "rating": null,
      "text": "We visited first time to Krishna jewellers experience is excellent Sandhya rai give very good service",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1231",
      "name": "Mahender S",
      "rating": null,
      "text": "Good service. Mahesh made us feel comfortable and patiently answered all of our questions.",
      "date": "",
      "displayDate": "3 months ago",
      "relativeDate": "3 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1232",
      "name": "Mahender Sada",
      "rating": null,
      "text": "Veey nice collection of jewellery. Mr yadav is very good",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1233",
      "name": "mahesh dasari",
      "rating": null,
      "text": "I visited krishna jewellers pearl# & gems recently for buying a jewellery worth 1.5L but I buy a jewellery worth 2.5L the assistance provided by Mr venkat is remarkable and polite in nature. The pieces he shown to me is absolutely marvelous.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1234",
      "name": "Mahesh M",
      "rating": null,
      "text": "Excellent customer service by Mrs Ramya Pavani and Chary garu. The store offers unique designs and our kids loved their sandwiches. Thank you for taking good care of our family during our visit and offering us the best price. We’ll certainly revisit.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1235",
      "name": "Mahesh Madala",
      "rating": null,
      "text": "Very good collection and excellent customer service. Had great experience with sales team Mr Loknath and Mr kashinath.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1236",
      "name": "Mahesh Muppavarapu",
      "rating": null,
      "text": "Vinayak provided a great customer service. He had shown great patience in showing us the bangle models and provided perfect client experience. Ordered the bangle when the size was not available in store and delivery was on time.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1237",
      "name": "Maheshwari I",
      "rating": null,
      "text": "recently purchased a stunning pair of ear tops from Krishna Jewellers Pearls and Gems in Hyderabad, and I am absolutely satisfied with them ! The craftsmanship is upto the mark and Excellent! The team's service was wonderful, even the …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1238",
      "name": "Maheswar Polur",
      "rating": null,
      "text": "Collection and their response and ambiance towards customers is good. We were attended by Pavani",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1239",
      "name": "mahidhar kadambi",
      "rating": null,
      "text": "Nice place and having good collections. Interacted with Mallikarjun and he was very cordial. A good example of customer service. We will definitely visit again.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1240",
      "name": "Mahima bhavaraju",
      "rating": null,
      "text": "I really liked shopping here. Wide range of variety and very good hospitality. A special shout out to akshaya garu who was very patient and also has very good knowledge about latest trends and what would best suit our requirements. Thank you! Will definitely come back to shop :)",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1241",
      "name": "Malka Shaik",
      "rating": null,
      "text": "Our experience shopping at Krishna Jewelers was very pleasant. Their hospitality is top notch. Especially Sandhya Rani was extremely patient and present in helping us out make the right choices",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service",
        "gifting"
      ]
    },
    {
      "id": "stream-1242",
      "name": "mallela suma",
      "rating": null,
      "text": "Ramadevi Thank you for showing us nice designer and response was very nice .we like to visit the store again .",
      "date": "",
      "displayDate": "Edited 9 months ago",
      "relativeDate": "Edited 9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1243",
      "name": "Malleswari Imandi",
      "rating": null,
      "text": "Very good experience wuth krishna jewellers, they valued customers and their concerns... Nice experience with executive pavani.. Showing designs with more patience..",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1244",
      "name": "Mallik",
      "rating": null,
      "text": "Excellent service, particularly of Mr Loknath. Worth visiting once.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1245",
      "name": "Mallikarjun Raju",
      "rating": null,
      "text": "Just visited to buy a couple rings for my friend's engagement. They have shown me great stuff it's really bit confused in choosing. Really appreciable salesmen's patience in showing each and every thing which I have asked. Great stuff in their social media profiles i regularly follow their Instagram profile for new collection updates.",
      "date": "",
      "displayDate": "7 years ago",
      "relativeDate": "7 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1246",
      "name": "Mallu Vineesha",
      "rating": null,
      "text": "I have visited to this store for my wedding jewellery. They have wide range of collections and best hospitality. Ramadevi garu showed us all latest collections with patience and helped me in choosing best for my big day.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1247",
      "name": "Mamatha Sree",
      "rating": null,
      "text": "Its my first visit to krishna jewellers, I see huge collections which fulfilled my requirement and I loved it. Staff are too Friendly, especially priya welcomed us with great smile and through out she was very patient. Thanks to her😀. …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1248",
      "name": "manasa bobba",
      "rating": null,
      "text": "Sunitha has assisted us with lot of patience and was very cooperative. Had a very good experience.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1249",
      "name": "Manasa Ganguri",
      "rating": null,
      "text": "Pavani was the service person who helped the whole session. She was fantastic and helped in making me understand the quality. She was helpful to finalize the item when in dilemma. Overall, look forward to meet her soon and buy more jewellery.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1250",
      "name": "Manasa reddy",
      "rating": null,
      "text": "Totally satisfied… brought long and short diamonds set… waiting for more new collection… Meenakshi was our sales person… she has so much patience because of her we were done with our shopping succesfully and satisfactorily…",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1251",
      "name": "Manasi K",
      "rating": null,
      "text": "It was my first time shopping with Krishna jewelers. Their on line shopping is amazing experience. Mr. Vipin helped us in store. And shopping online with Mr. Venktesh Was superb experience. He showed me patiently all the designs available in my budget. Answered my queries. Over all happy 😊 …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1252",
      "name": "manaswi gsn",
      "rating": null,
      "text": "Our experience at the Jubilee hills showroom is truly satisfying. We would like to thank Sai Kumar garu who has been very kind and patient in showing us their entire collection and explaining us very intricate details. Thank you so much for …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1253",
      "name": "Manaswini Chowdary",
      "rating": null,
      "text": "Today we visited the store to purchase hase gold for wedding. We were hosted by an employee named(Pavani). This lady was too rude and arrogant. Definitely not in a way to deal with clients. And not sure why they are showing wrong gold price …",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1254",
      "name": "Manchi Siva Sankar",
      "rating": null,
      "text": "Pavani received us in a smooth manner n explained about ornaments in excellent manner.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1255",
      "name": "Maneesha Kasula",
      "rating": null,
      "text": "After visiting a lot of stores in panjagutta, Abids , Komaplly just found this store . As it is in core Jubilee Hills hesitated to go this store thinking they charge more . Amazingly the store is a hidden gem with fashionable jewellery …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1256",
      "name": "Manik Rao",
      "rating": null,
      "text": "Representative - Mr. Mallikharjun and bhavani have done excellent sales efforts and good customer relationship. We appreciate them and deserve recognition",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1257",
      "name": "Manikanta Deshpande",
      "rating": null,
      "text": "We have visited the Sri Krishna Jewellers, Bheem and Pavani showed best collection. Highly recommendable to go visit the store",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1258",
      "name": "Manisha Reddy",
      "rating": null,
      "text": "The jewellery has one of the best stones and the service from Bharat and Sai kumar along with Swamy krishna here is the best and they take care of the customer needs and also takes care of the purchases with best prices and huge discount. Overall it is one of best places to go for buying jewellery.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1259",
      "name": "Manjunath Reddy",
      "rating": null,
      "text": "Had great experience buying at this place . The store has different and n number of models for each type. Representative was so patient in showing different models in the requested type …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1260",
      "name": "Manne Venkat",
      "rating": null,
      "text": "Krishna Jwellary Pearls and Jwellarys Jublihills branch: since 2015 I am visiting this store, nice collection and new models for all age groups and staff also very friendly and excellent hospitality. Store manager Nayeem, executive …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1261",
      "name": "Manogna K",
      "rating": null,
      "text": "Loved the collection, great customer support and very co-operative staff. We have done our shopping with sales manager Mahesh, he is patient, helped us a lot. They always maintain wide range of collections, reasonable prices and excellent customer support.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1262",
      "name": "Manogna Manu",
      "rating": null,
      "text": "Collections are very good,- Pavani’s service is very good",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1263",
      "name": "MANOJ KUMAR",
      "rating": null,
      "text": "We had very good experiences with the purchase here. Priya had done a wonderful job in explaining and showing up the models. Thank you.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1264",
      "name": "Manoj Muddam",
      "rating": null,
      "text": "Loved the collection, customer friendly and great place to purchase ornaments nice service provided by pavan",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1265",
      "name": "Manpreet Kaur",
      "rating": null,
      "text": "Good pearls shopping experience. The hospitality provided by the staff especially Mr. Vivek Krishna is commendable, as he was showing us just the perfect designs as if he already knew what we are looking for. All of this makes him an amazing salesperson.",
      "date": "",
      "displayDate": "8 years ago",
      "relativeDate": "8 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1266",
      "name": "Mantosh Behera",
      "rating": null,
      "text": "Awsum designs. The elegancy on the designs was the most I liked it. Moreover we met Venkatesh was best who showed us designs on our budget. When you next visit please take reference from Venkatesh.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1267",
      "name": "Maram NagiReddy",
      "rating": null,
      "text": "They are having amazing jewellary , great designs. The staff is very hospitalable especially rama devi",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1268",
      "name": "Maria Tuohy",
      "rating": null,
      "text": "Pavani's service was superb. We were well attended to with a variety of choices, and had our specific needs met with changing clasps and fixing other jewellery.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1269",
      "name": "martin pidakala",
      "rating": null,
      "text": "We attend your exibition in Bhimavaram. The collection of jewellery is in grand manner. Sales person Ratna Raju received us with an excellent manner and provide wonderful service to us.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1270",
      "name": "Mary Jyoshna",
      "rating": null,
      "text": "Rekha - I have recently visited the store, had a great experience they are having the latest new collections with latest designs which are at reasonable cost and staff are having good patience. One store to have all types of jewellery collections.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1271",
      "name": "Masura Shiva",
      "rating": null,
      "text": "Nice collection and very differently designed jewellery. Impressed with their hospitality and attendance. …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1272",
      "name": "Mayuri Gunda",
      "rating": null,
      "text": "Rama devi was and has been my senior sales executive for many years now. She is the best and I would give us suggestions and show me the best collection and also give me ideas on the latest trends. She shows me a wide variety of collections …",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1273",
      "name": "meda sadhana",
      "rating": null,
      "text": "I am writing to express my sincere appreciation for the outstanding service I received from one of your online sales executives, Mr. Guravaiah. I recently had the pleasure of shopping through your online platform and the experience was …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1274",
      "name": "Meena Murthy",
      "rating": null,
      "text": "Sarvesh gave very good service with lots of patience and smile which was very pleasing. Nisha helped in choosing the right choice and guided in many ways. Thank you",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1275",
      "name": "Meenakshi.ck .Reddy",
      "rating": null,
      "text": "Excellent collection and service by Mr. Kushal. He patiently beared with us and helped us with selecting what we like. We will definitely look out for Mr. Kushal whenever we visit the next time. It was a great experience with shopping this time with krishna jewellers.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1276",
      "name": "Meganathan P",
      "rating": null,
      "text": "This is the very first time I have placed my order over phone in jewellery area, Billing team (Bhagya sree) done very good job in tracking and explaining all the formalities. Shipping was also excellent. Thanks.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1277",
      "name": "Megha shree",
      "rating": null,
      "text": "Thank you krishna jewellers we liked the collections... collections are beautiful. Naresh was very helpful and very patiently he helped us to shown the best collections.... were warmly greeted by all members at krishna jewellers by providing the best customer service. And they gave best price.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1278",
      "name": "Meghana Chikkam",
      "rating": null,
      "text": "Nice place for buying unique designs. Meenakshi ma’am helped us find the right designs. 👍🏻 great place to start …",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1279",
      "name": "Meghana Dirisala",
      "rating": null,
      "text": "They have beautiful and unique designs, I really had good experience shopping at Krishna Jewellers, I was assisted by Ramya from online department and Ramadevi from sales. They were so professional and patient throughout the process of my purchase…Thank you😊 …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1280",
      "name": "meghana gudala",
      "rating": null,
      "text": "Beautiful collection and great customer service with prompt response :) I was assisted by Srikanth , Guruviah and Kishan - professional and timely. Thank you.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1281",
      "name": "Meghana Marepalli",
      "rating": null,
      "text": "I reached out on a phone call. The team helped me & safely delivered the product home. Satish very patiently sent me all the options available.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1282",
      "name": "Meghana Patel",
      "rating": null,
      "text": "I had traveled to Hyderabad especially only to visit Krishna house of Silver I m really Happy to say , i had selected some of the most gorgeous designs of silver made items i have ever seen …",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1283",
      "name": "Meghana Reddy",
      "rating": null,
      "text": "Ramya Pavani the way of she received the customer and showing items and explaining very nice",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1284",
      "name": "Meghana Reddy",
      "rating": null,
      "text": "Excellent and prompt service by Mr Ramesh. He was extremely courteous throughout the shopping process . Highly appreciated !",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1285",
      "name": "Meghna Rao",
      "rating": null,
      "text": "Salesman mallikarjun is very good. He's very patient , friendly and we can completely rely on him for picking up a complete set for bride even.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1286",
      "name": "Metla Satish",
      "rating": null,
      "text": "Very good experience at krishna jewellers. Satish gave a good service to us",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1287",
      "name": "Miss Sanjana Adhikari",
      "rating": null,
      "text": "I came here to shop for my brother's engagement, had a great shopping experience. Our sales executive pawan was really supportive and helpful throughout. Would definitely recommend people to shop here",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1288",
      "name": "Mitali Adhikari",
      "rating": null,
      "text": "Good decorations.& staff also friendly behavior and good thank you vikas pandey",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1289",
      "name": "mithun mohanty",
      "rating": null,
      "text": "Very nice place, good service, staff are very friendly Bharat name staff is really good",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1290",
      "name": "mohammed sameer",
      "rating": null,
      "text": "Hello Dear Team Of Krishna Jewellers Pearls And Diamonds I Really Appreciate Your Gold & Diamonds Ornaments Good Collection In your Branch Jubilee Hills And I visit So Many Times They Give Good Response Yesterday I Visit To shop Your Sales …",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1291",
      "name": "Mohan Kottamasu",
      "rating": null,
      "text": "Rama Devi helped us purchase a diamond necklace. Most helpful 😀 …",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1292",
      "name": "Mohan Narendra",
      "rating": null,
      "text": "Ramadevi facilitated very well and understood customer requirements and showed really good designs based on our budget. Very friendly environment and must visit store for buying diamond jewellery",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1293",
      "name": "Mohan Reddy",
      "rating": null,
      "text": "M. Sunitha is so helpful, she is so co-operative and provided lot of information on the designs on jewelry.. I appreciate her patience and she is very welcoming and spent almost 7 hours and made sure our purchase is worth while..",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1294",
      "name": "Mohd Iliyas Pathan",
      "rating": null,
      "text": "Krishna Jewelers was a great shopping experience with a large collection. It really helped to have venkatesh as our salesperson she was so patient and gave her honest opinion on what looked nice, as well as doing the most to give a reasonable price.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1295",
      "name": "Mohd Sohail",
      "rating": null,
      "text": "Nice collections Good service by Govind",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1296",
      "name": "Mohini Ramaraju",
      "rating": null,
      "text": "Collection are good designs are good pavani help very well",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1297",
      "name": "Mohmmed Shadab",
      "rating": null,
      "text": "2nd time visited Krishna pearls. Just I use one word for this showroom \"Trust\". Good quality pearls with reasonable price …",
      "date": "",
      "displayDate": "6 years ago",
      "relativeDate": "6 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1298",
      "name": "moni amrutha peddi",
      "rating": null,
      "text": "I am feeling very happy after visiting Krishna Jewellers by seeing the latest designs and polite staff. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1299",
      "name": "Monika Reddy",
      "rating": null,
      "text": "Came to buy kundan jewellery. Found very good designs. Customer service executive( Ganga Bhavani) wqs very patient and showed is multiple models. Overall great service and best quality gems and workmanship can be seen in the pieces.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1300",
      "name": "monika sangem",
      "rating": null,
      "text": "Krishna jewellers pearls and gemes jubilee hills branch . Visited twice . Pleasant visit. All diamond jewellery designs are so good . Executive Venkatesh has assisted us very efficiently . I would definitely come to this point at my wedding time.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1301",
      "name": "Moulica Raavi",
      "rating": null,
      "text": "I had previously purchased few gold items from Sri krishna jewellers and was in awe with their collection. Recently I had visited them for simple daily wear gold chains and to my surprise I was shocked to see the behaviour of the staff , …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service",
        "gifting"
      ]
    },
    {
      "id": "stream-1302",
      "name": "Mounica Changari",
      "rating": null,
      "text": "I am a regular customer at Krishna. I just love their collection. I was attended by pavani this time and she was very patient and showed me all the rings collection in the shop. They had some amazing collection bdw. Got two rings for both …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1303",
      "name": "mounica snigdha",
      "rating": null,
      "text": "I regularly purchase in krishna jewellers Jubille hills.Wonderful collection.Very unique and designer wear collection.Specially I want to thank sales person yadav he helps me every time to pick right designs through d purchase.Thank u so much Vinayak for u r patience.",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1304",
      "name": "Mounika Kadiyala",
      "rating": null,
      "text": "Mahalakshmi madam has showed varieties of designs and really helped in selecting the good designs 👌👌 …",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1305",
      "name": "mounika kunaparaju",
      "rating": null,
      "text": "First time visiting Krishna Jewelry store. Great customer service with stunning wide range of jewelry collection. Kushal was our sales executive and he made sure we had an amazing experience. He was very welcoming, responsive and exactly …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1306",
      "name": "Mounika M",
      "rating": null,
      "text": "We received the product securely. This is the first time we are ordering directly from a jeweler from India to USA and we were little skeptic about the safety. Krishna jewelers and their staff made it easy for us and delivered product in …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1307",
      "name": "Mounika reddy Maddi",
      "rating": null,
      "text": "Very good Collection response was good and thank you Sathish garu",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1308",
      "name": "Mounika Sheelam",
      "rating": null,
      "text": "Amazing experience whenever I visit .. it’s my favourite store in Hyderabad. Mr. Sarvesh helps to find the best jewellery with patiently with good discounts. I would recommend to visit and feel the presence.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1309",
      "name": "Mounika Yarlagadda",
      "rating": null,
      "text": "Large selection of gold, diamond, and pear jewelry& accessories. Excellent customer service from Pavani for both in store and online inquires as well as coordinating with other branches for requested items …",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1310",
      "name": "MR UV",
      "rating": null,
      "text": "Nice collections and good staff pawan helps a lot",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1311",
      "name": "MrTechRC",
      "rating": null,
      "text": "Spacious and variety of designs at good price compare to competitors. Well decepline staff, Bharath is very patient and very helpful guy. Never been disappointed with service.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1312",
      "name": "mrudula DEsai",
      "rating": null,
      "text": "I recently bought a gold set at Kirshna jewellers and had a great experience Bheem was professional and handled the transaction very well I would recommend this store to who ever wants to purchase weddding jewellery",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1313",
      "name": "MSk",
      "rating": null,
      "text": "Amazing designs , Good hospitality and explanation from Mr Venkat .",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1314",
      "name": "muktha k",
      "rating": null,
      "text": "This is my first time in Krishna jewellery road no 36 jublee hills Hyderabad. I came all the way from Bangalore. I am very happy with service here, a dedicated senior sales person Ms. Shakeela and Mr. Ramakanth were with me and cleared all …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1315",
      "name": "Mukunda Reddy",
      "rating": null,
      "text": "We are regular customers for Krishna Jewellers, Pearls & Gems, Jublihills since last 5 years. They have unique collection and best prices. The sales executive Mr.Ydav is very professional and polite, he made our shopping experience very …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1316",
      "name": "Murali krishna",
      "rating": null,
      "text": "We are regular customers for Krishna Jewellers, Pearls & Gems, Jublihills since last 3 years. They have unique collection and best prices. The sales executive Mr.P Vinod garu is very professional and polite, he made our shopping experience …",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1317",
      "name": "Murali Vemuri",
      "rating": null,
      "text": "This is the first time I bought jewellery from this store through Instagram. Sales executive Somesh dealt with me mostly . He has been extremely helpful in showing several items. He supported a lot until the delivery of the items. All in all a first class experience !!!",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1318",
      "name": "Muram Nagendra Reddy",
      "rating": null,
      "text": "If want to find various variety of and quality of jewellers and pearls I suggested to you the best is Krishna jewellers in Jubli hills in Hyderabad. And they provide good service to customers. I am very impressed with customer …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1319",
      "name": "Murthy Ivaturi",
      "rating": null,
      "text": "Had a very wonderful shopping experience at Krishna Jewellers. Rama Devi was very personable with great service towards us. She quickly understands the mentality and needs of her customers and gives a 10 star experience. I would come back for future purchases.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1320",
      "name": "Murthy Samanthula",
      "rating": null,
      "text": "Sarvesh and Praneeth gave an excellent customer service.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1321",
      "name": "Mutnuru Kalyani",
      "rating": null,
      "text": "Very well taken care of my exchange experience. Got the best price for my diamond studs and shown the entire collection. Mr. Bharath has explained the details of the product very well with a lot of patience.",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1322",
      "name": "Mythili Naidu",
      "rating": null,
      "text": "The collection at Krishna pearls and jewellery is wide and beautiful. The staff are super supportive and patient and make sure to provide their best quality service. Nitesh has been very helpful in providing us the best service while we got a custom made pearl with gold pendant choker. Thank you",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1323",
      "name": "Mythily Kalli",
      "rating": null,
      "text": "Collections were so good. Salesperson meenakshi was good and showing all the sets so patiently and explaining in details. Overall satisfaction was very good.meenakshi",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1324",
      "name": "N D",
      "rating": null,
      "text": "Guraviah Garu, has helped me with my first purchase at Krishna Jewellers. He was very helpful and showed me a lot of beautiful designs. The store has wonderful collections and I will be definitely buying from here again. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1325",
      "name": "Naga Lohith karnati",
      "rating": null,
      "text": "@Bheem helped me in showing different collections and also suggested nakshi design haram with tops...co operated whole heartedly.....thank you bheem",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1326",
      "name": "Naga Niroosha Boyapati",
      "rating": null,
      "text": "It was an amazing experience. Reasonable prices, great hospitality and they treat us with lots of patience. I was assisted by Mr.Bharath. He was awesome at his job. The collection was great. I definitely will visit again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1327",
      "name": "Naga Venkata Ramadevi Prathi",
      "rating": null,
      "text": "We visited first Time krishna jewellery jubli hills sandhya rani executive is very good service and collection good",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1328",
      "name": "Nagamani narayana",
      "rating": null,
      "text": "I bought jewelry through video call in Krishna jewelers. Venkatesh coordinated so well and sent me pictures of jewelry designs I requested and arranged a video call. Vinod was so patient and showed me all designs I requested. Both are so …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1329",
      "name": "Nagaraju Javvaji",
      "rating": null,
      "text": "My family loved the collection, great customer support and very co-operative staff. We have done our shopping with sales manager Vinay, he is patient, helped us a lot with smiling face, highly recommend, you definitely saved your time, like …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1330",
      "name": "Nagaraju Nagaraju",
      "rating": null,
      "text": "Good service Srikanth sales man",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1331",
      "name": "Nagavamshi Vivek",
      "rating": null,
      "text": "Your presentation skills are impressive! You were able to clearly articulate complex ideas and keep the customer engaged. …",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1332",
      "name": "nageli sreevani",
      "rating": null,
      "text": "Found what we were looking for. Happy with the purchase price hospitality and all the staff members.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1333",
      "name": "nagendra kumar",
      "rating": null,
      "text": "Sai kumar & S.Bharath Good patience’s excellent service thanks krishna jewellers",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1334",
      "name": "Nakul",
      "rating": null,
      "text": "Nice and collections and Govind helped with show collections Thanks Govind",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1335",
      "name": "Nallimilli Deepthi",
      "rating": null,
      "text": "Excellent collection. Reasonable prices. One stop shop for everything. Staff was very helpful especially Nagarjuna sir. Guided me with right choice. Very happy with my choice. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1336",
      "name": "Namasvitha Adda",
      "rating": null,
      "text": "Pavani ramya was very helpful understanding pulse of customers. Good collection and exclusive pieces",
      "date": "",
      "displayDate": "Edited 6 months ago",
      "relativeDate": "Edited 6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1337",
      "name": "Namburu Praveen",
      "rating": null,
      "text": "After a long search for neckless sets, we finally ended up in Krishna Jewellers. Believe me it is an amazing experience buying jewellery. The collection was exceptional. I would say you go and visit you will never regret. The staff …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1338",
      "name": "Namrata Shinde",
      "rating": null,
      "text": "Beautiful designs and amazing customer service,Pawan was very helpful, patient, and guided me perfectly. Would definitely visit again.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1339",
      "name": "Nanda Kishore B",
      "rating": null,
      "text": "Wonderful experience in Krishna , nice explanation and products shown by Mr.Pasha.Great collection.worth buying if you really like authentic Hyderabad Pearls",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1340",
      "name": "Nandini K",
      "rating": null,
      "text": "Had a great experience purchasing at Krishna. Ramadevi garu helped to choose a nice studs.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1341",
      "name": "naralasetty likhitha",
      "rating": null,
      "text": "It was a very nice experience and great collection at Krishna Jewellers, especially with assistant Sai Kumar it made even more easier. Thanks Krishna Jewellers, found the right ornament for me. Keep updating your collection like this.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1342",
      "name": "Narasimham Poleboyina",
      "rating": null,
      "text": "Ramadevi rendered excellent service throughout the entire process from showing different selection to the final negotiation. She displayed deep knowledge about the product.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1343",
      "name": "Narra Anjani",
      "rating": null,
      "text": "It was splendid on account of decent, pleasant and modest behaviour of Mrs. Rama Devi who identifies the interests of customers like us. Because of such nature, we have been visiting the Store time and again and making purchases.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1344",
      "name": "Navanath Ch",
      "rating": null,
      "text": "nice collections Good services by Govind",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1345",
      "name": "naveen bethi",
      "rating": null,
      "text": "Rama Devi - We just loved her service and to be frank she is the one who is whole and sole responsible for me to shop here. Love her live shows and I would definitely come back if Rama Devi garu can explain us like this. She has so much …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1346",
      "name": "Naveen Kumar",
      "rating": null,
      "text": "Great service i must say and collection too. It’s quite vast and has been maintaining high standards with their service. Loknath was our executive and offered excellent hospitality while we were at the shop. We had a kid so he offered us …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1347",
      "name": "Naveen Kumar Vunnam",
      "rating": null,
      "text": "Great experience and great accommodation provided by Pavani. She was very patient and shown us all the available options. Happy to be here and will come again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1348",
      "name": "Naveen Nayakoti",
      "rating": null,
      "text": "Overall, this is a reliable jewellery store that combines quality, variety, and excellent customer service. I'd highly recommend it to anyone looking to purchase jewellery for daily wear, gifts, or special occasions by Pavan sales person",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1349",
      "name": "Naveen Reddy Mopuru",
      "rating": null,
      "text": "Wonderful collection at Krishna jewellers, where Vinod has patiently guided us right from the beginning till the selection of an item which we liked the most. He displayed many varieties from their inventory and helped us in explaining each item with minute detail with his experience. We wish to visit again for future purchases.",
      "date": "",
      "displayDate": "Edited 11 months ago",
      "relativeDate": "Edited 11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1350",
      "name": "Naveena Alluri",
      "rating": null,
      "text": "They have the best collection compare to other stores in Hyderabad. Ramadevi explains very well about each and every detailing of the items. Nayeem sir is such a nice person and he makes the best price all the time 🙂 …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1351",
      "name": "naveena nagulapati",
      "rating": null,
      "text": "My sister and I personally loved the collection in both gold and silver… we have purchased many items coming to cost Meenakshi garu and chary garu done a great job via price point satisfied clearly…. The store ambience is so good and the way handling their customers is so good…all over a happy customer with happy purchase 😁 …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1352",
      "name": "Navya Bellamkonda",
      "rating": null,
      "text": "After visiting Krishna Jewellers, I was ecstatic. I want to thank Malikarjun in particular because he showed us the designs in a …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1353",
      "name": "Navya Chowdary",
      "rating": null,
      "text": "Always love the experience here. As a regular customer i would highly recommend krishna jewellers to each and everyone. Sai kumar assisted us this time and totally liked the service that they provide.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1354",
      "name": "Navya D",
      "rating": null,
      "text": "Meenakshi is lovely and very patient :) She understands and treats her customer very well.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1355",
      "name": "Navya Kovvuri",
      "rating": null,
      "text": "I had a very pleasant experience shopping at the store. Mr Naresh and Mr Sarvesh helped me understand and explore different designs they have. Store has wide range of collection …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1356",
      "name": "Navya Naramsetty",
      "rating": null,
      "text": "Mr Sandeep was really helpful and patient in showing us variety of designs in multiple ornaments. Would highly recommend the store as their customer service is excellent and top-notch. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1357",
      "name": "Navya Pola",
      "rating": null,
      "text": "Krishna Jewellers has a great collection, and the staff is very patient in showing the designs. A special thanks to Loknath for his excellent assistance!",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1358",
      "name": "Navya Rayani",
      "rating": null,
      "text": "Satish helped me and handled my order so well.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1359",
      "name": "Navya Tubati",
      "rating": null,
      "text": "I recently purchased jewellery from Krishna jewellers Jubilee hills branch. Mr. Pavan and Ms. Rajashree garu assisted my family with our purchase. They were very warm and welcoming. Their designs are mesmerizing. Also, their product …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1360",
      "name": "Navyasree Janjirala",
      "rating": null,
      "text": "Completely satisfied with my whole experience at KJ. Purchased my wedding jewelry in Jubilee Hills branch. Mr. Bharat was extremely helpful, friendly, knowledgeable and understood my preference clearly which made the entire process easy and …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1361",
      "name": "Nayan Dutta",
      "rating": null,
      "text": "Nice collection thanks to Satishji and Sonia for their assistance to chose great pearls jewels",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1362",
      "name": "Nayan Shah",
      "rating": null,
      "text": "After almost one decade been again to Krishna Pearls Jubilee Hills. Amazed by collection and nice service specially by their sales executive T Rohit. Thank you.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1363",
      "name": "Neela Srujan",
      "rating": null,
      "text": "The sales person Sunitha she is very humble, and has good knowledge over the designs.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1364",
      "name": "neeraja kapse",
      "rating": null,
      "text": "I have made online shopping from USA with sri Krishna Jewellars, staff were very good in showing designs and models I expected and received quick response when ever I messaged. Staff Vijaya Agarwal was point of contact for me while shopping …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1365",
      "name": "neeta potdar",
      "rating": null,
      "text": "Rekha was very calm , enthusiastic and guided and showed us everything properly .Happy with her .Give her raise. I like krishna jewellers as they always have fresh pieces and look if prosperity .God bless",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1366",
      "name": "Neha Reddy",
      "rating": null,
      "text": "I loved my experience at Krishna Jewellers. Bhavani was great in helping me out choosing the best for my brothers wedding. I suggest to go ask for bhavani as she was very patient with us.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1367",
      "name": "nekkalapudi satya",
      "rating": null,
      "text": "Wonderful collection. Excellent workmenship on diamond jewelry. Very reasonable and affordable prices. Sure you love it and buy it 🙂.salesman services also very good. Particularly I'm talking about loknath.he had more knowledge about diamond jewelry. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1368",
      "name": "Nicki Reddy",
      "rating": null,
      "text": "It was such a pleasant experience, Shivaji was so patient & helpful & made our shopping experience wonderful. We are so Happy to have done business with Him & of course with Krishna Jewelry.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1369",
      "name": "Nidhi Chig",
      "rating": null,
      "text": "Shivani and gururaj have been wonderful with their assistance and hospitality. My wedding shopping experience has been nothing short of spectacular. I highly recommend Krishna Jewellers inJubilee Hills rd no 36 for all the brides to be for a stress free experience :)",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1370",
      "name": "Nikhil I",
      "rating": null,
      "text": "Got blessed by Krishna Jewelers. Very friendly people and amazing experience. Bheem was the primary individual helping me and he made the process enjoyable. Would recommend!",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1371",
      "name": "Nikhil Manigandla",
      "rating": null,
      "text": "Sai reddy and Guravaiah helped us to buy a Diamond Brooch and Puligoru pendant here. They helped us get best price. We bought gold through video call for the first time and it was a great experience. …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1372",
      "name": "nikhila n",
      "rating": null,
      "text": "It was a nice customer experience here. Staff was very helpful in their service. Bharat had helped us accordingly with our preferences. …",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1373",
      "name": "Nikhita Kalesan",
      "rating": null,
      "text": "Collections are awesome modes are good pavani show very well",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1374",
      "name": "nikhita ramineni",
      "rating": null,
      "text": "We had a very pleasant experience. We have been coming here since 5 years and they always give us the best rate possible. Especially Mr Mahesh has been very attentive and shows us really nice models every time we are there",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1375",
      "name": "Nikitha Narsing",
      "rating": null,
      "text": "We had a great online shopping experience with Guruvaiah, he showed me all the necklace models in my price range and explained each detail very well. Its almost like an in-shop experience. Would definitely recommend the store for anyone looking for jewellery from out of country too as they have great staff with tremendous knowledge.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1376",
      "name": "Nikitha Reddy",
      "rating": null,
      "text": "Very nice collection and satisfied with their unique designs . Customer ganga Bhavani was very patient in explaining the details and showing nice designs.We had a great shopping experience at Krishna",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1377",
      "name": "Nikitha Reddy",
      "rating": null,
      "text": "Brought a huge jewellery from krishna jewellers. The staff were very helpful especially J Mahesh from sales was really responsive, patient and friendly. He took time to explain all the questions we had. Thank you so much for such a wonderful experience with buying jewellery.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1378",
      "name": "Nimish Salve",
      "rating": null,
      "text": "SandhyaRani was very helpful and patient while showing bangles and bracelet. Beautiful design of gold and diamond necklaces. Very prompt service. Recommends to visit if you are planning to buy gold necklace.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1379",
      "name": "Nirmala K",
      "rating": null,
      "text": "Mallikarrjun has assisted us in finding the ornaments of choice with a lot of patience and making sure we had a pleasant experience. Would definitely recommend for their amazing collection and great customer service!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1380",
      "name": "Nisha M",
      "rating": null,
      "text": "Great experience always... Good designs, Good service! we have been visiting Krishna Jewellers from the past 15 years! Nayeem Bhai is the most humble person we have met. …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1381",
      "name": "nishitha reddy",
      "rating": null,
      "text": "Absolutely love the Bridal jewellery. Special thanks to Rama Devi and Nayeem garu for helping us in choosing best jewellery... each and every design in the store is unique and we definitely cant take eyes off. Also thanks for the video …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1382",
      "name": "Nishitha reddy",
      "rating": null,
      "text": "Stunning diamond collections with absolutely the best prices compared to all other stores in Hyderabad. Must visit.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1383",
      "name": "Nithin kumar Nithin",
      "rating": null,
      "text": "Good designs and nice hospitality pawan has helps us suggest the jewellery",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1384",
      "name": "Nithin Pinninti",
      "rating": null,
      "text": "Prakash was very helpful in showing the collection and the service , hospitality was very good. Very happy with overall service",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1385",
      "name": "Nithin Raj Shetty",
      "rating": null,
      "text": "one of the best online jewellery shop i can Recommend every one. immediately and quick response we can get here. i received my item in safe courier service within 3 days after payment. if anybody intrested to buy online silver, pearls or …",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1386",
      "name": "Nithish Reddy",
      "rating": null,
      "text": "Very good experience. Collections are amazing. Ms. Pavani was very politely , attentive and was very helpful.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1387",
      "name": "Nithisha R",
      "rating": null,
      "text": "KJPG has never failed to fascinate me, with it's amazing collection n fair prices. Our experience with Mr. Loknath has been amazing, explaining us all the details, showing us numerous pieces , answering our endless doubts and providing us an amazing service !",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1388",
      "name": "Nithya Shre",
      "rating": null,
      "text": "From the moment I walked in, I was greeted warmly by staff who were eager to assist me. Nagasai took the time to understand my preferences and guided me through the store’s exquisite collection. He patiently assisted throughout the selection and billing process. Highly commend his patience and explanation.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1389",
      "name": "Nithya Sree",
      "rating": null,
      "text": "It was a good experience and a great collection... Thank you, Bheem Garu and Pavani Garu, for your service.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1390",
      "name": "Nitin Kunchala",
      "rating": null,
      "text": "Ramadevi good service, and excellent designs",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1391",
      "name": "Nitisha Agarwal",
      "rating": null,
      "text": "The jewellery collection is amazing . And the staff is also very cooperative and humble . They deal with patience. Sales service executive Venkatesh is very polite and dealt with patience . I highly recommend dealing with him",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1392",
      "name": "Nitya Reddy",
      "rating": null,
      "text": "Visited krishna for diamond jewellery, vinod is very kind and showed a lot of varieties with patience. Would highly recommend him",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1393",
      "name": "niveditha lekkala",
      "rating": null,
      "text": "I like the collection with Krishna jewelers. Online video shopping where you can book slots in your time zone is a big hit. I worked with Riaz who made our shopping so easy as he understood our requirements and suggested models. They have …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1394",
      "name": "nivi vasu",
      "rating": null,
      "text": "Pavani was very quick and showed us everything we liked as our taste … had nice experience overall. We purchased 3 lovely sets for very satisfied rates .",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1395",
      "name": "Niyathi Mahisree Kintali",
      "rating": null,
      "text": "R.Satheesh has provided us great service. The presentation skills are very impressive. We highly recommend this place.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1396",
      "name": "Noma Prasanna",
      "rating": null,
      "text": "Their collection is beautiful and have wide veriety of designs. Representatives were very polite and helpful, especially Mr.Yadav was very patient and had shown multiple designs.very happy with the service.",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1397",
      "name": "Noor Fazal",
      "rating": null,
      "text": "I am very delighted to share my experience with krishna jewellers . I purchased a set on tops which I liked them very much and Neelam helped me a lot during the process and was very patient in the process .",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1398",
      "name": "Not_so_local_wayfarer",
      "rating": null,
      "text": "Wonderful collection. Very unique and designer wear models. One of a kind designs. The staff is well organised and very respectful. Receiving is great. It is one of the best places in Hyderabad to buy either gold or diamond jewellery. The …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1399",
      "name": "Nukala Sanvi",
      "rating": null,
      "text": "Very good place to buy jewellery. They only use high quality material. The staff is very sweet especially ms.ramadevi who had help us a lot.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1400",
      "name": "Oramganti Vineela",
      "rating": null,
      "text": "Budget friendly and amazing collection, team members are showing the extra collections finally it's very good",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1401",
      "name": "os 99",
      "rating": null,
      "text": "Purchased necklace and attended by Mrs Pavani. Design is elegant. Ambience was good. Whole purchase experience was nice. Explained all queries and well supported. Would like to come again for my daughter's bridal wearing in few months.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1402",
      "name": "Oviya Subramanian",
      "rating": null,
      "text": "Lovely shopping experience, Krish was very helpful and friendly.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1403",
      "name": "p sush",
      "rating": null,
      "text": "Great designs and the sales person Yadav was very patient and helped us in choosing the collection for best price. Overall experience was great.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1404",
      "name": "p. ranjith",
      "rating": null,
      "text": "The purchase experience is excellent. The reception was good and the sales excecutive Sandhya Rani she is very helpful in showing the models and patient. she helped us to get the jewelry what i wanted, she is telling online shopping also",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1405",
      "name": "Padma G",
      "rating": null,
      "text": "Mr.Sravan -Executive, who showed us with great patience. Good ambience, courteous service by the sales personnel and the management is appreciable. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1406",
      "name": "Padma Kilaru",
      "rating": null,
      "text": "We had a great experience at krishna jewellers today. Especially our sales manager Mallikharjuna took time to educate and listen to our needs to make our sales process easy. We recommend him for future needs and wish him good luck with future!!",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1407",
      "name": "Padma Kinger",
      "rating": null,
      "text": "Loved the silver item designs Thanks to the sincere effort by Pooja and the team at Krishna Jewels for making the online shopping experience smooth and easy Keep up the good work 👍 …",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1408",
      "name": "Padma Priya",
      "rating": null,
      "text": "The store has a really good collection. Mr. Kushal was very patient and showed me innumerable pieces before i finally picked one. Clearly explained the price break up as well.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1409",
      "name": "Padmaja Miriyala",
      "rating": null,
      "text": "We were assisted by Mr. Mallikarjuna, Id like to credit his patient nature and keen interest with which he helped us pick the perfect necklace. Would highly recommend Krishna Jewellers to everyone, They have the most unique designs and offer competitive prices.",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1410",
      "name": "Padmasri Dantu",
      "rating": null,
      "text": "My recent purchase experience with Krishna Jewellers, Jubilee Hills, Hyderabad, was extremely satisfying. Sales representative S.Mahesh was helpful, knowledgeable about products, patient with answering questions. He followed up throughout …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1411",
      "name": "Padmavathi Manne",
      "rating": null,
      "text": "Online sales executive Guravaiah is very humble and patience at store to help us in showing our requirements. We are here for 4 hours , he carried out same level of smile and patience. Appreciate all his support.. Thanks to Chary garu for the great discount..",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1412",
      "name": "Palla Haritha",
      "rating": null,
      "text": "Sai kumar excellent customer service good showing collections thanks Krishna jewellers",
      "date": "",
      "displayDate": "Edited 7 months ago",
      "relativeDate": "Edited 7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1413",
      "name": "Pallavi",
      "rating": null,
      "text": "Their collection is huge and designs are unique. This is something you can see in pictures and insta profile. But, the best part is their service. It is top-notch. We parked our car a little further ahead and went in. It got towed and the …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1414",
      "name": "Pallavi Gottumukkala",
      "rating": null,
      "text": "Ramadevi garu gave us a very detailed explanation of wide range of jewellery at Krishna jewellers .. I am very much happy with purchase of diamond and polki jewellery for my wedding. I appreciate her time and effort in showcasing all the …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1415",
      "name": "Pallavi Sivalenka",
      "rating": null,
      "text": "I just bought antique gold set from Krishna Jewellers for the first time and I'm super happy with it! I saw their collection on Instagram and messaged them on WhatsApp. They got back to me really fast every time. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1416",
      "name": "pamidimukkala lavanya",
      "rating": null,
      "text": "Krishna Jewellers has amazing collection. Kushal helped me to select necklace for my daughter and am very thankful to him for patiently showing wide range of collection and helping with the selection process, billing etc.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1417",
      "name": "pannaga kulkarni",
      "rating": null,
      "text": "Liked their diamond collection a lot. Chaitanya helped me to buy one necklace within a hour as we were running out of time. Thanks a lot. I got the best one.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1418",
      "name": "Pannir Selvan",
      "rating": null,
      "text": "Please be careful when order online. I bought one silver idol one month ago via online. After receiving the payment, they claim tat particular item out of stock. More than a month I m waiting and still no proper reply from their customer …",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1419",
      "name": "Panyam Srinivas",
      "rating": null,
      "text": "Very good store. They receive the customers very well. Have good collections. Special thanks to Yadav garu and Srinivas garu for your hospitality. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1420",
      "name": "Papi Reddy Mekala",
      "rating": null,
      "text": "Great customer service by Namedev. He knows the product very well. Was very polite and friendly. We just came to see the models but ended up buying a harem.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1421",
      "name": "paramesh waran",
      "rating": null,
      "text": "We visited the Krishna pearls shop which is in jubilee hills. Its really a good experience. How they treated the customer is very good. They have really shown very much patience to show the collections till I finalize the pearl. Its worth for our money.",
      "date": "",
      "displayDate": "6 years ago",
      "relativeDate": "6 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1422",
      "name": "Parameshwar Tella",
      "rating": null,
      "text": "Designs and craftsmanship is so beautiful and they give good discounts. Salesman Rajesh is very professional and helpful! I would like to continue purchase at KJ further l, I had good purchase experience.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1423",
      "name": "Pari Medhora",
      "rating": null,
      "text": "Pavani gave beautiful service, with all the knowledge about jewelry. Her smiling service and did spend enough time for purchase. communications are impressive. I would recommend the store for big choice of jewelry .",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1424",
      "name": "Parijatha Varre",
      "rating": null,
      "text": "Collections are good shehelped me pick my jewelry. I am happy with my purchase and want to thank for their service. They patiently responded to all my questions. is are awesomeService is good, pavani showed very well",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1425",
      "name": "Parimal Bhatt",
      "rating": null,
      "text": "Satish is asset for Krishna pearl and vey knowledgeable and have given us very satisfactory service thank you Satish.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1426",
      "name": "parvathi",
      "rating": null,
      "text": "excellent hospitality n service helped me throughout the purchase very patiently thank u Radha",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1427",
      "name": "pasapala harikrishnareddy",
      "rating": null,
      "text": "Collection is super and customisation is done with in a week. Staff ( Priya) support is also good she is also convincing and friendly staff …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1428",
      "name": "patibandla lakshmi",
      "rating": null,
      "text": "Amazing collection! Nitesh was really nice enough to show us all the unique collection and has great knowledge on each product. Overall very good experience and amazing staff",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1429",
      "name": "Pavan K Reddy",
      "rating": null,
      "text": "I really love the Wonderful receiving and best respect to the customers. Mr Sarvesh shown the wide range ange and lots of varieties and gave us best options with lot of patience and information, i really like the behaviour & attitude of Mr …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1430",
      "name": "Pavan Sai",
      "rating": null,
      "text": "Great jewelry shopping experience good and friendly staff especially guravaiah was nice and manager nayeem",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1431",
      "name": "Pavani Chavali",
      "rating": null,
      "text": "Diamond necklace collection is awesome. They staff understood our needs and showed us exactly what we requested and we are amazed at the quick and awesome experience of shopping for diamond necklace. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1432",
      "name": "Pavani Gottumukkala",
      "rating": null,
      "text": "Mr. Loknath helped us out a lot. He was very negotiable as he reduced the price heavily. Overall we had a very satisfying experierience at Krishna Jeweller. Would definitely recommend to someone. There is also a fabulous collection full of all the modern styles as well as unique ones that are eye-catching.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1433",
      "name": "Pavani kalidindi",
      "rating": null,
      "text": "I had a fantastic experience at krishna jewellers. The salesperson, Bheem, was extremely knowledgeable and patient. He guided me to make the best choice within my budget.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1434",
      "name": "Pavani Koney",
      "rating": null,
      "text": "Very nice collection and warm welcome from Krishna Jewellers Pearl's and Gems,Jubilee Hills. Prasanna has assisted us in very polite manner and helped us in proper way to select item very fast according to our taste and budget. Thank you …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1435",
      "name": "Pavani Mamidi",
      "rating": null,
      "text": "Collections are very pretty we purchased diamond necklace designs are superb thank you for pavani she show very well",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1436",
      "name": "Pavankumar B",
      "rating": null,
      "text": "Had a good experience, Gururaj & Ramadevi showed all the designs and explained in detail.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1437",
      "name": "Pedda Ranga",
      "rating": null,
      "text": "Very&nice Krishna jeweller designs Mr.venkat was awesome he was very patient and explained the details very well gave us a good deal as well. He give best services to customers",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1438",
      "name": "Pekanti Suneela",
      "rating": null,
      "text": "We purchased bridal jewellery in Krishna jewellers pearls and jems collection are awesome models are good pavani show very well collection are awesome",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1439",
      "name": "Pemmasani Sudha Rani",
      "rating": null,
      "text": "Had great experience shopping here. Rheem was very polite, patient, and helpful in explaining all options. He helped us choose exactly what we are looking for. Highly recommended.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1440",
      "name": "Penmetsa Sahithi",
      "rating": null,
      "text": "We had a wonderful experience at your gold shop! The collection is truly impressive—so many beautiful designs to choose from—and the pricing is very reasonable. We were extremely happy with our decision to visit your store. Special thanks to Meenakshi Garu for her excellent service and support throughout our purchase.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1441",
      "name": "peyyala sharon",
      "rating": null,
      "text": "It was a great and hassle free experience shopping in krishna jewellers. mahesh garu helped us in the better way possible to go through all the available designss and pick up the best one frm the collection. Thank you!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1442",
      "name": "Phanikireeti mullapudi",
      "rating": null,
      "text": "Excellent service, received the ordered product safely to home, excellent service and safe delivery, salesman Riyaz helped me in step by step in online process. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1443",
      "name": "Phanindher Patlola",
      "rating": null,
      "text": "Chandu did a splendid job helping us buy jewelery for an event. Please ask for him if you visit the store.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1444",
      "name": "Philomeena Rodrigues",
      "rating": null,
      "text": "Very good store for buying jewellery. Good customer service. Bheem is an excellent salesperson",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1445",
      "name": "Pinnaka Geetha",
      "rating": null,
      "text": "Unique and good jewelry collection. Our executive Mahalakshmi offered excellent hospitality, showed unique designs and explained about products very clearly.",
      "date": "",
      "displayDate": "Edited 11 months ago",
      "relativeDate": "Edited 11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1446",
      "name": "piyush satpathy",
      "rating": null,
      "text": "Satish's behaviour and dealings were very good",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1447",
      "name": "Pochetti Rachana",
      "rating": null,
      "text": "It was a great experience overall. Mr. Bharat was very friendly and cooperative he has shown us exquisite diamond designs …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1448",
      "name": "Pooja Balachandar",
      "rating": null,
      "text": "I recently ordered a gift from Krishna jewellers. Neelam from the ecom department was very efficient and made sure that I could receive the gifts in time to give at the occasion. Beautiful collections and prompt service.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service",
        "gifting"
      ]
    },
    {
      "id": "stream-1449",
      "name": "Pooja Godavarthi",
      "rating": null,
      "text": "The experience was so good at Krishna jewellers Jubilee Hills.. Mr. Venkat has been very patient in showcasing all their jewellery.. overall I would rate them 10 on 10",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1450",
      "name": "Pooja Reddy",
      "rating": null,
      "text": "Beautiful and variety collection on all type of jewelry. Staff is really good. Salesperson Kushal is amazing and Showcase exactly the type and latest collection we are looking for.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1451",
      "name": "Poojabagavathy S",
      "rating": null,
      "text": "Ordered a goddess lalithambal idol 3 months back. Still have neither received the idol not refund. Very poor customer service when purchased through social media.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1452",
      "name": "poojitha k",
      "rating": null,
      "text": "Nice collection , Sri lakshmi mam shown very patiently",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1453",
      "name": "Poorna Chander S",
      "rating": null,
      "text": "We have been to Krishna Jewellers multiple times in last few months. The experience has been wonderful. We were greeted and hosted by Sandeep everytime. He was patient in responses and demonstrations. Appreciate his efforts and would certainly recommend Krishna Jewellers to friends and family.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1454",
      "name": "Prabhu kumar Agganoor",
      "rating": null,
      "text": "Excellent collections.Last 5 years experiencing good customer relationship. Venkatesh is a very good sales person with a lot patience and curtesy . Mr Nayeem is a good Store manager handles the customers with respect and convenience the uniqueness of item and makes to feel worthy of buying",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1455",
      "name": "prabhu n",
      "rating": null,
      "text": "Sunitha and lavanya are the two persons helped a lot in my purchase. Good service at all times",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1456",
      "name": "prachi chaudhari",
      "rating": null,
      "text": "Superb silver collection very intricate and detailed and cudnt stop myself from buying ur collection very unique and Ambika helped us find the best options we were lookin for thank you so much Ambika . Just for the collection I have come twice in a week to shop.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1457",
      "name": "Pradeep K",
      "rating": null,
      "text": "Very much impressed with service from Venkat & team, they have been patience in displaying our interests We came here to buy couple of items and went back with 5 items …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1458",
      "name": "PRADEEP REDDY",
      "rating": null,
      "text": "Mrs Ramadevi was very patient and showed us many Designs. Over all store has Best collection",
      "date": "",
      "displayDate": "Edited 7 months ago",
      "relativeDate": "Edited 7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1459",
      "name": "prameela jammi",
      "rating": null,
      "text": "Venkat garu showed most of the collection patiently his service is really good we are glad to purchase in Krishna jwellers",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1460",
      "name": "Prameela Penmetsa",
      "rating": null,
      "text": "Namdev more He has shown the Jewellery items very nicely . His service is excellent. All the items are superb. We have ordered a Ram Parivar Locket. We will be in touch with you & very soon going to visit your shop at Road no. 36.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1461",
      "name": "Pranathi Bandi",
      "rating": null,
      "text": "Latest designs and extensive collection. Mr.Vinayak was very customer friendly and patient and showed us as many designs as we asked for. Very helpful and courteous.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1462",
      "name": "Pranathi Yerrabotula",
      "rating": null,
      "text": "Great collection. Sri Lakshmi showed us trending jewellery",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1463",
      "name": "pranav kantheti",
      "rating": null,
      "text": "Govind has shown us very good collection of bangles.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1464",
      "name": "PRANAY REDDY SINGIREDDY",
      "rating": null,
      "text": "Had an experience at Krishna Jewelry. Laleppa service was great, He helped us get our desired models",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1465",
      "name": "PRANAYA REDDY",
      "rating": null,
      "text": "It was a great experience. I could get all the items I want in the budget I wanted to. They have amazing diamond collection. I do recommend to visit krishana jewellers if your looking for something amazing at good budget. Staff is also …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1466",
      "name": "prani praneetha",
      "rating": null,
      "text": "Very nice designs and satisfied with their unique collection . Customer representative Nithesh was very patient in explaining the details.we had a great shopping at krishna jewellers.looking forward to shop again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1467",
      "name": "Prani Prani",
      "rating": null,
      "text": "I’m very happy with the experience with the Krishna jewellers. Been visiting the store from 3 years. …",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1468",
      "name": "Pranita Thakur",
      "rating": null,
      "text": "One of the best places i have shopped for jewellery and silver. I am a repeat customer, not only are the designs good.. but the store manager Mr.Nayeem has ensured that we leave the store with a smile. Also, Ms. Rama is a very courteous and …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1469",
      "name": "Prasanna bandla",
      "rating": null,
      "text": "Great experience on my first purchase with krishna jewellers. I purchased diamond choker with neckset and jhumkas online and they showed them in video calls very patiently. Thanks to Sales team B. Naresh who was very patient showing the all …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1470",
      "name": "Prasanna Rapala",
      "rating": null,
      "text": "Ms. Prasanna is a good executive giving fair price to all the customers and having a pleasant smile always on her face. Treating the customers the best is what everyone wants and she is doing her job well. Happy to share the review about this person..",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1471",
      "name": "Prasanna S Rao",
      "rating": null,
      "text": "Customer service is fabulous. Fast and safe delivery of the consignment. Awesome package, neatly they have done the parcel delivery. Improvement area is they can introduce some loyalty program like giving compliments and gifts to the …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1472",
      "name": "Prasanthi Ganga",
      "rating": null,
      "text": "Thank you Ramya Garu , Kushal Garu and other team members at Krishna Jewellers for making our experience of buying jewellery via video call easy and pleasant. …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1473",
      "name": "Prasanthi Maditati",
      "rating": null,
      "text": "Krishna Jewelry is one and only the best shop in Hyderabad. They are giving best price. Mr. Bharath has helped us a lot. When ever we called he responded in a nice way. I strongly recommend krishna jewellery",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1474",
      "name": "Prasanthi Muppireddy",
      "rating": null,
      "text": "Great collections of diamonds, gold and Victorian style jewelry. We were assisted by Sravan who is very friendly(also great at taking your pics with jewelry) and showed us all items over a period of 2 days and stayed with us till the end of billing. Very happy with the shopping experience. Go to place for our family shopping.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1475",
      "name": "Prashant Pandit",
      "rating": null,
      "text": "Excellent collection n orignal pears. Pasha is good manager assisting customers",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1476",
      "name": "Prashant Upadhyay",
      "rating": null,
      "text": "The overall experience was good. All the staffs were very welcoming and specially Ramakanth, who has shown us the latest collection. I must say they have a unique design and would like to recommend everyone to atleast visit their store once.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1477",
      "name": "Prashanth Ankala",
      "rating": null,
      "text": "Recently I visited krishna jewellers with my family I like the way receiving and way of explaining about jewellery Finally I am satisfied with staff srikanth",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1478",
      "name": "Prashanth Reddy",
      "rating": null,
      "text": "Bridal collection is very nice. Service and quality is amazing. Shakeela helped us in choosing ear rings for my finace.She is very smart and patient. Thankyou krishna jwellers for amazing service",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1479",
      "name": "prashanthi k",
      "rating": null,
      "text": "Staff very cooperative and patient.....srilaxmi responded very well...",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1480",
      "name": "prathap reddy",
      "rating": null,
      "text": "Very good store with unique and great collection. Staff are extremely polite and punctual. Special mention to Guravaiah for his help and guidance in understanding the jewellery.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1481",
      "name": "prathima reddy",
      "rating": null,
      "text": "Sandhya Rani sales excutive is service is good Visited krishna pearls and gems jewellers first time the Collection is awesome and the hospitality is also good",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1482",
      "name": "prathyusha bommepalli",
      "rating": null,
      "text": "Very nice collection. The sales person Sai Kumar is very good and helpful. He is very patient in showing us different model.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1483",
      "name": "prathyusha dharani",
      "rating": null,
      "text": "The designs are awesome is their service. Pavani has done an amazing job. I really loved shopping here. They have wide range of designs.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1484",
      "name": "Pratibha Gaddam",
      "rating": null,
      "text": "They have excellent collection. Ganga Bhavani was very patient and helpful. She has helped us with the whole process until the billing was done.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1485",
      "name": "Pratts P",
      "rating": null,
      "text": "Visited Krishna jewellers for first time, they got nice collection and customer service is superb. Mallikarjuna garu showed us designs according my taste and helped us to find …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1486",
      "name": "Pravalika Veeramalla",
      "rating": null,
      "text": "Designs are great and unique. They have many new patterns compared to other stores. Customer representative Ganga Bhavani is very patient and explained us all the designs clearly. She was very helpful and gave us nice design suggestions …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1487",
      "name": "Praveen kumar",
      "rating": null,
      "text": "Worst customer treatment. Have visited store today to buy gold worth 6lakhs. To look after the salesman target they clearly told that if you do not have general proof no problem, we can swipe. After swiping the card he literally …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1488",
      "name": "Praveen Pola",
      "rating": null,
      "text": "Excellent service , there were couple of issues with the ornament we bought Sales person Yadav had gone extra mile to correct them and then only deliver , also he made sure that we get good price on the exchange of gold. Overall very good experience.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1489",
      "name": "praveena swathi",
      "rating": null,
      "text": "Krishna is our go-to Jewellers for years. Reasonable waste and making charges. Exclusive collection. Shout out to Pavani Ramya for understanding our taste quickly.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1490",
      "name": "praveena varma",
      "rating": null,
      "text": "Very good collection.. the staff were very welcoming especially yadav garu has been very patient and showed all the designs and explained in detail..very good service",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1491",
      "name": "Pravin Parab",
      "rating": null,
      "text": "Good team coupled with great designs and quality that makes Krishna a one stop destination for your jewellery needs. Ganesh and Surender in silver section and Raj Kumar in the pearls section are excellent people providing wonderful service. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1492",
      "name": "Preetham Reddy",
      "rating": null,
      "text": "To start with, we wanted to buy a choker in Nakshu and almost visited all jewellery stores and trust us Krishna Jewellers had awesome designs and quantity. We were impressed by the designs and range of weights they maintain. The pricing was …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1493",
      "name": "preethi miriyala",
      "rating": null,
      "text": "We recently went gold shopping, and Sarvesh was incredibly helpful throughout the process. He provided excellent guidance, making the experience smooth and enjoyable. His knowledge, patience, and professionalism ensured we found exactly …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1494",
      "name": "Preethi Mulley",
      "rating": null,
      "text": "Krishna Jwellers are trust worthy, friendly staff and elegant designs. Appreciate Rama and Nayyum for their courtesy and Customer support.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1495",
      "name": "preethi preethi",
      "rating": null,
      "text": "It’s my first time visit in Krishna Jewellers . Usually I buy Jewellery when I visit India, but this was my first pleasurable experience with you. Mr. Sandeep is a person who is down to earth, very awesome supportive and understands the …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1496",
      "name": "Prema Deepika",
      "rating": null,
      "text": "Nice purchase and silver jewellery section satish given his best time to deliver the product.. feeling very satisfied",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1497",
      "name": "Priscilla Cyril",
      "rating": null,
      "text": "Hello, I recently visited Krishna Jewellers, Jubliee Hills branch, where I witnessed an excellent service and hospitality provided by all their staff members. A special thanks to the manager, Mr. Santosh Kumar for his special guidance. It …",
      "date": "",
      "displayDate": "7 years ago",
      "relativeDate": "7 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1498",
      "name": "Prithvi Hangarge",
      "rating": null,
      "text": "Very good service 😀\"Satish from online sales team has helped me for the seamless process and ensured the product is reaching to me safely\" …",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1499",
      "name": "priti samal",
      "rating": null,
      "text": "M.Satish & Krish were very cordial & the service provided was excellent.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1500",
      "name": "priya darshini",
      "rating": null,
      "text": "Polite staff ,Smooth delivery and awesome workmanship on the products. Fully satisfied.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1501",
      "name": "priya kadam",
      "rating": null,
      "text": "Very nice and unique collection and the employees were very helpful... Bheem was very helpful and very patient when showing the designs... very good hospitality.. will like to visit again.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1502",
      "name": "priya pandiri",
      "rating": null,
      "text": "Craftsmanship and Designs are very attractive compared to other shops in Hyderabad. Staff (S.Bharath) is knowledgeable, attentive, and patient. Totally worth to come to shop at this place.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1503",
      "name": "Priya Patil",
      "rating": null,
      "text": "Sai charan was very helpful. He is an amazing representative Hoping to purchase soon with good discount",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1504",
      "name": "priya reddy",
      "rating": null,
      "text": "Ashok and Pasha were very patient. Loved the collected their service",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1505",
      "name": "Priya sohith",
      "rating": null,
      "text": "Good collection and best ambience in the jublee hills , had great experience with pavan👍 …",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1506",
      "name": "Priyanka Dendi",
      "rating": null,
      "text": "Very nice Customer service. Sales person Bhavani was very patient and was very good at figuring out the needs of the customers. Liked their designs and will definitely consider purchasing more from this store.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1507",
      "name": "priyanka h",
      "rating": null,
      "text": "Bharat who is representative was awesome showed all article with patience i recommend to buy in Krishna jewellery for pure gold and good models",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1508",
      "name": "Priyanka Karna",
      "rating": null,
      "text": "Loved their unique collection and hospitality. Thanks to Mrs. Sunitha garu for patiently showing the items according to our requirements and making our purchase an easy experience.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1509",
      "name": "Priyanka Minde",
      "rating": null,
      "text": "The experience was really good. We had pleasant experience at the store with the customer sales person Kushal who was very good at showing all the latest collections and the over all process was good and smooth. They have all the latest collections in store.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1510",
      "name": "Priyanka Pinky",
      "rating": null,
      "text": "I love the collection in your store and Pawan is our personal choice to show us the jewelries as he communicate and explains very well.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1511",
      "name": "Priyanka S",
      "rating": null,
      "text": "Very good service..the polki jewellery is very pretty and classy..Mr Yadav has been very cooperative and patient throughout the purchase process..",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1512",
      "name": "priyush j",
      "rating": null,
      "text": "Great hospitality and wonderful service. Was in a rush to get the things done and Sandeep did take in all my requests and provided me with the best options available in the shortest time possible. He did thoroughly followed up and made sure …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1513",
      "name": "PROMTEK International",
      "rating": null,
      "text": "Super experience. Ms.Priya has shown great patience to show ornaments of various varieties. She is super lady and charismatic personality. We love to come back again and again. Thanks to Ms.Priya.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1514",
      "name": "Prudvi Saraseshwari",
      "rating": null,
      "text": "Service provided by Ramadevi is very good and overall experience is satisfied",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1515",
      "name": "PShivajiRao PShivajiRao",
      "rating": null,
      "text": "Nice collections Good service by Govind",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1516",
      "name": "pujari jagadeesh",
      "rating": null,
      "text": "Nice collection sri Lakshmi showed all the collections very patiently, very co- operative staff",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1517",
      "name": "Pulluri Suresh",
      "rating": null,
      "text": "It was very nice experience in Krishna Jewelers. Staff was very friendly and polite… Shakeela is our sales representative and she was awesome. Always smile on her face and very patience… We really liked overall experience with our purchase. Thanks",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1518",
      "name": "purnachandrarao vemula",
      "rating": null,
      "text": "In Krishna jewelers pearls @ gems, I love the quality of the items and the team response. They showed me few Diamond sets also and designs are good but the price is little bit high. …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1519",
      "name": "purnagayatri g",
      "rating": null,
      "text": "It was a great experience with Krishna Jewellers and their very supportive staff, especially Yadhav. Thank you.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1520",
      "name": "R Amulya",
      "rating": null,
      "text": "Impressed with Mr Govind's work, he served us really well and understand our requirements. I am able to choose good designs and satisfied with the product.",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1521",
      "name": "R MT",
      "rating": null,
      "text": "Pavani‘s service was excellent! She helped me find a beautiful matching antique style earring for my necklace. Thank you for your wonderful service :)",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1522",
      "name": "radha madhavi",
      "rating": null,
      "text": "These people have wonderful collections They never disappointed me. And the staff is very polite e specially sai kumar He have lots of patience and he knows what a customer needs",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1523",
      "name": "Radha S",
      "rating": null,
      "text": "Referred by one of our relatives, we shopped in Krishna Jewellers and sales Executive Mr.Venkatesh is very friendly assisting decide right items. Pricing wise too, made best pricing package that's competitive. Can't find better place to buy gold and pearl jewellery.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1524",
      "name": "Radhakrishna Yanaki",
      "rating": null,
      "text": "Good service, Very nice designs and satisfied with their unique collection. Customer representative survesh was very patient in explaining tha details,We had a great shopping experience at Krishna Jewellers. Looking forward to shop again!!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1525",
      "name": "Radhika bobby",
      "rating": null,
      "text": "Collection was very good.. Uniq collection. Sunitha she very shown very patiently n good",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1526",
      "name": "Radhika G",
      "rating": null,
      "text": "Sai Kumar garu is always the best when it comes to selecting and purchasing jewellery here. Highly recommend Krishna jewellers for classy and rich jewellery",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1527",
      "name": "Radhika Yellanki",
      "rating": null,
      "text": "Our experience was very good, Sri Lakshmi put extra effort to find designs that suited our interest",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1528",
      "name": "Raghav D",
      "rating": null,
      "text": "Definitely recommend to a friend or colleague. Friendly staff, quality products and helpful management. Mr. Sai Kumar, Mr. Riyaz and manager Srinivas garu helped us to get better deals and nice jewelry for my wife.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1529",
      "name": "raghava G",
      "rating": null,
      "text": "Reached out to them after watching their live on Instagram for nakshi bangles. Amazing customer experience with prompt responses. I would like to give a special mention to Mr.Naresh, their sales representative he is very patient and …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1530",
      "name": "Raghava Sathuluri",
      "rating": null,
      "text": "Good collection, R Ssteesh is very helpful in explaining the details of the jewellery with patience and showing various models. Overall great experience.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1531",
      "name": "RAGHUNATH SHEDOLE",
      "rating": null,
      "text": "We were able to find everything we were looking for gold chain, necklace,and earrings.Mr.S.Bharat was very helpful and kind....must visit the store",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1532",
      "name": "raghunathreddy konda",
      "rating": null,
      "text": "Highly recommend taking a visit. Beautiful collection and always impressed with the Quality of the items. Sravan was exceptional Sales Rep. He was readily available to answer any questions I had. Thankyou Sravan for advising and being so helpful when we were choosing our necklace. I will always purchase my jewellery here !!!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1533",
      "name": "Raghuram Nagubandi",
      "rating": null,
      "text": "Wide variety of designs are available here and customer service is also good. Thanks to Swamygaru. He showed us latest designs",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1534",
      "name": "Raj",
      "rating": null,
      "text": "We received our purchase with great honor and are thrilled with the service S.Bharat",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1535",
      "name": "Raj Peddisetty",
      "rating": null,
      "text": "Best jewelry store. So many varieties- traditional and modern. Sandhya Rani is amazing. She is nice and patient. Had a pleasant experience.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1536",
      "name": "Rajani Datla",
      "rating": null,
      "text": "I am so impressed with the jewelry designs and customer service. From begining to end, every interaction I had with them was dealt with prompt and helpful response. Overall I had wonderful experience shoping with Krishna jewellers. Thanks to sales rep Swamy garu!",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1537",
      "name": "Rajani Polampalli",
      "rating": null,
      "text": "Loved my online shopping experience with Krishna Pearls & Jewels. Bought a pearl choker — it’s beautiful, delivery was super fast, and the staff were very helpful. Great experience overall! 🌸 …",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1538",
      "name": "rajani yarlagadda",
      "rating": null,
      "text": "Pavani was very helpful and showed us lots of designs over several days. Very good designs and selection of jewelry at this branch.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1539",
      "name": "Rajasekhar Garapati",
      "rating": null,
      "text": "We are satisfied with the experience again as previous. Sai Kumar showed us the models according to our range and variety.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1540",
      "name": "Rajbir Grewal",
      "rating": null,
      "text": "Very good experience with Meenakshi and Dileep babu Very helpful staff",
      "date": "",
      "displayDate": "3 months ago",
      "relativeDate": "3 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1541",
      "name": "Rajendra Talluri",
      "rating": null,
      "text": "Quality & designs are next level. One must compulsory try this place for all their occasions. Sandeep garu tried convincing us with sincere & genuine approach which helped us to pick the right product👍👍 …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1542",
      "name": "Rajesh Boddapati",
      "rating": null,
      "text": "Ramya Pavani : Excellent coordination. She has good patience to show different designs . Will visit again . Over all the experience was good with Krishna Jewellers , Jubilee Hills branch .",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1543",
      "name": "Rajesh kollu",
      "rating": null,
      "text": "Have been visiting multiple times. Models are great and the service is much better. They displayed many models without any hesitation and was find the better one. Thanks Venkatesh(saled executive), who helped us to find the best model and for his efforts to get the satisfactory price.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1544",
      "name": "RAJESH KUMAR",
      "rating": null,
      "text": "Very exciting jewellery range and humble sales person Mr Sai Charan. Best wishes to the team. Bought what we wanted.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1545",
      "name": "rajesh s",
      "rating": null,
      "text": "Sunitha was very good sales person and the collection is very good we had a good experience",
      "date": "",
      "displayDate": "3 months ago",
      "relativeDate": "3 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1546",
      "name": "rajeswari nekkanti",
      "rating": null,
      "text": "i purchased gold vaddanam and bangles from krishna jewellers, Durga prasad delivered to my home very safely and explained about the weight and stones clearly and handedovered the jewellery and the bills safely, and ganesh garu helped us …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1547",
      "name": "Rajeswari Polimera",
      "rating": null,
      "text": "Mr. Mallikarjuna , the sales person showed us many designs in Italian chains and diamond studs patiently. Excellent designs and lot many collections to select at this shop. Prices are maket competitive.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1548",
      "name": "Rajitha Devi",
      "rating": null,
      "text": "We visited Krishna Jwelery’s and K.Sai Kumar was sales person. He was so polite and patience. There were a lot models with affordable prices",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1549",
      "name": "rajitha reddy",
      "rating": null,
      "text": "Good and exclusive collection of gold necklaces. Bheem showed us a wide variety of neck pieces. Will definitely visit again.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1550",
      "name": "Rajitha reddy",
      "rating": null,
      "text": "Very satisfied with Service. Yadav was the sales person who showed us everything in detail. Thanks to him. Collection was very good. Highly recommended.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1551",
      "name": "Rajkumar Bellale",
      "rating": null,
      "text": "Good service S.Bharat and collection was good",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1552",
      "name": "Rajkumar Sweet",
      "rating": null,
      "text": "Good experience been here multiple was times very helpful govind he is great job very nice collection and service by Govinda",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1553",
      "name": "Rakesh Katanguri",
      "rating": null,
      "text": "One of the best stores in Hyderabad with wide range of collections & options. Sales executive ‘Loknath’ helped us finding the best designs, he was very professional & polite all the time with us.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1554",
      "name": "Rakesh saini",
      "rating": null,
      "text": "Very nice collection, staff especially Bheem was very patient, helpful and showed us all the collections, very happy with the bangle purchase,",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1555",
      "name": "Rakoti Jhansi",
      "rating": null,
      "text": "Staff was so nice and helpful.Expkained everything in detail. Rekha, Praveen and Sai reddy were so helpful",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1556",
      "name": "Ram",
      "rating": null,
      "text": "Very impressed with the collection at Krishna jewellers. I highly recommend the store to anyone. We reached to Ramadevi garu and she was very polite and helpful.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1557",
      "name": "ram mohan",
      "rating": null,
      "text": "They show high price in quotation and add 2 time GST after they less it and show us they reduce the price and cost of making also high compare to market and diamonds cost also high pls all of u know their price on board inclusive GST they …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1558",
      "name": "Rama Adusumilli",
      "rating": null,
      "text": "Excellent attention to detail and to customer - felt very comfortable, no pressure, mr venkatesh was very knowledgeable about the various products and gave us a good deal!! Definitely coming back here again and very good selection!!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1559",
      "name": "rama devi",
      "rating": null,
      "text": "Good collection and pavani service is good nd she is good patients",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1560",
      "name": "Rama Devi",
      "rating": null,
      "text": "Good collection! Had a wonderful and productive experience with Ramadevi and good service,the best krishna jewellers. 😊 …",
      "date": "",
      "displayDate": "Edited 5 months ago",
      "relativeDate": "Edited 5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1561",
      "name": "rama krishna",
      "rating": null,
      "text": "The service & Hospitality was good at Krishna Jewellers Pearls & Gems, Jubileehills, Road no-36. The designs of the Gold jewellery & Silver Articles were really of good quality …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1562",
      "name": "RAMA KRISHNA RAO RACHURI",
      "rating": null,
      "text": "R Satish was given very excellent service on our visit to Krishna Jewellery",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1563",
      "name": "Rama Reddy",
      "rating": null,
      "text": "The collection was great. wide varieties in all categories.The team was very patient. Thanks to the sales rep Nagarjuna for providing the detailed explanation and for the great response.Special thanks to MR.Nayeem the manager who handles the customers with respect .",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1564",
      "name": "ramadevi epperla",
      "rating": null,
      "text": "Rajesh showcased items very patience.Workmanship is verygood.Iam very much satisfied..",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1565",
      "name": "Ramakumari Madhira",
      "rating": null,
      "text": "Yadav and Sai Kumar was good customer service showing all unique collections thanks",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1566",
      "name": "Ramana kumari",
      "rating": null,
      "text": "Pavan is a very good person, he is very patience and calm, I would reffer him to Krishna jewellers at Jubilee Hills Hyderabad",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1567",
      "name": "Rambabu Bandarupalli",
      "rating": null,
      "text": "Bharat has showed all the items with patience, good services very happy with the services THANKS to Bharat and team",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1568",
      "name": "Ramesh Mahalaxmi",
      "rating": null,
      "text": "Awesome collection. We just came for window shopping but Executive Sravan totally conversion into shopping he was extremely good he explained all products clearly....I give 5 star rating to Store and also Sravan. I will refer my relatives also...Tq",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1569",
      "name": "ramesh melapu",
      "rating": null,
      "text": "While the designs and collections at this shop are impressive and the pricing is generally good, my recent experience with their service was disappointing compared to earlier visits. After placing an order for an item that wasn’t readily …",
      "date": "",
      "displayDate": "Edited 10 months ago",
      "relativeDate": "Edited 10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1570",
      "name": "Ramesh reddy Chinthakuntla",
      "rating": null,
      "text": "It was a display of an excellent collection of ornaments with wide range of options, which have been crafted carefully with an excellent workmanship. …",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1571",
      "name": "Ramkumar Singavarapu",
      "rating": null,
      "text": "Wonderful Shopping experience with Krishna Jewellers , Jubilee Hills . Great relationship and attitude with the customers by staff members particularly Sri.Ganesh and Srinivas Garu they helped a lot in exploring the range of Items and till the delivery of Items.Suggesting to keep it up.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1572",
      "name": "Rammohan Cv",
      "rating": null,
      "text": "Nice models service is good for /srilakshmi",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1573",
      "name": "Rampally Adarsh",
      "rating": null,
      "text": "I recently purchased a pair of gold and diamond earrings, and I was thoroughly impressed with the level of service provided by the salesperson Guruvaiah who assisted us. …",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1574",
      "name": "rams ...",
      "rating": null,
      "text": "My experience with Krishna Jeweler’s was outstanding, Thank you for showing us the wonderful product and Sandeep service is very prompt, I'm very pleased. He has showed us the relevant details such as the type of metal, gemstone used, purity scale, and any unique design elements that make the piece stand out.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1575",
      "name": "Ramu Goud",
      "rating": null,
      "text": "We purchased gold bridal jewellery in krishna jewellerys pearls and gems at Jubilee hills Mr Sai Kumar was very helpful to us in shopping, we would like to recommend this showroom to all who are looking for beautiful jewellery in all categories",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1576",
      "name": "Ramya A",
      "rating": null,
      "text": "Krishna Jewellers had wonderful collection. The way they received and hospitality was amazing and very much impressed. Especially working with Bharath was a really good experience. Will sure visit the store again..",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1577",
      "name": "Ramya Krishna",
      "rating": null,
      "text": "Collection is good. Sai Kumar used to help us getting nice designs as per our taste and requirements.",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1578",
      "name": "RAMYA MADHAVI",
      "rating": null,
      "text": "I’ve been in search of a elegant choker which I’ve found it in Krishna Jewellers online via WhatsApp. Visited the store and was received with excellent hospitality. Thanks you Dhinkar garu for your patience and follow ups. Also, Riaz garu for your time and suggestions. Fully satisfied with the ornament designs and hospitality",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1579",
      "name": "Ramya Medapati",
      "rating": null,
      "text": "Their collection boasts a range of exquisite designs that cater to diverse tastes. Mr.Bheem, Mr.Srikanth were excellent in showing their collection. Highly recommend the store!",
      "date": "",
      "displayDate": "Edited 11 months ago",
      "relativeDate": "Edited 11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1580",
      "name": "Ramya P",
      "rating": null,
      "text": "I recently visited Krishna Jewellery and was very impressed with their collection. Sunitha was extremely helpful and showed all the jewellery with great care and professionalism.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1581",
      "name": "Ramya Popuri",
      "rating": null,
      "text": "Very good collection.. Staff received very well. Sales woman Ganga Bhavani has been very polite and showed us models with much patience. Overall a good experience",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1582",
      "name": "Ramya Valluri",
      "rating": null,
      "text": "In prestige high fields they have done exhibition and I loved the collection a lot and I visited the store again in jublie hills and there Mr Sandeep guided me in each and every aspect and finally got my awesome piece to my hand... And the staff in thi's place are really helpful and polite.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1583",
      "name": "ranganayakulu bysani",
      "rating": null,
      "text": "pavani very patient to show us the designs as per our requirement. She has good knowledge on latest trends and models. Had a very good experience at Krishna Jewellers and would definitely recommend and re visit.",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1584",
      "name": "Rani Ch",
      "rating": null,
      "text": "Has wide variety of collections. Customer service is really good. Mr Bharath is polite, well spoken and has taken care of all our requirements really well.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1585",
      "name": "Rani Reddy",
      "rating": null,
      "text": "I met Mr kushal and Mr chary in krishna jewellers to buy a choker. Both of them were too patient and showed me all designs. Thank you.. They helped me finalise a design. Keep up the good work.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1586",
      "name": "Ranjani Chowdary",
      "rating": null,
      "text": "Very nice designs and satisfied with their unique collections. Customer representation bhavani mam is very patient in explaining the details. Thankyou mam for showing all with clear explanation thankyou @bhavani garu",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1587",
      "name": "ranjini reddy",
      "rating": null,
      "text": "I had good experience in purchasing gold from this Jwellers. Representative Kushal was very helpful and kind. He had shown us different types of Jwellery with lot of patience. I would personally suggest this store and representative Kushal for buying Jwellery.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1588",
      "name": "ranjit Kumar",
      "rating": null,
      "text": "Prakash has given very good customer service",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1589",
      "name": "Ranjith Kumar",
      "rating": null,
      "text": "Sravan is so helpful he was awesome nic hospitality and also awesome collection. Once again thnks to our hero I mean Sravan..gives 5 star rating for Krishna jewellers.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1590",
      "name": "Rashmi A",
      "rating": null,
      "text": "I got pearl jewellery which includes pearl studs, neck pieces and bracelets. And all these were so pretty and have a great precision and quality. Ratnaraju helped me a lot in showing most of these pieces and he also paid attention to every …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1591",
      "name": "Rashmi Bagewadi",
      "rating": null,
      "text": "I wanted to leave a negative rating for their service, but that option isn't available. Their customer service is among the worst I've encountered. The ornaments I purchased did not have an HUID number or BIS hallmark. When we inquired, …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1592",
      "name": "Rashmi R",
      "rating": null,
      "text": "Good collection of pearls. Good service provided by Satish R.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1593",
      "name": "rashmi reddy Rashu",
      "rating": null,
      "text": "Service was great! Much appreciated Swamy and P Amar for showing us great designs and helped us to easily find our desirable diamond choker. Thank you Krishna Jewellers!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1594",
      "name": "Ravali Javvaji",
      "rating": null,
      "text": "I had a really great experience in getting help from krishna jweller's associates.B.Naresh is the assiociate who was available all the time throught out the clock to help with my adhoc requests to pair up the jwelery combinations and to …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1595",
      "name": "ravali reddy",
      "rating": null,
      "text": "Good experience and hospitality Special thanks to Sri laxmi",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1596",
      "name": "Ravali Reddy",
      "rating": null,
      "text": "Always had good experience here. Govind was very patient and pleasing with his smile all throughout. As usual krishna has latest collection to engage us with.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1597",
      "name": "Ravali venu",
      "rating": null,
      "text": "Awesome experience just like I expected. Mr. Bheem Kanse was very helpful and patient. He showed us a lot of amazing pieces and made us choose the right piece. Must visit in Hyderabad",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1598",
      "name": "Ravi Chandra",
      "rating": null,
      "text": "Good collection of diamond jewellery. Service is top notch with Ramadevi helping in every aspect end to end.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1599",
      "name": "Ravi Holi",
      "rating": null,
      "text": "Nice cooperative staff With plethora of choice.. Nice place to visit and shop...great shoping experience",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1600",
      "name": "ravi kumar",
      "rating": null,
      "text": "We were so happy the service provided by Sravan and he understood our requirement and showed the designs. Must visit gold shop in Hyderabad. Once again thanks Sravan for the best assistance.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1601",
      "name": "Ravikumar Jagu",
      "rating": null,
      "text": "Wonderful experience @Krishna jewellers Jublihills and Kushal had shown all the varieties and we had a great i time and must visit store for your all jewellery purchase. Thank you Kushal for all your time and patience shown all the models .",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1602",
      "name": "Ravindra Vytla",
      "rating": null,
      "text": "Excellent designer and trendy collection. Very good engagement with the customers. Mr.Nagarjuna explained all the details thoroughly and we had a great experience.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1603",
      "name": "Raviteja Vuppala",
      "rating": null,
      "text": "The collection is excellent and Mr. Yadav was great to show, assist and explain everything in detail. It was a wonderful experience!!!!",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1604",
      "name": "Rayavarapu Soundarya",
      "rating": null,
      "text": "I have visited the Krishna Pearls for the first time and the service offered by Mr Sravan is really good. He has suggested very well and I have got the solution for my requirement. Thank you Mr. Sravan",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1605",
      "name": "Reema Roy",
      "rating": null,
      "text": "The staff is very courteous specially Mr. Srikanth who was absolutely polite and had great listening skills. The store is worth a visit if anyone is looking for pearls. I was very satisfied with the experience.",
      "date": "",
      "displayDate": "6 years ago",
      "relativeDate": "6 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1606",
      "name": "Rekha Kasarapu",
      "rating": null,
      "text": "Sai Kumar has good customer service",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1607",
      "name": "rekha nadagouda",
      "rating": null,
      "text": "I recently purchased agarbatti stand ..I really liked it.. experience is too good.. very kind and patiently they will share their products.. totally happy by shopping with Krishna jewellery",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1608",
      "name": "Renuka Pathapati",
      "rating": null,
      "text": "We had very good experience. Bhem Kansee showed all items that we requested. We satisfied with the service.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1609",
      "name": "Renuka prasanna",
      "rating": null,
      "text": "The ambiance by your store executives was perfect for browsing. And thank you so much for your help, Ramalakshmi. I felt so comfortable asking questions and you answered them all with such enthusiasm and made it easy for my decision. …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1610",
      "name": "Renuka Shedole",
      "rating": null,
      "text": "i have the best experience in krishna Jewellers with awesome collection mainly experience with Bharath shown with patience and explained clearly everything I liked everything with heartfully",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1611",
      "name": "Reshma Mohammed",
      "rating": null,
      "text": "I have recently visited multiple gold jewellery shops and this one stands out. They have a huge variety of jewellery and my experience with Krishna Jewellers was great!! …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1612",
      "name": "Reshma Raghunath",
      "rating": null,
      "text": "Exceptional customer service ! I had to change a COD order of pearl necklace set to prepaid. Neelam from customer service cell helped immensely with the process with …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1613",
      "name": "Revanth Kumar Malle",
      "rating": null,
      "text": "Today I shoped @krishna Jewellers I have seen beautiful collection and unique designs executive beem shown all the collections with patience",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1614",
      "name": "Revathi Alluri",
      "rating": null,
      "text": "Krishna Jewellery in Jubliee Hills has wide range great designs with best prices. Bharath, Srinivas garu helped us a lot in selecting the best Jewellery. Very happy with the service they provided, great hospitality and shopping experience",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1615",
      "name": "Revathi Gorijavolu",
      "rating": null,
      "text": "Bought Jewellery for my baby and really happy with the purchase. I only had 10 days time and wanted a customized piece. I was a bit hesitant on whether they would cut corners on the finish in the short time frame I gave them. However, …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1616",
      "name": "Revathi Reddy",
      "rating": null,
      "text": "I recently visited Krishna jewellers pearls annd jewellers ant Jubilee Hills and had an amazing experience! From the moment I walked in, the staff was welcoming and attentive. They have a wide selection of stunning jewelry, from elegant …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1617",
      "name": "Revathy Arun Kumaran",
      "rating": null,
      "text": "Krishna Jewellery exceeded expectations! Excellent customer service, beautiful products, and timely delivery. Online order reached us right on schedule. Trustworthy and reliable, 5-star experience! 💯. …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1618",
      "name": "Revathy G",
      "rating": null,
      "text": "Excellent Collections , staff where very professional especially Prakash who had taken care of our purchase was very patient and explained everything… Will purchase again …",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1619",
      "name": "Ricky REDDY",
      "rating": null,
      "text": "Pavani has given an amaizing service . She has been very patient with us an explained and showed enormous interest in showing the designs in gold,kundhan and Diamond jewellery. The designs are excellent/ fabulous. I have purchased diamond …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1620",
      "name": "Riddha Basu",
      "rating": null,
      "text": "Review of My Experience with the Salesperson, Md. Saukat Ali at KHRISHNA PEARLS PVT. LTD at Jubilee Hills, Hyderabad: On Feb 4, 2020 I came in company with my wife, Mrs Chandana Basu to purchase a …",
      "date": "",
      "displayDate": "6 years ago",
      "relativeDate": "6 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1621",
      "name": "RISHIKA ENTERPRISES HYD",
      "rating": null,
      "text": "Nice collection good service by govind",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1622",
      "name": "Rishitha Reddy",
      "rating": null,
      "text": "Just wanted to give a genuine shoutout to Yadav garu. Every time we come to the store he always understands exactly what we’re looking for and shows us the best pieces without wasting time. He’s patient, honest and handles all our doubts …",
      "date": "",
      "displayDate": "Edited 6 months ago",
      "relativeDate": "Edited 6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1623",
      "name": "Ritesh Agrawal",
      "rating": null,
      "text": "Great Jewellery designs at store for all your needs. I was looking for ethnic collection and surprisingly there are lots of designer ethinic collection which normally I do not see in most of the stores. …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1624",
      "name": "Ritesh Reddy",
      "rating": null,
      "text": "Super and fantastic designs here in krishna jewellers. Especially the patience of the sales person kushal has shown me a lot and lot of models untill we like them thank you kushal garu for your kind service❤️",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1625",
      "name": "RK",
      "rating": null,
      "text": "Amazing experience at Krishna Jewellers, Jubilee Hills. Our sales persons- Rekha, Shivaji and the store manager Shiva Kumar were amazing! They displayed tremendous patience and gave us the best possible price. The quality of the jewelry is …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1626",
      "name": "Robert Jeevan",
      "rating": null,
      "text": "Had a great experience at Krishna Jewellery! Special thanks to Rekha for her excellent service and helpful suggestions. Loved the collection—will surely visit again! 🌟 …",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1627",
      "name": "Rohit Gauri",
      "rating": null,
      "text": "KashiRam has been a great in helping me with understanding various pearl designs. He took care of me with patience and gave his 100% attention. I would recommend krishna pearls and jewellers to everyone",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1628",
      "name": "Rohit Gundamaraju",
      "rating": null,
      "text": "Got my amazing choice of pearls showcased by Chandu ! Do visit the store for some cool contemporary sets",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1629",
      "name": "rohit yadav",
      "rating": null,
      "text": "Nice collection they showing different model as per our taste and budget especially from Yadav garu",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1630",
      "name": "Rohith Gangula",
      "rating": null,
      "text": "Good collection, our go to store for all our jewelry needs. Best staff particularly Sandhya Rani garu.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1631",
      "name": "rohith karnati",
      "rating": null,
      "text": "Very great collection and designs. Swamy is an excellent employee here. He is really helpful in showing everything until I found what i liked in my price range and exact size. It’s very hard to find the right product but Swamy made it very …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1632",
      "name": "Rohitha P",
      "rating": null,
      "text": "They had the best collection when it came to Diamonds. J. Mahesh understood our requirements instantly and gave us the best experience. B. Praveen helped us finding the products. Very happy with our purchase. Definitely coming back.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1633",
      "name": "Roja Palla",
      "rating": null,
      "text": "Excellent customer service, designs are amazing with reasonable price for the quality product. staff are very knowledgeable and ensures to know the customer needs. Gururaj garu helped a great deal to recommend jewelry as per my requirements. Overall great experience and would recommend Krishna Jewelers to family and friends.",
      "date": "",
      "displayDate": "Edited 8 months ago",
      "relativeDate": "Edited 8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1634",
      "name": "Roopa Popuri",
      "rating": null,
      "text": "Recently visited store. Customer service is excellent. Specifically to mention ms. Shakeela did great job showing us all the collection with lots of enthusiasm.rest of all the store people are very welcoming and pleasent.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1635",
      "name": "Roopa Yenigella",
      "rating": null,
      "text": "Nice experience at Krishna Jewellers one more time! The staff are very helpful, thanks Mr.Naresh ones again for helping me buy beautiful bangles. …",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1636",
      "name": "Rose",
      "rating": null,
      "text": "Krishna Jewellers Jubilee Hills has exceptional service and i’m quite impressed by Srikanth and Abhimanyu’s service and patience. Srikanth has been helping me via video calls and whatsapp chats for the type of pieces I was looking for my …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1637",
      "name": "Roshini V",
      "rating": null,
      "text": "We recently shopped here for wedding .The quality of work in Krishna Jwellers ,Pearls and Gems is excellent.They have provided all the jwellery with high quality and at a reasonable price. Sincere thanks Nayeem garu for this.They always …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1638",
      "name": "RSReddy Sathi",
      "rating": null,
      "text": "Excellent designs, the hospitality that we received is awesome. very good service especially Mr. Venkatesh, such a nice person and has lots of patience and explained everything indetail. Thank you for your service and hospitality. From last 3 years I'm a regular customer awesome designs.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1639",
      "name": "ruchita darshan",
      "rating": null,
      "text": "Krishna jewellers has the best collection to offer among all the places I’ve visited so far. Their quality and design definitely stands out and makes heads turn. Loknath Dutt has helped us pick jewellery according to our taste and budget and has a very warm and friendly approach.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1640",
      "name": "Ruchitha Kode",
      "rating": null,
      "text": "Visit Sandhya Rani garu she give good discounts",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1641",
      "name": "S S",
      "rating": null,
      "text": "Mesmerizing pieces of art and jewels. They have started this WhatsApp Video chat for customers who want to buy without visiting stores in accordance to COVID-19. I used the service and found out extremely good and convenient also was well explained and executed by the sales people (Mr Arun helped me well). I would rate 5+ stars.",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1642",
      "name": "S shivani Reddy Shivani",
      "rating": null,
      "text": "Very patiently showing the items and review everything that was awesome experience R.Sateesh",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1643",
      "name": "S Venukumar",
      "rating": null,
      "text": "Krishna jewellery I visit first on this store nice collections good varieties lot designs in this shop customer service very good sales girl Meenakshi",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1644",
      "name": "Sabbineni Pranathi",
      "rating": null,
      "text": "Yadav, the sales rep has been very patient in showing different designs we asked for. Very efficient and helpful. Keep up the good work.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1645",
      "name": "Sachin Tendulkar",
      "rating": null,
      "text": "We are really impressed with Ganga Bhavani’s service at Krishna Jewelers. She is very patient while showing different diamond models and very knowledgeable while explaining each and every necklace model. Very glad to have her at service and …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1646",
      "name": "Sagarika Reddy",
      "rating": null,
      "text": "It was a wonderful experience buying jewelry from Krishna Jewellers .sales person Nithesh was very responsive and patient in showing us various models answering all our questions ,The customer service is excellent. …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1647",
      "name": "Sagrika",
      "rating": null,
      "text": "Really like the variety and the range for silver products, even the dealing was very nice and smooth, reliable seller and keeps a track for your order! Will keep shopping for more, thankyou so much!",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1648",
      "name": "Sahan Gupta",
      "rating": null,
      "text": "I recently visited Krishna Jewellers and had an exceptional experience, thanks to Suneeta. She was incredibly knowledgeable, patient, and attentive, helping me find exactly what I was looking for. Her professionalism and friendly demeanor …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1649",
      "name": "Sahith M",
      "rating": null,
      "text": "Very good collection. Venkat has lot of patience and is extremely professional and helped us through buying process. Will surely come again.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1650",
      "name": "Sahithi Elapanty",
      "rating": null,
      "text": "Swamy showed us very unique designs. We have recommended this store to our close friends and family. Staff are too helpful and friendly. Really impressed with hospitality. Thank you for the great service.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1651",
      "name": "Sahithi Uppala",
      "rating": null,
      "text": "Representative Yadav has been helping me for more than an year. He makes us feel welcome at the store and shows designs to my liking always.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1652",
      "name": "Sahithi Voruganti",
      "rating": null,
      "text": "Very good designs and great workmanship. Kushal Jadhav has been really helpful during our complete wedding shopping.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1653",
      "name": "Sahithya Kadaru",
      "rating": null,
      "text": "Ramya pavani was really helpful in answering all my questions. Understood my jewelry preference and showed designs that align my interest. She made my shopping experience amazing.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1654",
      "name": "Sahithya Kaja",
      "rating": null,
      "text": "I visited the store for my wedding jewellery, priya showed us all the collection with utmost patience and helped me with customisation as well. Really glad that priya assisted me throughout the process.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1655",
      "name": "sahitya reddy",
      "rating": null,
      "text": "Prasanna was really polite, patient and helpful while we were shopping. She made genuine efforts to show us best designs and gave us a worthy price. Thank you !",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1656",
      "name": "Sai Chaitanya",
      "rating": null,
      "text": "Krishna Jewellers, Pearls & Gems is not just a jewelry store; it’s a legacy, a promise of quality. We are happy with the jewelry and pricing. Naga sai and Manager Srinivas were very helpful and engaged us by showing the best designs.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1657",
      "name": "Sai Chandana",
      "rating": null,
      "text": "Ramya pavani is very friendly and she asked what I was looking and showed as per my taste. I really enjoyed my shopping with pavani.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1658",
      "name": "Sai Devireddy",
      "rating": null,
      "text": "Overall experience was great. The collection is nice and the price is competitive. Sai Kumar, who assisted us is knowledgable and proactive, making our purchase experience a pleasant one.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1659",
      "name": "sai katta",
      "rating": null,
      "text": "Recently bought Gold jewellery with antique finish from this store, this is my second time purchase in last two months. The designs and quality are par excellence.Riaz has helped through out, he went above and beyond to get us the best designs and awesome prices. Looking forward for more shopping :)",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1660",
      "name": "sai krishna reddy",
      "rating": null,
      "text": "Good &Trendy collection Mr.lokanath has good knowledge of products ..he explained very well with lot of patience .",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1661",
      "name": "SAI KRISHNA REDDY PASHAM",
      "rating": null,
      "text": "Excellent service. Amazing Designs. Loved their collection. Sales Executive Ms Pavani is very professional and an excellent customer service oriented person. She is very honest and hardworking. Their Manager Mr Nayeem was really helpful …",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1662",
      "name": "Sai Madhurya",
      "rating": null,
      "text": "I visited store today and Mrs.Rama devi was very patient and helpful in explaining everything. Will always come back to the store and see Rama devi garu for future purchases! Sweet and patient",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1663",
      "name": "Sai Manoj",
      "rating": null,
      "text": "What impressed me most was the quality and craftsmanship of the pieces—each item felt unique and finely detailed. The pricing was reasonable compared to other stores, and they provided proper certification for every purchase, which built my trust. Pawan sales helps us lot",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1664",
      "name": "Sai Nandini Rao Chitneni",
      "rating": null,
      "text": "First time visiting Krishna Jewelry store. Great customer service with stunning wide range of jewelry collection. Rama Devi was our sales executive.she was very welcoming, responsive and very attentive to our requests/wishes and was proactive in showing us the latest designs.She remained patient throughout our stay.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1665",
      "name": "Sai Prasanna",
      "rating": null,
      "text": "Great experience as always with Govind and Sandeep! They’re my go to people for everything. They go extra lengths for ensuring we get the best designs.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1666",
      "name": "sai ram goud",
      "rating": null,
      "text": "I have recently visited the gold shop and brought some items i have fully satisfied with their collection fully appreciate the man Mr. Venkat have exegesis he have proficiency about what he was doing we will definitely visited once again soon.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1667",
      "name": "Sai Ramya Katta",
      "rating": null,
      "text": "Recently bought Golden south sea pearls premium quality from Krishna Pearls, Dinaker has been very helpful right from getting the actual shade of pearls, giving the best price and shipment. Highly recommend this store for buying authentic rare shades of Golden south sea pearls.",
      "date": "",
      "displayDate": "Edited 4 years ago",
      "relativeDate": "Edited 4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1668",
      "name": "Sai Sai",
      "rating": null,
      "text": "I have wonderful experience here for my function they have a huge collections sales pawan helps us to select the perfect jewellery to our function",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1669",
      "name": "Sai Shankar",
      "rating": null,
      "text": "Nice place to buy designer armament we have received good response from sales executive Mr Prakash to select the items",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1670",
      "name": "Sai Sharanya Reddy Kotha",
      "rating": null,
      "text": "Collection is too good. Salesman loknath is having good patience",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1671",
      "name": "Sai Sharath",
      "rating": null,
      "text": "Sarvesh has been phenomenal and has been very patient in our whole marriage jewelry shopping experience! Made our day with all the collections and reasonable rates",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1672",
      "name": "Sai Sindhura",
      "rating": null,
      "text": "Collection is good and the sales executive sravan is very patient and friendly. He took time and showed all the models which I wanted. Definitely recommended.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1673",
      "name": "sai srujana",
      "rating": null,
      "text": "Staff was really helpful. Especially Akshaya garu in sales department was very patient and helpful in showing us all the latest trending jewelry within our budget",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1674",
      "name": "Sai tarun",
      "rating": null,
      "text": "Great experience. The service professional Govind did a great job explaining to us all the varieties. Awesome service and a very good collection.. especially Govind who was the sales person thanks alot",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1675",
      "name": "Sai Vinnakota",
      "rating": null,
      "text": "I have had a great experience buying jewellery here. Pavani has assisted us really well. Appreciate her patience and the variety of jewellery she showed us.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1676",
      "name": "Saicharan Reddy",
      "rating": null,
      "text": "Good Collection and pleasant environment and Staff is very kind Srilakshmi assisted and explained us with great patience",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1677",
      "name": "saikamal pulimi",
      "rating": null,
      "text": "We have really great time in Krishna jewellers pawan was really help full and explained about jewellery we like the jewellery",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1678",
      "name": "saikeerti nuthigattu",
      "rating": null,
      "text": "Had a very good experience with Ganga Bhavani madam at this shop. She has shown wide range of varities with utmost patience. And final result is done to my satisfaction.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1679",
      "name": "saikrupan .j",
      "rating": null,
      "text": "Very Nice collection. Special thanks to Mr Loknath for being patient and superhelpful during the selection and purchase process",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1680",
      "name": "Saikumar Mumma",
      "rating": null,
      "text": "Visited krishna jwellery for purchasing silver and tried out a scheme and purchased gold as well speaking with Sunitha was a awesome experience",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1681",
      "name": "Sailu Ajju",
      "rating": null,
      "text": "I had a great experience at the store!The jewellery collection is really beautiful.The salesman mr.bharat is very patient, attentive and friendly..the collection is very good must visit is the store",
      "date": "",
      "displayDate": "Edited 4 months ago",
      "relativeDate": "Edited 4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1682",
      "name": "sain sha",
      "rating": null,
      "text": "Very well maintained and they have wide range of collections. Yadav was very helpful, knowledgeable and patient showing all of the collection without any hesitation. Would definitely recommend Krishna jewellers to friends and family.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1683",
      "name": "saisankar narla",
      "rating": null,
      "text": "I had an amazing experience with T SANDYA RANI They were knowledgeable, friendly, and helped me find exactly what I was looking for. Good collection and I suggest my family and friends",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1684",
      "name": "Saisri Nikhil",
      "rating": null,
      "text": "Great service! Pawan was very polite and helpful. He explained everything clearly and made the purchase smooth. Highly recommend!”",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1685",
      "name": "samanth mittu",
      "rating": null,
      "text": "Sai kumar gives me good experience to buying jewellery. Sai Kumar, know the taste of the customer. I feel comfort to buying jewellery with Sai Kumar",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1686",
      "name": "Sambit Daspatnaik",
      "rating": null,
      "text": "Good quality and workmanship. Professional approach with a personal understanding of the customers requirement. Sandeep from the sales team was very proactive in ensuring we get the right service. Thank you",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1687",
      "name": "Sambu Divya",
      "rating": null,
      "text": "Excellent Collection. Nagarjuna garu has shown us all the models with lot of patience. Everytime we visited the store, received us very well. We went to purchase 1 item but done with 2. Thanks a lot Nagarjuna garu for helping us choose the best",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1688",
      "name": "SAMPATH REDDY M",
      "rating": null,
      "text": "you will see unique designs and models of the items…. And Mr S Bharath is the who was assigned was us to show the models he was so patient and has shown us each and every models they have … highly recommended place for purchasing jewellery.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1689",
      "name": "Samyuktha Narra",
      "rating": null,
      "text": "I’ve got what exactly I wanted. Amazing models. The Staff are very friendly and excellent at providing service. Thanks to Bheem for being so patient.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1690",
      "name": "Sana Fatima",
      "rating": null,
      "text": "Mallikarjun is very good person to help us decide which would be more and best options to choose from. Thanks to Krishna Jewellers for awesome products. I have been using your jewelry from several years thank you 🙏 …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1691",
      "name": "Sanchali Roy",
      "rating": null,
      "text": "The collection they have is by far the best I have come across in Hyderabad. They give great discounts, better than their contemporaries, during festivals. I love the cut and colour of their pearl drops. Do try out if you are in Hyderabad.",
      "date": "",
      "displayDate": "9 years ago",
      "relativeDate": "9 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1692",
      "name": "Sandeep Datla",
      "rating": null,
      "text": "Visited them for a diamond necklace. They have good collection and their sales executive Ramadevi understood our requirement and gave good suggestions which made the purchase decision easier.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1693",
      "name": "Sandeep Deshpande",
      "rating": null,
      "text": "Amazing Place, Wonderful Variety, Trustworthy Products, Superb Designs & Finishing. Riaz their executive is simply one the best professionals I've come across and would like to return back for the aforementioned reasons. Thank You!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1694",
      "name": "Sandeep pns",
      "rating": null,
      "text": "Good Designs, Staff Srikanth and Pawan were patient in showing the designs. One of the best jewellery stores in Hyderabad.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1695",
      "name": "sandeep reddy",
      "rating": null,
      "text": "Had a very wonderful shopping experience at Krishna Jewellers. Sandhya was very personable with great service towards us. She quickly understands the mentality and needs of her customers and gives a 10 star experience. I would come back for future purchases.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1696",
      "name": "SANDEEP REDDY REVURE",
      "rating": null,
      "text": "Had a good experience at the store. Shivaji was very courteous and helpful with the designs and collections. Discount could have been better",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1697",
      "name": "Sandesh Thakur",
      "rating": null,
      "text": "It is a good collection and the designs are new.thank you pavan sir for helping us in shopping.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1698",
      "name": "Sandhya Nandiraju",
      "rating": null,
      "text": "Absolutely trustworthy and one stop destination for all kinds of jewelry needs for any occasion. We had very good experience with Mrs. Rama Devi, who assisted us for customizing our choice of jewelry.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1699",
      "name": "Sandhya V",
      "rating": null,
      "text": "We have bought some amazing jewellery from their great and unique range of collections. All of their staff are cooperative and knowledgeable, my special thanks to sales person Sravan, he understands exactly what customer a customer needs …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1700",
      "name": "Sandhya Yadagani",
      "rating": null,
      "text": "This was my first visit to the store as a walkin and I wasn't sure that I would make a purchase. But the collection was superb and Ms Meenakshi's service was awesome. She understood my expectation pretty quickly and showed the best collection which prompted me to purchase without any hesitation.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1701",
      "name": "Sangeetha Krishna",
      "rating": null,
      "text": "I wanted to say purchasing online with Krishna jwellery was a good experience they were able to show their designs through video call and gave me timely reply for my queries.pirchasing online is not same as direct buying so it requires …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1702",
      "name": "Saniya Mathur",
      "rating": null,
      "text": "Had a great experience at Krishna Pearls Store. Rama Devi was very helpful, very good experience with this sales executive made our work easy.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1703",
      "name": "Sanjana Dhilod",
      "rating": null,
      "text": "As I have visited a store meet with Mr.Bharat he was so polite nature and and providing value to customers rather than just closing deal. Must visit the store",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1704",
      "name": "Sanjay Kusuma",
      "rating": null,
      "text": "A big thank you Rama Devi garu.!! Appreciated!! We were provided excellent customer service, that humility and the respect will …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1705",
      "name": "Sanjeevini Namboori",
      "rating": null,
      "text": "Srikanth from Krishna Jewellers has assisted me on my jewelry order. He has been very helpful throughout from the initial stages to delivering it to me. Thank you .",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1706",
      "name": "Sankeerna Reddy",
      "rating": null,
      "text": "We have been hosted by Mr. Kushal & Mr. Mallikarjun today, they really understands the customers requirements and shows all the design until customer satisfactory. They are very polite, amazing manners and lot of patience. Overall I would definitely recommend Krishna Jewellers for their best designs, quality and customer services.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1707",
      "name": "Santarani. Aichm",
      "rating": null,
      "text": "Akshara’s service was good. She and her team patiently helped us in choosing a custom design as per our choice. Looking forward to the ring delivery in next few days",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1708",
      "name": "Santhi Ganta",
      "rating": null,
      "text": "Sandhya and Mahalakshmi is very good & excellent service",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1709",
      "name": "Santhosh Kamini",
      "rating": null,
      "text": "I did jewellery shopping at Krishna jewellers and I really had wonderful experience. The designs were wonderful and the shopping was like a breeze. Nagarjuna garu was very kind and helpful. He was very patient and showed us everything we …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1710",
      "name": "santhosh kumar",
      "rating": null,
      "text": "Visited Krishna Jewellers. Mr. Yadav is very humble and showed us different designs patiently. We came here to buy one item but end up buying 4 items because of Mr Yadav. Thank you.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1711",
      "name": "santhosh maddala",
      "rating": null,
      "text": "I have recently visited for buying jewelleries for my sister's wedding, a wide range of products with good quality. I purely recommend this store from jubilee hills branch to all of my family and friends for any purchase for any occation. …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1712",
      "name": "Santhosh Reddy",
      "rating": null,
      "text": "Happy with the variety and the overall experience. Thanks to Pavani for hearing us out and showing the models to our liking",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1713",
      "name": "Santosh Kumar",
      "rating": null,
      "text": "Normally I don’t visit jewellery shops but thought of taking a diamond stud for me. It’s pretty good to have such a behaviour from the sales lady Ramadevi. She understood my requirement, she was patient in showing me many products and also …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1714",
      "name": "Santoshi Narsing",
      "rating": null,
      "text": "The collection and service was very customer friendly specially Mr.S.Bharat has always been very patient enough to show as many designs",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1715",
      "name": "Saptarshi Chakraborty",
      "rating": null,
      "text": "It was nice experience in the krishna pearls jubilee hills Road.G praveen Kumar, has shown us great items and we have puchased multiple ear rings. Recommended",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1716",
      "name": "Sarada Gunturu",
      "rating": null,
      "text": "Krishna Jewellers is the place for any Gold Nakshi and Polki diamond collections. Mr. Guruvaiah who was very patient and experienced, showed us all good collections and helped us …",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1717",
      "name": "Sarah McGrath",
      "rating": null,
      "text": "Amazing customer service from Satish and his team and the most beautiful jewellery I’ve ever seen!",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1718",
      "name": "Sarannya Anil",
      "rating": null,
      "text": "I received good service from Yadav and Nagarjuna. And they were patient with me and my aunt as we went though many different designs and shared with them my requirement for my preferred accessories. Will definitely be back in the future. I …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1719",
      "name": "Saranya Borra",
      "rating": null,
      "text": "Krishna jewellers, pearls and gems jubileehills branch ....Its been a almost a year that I am visiting this branch....their collection is quite good...purchase about 5 to 6 gold and kudan items from this store sales man vekatesh was very …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1720",
      "name": "saranya reddy",
      "rating": null,
      "text": "The collection is good in both gold and diamonds , huge collections for simple and grand weddings. Customer receiving is good. Ramya served us well.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1721",
      "name": "Saraswathi Arkala",
      "rating": null,
      "text": "We love the customer service from Rama Devi she was very friendly and made us feel very comfortable. She is the reason why we visited Krishna Jewellers. Love to visit here again and again. KJ Customer",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1722",
      "name": "saraswathi b",
      "rating": null,
      "text": "Sri lakshmi service is very good & collection is very nice",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1723",
      "name": "sarat varma",
      "rating": null,
      "text": "Fantastic collection.. very friendly Staff Rajesh has good understanding of the details and showed different options and models and helped us find one of the best item as per our choice",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1724",
      "name": "sarat vundavalli",
      "rating": null,
      "text": "It has been a wonderful experience!! Mr. Sandeep were very helpful and provided with utmost hospitality untill we got out of the store!! Would love to shop again😊 …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1725",
      "name": "sarika dharavath",
      "rating": null,
      "text": "Very good collection, with unique products, finishing...last but not the least...experienced a great hospitality by Nitesh. His marketing skills made us buy even more!! Thank you very much Nitesh!!!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1726",
      "name": "sarita mahapatro",
      "rating": null,
      "text": "Prashant was really helpful in the silver section, really like the customer service",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1727",
      "name": "Sarita Verma",
      "rating": null,
      "text": "Beautiful collections in all antique, contemporary designs... Salesman Mr.Bharath shown all the collections with patience...he helped us a lot..he is so polite nd good nature ..nd showing all the different varieties as per the customer needs.. good collection in krishna jeweller pearl's &Gems...",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1728",
      "name": "Saritha",
      "rating": null,
      "text": "Great Experience on my first visit to Krishna Jewellers, Jubilee Hills, Hyderabad. Excellent service by Mrs. Ramadevi. She was very patient and helpful throughout our purchase. Great place to shop jewelry and very good collection. Overall had a great experience, and I would definitely visit again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1729",
      "name": "Saritha Kaja",
      "rating": null,
      "text": "What a fantastic experience once again at Krishna jewellers Pearls and gems today! Sandeep was brillant and extremely knowledgeable.He took care of our business wonderfully. He was quick to understand my taste and showed us the designs to …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1730",
      "name": "Saritha Kallem",
      "rating": null,
      "text": "Recently visited Krishna jewelry store and Bharath helped us to find the best and perfect jewelry It is really awesome place to buy jewelry and they have wide range of items",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1731",
      "name": "Saritha Reddy",
      "rating": null,
      "text": "Ramadevi service was excellent 👌👌 Nice person Because of her we bought 4 items …",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1732",
      "name": "SASH SASH",
      "rating": null,
      "text": "Pavani has been an amazing salesperson. She is truly an asset to Krishna Jewellers Pearls and Gems. Tons of patience and helps her customer with many ideas and help them pick what best suits them.This is 3 years in a row she has been …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1733",
      "name": "Sateesh Neerukonda",
      "rating": null,
      "text": "I had a wonderful experience with a wide variety of selections to choose from. The service was excellent, and Mr. Bheem was very helpful during the selection process.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1734",
      "name": "Sathish Dasara",
      "rating": null,
      "text": "Nice designs and good price, we were assisted by Sales person Guravayya and he provided us with timely updates of our order and offered us best discount",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1735",
      "name": "Sathish Veerappan",
      "rating": null,
      "text": "The best salesman Prakash at Krishna. Who helped with unique Shiva & Parvith gods with pearls. Thanks",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1736",
      "name": "Sathya Sravan Reddy Choppa",
      "rating": null,
      "text": "Excellent customer service by Yadav here at Krishna Jewelry store. Very good collection of jewelry and lot of choices.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1737",
      "name": "Satya",
      "rating": null,
      "text": "I have been buying gold for the past year. The service has been excellent, particularly from Venkat, the salesperson, who has been very welcoming and informative. He has also offered reasonable making charges on gold ornaments. Overall, it's been a great experience.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1738",
      "name": "Satya Elmed",
      "rating": null,
      "text": "Great xperience with Mahalakshmi executive regarding product discription,usage of product and interaction with us",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1739",
      "name": "satya kishore",
      "rating": null,
      "text": "We had a great experience and very good collection. The team was so humble in showcasing jewellery as per requirement. Happy to visit again",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1740",
      "name": "Savithri Rajendran",
      "rating": null,
      "text": "We visited Krishna Jewellers and loved the collection there. More than the jewellery, the staff were very helpful, especially Mr. Govind, who went out of the way to help us with our purchase. Would 10/10 recommend.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1741",
      "name": "Sayan Jana",
      "rating": null,
      "text": "Have been visiting Krishna jewellers for the last 5 years and the experience has been amazing. Kushal and team have been wonderful . Keep up the great work .",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1742",
      "name": "Sebastian Fuentes",
      "rating": null,
      "text": "Pavani provided excellent customer service and support in helping us find the perfect garnet stone and ring design. I highly recommend seeing Pavani and the team for your next purchase. - Sebastian (Dallas, TX)",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1743",
      "name": "Sensational Updates",
      "rating": null,
      "text": "Salesman Venkatesh has done outstanding job. We visited first time and Venkatesh is so helpful and made us so comfortable by offering various models and suggested suitable models. Krishna Jewelery need active outperforming team members like …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1744",
      "name": "shaik abdulrahim",
      "rating": null,
      "text": "Sunitha is kind human being explained us very nice and the collection is good",
      "date": "",
      "displayDate": "3 months ago",
      "relativeDate": "3 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1745",
      "name": "SHAIK SHAKIRMIYA",
      "rating": null,
      "text": "Amazing service at Jubilee hills flagship store. Their sales associate venkatesh helped was so patient and friendly and helped us thoroughly with all of our questions. They have more collections than other flagship stores. Completely satisfied and wont hesitate coming back here.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1746",
      "name": "Shaik Sony Rakshitha",
      "rating": null,
      "text": "Collection was Good,and service also so good thank you Sri Lakshmi mam for ur corporation",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1747",
      "name": "Shalini Gannavaram",
      "rating": null,
      "text": "Very good service, had been shopping here since last two years, Executive Mr.Venkatesh is very knowledgeable and patient to show all the collection. Will keep shoping again in future..",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1748",
      "name": "Shalini Laadi",
      "rating": null,
      "text": "It's really an amazing experience visiting the showroom. Visited two years back and visited recently. During my recent visit, the floor manager I guess Mr.Praveen Kumar explained the gold schemes very well and the customer treatment is well …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1749",
      "name": "Shalini Maane",
      "rating": null,
      "text": "Mr Satish answered all my queries patiently. Provided me with details of the products and good discounts. Items reached me on time in good condition. Very satisfied with the purchase",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1750",
      "name": "Shamitha Reddy Gali",
      "rating": null,
      "text": "Had a great experience with Yadav,wide range of collection over nice hospitality",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1751",
      "name": "Shanmukeshwari Devi",
      "rating": null,
      "text": "Hi this is sunitha … I visit Krishna Jewllery in Jubilee hills … I was assisted by RAMA DEVI she is so excellent… Give the Correct choose of jewellery…Me and my family members are so happy with her hospitality and the way she treats …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1752",
      "name": "Shanti Priya Dhamma",
      "rating": null,
      "text": "I had a wonderful experience at the gold shop, thanks to the excellent service provided by R. Sateesh . He was extremely patient throughout our visit and took the time to carefully listen to all our preferences and requirements. His calm …",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1753",
      "name": "sharanya L.G",
      "rating": null,
      "text": "Excellent service provided by Vinod garu at krishna jewellers pearls and gems. Wide range of designs at reasonable prices.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1754",
      "name": "Shashank Kakarla",
      "rating": null,
      "text": "I had an absolutely delightful experience at Krishna Jewellers. Upon entering their establishment, I was immediately struck by the stunning array of both gold and platinum jewellery on display. The craftsmanship and quality were truly …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1755",
      "name": "Shashank Suman",
      "rating": null,
      "text": "Our experience with Krishna jewellers was fantastic and they gave best service. Very good quality Gold and they showed all varieties politely. Pavan and Riaz is a great person who served us today.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1756",
      "name": "shashank uppala",
      "rating": null,
      "text": "We had a great experience at this store. Amazing models and this has become our go to store. Mr Riaz was very sweet and polite and helpful. They treated us with respect and everytime we went to get an update on our order they helped us with a smile and incorporated minute changes if we requested for it without any trouble.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1757",
      "name": "shashi tejaswi",
      "rating": null,
      "text": "Awesome customer service, especially pasha is great to work with! They have unique and Amazing designs of great quality at Very reasonable prices. I did 1 in store purchase and 2 online purchases, both experiences were great, Instore they …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1758",
      "name": "Shaukat Hasan",
      "rating": null,
      "text": "I had a very good experience as I bought wedding jewelry for my daughter. Very polite and quick in responding with each inquiry although it was bit challenging communicating with them due to time difference between India and Canada. Rajkumar was very professional from their team whom I dealt with most of the time.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1759",
      "name": "Sheena Reddy",
      "rating": null,
      "text": "Shopping here has been a real pleasure ...the whole team at Krishna jewellers are very professionaland amiable..Right from the owner Mr umesh Aggarwal to the sales staff they are very attentive and make you feel at home and very patiently …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1760",
      "name": "sheetal reddy",
      "rating": null,
      "text": "Service was excellent, they had really Trendy designs and Venkatesh Garu showed us with patience and cleared all our questions humbly. I would recommend this showroom to everyone who is looking for contemporary yet sleek designs",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1761",
      "name": "Shilpa K",
      "rating": null,
      "text": "Cordial and very personable first experience at the store in Jubilee hills. Mr. Loknath was knowledgeable, friendly and patient while discussing and showing us jwelery of interest to us.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1762",
      "name": "Shilpa Kavuturu",
      "rating": null,
      "text": "Excellent service and humble salesperson, showed very patiently. We bought with Guruvaiah who helped us and showed us many designs patiently. Have been a customer since last few years and always leave satisfied",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1763",
      "name": "shilpa kommidi",
      "rating": null,
      "text": "Lot of variety in their collections. Excellent customer service and friendly staff. My sister’s purchase was assisted by Ramya Pavani - to get thru viewing a large collection fairly quickly and purchase efficiently.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1764",
      "name": "Shilpa Reddy",
      "rating": null,
      "text": "Good Collection, appreciate Sunitha’s patience and time to show the best jewellery pieces .",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1765",
      "name": "Shirisha A",
      "rating": null,
      "text": "I had the pleasure of visiting Krishna Jewellers recently, and I am absolutely thrilled with my experience. From the moment I walked in, I was greeted with warmth and professionalism by the entire team. They were incredibly attentive and …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1766",
      "name": "shiv cld",
      "rating": null,
      "text": "I had an excellent experience shopping for jewelry, thanks to Bheem Kanse. He was extremely knowledgeable, patient, and attentive to my preferences. Bheem provided great suggestions without being pushy and made the entire process smooth and enjoyable. I highly recommend him for anyone looking for exceptional customer service!",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1767",
      "name": "Shiva Jhansi",
      "rating": null,
      "text": "Good collection Good service by govind",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1768",
      "name": "shiva kilari",
      "rating": null,
      "text": "Designs and service is best never seen in any gold shops.highly recommend this is the best place to buy the gold, I was lucky to be looked after by R Sateesh, best sals rep too…",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1769",
      "name": "Shiva Patel",
      "rating": null,
      "text": "I am feeling very happy after visiting Krishna Jewellers by seeing the latest designs and polite staff. …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1770",
      "name": "shivani bimavarapu",
      "rating": null,
      "text": "yadav was very helpful and very friendly in giving suggestions when it comes to choosing the designs. He took care of us really well and we were able to find one of the best pieces.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1771",
      "name": "Shivani Palicherla",
      "rating": null,
      "text": "Today visited krishna jewellers, collection is awesome. Mr.Swamy was very humble and showed us wide variety of designs. Such an unique collection. Must visit store in hyderabad",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1772",
      "name": "shivani reddy",
      "rating": null,
      "text": "@Venkatesh....very good service!! We have been shopping here since past two years, they have got great collection and best customer interaction.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1773",
      "name": "Shivika Marwah",
      "rating": null,
      "text": "Krishna Jewellers has a lovely and extension collection. We were assisted by Satish and had a happy purchase.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1774",
      "name": "Shobha Kasireddy",
      "rating": null,
      "text": "Rekha is great assisting with customers requirements/ needs and showcase the Jwellery and going over the items. We definitely will shop again in Krishna Jwellers as we are happy with the customer care and also store manager is very …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1775",
      "name": "Shobha Rani",
      "rating": null,
      "text": "It was a good experience shopping at krishna jubli. We did purchase earlier at abids show room earlier but this place is good, spacious and lots of vatieties in many ranges. Sales persons were very helpful .",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1776",
      "name": "shravan patlolla",
      "rating": null,
      "text": "Chary is our regular contact person,ensures he shows the designs as per our requirements and we never step out with empty hands. Nayeem is our favourite go to person in the store, very warm and welcoming person. Our relationship is …",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1777",
      "name": "shravani karumuru",
      "rating": null,
      "text": "Very nice and authentic jewellery ..sales executive Mr Ch Venkat garu is awesome in his job ..one of the great collection and must go place for gold and diamonds in the city .",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1778",
      "name": "shravani n",
      "rating": null,
      "text": "Awesome customer support by Loknath, very patient and easy to work with. I really like the collection here and I recommend 100% to shop in this store.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1779",
      "name": "Shravani Thammishetty",
      "rating": null,
      "text": "Good collection and excellent customer service. Especially Mr. Nayak, his patience in showing wide variety collection is appreciated",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1780",
      "name": "Shravya Reddy",
      "rating": null,
      "text": "I have a very good experience with Krishna jewellers here at Jubilee Hills. They have very unique collections when it comes to nakshi, diamond jewellery and especially kundan. And the environment is also very calm so wouldn’t mind to sit …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1781",
      "name": "Shree Rai",
      "rating": null,
      "text": "Krishna Jewellers has a variety of options and designs. They are competitive with their pricing too. Their staff is extremely courteous and they take good care of their customers. We were serviced by Ms. Priya. She was very patient and understood our taste very well. We had an overall good experience.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1782",
      "name": "Shreya 14",
      "rating": null,
      "text": "Had a very nice experience at Krishna. They have unique models, and Loknath garu has been pretty helpful! In general, there’s great hospitality at the store.",
      "date": "",
      "displayDate": "Edited 8 months ago",
      "relativeDate": "Edited 8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1783",
      "name": "Shreya Ramesh C",
      "rating": null,
      "text": "Visited the store from Chennai seeing the collection online! In person also the collections are beautiful! Mr. Vinay in the diamonds section was very kind and helpful …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1784",
      "name": "Shruhith Prem",
      "rating": null,
      "text": "Very good customer service from Yadav and Nagarjuna. Made our selection process much easier and helped us get the right designs we were looking for.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1785",
      "name": "Shruthi Reddy",
      "rating": null,
      "text": "Had a great experience at Krishna jewellers.Ramadevi mam helped us through out purchase process.",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1786",
      "name": "Shubham Gupta",
      "rating": null,
      "text": "Very nice collection and extremely helpful staff. Ramesh Ji helped us patiently in making the purchase.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1787",
      "name": "Shuchi Modi",
      "rating": null,
      "text": "Thank you so much Rajshree ma'am for making my online shopping experience with Krishna Jewellery truly exceptional! I'm thrilled with the lightweight and budget-friendly jewelry pieces I purchased. …",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1788",
      "name": "Shwetha M",
      "rating": null,
      "text": "I orderd lakshmi idol on 18th through online...from banglore..first time very doubtIy & scared to ordered...after that talk to them felt good and gave a order finallay received my Lakshmi idol yesterday May I compliment you on the …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1789",
      "name": "Shwetha Reddy",
      "rating": null,
      "text": "Silver section in Krishna jewellers has the best collections. The shopping experience is amazing with Ramalakshmi. She understands and helps in right selection with lot of patience. …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1790",
      "name": "silpa Dasari",
      "rating": null,
      "text": "Very good service and good collection. Satish salesman was to good in assistance",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1791",
      "name": "Sin Li",
      "rating": null,
      "text": "If you looking for unique collections of any diamond jwellery this is the best place ….Sai Kumar from sales executive just exclusive items showed us .. with lot of patience .. we truely appreciate his actives .. he making our shopping very easy",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1792",
      "name": "sindhu chowdary",
      "rating": null,
      "text": "Best place to Purchase jewelry. Loved the collection and service. Yadava, Naresh - both of them are helpful and they showed the collection with lot of patience. Thank you.",
      "date": "",
      "displayDate": "Edited 7 months ago",
      "relativeDate": "Edited 7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1793",
      "name": "Sindhu Komati",
      "rating": null,
      "text": "We were warmly greeted by all members at Krishna Jewellers. Loknath was very helpful by providing the best customer service. Him and his colleagues patiently showed us all their latest designs according to what we had in mind, helping us find a piece that we truly adore. Would recommend this jeweller!",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1794",
      "name": "sindhu reddy",
      "rating": null,
      "text": "The online shopping experience of krishna jwellers was really good. Staff were very professional, especially Rama who helped me with lot of suggestions for my customized earings. She was very patient in explaining all the details that I …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1795",
      "name": "Sindhuja Adidela",
      "rating": null,
      "text": "We had great experience shopping in Krishna jewellers, pearls and gems. Price is reasonable and there is good collection of jewellery. Good customer experience. Rajesh has shown us many jewellery models with soo much of patience.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1796",
      "name": "Sindhuja Reddy",
      "rating": null,
      "text": "I like the way they treat customers specially priya Thanks for this nice collection and your hospitality",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1797",
      "name": "Sindhura Tangutur",
      "rating": null,
      "text": "Mr srinivas and Mr Venkatesh helped us with the items we need. I have beed visiting yhe store for the past 6 years. Each time we see new and authentic collection. I personally prefer Krishna Jewellers at Jubilee hills, Hyderabad.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1798",
      "name": "sindu reddy",
      "rating": null,
      "text": "Hello \"Krishna Jewellers\" I Would like to appreciate online sales person j.guravaiah for the wonderful time he gave me in showing the items at store. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1799",
      "name": "Sireesha Rani",
      "rating": null,
      "text": "The overall experience is very good. Prasanna is very good and she shown us the designs with patience and helped us to select the best price..",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1800",
      "name": "sireesha sannayala",
      "rating": null,
      "text": "Had a great experience at Krishna jewellers g s yadav was very helpful and explained everything clearly really appreciate is support",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1801",
      "name": "Siri C",
      "rating": null,
      "text": "Great experience with this store and with the team assisting us! Bharath and team was very patient in showing us all the pieces, loved shopping here and very reasonable prices. Highly recommend!",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1802",
      "name": "Siri K",
      "rating": null,
      "text": "Good products maha lakshmi service good",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1803",
      "name": "Sirichandana Divakala",
      "rating": null,
      "text": "It's a great experience shopping with Krishna Jewellers. Pavani has assisted very well and gave us a decent discount on our purchase. There are wide variety of collections here.All contemporary jewellery available here at Krishna Jewellers",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1804",
      "name": "Sirisha Akula",
      "rating": null,
      "text": "Absolutely amazing collection and great prizes. Probably the best in the city. Had an excellent experience because of Mr. Sai Kumar’s assistance. Do yourself a favour and ask for Sai Kumar to help you out in your next visit! Lovely experience 😄 …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1805",
      "name": "Sirisha C",
      "rating": null,
      "text": "We visited the Jubilee Hills store for the first time and it has been an amazing experience. Mr. Guruvaiah has been very helpful. Will recommend the store for sure and will be visiting again.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1806",
      "name": "Sirisha Noone",
      "rating": null,
      "text": "Meenakshi garu was amazing in showing different collections. We loved the diamond collection .. so many options to choose from.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1807",
      "name": "SIRISHA TRADE WINGS HYD",
      "rating": null,
      "text": "Mallikharjun is a very good staff. Very patiently he showed us al items. Cooperative and informative. Thanks",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1808",
      "name": "Sirisha Uppala",
      "rating": null,
      "text": "They have very unique collection and always impressed with the designs and the artwork. Very nice staff, and swamy is the person who helped us in showing them very patiently. You will definitely feel satisfied for the money u spent. My best …",
      "date": "",
      "displayDate": "Edited 4 years ago",
      "relativeDate": "Edited 4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1809",
      "name": "Siva Gayathri",
      "rating": null,
      "text": "Has lots and lots of new designs and staff were very helpful. Loknath was very patient in explaining every details of the ornaments and were showing all the models.Very happy Shopping here",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1810",
      "name": "Siva Kanumuri",
      "rating": null,
      "text": "Loknath & Mahesh are the best Salespersons. They detailed us for everything we asked for. They have lot of Patience and that's what a best salesperson need. Overall experience is so awesome. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1811",
      "name": "SIVA KUMAR LUGALAPU",
      "rating": null,
      "text": "R.Satheesh Nice experience with politeness and product explanation",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1812",
      "name": "siva nagaramya",
      "rating": null,
      "text": "I recently visited the gold shop for purchase of 2lak gold.But the support of executive Mr.vekat is very nice and he give best suggestions to me.the way of treating customer's is very nice.venkat's professionalism and knowledge about the prices is very well.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1813",
      "name": "siva rama krishna Devabakthuni",
      "rating": null,
      "text": "I am so happy with their service and I really had a good experience with them, they really have wide range of collection. I was assisted by Rama Devi she is so friendly and patient.Thanks you😊 …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1814",
      "name": "sivakumar Konduru",
      "rating": null,
      "text": "We came today to buy jewellery item. Sandeep has helped us well. He had lot of patience and shown all possible options. We are very happy with the collection",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1815",
      "name": "sivanandini neelam",
      "rating": null,
      "text": "The experience at Krishna jewellers Jubilee Hills is exquisite. Employee yadav is so polite and patience in explaining the ornaments. Also the collection here is too good as this type of ornaments are not available in another stores of …",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1816",
      "name": "Sivaram Chowdary Paladugu",
      "rating": null,
      "text": "JI just visites the place once with my cousins and after that I became a regular customer to them. The way they recieve the customer, the way they exhibit to you, the models they exhibit are always good. I recommend 5/5 for a new customer. …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1817",
      "name": "Sivasankar Reddy",
      "rating": null,
      "text": "Had a great experience at Krishna Jewellers. They have many designs at different prices and good service provided by Venkatesh through his expertise in explaining designs",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1818",
      "name": "Sk",
      "rating": null,
      "text": "I recently purchased gold Jewellery from Krishna Jewellers.I have worked with Sales contact Riaz khan Garu through online video shopping.I am very happy for the service and received international shipping very fast and secure.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1819",
      "name": "SKLSLORRYSERVICE us",
      "rating": null,
      "text": "Nice and unique collection very kind and staff Sathya madam",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1820",
      "name": "Smita Reddy",
      "rating": null,
      "text": "Shopping at Krishna jewellers felt awesome with plenty of collection and staff members received well .Thank you so much",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1821",
      "name": "snidha",
      "rating": null,
      "text": "Had a good experience and I like the collection in the store. Whenever I walk-in has a warm welcome and if I need any models Pavani shares the latest collection whenever I message her in what’s app.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1822",
      "name": "sofia alisha",
      "rating": null,
      "text": "Namdev is very skilled it's my first time to buy diamond hw told me each n every details so well now I know how to buy diamonds n got a lot of information about Diamond very happy to come n experience this thank you Namdev ji ..",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1823",
      "name": "soma sekhar",
      "rating": null,
      "text": "This store have wide range of collections starts with light weight. Pavani showed us the collection and has very patience to show every item which helped us to purchase the item. Overall we had a great experience and came out with satisfaction. Will definitely visit again and recommend to others as well",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1824",
      "name": "Sonali M",
      "rating": null,
      "text": "Loknath and Sarvesh helped us in shopping, they have lot of patience.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1825",
      "name": "Sonalisa Mohanty",
      "rating": null,
      "text": "This place is a Gem , wide variety of selection and a one stop shop . The staffs are also very polite . Thanks to R satheesh for overall experience",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1826",
      "name": "Sonu",
      "rating": null,
      "text": "We purchased gold haram nicedesins pawan",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1827",
      "name": "Sony",
      "rating": null,
      "text": "Great service! Pawan was very polite and helpful. He explained everything clearly and made the purchase smooth. Highly recommend!”",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1828",
      "name": "sony reshu",
      "rating": null,
      "text": "We made a purchase recently at Krishna pearls. Collection is really nice. Salesmen Saikumar showed us the entire collection with patience. MD Nayeem sir gives the best discount. He is really a nice person.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1829",
      "name": "Soujanya Manda",
      "rating": null,
      "text": "I had a wonderful experience at Krishna Jewellers. Santoshi, Sunitha and Pasha toon exceptional care of us. And we found amazing designs",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1830",
      "name": "Soujanya V",
      "rating": null,
      "text": "Wonderful designs and staff was very friendly and have lot of patience Especially Mr Yadav was a marvelous person.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1831",
      "name": "Soumya Ivaturi",
      "rating": null,
      "text": "I bought a diamond ring for my birthday. Rama Devi Garu helped us with the purchase and she was very patient and took time to explain everything with us.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1832",
      "name": "Soumya Nagavarapu",
      "rating": null,
      "text": "They know who their customers are and they very closely understand the needs and provide us as per our specifications and I recently did a online purchase and the product turned out to be excellent",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1833",
      "name": "soumya soumi",
      "rating": null,
      "text": "Great jewellery collection. Bheem was very patience and explained all details very clearly. It’s a hassle free experience. Highly recommend.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1834",
      "name": "sowbhagya",
      "rating": null,
      "text": "Very decent and elegant collection, Good service by Pavani , very patient and well explained. Must visit.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1835",
      "name": "Sowjanya Basireddy",
      "rating": null,
      "text": "Today I went to Krishna jewellers and bought vaddanam. Vaddanam I liked was not available and they offered me for custom made. I am a foreign customer, came for wedding and they went above and beyond to help me. They offered me a loaner …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1836",
      "name": "Sowjanya Karthik",
      "rating": null,
      "text": "Srikanth was really helpful and showed amazing jewelry. Abhimanyu and Srikanth were helpful throughout the end to end process.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1837",
      "name": "Sowjanya Munni",
      "rating": null,
      "text": "Mr. Yadav's Sarves was good And the collection is also good 😊 …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1838",
      "name": "Sowjanya nuti",
      "rating": null,
      "text": "I personally love their design! And amazing service by Meenakshi! Just the right place if you want amazing diamond jewellery",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1839",
      "name": "Sowjanya Oruganti",
      "rating": null,
      "text": "I really appreciate the support Rakshita provided, all through the purchasing. Very reliable and prompt with her answers and would love to work with her in future.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1840",
      "name": "sowmini guntoju",
      "rating": null,
      "text": "Vinay has been very kind and patient. He ensured that got the item within the price range that we are looking for. Overall, we liked the designs and experience at Krishna jewellery and pearls..",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1841",
      "name": "Sowmya Manchana",
      "rating": null,
      "text": "I had a great experience shopping at Krishna Jewellers. They have a very good collection of jewelry. Staff was very supportive especially Ramadevi. She helped me choose a perfect one.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1842",
      "name": "Sowmya Manne",
      "rating": null,
      "text": "Good collection. Very friendly staff. Rama devi helped share the recent collection over Whatsapp and was very helpful in store as well. She understood our preferences quickly and showed jewelry accordingly",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1843",
      "name": "Sowmya Yella",
      "rating": null,
      "text": "I came across Krishna Jewellers in Instagram and noticed that they have huge collection of jewelry. I live in the US, so I contacted them via phone. The staff was really helpful. They were very patient and spent lot of time to show the …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1844",
      "name": "Spandana Menta",
      "rating": null,
      "text": "Excellent service provided by the store, staff members are friendly and attentive for the customers. Especially Mr.sarvanappa provided excellent service. Very much satisfied.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1845",
      "name": "Spurthi Reddy",
      "rating": null,
      "text": "Krishna has great designs and must visit for jewellery shopping for any occasion. Mallikarjun was a very attentive sales executive and kept us entertained through out the shopping experience.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1846",
      "name": "Sr Konda",
      "rating": null,
      "text": "Krishna Jewellers has unique designs and variety of collections. Customer rep Sravan is very helpful and detail oriented. He is very knowledgeable and gives quick responses by phone. We will continue to shop at Krishna Jewellers as we are confident that they are just a phone call away. Thank you Sravan for your great service!!!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1847",
      "name": "Sravan M",
      "rating": null,
      "text": "The products here are amazing especially the diamond ornaments.The hospitality here such as the food and service is just magnificent. The worker who showed us the ornaments J.Mahesh is so kind, friendly and knowledgeable. Overall we had a …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1848",
      "name": "Sravani Guda",
      "rating": null,
      "text": "I love the collection.there are wide range of Collections..sales executives Maintains customer friendly relationship ...sales executive her name is \"sandhya rani \"she showed us awesome collection..we purchased necklace in this shop..I liked it very much..",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1849",
      "name": "sravani kalluri",
      "rating": null,
      "text": "Hospitable, Mr. Sai Kumar was very patient and customer friendly and helped us in finding what we expected without any rush",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1850",
      "name": "Sravani Kandamuru",
      "rating": null,
      "text": "I recently visited this jewellery store at Jubliee hills that truly impressed me! The selection of pieces was stunning, featuring everything from elegant necklaces to intricate rings. Thanks to Loknath sir who is incredibly knowledgeable …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1851",
      "name": "Sravani Nadendla",
      "rating": null,
      "text": "Very good collection and amazing service to go with. Support staff especially Prasanna whom we worked with has been very patient and answered all our questions. She was very knowledgeable and instrumental in decision making process.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1852",
      "name": "sravani V",
      "rating": null,
      "text": "We have been the customers for Krishna Jewellers from last 6 years. They have amazing collection and their service is extra ordinary. Sivaji from sales team has been very patient and courteous. Excellently provided the support and service. …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1853",
      "name": "Sravani V",
      "rating": null,
      "text": "We have been the customers of Krishna Jewellers from last 10 years. It's always been a wonderful experience shopping jewellery. It has got wide varieties and unique collection. Service is at top notch here. Staff Sandhya Rani has been very patient, polite and has provided great service. Must Visit....",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1854",
      "name": "Sravanthi Allumwar",
      "rating": null,
      "text": "Sandhya rani was very helpful with finding our preferred sets of jewellery. The sets and designs were both beautiful and unique...was an unforgettable purchase.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1855",
      "name": "Sravanthi Anne",
      "rating": null,
      "text": "I recently bought diamond jewelry from Krishna, the service is good, staff person Gururaj is very patient and helpful in showing the diamond designs that we asked",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1856",
      "name": "Sravanthi Gowlikar",
      "rating": null,
      "text": "very good quality and Govind was really patient and provided great service, he showed us great pieces from the collection, and was good at giving expert advice as well. Would definitely recommend other people to come here.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1857",
      "name": "Sravanthi Gupta",
      "rating": null,
      "text": "One of the best collection you'll get in Hyderabad. Salesperson Loknath helped us pick the correct piece in less time.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1858",
      "name": "Sravanthi Reddy",
      "rating": null,
      "text": "First visited jewellery, very nice collection and beautiful design and prices are also reasonable,. Must buy jewellery shop in hyd. Free shiping inida and us available. Code. VT",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1859",
      "name": "Sravya",
      "rating": null,
      "text": "I visited the store and had a great experience via video call. Thanks to Rajesh garu for his help showing a few collections patiently, and I'm satisfied with the product.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1860",
      "name": "Sravya Bade",
      "rating": null,
      "text": "Had a good shopping experience with sateesh",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1861",
      "name": "sravya kmalectures",
      "rating": null,
      "text": "We visited Jubilee hills store and the kundan with pearls collection was very good and the staff especially Yadav has showcased and explained in the detailed manner. …",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1862",
      "name": "sravya reddy",
      "rating": null,
      "text": "Good collection, wide ranges in all categories. Mrs. Ganga Bhavani is of a great help for purchase for us. She was patient and explained the details well. …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1863",
      "name": "Sravya Reddy",
      "rating": null,
      "text": "Very good collection with reasonable price. Staff Sandhya garu assists us always and is very patient in showing the collection",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1864",
      "name": "Sravz V",
      "rating": null,
      "text": "Worked with Pavani and Bharath for several purchases over the past year. They’ve been very welcoming and have done their best to work with us and meet all of our needs.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1865",
      "name": "Sree Deepu",
      "rating": null,
      "text": "We recently visited Krishna Jewellery and had the pleasure of being assisted by Sandhya Rani. She was incredibly helpful and knowledgeable about their jewelry collection. Sandhya patiently guided me through their selection, showcasing …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1866",
      "name": "SREE JALADI",
      "rating": null,
      "text": "Ramadevi has shown a fantabulous pieces and we were very much satisfied with the collection and recommend to others",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1867",
      "name": "Sree Latha",
      "rating": null,
      "text": "Collection are. Models are awesome good pavani show very well we purchased gold tops",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1868",
      "name": "Sree Mandapati",
      "rating": null,
      "text": "Nice jewellery store. It has large and variety of designs to choose. One of their executive Mr. Sandeep understood my requirement exactly and showed appropriate models and saved our time. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1869",
      "name": "Sree Pasumarthi",
      "rating": null,
      "text": "Nice customer service, great collection, quickly brought pieces based on descriptions, and was overall a welcoming environment. Check this place out next time you are in Hyderabad!",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1870",
      "name": "Sree Vaishnavi",
      "rating": null,
      "text": "Had a good service. The employees received well. The employee who guide me was Rekha she was very patience.",
      "date": "",
      "displayDate": "Edited 11 months ago",
      "relativeDate": "Edited 11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1871",
      "name": "Sree Yelgam",
      "rating": null,
      "text": "They have a ton of collection one could choose from. Akshaya was our sales person, she was very nice with us and did an excellent job showing us latest Jewellery collection. She spent almost 4 hours with us patiently showing us best designs.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1872",
      "name": "Sreedevi Ponasanapalli",
      "rating": null,
      "text": "Yadav garu shows nice collection and he has really good patience .",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1873",
      "name": "Sreedhar Bukya (Siddu)",
      "rating": null,
      "text": "Krishna Jewellers Pearls & Gems. We have been watching the videos on YouTube and Instagram and my wife specially like this place. The collection is the one of the very unique in the Hyderabad. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1874",
      "name": "Sreeja Chegondi",
      "rating": null,
      "text": "I visited Krishna jewellers for temple gold bangles and sales person Sravan Kumar Singh helped me in showing all the collection they have. He understood my requirement clearly and showed me a very good collection. The staff were very …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1875",
      "name": "Sreela Karlapalem",
      "rating": null,
      "text": "Amazing experience @ Krishna Jewellers, Jubilee Hills. I strongly recommend the sales persons - Shivaji and Rekha. They have done a great job showing the jewellery. The store manager, Shiva Kumar, gave us the best deal.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1876",
      "name": "Sreelakshmidevi maddika",
      "rating": null,
      "text": "My recent experience in Krishna jewellers hyderabad , Jubilee Hills was extremely satisfying .we found some bangles here that was good and satisfying Thanks to Malikarjun garu who was attentive to our request and he was helpful, knowledgeable and patience with answering questions in showing us latest designs..",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1877",
      "name": "sreenivas reddy GB",
      "rating": null,
      "text": "Very happy with the store’s wide range of Kundan and diamond jewellery. Bheem showed us the exclusive collection",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1878",
      "name": "Sreevani Tummala",
      "rating": null,
      "text": "Thank you Ramya and Rekha for the wonderful customer service! I had a great experience shopping with Krishna Jewellers, thanks to Rekha! She is very understanding and was able to find/show me jewellery that I liked and in my budget range. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1879",
      "name": "sri kanth",
      "rating": null,
      "text": "Great service by mr. Sai Kumar. The experience was great as well.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1880",
      "name": "Sri Lakshmi",
      "rating": null,
      "text": "I and wife are visiting krishna jewellers pearls and Gems for the last 15 years.the one gold and diamond the wide variety of designs.the hospitality that we receive is awesome.Nayeem Garu is a very professional that we always cherish to …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1881",
      "name": "sri lalitha sri lalitha",
      "rating": null,
      "text": "Nice and exclusive collection…. Sateesh has shown all the latest designs as per the requirement…. I’m very happy with the purchase",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1882",
      "name": "Sri Nitya",
      "rating": null,
      "text": "Very nice collection. Mr. Loknath was incredibly helpful in assisting me with my recent purchase.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1883",
      "name": "sri p",
      "rating": null,
      "text": "I had a wonderful experience at Krishna Jewellers in Jubilee Hills. Sarvesh was extremely helpful and showed me a really good collection with patience and detailed explanation. The jewelry designs are elegant and unique, and the staff overall were very courteous and professional. Highly recommended.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1884",
      "name": "Sri Satya",
      "rating": null,
      "text": "Really liked the different nakshi designs in this store. Pavani was very patient and was helpful throughout the process.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1885",
      "name": "Sri seerapu",
      "rating": null,
      "text": "Sateesh is very helpfully and well patient with customers. Honest and truthfully opinion is his best approach",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1886",
      "name": "Sri Sri",
      "rating": null,
      "text": "Excellent quality of diamonds and trending collection , exceptional customer service , especially Sunil and his team was great support throughout the process. Thank you.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1887",
      "name": "sri vaishnavi",
      "rating": null,
      "text": "Krishna jewellers never fails to satisfy customers. Their hospitality is very good. Special mention to sandeep garu who’s taken very good care of us showing variety of collections at reasonable prices. I’ll be forever customer to them! Special mention to mr. mallikarjuna for assisting us",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1888",
      "name": "Srichandana",
      "rating": null,
      "text": "were assisted by Mr Ch.venkat very pleasant and personable makes it a memorable experience. Highly recommended a visit at Krishna jwellers here you will be sure to return. They don't treat you like customers but like old friends. Glad to have visited here!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1889",
      "name": "sridevi parna",
      "rating": null,
      "text": "Excellent collections and excellent service by meenkashi, made my shopping ease",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1890",
      "name": "Sridhar Munjuluri",
      "rating": null,
      "text": "Amazing customer service and knowledge on the topic of gold, thanks a lot to SAINATH garu for the the help. Superb collection and designs at the Jubilee hills would strongly recommend for gold shopping",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1891",
      "name": "sridhar reddy",
      "rating": null,
      "text": "Today I visited srikrishna jewellers jubllie hills. Service was amazing and especially employee Bharath chandra having lot of patience spend time with family showing all type of diamondset and we were able to do some purchase.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1892",
      "name": "Srihari N",
      "rating": null,
      "text": "Very beautiful collection what they have here. We have occassionally bought jewellery here and have always felt very happy and satisfied. Sales executive Sai Nath has been very polite and patient in showing the collections. His suggestions are also very insightful.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1893",
      "name": "Srija Reddy",
      "rating": null,
      "text": "Beautiful collection Excellent staff Recently purchased bridal gold jewellery….quality and designs are very …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1894",
      "name": "Srija Srija",
      "rating": null,
      "text": "Very nice designs and satisfied with their unique collection. Customer representative Bharat was very patient in explaining the details. Mr. Chary and Store Manager provided us a good service. We had a great shopping experience at Krishna …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1895",
      "name": "Srikanth Muvva",
      "rating": null,
      "text": "Excellent experience! Very happy with the products that we purchased through video call shopping. The service was excellent and staff very friendly, thanks to Naresh for helping us in online shopping, he is very knowledgeable about products …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1896",
      "name": "Srikanth Sagi",
      "rating": null,
      "text": "Very energetic, helpful, excellent service. Eager to show everything and had a good analysis on what we wanted. Best customer service! Pavani",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1897",
      "name": "Srikanth Sri",
      "rating": null,
      "text": "We purchased gold haram collection is very nice and your salesman Priya she has very such a polite manner she have very patience",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1898",
      "name": "srikanthrao sagi",
      "rating": null,
      "text": "Customer service is excellent. Ramadevi helped us very well in the selection of jewellery.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1899",
      "name": "Srilatha Reddy",
      "rating": null,
      "text": "Naresh was very cool and nice person . We need to appreciate him for his patience, working skills , explaining , showing each item patiently and the way he communicates with customers was too good . This type of people will help for business advertisement and growth😊😊 …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1900",
      "name": "Srilekha Kankanala",
      "rating": null,
      "text": "I came here for my wedding shopping. Pavani helped me in each and every step. Great service from Pavani. She was very patient and very responsive. Store got huge collection of gold and diamonds. I totally recommend coming to the store",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1901",
      "name": "srimathi shankar",
      "rating": null,
      "text": "Iam one of the oldest customer with Krishna jewellers and almost like their family… get always what I want and alway ever satisfied. Recent purchase have been awesome experience and the salesperson Mr. Venkatesh has been wonderfully …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1902",
      "name": "Srinath Thirupari",
      "rating": null,
      "text": "Had a great experience at Krishna Jewellers. They have many designs at different prices. We went with a clear budget but not specific design in mind. Mr. Kushal showed us so many pieces patiently before we finally picked one. Clearly …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1903",
      "name": "Srini Reddy",
      "rating": null,
      "text": "Hi, I am from Sydney and I’ve had the pleasure of purchasing items online from the Jubilee Hills Krishna Jewellery store. I was served by Venkatesh & Prakash from their store. They made the entire process seamless and efficient. They were …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1904",
      "name": "srinivas bingi",
      "rating": null,
      "text": "Excellent collection and excellent service 👌 Thanks to Sravan Kumar Singh for his knowledge of the products, his enthusiasm …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1905",
      "name": "srinivas goud",
      "rating": null,
      "text": "Krishna jewellery has good collection. Sunita salesperson helped us patiently",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1906",
      "name": "Srinivas Manda",
      "rating": null,
      "text": "Yadav given very excellent service. We are very happy for showing nice collections. We are very impressed his attitude and service. Thanq",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1907",
      "name": "Srinivas Polu",
      "rating": null,
      "text": "Store has good diamond collection and sales person Maha Lakshmi understood our requirements quickly to close the sale",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1908",
      "name": "Srinivas Reddy",
      "rating": null,
      "text": "Had an amazing experience, special credits to Sai Kumar for his patience and time",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1909",
      "name": "SRINIVAS REDDY BURUJU",
      "rating": null,
      "text": "So many models and good sales executive,Srikanth was so delighted to help",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1910",
      "name": "Srinivasarao G",
      "rating": null,
      "text": "It was nice experience with krishna jewellers and especially bheem supported very well Thank you.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1911",
      "name": "Srinivasarao Gadde",
      "rating": null,
      "text": "When my family had visited India in February, my wife and daughter visited Krishna Jewellers Pearls & Gems, talked to Sai Reddy and Srikanth, and selected Jewelry. After my family returned to United States, I contacted Sai Reddy. He gave …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1912",
      "name": "sripal reddy",
      "rating": null,
      "text": "R Satish was v good in providing service",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1913",
      "name": "sripathi rao kolamaddi",
      "rating": null,
      "text": "Good customer service by sai Kumar",
      "date": "",
      "displayDate": "3 months ago",
      "relativeDate": "3 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1914",
      "name": "sriram kumar",
      "rating": null,
      "text": "Very good collection and good customer service from R Satish. Recommend this store at Jubliee hills if you are planning for gold / diamond ornaments",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1915",
      "name": "Srisailam Goud",
      "rating": null,
      "text": "Nice collections Excellent service by Govind🤝 …",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1916",
      "name": "Srishti Sharma",
      "rating": null,
      "text": "Mr. G. Praveenkumar gave us such great service! Will definitely be coming back for more spends!",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1917",
      "name": "Srithan Vemuganti",
      "rating": null,
      "text": "Collection are good designs are awesome pavani very help me to purchase haram",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1918",
      "name": "Srivalli Thiyyagura",
      "rating": null,
      "text": "Sales team is very helpfull and shows new models, spend time to make us happy. Very competitive prices. Especially Sandeep sales person is very knowledgeable and have a lot of patience, answer all our questions.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1919",
      "name": "Srrinivas M",
      "rating": null,
      "text": "The service is truly extraordinary. Rajesh who attended my order was from beginning helping me to choose the best. I was felt a great and valued customer when I stepped the store. Never disappointed on the service. I recommend the store and hence sharing my experience. My choice is Krishna Jewellers. Thank you.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1920",
      "name": "Srujan BILLA",
      "rating": null,
      "text": "Great collection. Amazing customer service provided by Mahesh and his staff at jubilee hills location. Mahesh is one guy who has all the answers. Customer focused sales person who would ensure customer satisfaction from sales through end of transaction. Thanks Mahesh and team.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1921",
      "name": "Srujana Reddy",
      "rating": null,
      "text": "Models r good . Mr Bharath has shown us various mod ls as per our requirement",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1922",
      "name": "Srujana Reddy",
      "rating": null,
      "text": "We had a wonderful gold shopping experience, thanks to Govind’s excellent assistance. He was incredibly helpful throughout the process!",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1923",
      "name": "srujitha dangeti",
      "rating": null,
      "text": "I always like to do shopping here bcoz of the staff response and unique designs.. So when i have visited recently a person named Nagarjuna received us well and showed good collections, we felt happy for that.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1924",
      "name": "sruthi maidala",
      "rating": null,
      "text": "Had the most amazing experience. Service excellent throughout. A must visit place. Team Lead Kushal is soo polite and helpful.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1925",
      "name": "subhash Reddy Dunthula",
      "rating": null,
      "text": "Wide range of good collections and unique designs. Customer rep Bhavani was vary pairent to show the models and explain details. Much appreciated the service by her. Overall good experience in diamond Jwellery shopping.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1926",
      "name": "Suchithra Ramachandran",
      "rating": null,
      "text": "Krishna jewellers had really Good collections and their hospitality was exceptional. Srikanth and Lakshmi GRA really helped us out to check out the collections and finalize the product. Highly recommend shopping here",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1927",
      "name": "Sudha B Rani",
      "rating": null,
      "text": "I had very good experience with Krishna jewellery Hyd . Riaz helped so patiently in showing the jewellery and explaining the latest models , and he understands quite well abt our taste and shows accordingly. They have exclusive jewellery and gives us the best market price . And online delivery was Soo smooth . Thanq once again",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1928",
      "name": "sudha p",
      "rating": null,
      "text": "Vinod is amazing and showed different designs with patience and always with a smile .",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1929",
      "name": "Sudha Parimi",
      "rating": null,
      "text": "impressed with their online videos showing clear view of jewellery and contacted one of the staff member Mahesh garu and later Ajay garu and they both asked me to visit their store and promised they can give best pricing. Before leaving …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1930",
      "name": "Sudha rani Penmetsa",
      "rating": null,
      "text": "Very Fine And Rich Collection They Have,,, Must Visit Once, They Surely Make U Satisfy With Their Good Assistance, I Am Feeling Happy After Shop From This Place in Bhimavaram exhibition Sales Person Mr. Rahul",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1931",
      "name": "Sudha Ravula",
      "rating": null,
      "text": "I came across Krishna Pearls store on instagram and decided to come here when i visited India. Sandeep is the one who helped me there and he was very helpful and suggested me alot of varieties knowing my taste. He truly knows what a …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1932",
      "name": "Sudha T",
      "rating": null,
      "text": "It's a great experience shopping. Finally we are got what we are looking for. After lot of jewellery shops we visited and got what we are looking. The collection is so good and lot of varieties on necklace sets. I loved shopping. Nagarjuna assisted us very well and helped us to show lot of items. Thank you.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1933",
      "name": "Sudhakar D",
      "rating": null,
      "text": "A delightful visit n such a wealth of jewellery available. Sandeep provided outstanding service n helped us select a simple yet elegant Necklace n Bangle’s that will help make us memorable. I personally appreciate your sales executive …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1934",
      "name": "Sudheer Kumar Meesala",
      "rating": null,
      "text": "Very good collection; Pawan has been very helpful in guiding and explaining the right product meeting our requirements",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1935",
      "name": "Sudheer Mishra",
      "rating": null,
      "text": "R Satish was very polite and nice and attended the customer's request. I appreciate his excellent service.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1936",
      "name": "Sugandha Agirishetti",
      "rating": null,
      "text": "Thank you Krishna Jewellers for making my first overseas shopping experience worry free and wonderful right from jewelry selection to delivery. Both Srikanth, Pavan answered our questions with patience and helped me in choosing the jewelry of my choice within my budget. Look forward for shopping again at Krishna Jewellers.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1937",
      "name": "Sujana Reddy",
      "rating": null,
      "text": "As we all know Krishna jewellers have beautiful collection. On top of that, their customer service is excellent. Especially Ramadevi is too good at suggesting jewellery and she takes care of you in each and every step. I had an amazing experience with her.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1938",
      "name": "Sujatha Gorantla",
      "rating": null,
      "text": "I am very happy with their models n service. Priya helped us, she was patient n fast.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1939",
      "name": "Sujatha Lenkala",
      "rating": null,
      "text": "Meenakshi is very nice, and she took care of mine and my families purchases before.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1940",
      "name": "Sujatha Vegendla",
      "rating": null,
      "text": "I came here for the first time.. sales executive Venkatesh helped us getting the right choice. They have updated gold collection and good Pearl collection. Looking to come forward again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1941",
      "name": "Sukumar Rao",
      "rating": null,
      "text": "Every jewel piece in krishna jewellers is one of its own kind such stunning jewellery every one should visit this showroom to purchase jewelry and the staff Bharat guruviaha dinaker extra ordinary in receiving customers and giving best explanation",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1942",
      "name": "Sulekha reddy",
      "rating": null,
      "text": "I've purchased my jewellery from Krishna and it was a great experience and the staff ( Meenakshi) helped a lot.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1943",
      "name": "Sulokna Das",
      "rating": null,
      "text": "By far Krishna jewellery has been my favourite place, not just they have beautiful collection but also there stuffs specially Yadav have shown so much patience with me. Thank you and keep up the good work.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1944",
      "name": "suma n",
      "rating": null,
      "text": "Krishna Jewellers and Pearls have an amazing collection and great designs which I could not find at other jewelery stores. Apart from their great product, their sales team helped us a lot in the process especially Venkatesh who showed us …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1945",
      "name": "Suma Reddy",
      "rating": null,
      "text": "We had a wonderful and pleasant shopping experience here. Sales executive Bharath is very customer friendly and patient. He was very helpful with our purchase.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1946",
      "name": "Suma Reddy",
      "rating": null,
      "text": "Iam Suma Chintalapani mother of Miss komal who purchased diamond sets for her engagement nd marriage We are much satisfied with the product, service of your staff especially …",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1947",
      "name": "Sumayya S",
      "rating": null,
      "text": "Kushal has been really awesome to deal with. Made our experience so much better. We will comeback and ask for Kushal again. Overall good collection.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1948",
      "name": "Suneela Mandiga",
      "rating": null,
      "text": "Rama Devi garu as usually given the best service with great patience and serenely shown the requested jewellery. Her detailed explanation helped me a lot Thank you",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1949",
      "name": "Suneetha Valluri",
      "rating": null,
      "text": "Mr. Sravan has been very helpful and patient throughout the selection process, guiding us in finalizing the item that we actually wanted instead of being pushy. Nice to have such sales person.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1950",
      "name": "Sunil Patil",
      "rating": null,
      "text": "Had a wonderful experience. The staff (Loknath) were very helpful and knowledgeable, and they helped me find the perfect jewellery",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1951",
      "name": "Sunil Pullagura",
      "rating": null,
      "text": "Great shopping experience with Sri Lakshmi. Evaluates and understands customers taste well and shows accordingly. Good collection of gold and diamond jewelry",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1952",
      "name": "Sunita Samanta",
      "rating": null,
      "text": "Recently did a purchase from this outlet. The whole staff is very courteous and helpful. They helpede shop from Mumbai through video call showing me variety of jewellery. It was couriered also very quickly. The whole process was very smooth. I trust their quality and like their designs. Will definitely shop again !",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1953",
      "name": "Sunitha Kamulu",
      "rating": null,
      "text": "Bharth and Swamy were absolutely fantastic throughout the entire experience. They were not only incredibly knowledgeable, but also exceptionally patient and kind while answering all my questions and guiding me through the process. Their …",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1954",
      "name": "Sunitha konda",
      "rating": null,
      "text": "Nice collection...by yadav garu i appreciate your follow up dedication to ensuring my satisfaction and and super experience with yadav garu🫶 …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1955",
      "name": "Supraja Kumbam",
      "rating": null,
      "text": "Venkatesh has did a great job in patiently showing the asked jewellery and has been very helpful in finding our favourite pieces of the Nakshi gold collection. I would definitely recommend to take him as your salesperson on your next visit.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1956",
      "name": "Supriya D",
      "rating": null,
      "text": "Amazing designs and variety, quick service and hospitable staff. Suraj ji ensured we have the best experience at the store.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1957",
      "name": "Supriya Godithi",
      "rating": null,
      "text": "Very much welcoming.. thank you SandhyaRani for helping us out..",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1958",
      "name": "Supriya Muthyala",
      "rating": null,
      "text": "Made the first purchase. Sandya Rani was assisting us and she was so patient it was a great experience.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1959",
      "name": "Supriya Reddy",
      "rating": null,
      "text": "Jewellery is so good, Nakshi and kundan collection was excellent. Staff service is pretty impressive especially Kushal, guruvaya, Nayeem and Bharath are polite and respective towards customers. Krishna jewellers at Jubilee Hills is strongly recommended for all types of occasions.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1960",
      "name": "Supriya Yalamati",
      "rating": null,
      "text": "I recently visited the Krishna Jewellers and had an outstanding experience. Mr.Yadav was incredibly knowledgeable, patient, and passionate about helping me find the perfect ornament. He guided me through the various options, explaining the …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1961",
      "name": "suraj Allat",
      "rating": null,
      "text": "We had a very good experience at the store. Good staff and a great variety in ornaments and designs. Pawan assisted us in doing our purchases. He is a very good salesman",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1962",
      "name": "suraj reddy",
      "rating": null,
      "text": "The designs were extremely good. Pavani at the store has been helpful, understood our taste and showed pieces accordingly. All in all a pleasant experience.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1963",
      "name": "Suram Prameela",
      "rating": null,
      "text": "We had a great shopping experience at Krishna jewelers . Thanks to Nagaraju who was very patience in showing us the latest designs. Their collection was simply superb and very trendy I would definitely visit this store again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1964",
      "name": "Surekha Methuku",
      "rating": null,
      "text": "Great customer service from Srikanth reddy and Venket.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1965",
      "name": "Surendra Dodda",
      "rating": null,
      "text": "Great service and collection. Had a very good experience. I found them online by connecting to their online representative Guravaiah. They have showed a variety of collection through video call in WhatsApp. Definitely would recommend them.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1966",
      "name": "surendranath mushyam",
      "rating": null,
      "text": "Bheem is a good sales man with decent attitude and friendly nature and at the same time he is concerned with closing the sales so that customer may not go away without purchase.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1967",
      "name": "Suresh Cherukuri",
      "rating": null,
      "text": "Sales executive Sandhya has done a fabulous job. She is very polite and knowledgeable. We are very happy with her service",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1968",
      "name": "Suresh Ganta",
      "rating": null,
      "text": "Good collection, Wonderful buying experience at Krishna jewels and kudos to excellent customer experience by Sunitha",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1969",
      "name": "Suresh Katta",
      "rating": null,
      "text": "We had a wonderful experience at Krishna Jewellers, thanks to the exceptional service provided by Mr. Sainath. From the moment I walked in, he was incredibly attentive, patient, and genuinely invested in helping me choose the right piece of …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1970",
      "name": "Surigiri David",
      "rating": null,
      "text": "Krishna jewellers pearls I'm visit the first time good response and good looking about the customer. Good at the Krishna jewellers.. …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1971",
      "name": "Sury",
      "rating": null,
      "text": "Amazing diamond collection. Ramadevi garu helped us find the best unique neck piece. Highly recommend the store.",
      "date": "",
      "displayDate": "Edited 6 months ago",
      "relativeDate": "Edited 6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1972",
      "name": "Surya",
      "rating": null,
      "text": "Excellent service by Mr.S.Bharat he was shown very nicely and we will visit again",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1973",
      "name": "surya kumar",
      "rating": null,
      "text": "Sateesh is an experienced sales professional in the gold jewellery, His guidance helps customers make the right jewellery choices.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1974",
      "name": "sushmita k",
      "rating": null,
      "text": "I had a wonderful experience at Krishna jewellers pearls and gems . The collection is absolutely stunning, with a wide variety of elegant and unique designs. A special mention to Chandu, who made the shopping experience even more …",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1975",
      "name": "Sushmitha Marneni",
      "rating": null,
      "text": "Very attentive staff , they have wide range of collections . Mr. Bheem was very pro active and showed us all the varieties according to our requirement.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1976",
      "name": "Sushmitha Valapadasu465",
      "rating": null,
      "text": "Trendy new collection at reasonable prices. Happy to buy jewellery as it is worth every penny. Staff is also very good with lots of patience.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1977",
      "name": "Sushruth Tirunagari",
      "rating": null,
      "text": "I have recently visited krishna jewellery jublee hills stor, i have purchased a dimond chain the sale's person Sandhya Rani was really good and helped me a lot for showing me all the jewels thank youu!!",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1978",
      "name": "Susmitha Chivukula",
      "rating": null,
      "text": "Review from Himabindu as well. Excellent customer service. Mr Mallikarjun has given very good service and had been very friendly with us.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1979",
      "name": "Suvarchala Devi Sura",
      "rating": null,
      "text": "Great collection,quality and Ambience. Very patient staff. Wastage comparably fair and reasonable.I have been a regular visitor over the past few years. Now my friends too prefer purchasing from here.Mr.Vinayak is highly patient, coordinative and provides top class service. Great thumbs up to the store staff and Management.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1980",
      "name": "SV Trendz",
      "rating": null,
      "text": "Just shopped at Krishna Jewellers, Mahesh took great care of us with excellent communication with great respect. Prices are really good, the way he dealt with customers is appreciable. Would recommend to go and purchase. Thankyou , Alekya",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1981",
      "name": "swapna murari",
      "rating": null,
      "text": "I really like the collection have been visiting krishna for more than 5 years now.. thanks to Pavani and k. rahul for making the entire experience smooth",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1982",
      "name": "Swapna Reddy",
      "rating": null,
      "text": "Placed an order with them after video call. Have had a nice experience. Must mention one particular executive by name, Ramya who has been extremely prompt and courteous throughout the process of placing an order, with the payments and also with a small issue during delivery of shipment.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1983",
      "name": "Swapna Rudraraju",
      "rating": null,
      "text": "I am blown by the collection of their products and their amazing customer service. They always make me comfortable and provide up to date communication. Definitely recommend this place . Ch venkat",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1984",
      "name": "Swapnika P",
      "rating": null,
      "text": "We are very satisfied with the service at Krishna Jewelers. Bheem and Lavanya were very professional, helped us find the perfect piece. Appreciate the explanation.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1985",
      "name": "Swarnalatha Tejomurtula",
      "rating": null,
      "text": "The designs are good and customer support is also very good. Please contact Vinod for more friendly approach.",
      "date": "",
      "displayDate": "Edited 10 months ago",
      "relativeDate": "Edited 10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1986",
      "name": "swaroop akkala",
      "rating": null,
      "text": "The rxperience was amazing and the staff was very knowledgeable and patient in assisting especially Ramya was very helpful to find the right ear rings .",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1987",
      "name": "Swaroop Tata",
      "rating": null,
      "text": "We have wonderful experience with this jewel store from last several times and are completely satisfied with their products and services. They have very latest designs and willing to accommodate any changes that my family requested. The …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-1988",
      "name": "Swaroopa Vemula",
      "rating": null,
      "text": "Visited krishna jwellers well satisfied since one year coming regularly. We take bottu haram and jumikies. Well receiving. Excurive name Mr. Venkatesh pleasing personality.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1989",
      "name": "Swarupa Rani",
      "rating": null,
      "text": "Good product knowledge Saikumar no the customer test and he gives as good experience to buying jewellery we will vist store again",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-1990",
      "name": "Swathi Aditya",
      "rating": null,
      "text": "Very good experience..new collections..mallikarjuna garu has shown all the products with so much patience and assisted us very well..",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1991",
      "name": "Swathi Patibandla",
      "rating": null,
      "text": "Awesome collection and Excellent service by the staff. They are very kind and have lot of patience. Nagarjuna and Bharat are very good in showing the latest and trendy collection. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1992",
      "name": "Swathi R",
      "rating": null,
      "text": "Sarvesh and Kranthi are very nice and both are very patience and showed us new collections which made us to buy the jewelry.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-1993",
      "name": "swathisam recovery",
      "rating": null,
      "text": "R sateesh excellent service with good patience and very respectful towards customers.",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1994",
      "name": "swathy Manne",
      "rating": null,
      "text": "Models are very nice and service also. Salesperson Pavani is so nice and I got good collection, I’m so happy 😍. Thanks Krishna Team. …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-1995",
      "name": "Swati Dondapati",
      "rating": null,
      "text": "Had a very good experience buying jewelry online in the pandemic situation. Excellent customer service. Staff were very interactive with the customers and provided every detail. Mrs. Ramadevi helped me very well in this process. Will definitely go and visit the store next time.",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-1996",
      "name": "swati sahu",
      "rating": null,
      "text": "Pasha is very good and polite i like the purchase",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1997",
      "name": "Swetha Eragam Reddy",
      "rating": null,
      "text": "My recent purchase experience with Krishna Jewellers, Jubilee Hills, Hyderabad was extremely satisfying. Thanks to Mr.Sai kumar yadhav,Mr.Ganesh and Mr.Ranjith who was very attentive to our requests/wishes and They were very helpful, …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1998",
      "name": "Swetha M",
      "rating": null,
      "text": "Always a nice time shopping in Krishna jewellers. The staff is very sweet. Thank u Prakash for being very patient in showing is the designs",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-1999",
      "name": "Swetha Nuthalakanti",
      "rating": null,
      "text": "i had a wonderful experience shopping at krishna jewellers jubilee hills. One of the best jewelry store in recent times. Customer service is top notch. Mahesh and Shivaji were very helpful & made me choose the right jewelry.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2000",
      "name": "swetha reddy",
      "rating": null,
      "text": "Highly recommended for the quality and for the reasonable pricing. Mr. Bharath has given us a smooth experience for our bridal jewellery shopping and it’s highly appreciated. Recommended for all the brides.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2001",
      "name": "Swetha Reddy",
      "rating": null,
      "text": "Very good experience And thank u Pavani for ur patience and helping us in everything",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2002",
      "name": "Swetha Samineni",
      "rating": null,
      "text": "We were here to buy a necklace, ended up buying more as the collection is great. Sravan has done a great job showing contemporary styles, being patient and honest throughout the shopping process. Great place to shop jewelry and highly recommend this place!!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2003",
      "name": "Swetha Swetha",
      "rating": null,
      "text": "I visited 2 days well experienced staff especially Mr. Prakash and Mr. Mahesh sir very friendly and good of there ideas , as well as suggestions in there best scheme I am very more happy that in good best jewel I purchased for nearly 13 …",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2004",
      "name": "swetha yalla",
      "rating": null,
      "text": "We’ve been working with Krishna Jewelers for 6 plus years. We have always been satisfied with their unique collection and comfortable price. We have worked with Rama Devi who shows us what we are looking for with affordable prices. She is …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2005",
      "name": "swetha yeruva",
      "rating": null,
      "text": "I visit Krishna Jewellers every time I visit India. I’ve been in touch with Yadav garu and booked an appointment with him. He is very responsive and respects your time. He showed me all the latest models and explained everything very …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-2006",
      "name": "Swethha Telu",
      "rating": null,
      "text": "The staff Pavani garu is very polite and showing more and more varieties. This made us to buy more instead what we thought. Nice ambience, hospitality, collection of products and politeness made us highly recommend Krishna Jewels to our family and friends. Thank you so much.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2007",
      "name": "syamala usha devi lanka",
      "rating": null,
      "text": "This is my Third purchase from your store. Very much satisfied with product. Salesman Dhinakar deals very patiently and friendly manner with us. Thank you.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2008",
      "name": "T Guru",
      "rating": null,
      "text": "Ramya Pavani is the best sales person with good customer interaction and having knowledge on products, I recommend the Krishna Jewellers the best quality and designs, unique collection with reasonable prices in Hyderabad, I became regular customer to Krishna Jewellers. Happy New Year",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2009",
      "name": "T H V Tharaga",
      "rating": null,
      "text": "I recently visited a Krishna jewellers pearls and gems and had an amazing experience. The staff Sandeep was incredibly knowledgeable and helpful, and he wa able to answer all of my questions with ease. He took the time to understand what I …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2010",
      "name": "Takur Meher Manisha",
      "rating": null,
      "text": "Thank you Anusha garu fir your great patience in showing us many different designs and helping us in choosing the best one and we also like the services of your shop we recommend your store for further..it's a great shopping we had today at your store .",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-2011",
      "name": "TALLURI TARUN",
      "rating": null,
      "text": "They did expo in prestige high fields, nanakramguds. Very good experience and Verity of collection. Sandeep sales manager is taken very good care.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2012",
      "name": "Tanuja Reddy",
      "rating": null,
      "text": "It has been great experience buying Diamond jewellery from Krishna Jewellers, Jubilee hills. Naga Sai was so helpful with us and has been very patient with us explaining everything. I would strongly recommend Naga Sai and Krishna Jewellers.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2013",
      "name": "TANUSHREE MONDAL HAZRA",
      "rating": null,
      "text": "I had the pleasure of visiting the Jubilee Hills branch of Krishna Jewellers during my trip to Hyderabad last year, and more recently, I made an online purchase with them. Both experiences were truly exceptional. The in-store staff were …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2014",
      "name": "Tarak Tammareddi",
      "rating": null,
      "text": "Mr Yadav showed very good designs and described very well.Krishna jewellery maintains very good relationship with customers and also maintaing latest designs. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2015",
      "name": "TechieLife",
      "rating": null,
      "text": "We had really great time shopping at krishna jewellery. Sandhyarani wad really helpful and informative. The jewellery collection was decent enough",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2016",
      "name": "Teja",
      "rating": null,
      "text": "Recently I had visited Krishna jewels Jubilee Hills branch, the staff had responded quickly for video call facility and the collection is also amazing. Vinod from the staff is showing the collection very patiently and treating customer very politely, overall the experience is good and they have amazing collection.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2017",
      "name": "Teja Chinna",
      "rating": null,
      "text": "Good place to buy jewelry, light weight collections are nice and 'Kushal' helped us to find the right item within our budget. Thank you krishna jewelrs for being a part in our celebrations.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2018",
      "name": "Tejaswi T",
      "rating": null,
      "text": "Nagarjuna is the one who showed us all the latest designs and models and explained so well about each and every piece so patiently. Best designs in gold and diamonds and best prices. Excellent guest service offered.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2019",
      "name": "Tejaswini Jakkoju",
      "rating": null,
      "text": "It was good experience in the store. Naga sai was so patient and polite in display in the options. I would recommend him to be approached for any purchase.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2020",
      "name": "Thanishka Nallamothu",
      "rating": null,
      "text": "Good customer care from staff. Product details very well explained by Mr. Yadav. Over all nice experience",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2021",
      "name": "tharangini bingi",
      "rating": null,
      "text": "Krishna Jewellers is the best place to shop at because of their unique collections and hospitality of their staff. They guide us to choose the best collection for a customer and my experience with a sales man named Mr. Bharat who has done a wonderful job over there to choose best jewelry for me..",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2022",
      "name": "Tharun Kumar",
      "rating": null,
      "text": "Highly recommend, customer service is amazing... Variety of designs... Great collection of all products including silver and bridal requirements... …",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2023",
      "name": "Thatprettydoctor",
      "rating": null,
      "text": "It’s been 10years since we are shopping from krishna,they have unique designs.Loknath gives the best advice and service and is very patient with us.I definitely recommend this jewellers for brides to be and regular and occasional jewellery.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2024",
      "name": "The Misfit",
      "rating": null,
      "text": "My experience has always been awesome. This time I ordered ram parivar for our Pooja and the team delivered within hours. I was so happy to see lord ram entering our home with family. Thanks a lot team and special thanks to Namrata.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2025",
      "name": "The Warriors",
      "rating": null,
      "text": "Krishna Jewellery, a place to value for Items they provide to end customers, gold, silver, gems and diamonds. And their representative are very well groomed, knowledgeable on product to explain and deliver. Ms Kaliwale Rekha she is very …",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2026",
      "name": "Thejo Reddy",
      "rating": null,
      "text": "Awesome Experience. Products were delivered with great quality & ontime. Riyaz Bhai was wonderful to work with. Great hospitality & at most care was given. Love to work with him in future & with Krishna Jewellers.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-2027",
      "name": "Thirumagal Radja",
      "rating": null,
      "text": "Great experience visiting Krishna Jewellers, Jublie hills. Friendly staffs. Mr.Riyaz Khan was very patient showing us different collections.Excellent service by him.Overall great experience, I would definitely visit again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2028",
      "name": "Thirupathi Reddy Gangadasari",
      "rating": null,
      "text": "Priya helped us in shopping Collection was great. She is very humble and very good in showing variety items. Very good employee. Will visit again and again. Thanks",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2029",
      "name": "TJ Alahari",
      "rating": null,
      "text": "This place was fantastic only because of Sateesh. This support during the purchase is SPOT-ON",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2030",
      "name": "TR Reddy",
      "rating": null,
      "text": "Absolutely loved the diamond collections here.Satheesh is very helpful and very cooperative throughout the process of buying the necklace.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2031",
      "name": "Trimurtulu Nunna",
      "rating": null,
      "text": "We received by Mr. Sivaji, who is having excellent care approach, he made us very happy and provided excellent service. Over all we felt very happy for coming to Krishna jewellers. The service rating will be 10 out of 10.Regards Dr. Trimurtulu N",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2032",
      "name": "TRIPURA CHITTURI",
      "rating": null,
      "text": "We have been the customers for Srikrishna Jewellers from past 5 years. They maintain unique collection and best in class quality. They provide excellent service to customers. Especially Service executive Rajesh has been very courteous and has shown great enthusiasm in understanding the requirement and serviced excellently.",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2033",
      "name": "Tripuraneni Padmaja",
      "rating": null,
      "text": "Sunita is point of contact and she has lot of patience in showing collections and make us to buy. She is maintaining cordial relation with us. We feel like to come to your store because of her response. Timely delivery of orders placed by us.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2034",
      "name": "tsrvc",
      "rating": null,
      "text": "Great customer service by chandu in jubilee hills store. Our visit was smooth and well organized.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2035",
      "name": "Tushar Patel",
      "rating": null,
      "text": "Very good experience shopping here with mr. M.jaganath",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2036",
      "name": "Udaya Sree",
      "rating": null,
      "text": "Unique designs and great workmanship. Customer service is great, provided best advice as or the requirements@ venkatesh customer representative.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2037",
      "name": "udayreddy samreddy",
      "rating": null,
      "text": "Experienced a smooth process from selection to billing. Mr. Swamy was both helpful and knowledgeable about the products showcased. Had good collection for diamonds. Worth exploring!!",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2038",
      "name": "urvashi jawere",
      "rating": null,
      "text": "M Jaganath Reddy for humble and patient. He did his job so well. It was a nice experience shopping here",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2039",
      "name": "Usha Kavuluri",
      "rating": null,
      "text": "Great collection and great customer service. Our sales executive was Venkatesh. He was knowledgeable and did a great job of taking care of our requests even when we were not present physically in India and coordinated with him from U.S. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service",
        "gifting"
      ]
    },
    {
      "id": "stream-2040",
      "name": "Usha Usha",
      "rating": null,
      "text": "Had an amazing experience and they have an exclusive collection in diamonds and gold jewlery. Srikanth Reddy had been very helpful and patient in showcasing the jewlery. I would definitely visit again in future.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2041",
      "name": "V Padma",
      "rating": null,
      "text": "Excellent service and staff support by Nikhil. Done the work within few minutes.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2042",
      "name": "Vadde Dhana",
      "rating": null,
      "text": "good collections & more varities for bridal collection by krishna jewellaries Laleppa Garu showing by more collections. good patients. given by good service. Thanking krishna",
      "date": "",
      "displayDate": "Edited 4 months ago",
      "relativeDate": "Edited 4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2043",
      "name": "Vaibhav Patel",
      "rating": null,
      "text": "Unless you have a lot of time to waste dont visit this place. The billing time is unbelievably high. We made a payment for a ring and waited an hour, literally an hour for someone to create and invoice. I would have walked out if I hadn't …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-2044",
      "name": "Vaidya Geethanjali",
      "rating": null,
      "text": "We had a great experience overall with Krishna Jewellers right from the video call option and showing all the designs with patience .Excellent customer service, Great designs with so many options ,India to USA delivery ,shipping ,and …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2045",
      "name": "Vaishali Dubey",
      "rating": null,
      "text": "It was a wonderful experience at the store. They patiently took care of what I was looking for. Highly recommend if you are looking for quality and experience.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-2046",
      "name": "Vaishnavi Savithrabai",
      "rating": null,
      "text": "Govind given very exllent service we are very happy showing nice collection we are very impressed his attitude service Thanq",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2047",
      "name": "Vaishnavi Y",
      "rating": null,
      "text": "Felt there are many good models, received good hospitality and an excellent service from bharath .",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2048",
      "name": "Vaishnavi Yanamandra",
      "rating": null,
      "text": "R Sateesh has patiently shown us the jewellery we want. We had good service, they recived us nicely.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2049",
      "name": "Vaishu Sadwale",
      "rating": null,
      "text": "I got to know about krishna jewellers from one of my friend his name is Pavan he showed me about this shop when I visited it I saw so many new things which I have never seen in other shops and the collection of jewellers also awesome I really like it and I will visit again and again Thank you Pavan🙏🙏 …",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-2050",
      "name": "vallabhaneni sandhya",
      "rating": null,
      "text": "Sai Kumar and Sandeep very helpfull for jewellery purchase very exclusive collection thanks krishna jewellers",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2051",
      "name": "Vamshi Kandula",
      "rating": null,
      "text": "This is the first time we visited this place. They have a lot of varieties. This is definitely one of the best store in an area where we felt the cost would be too high for any thing we buy. But this store proved me wrong. Pavani guided us …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2052",
      "name": "Vamshi Pasunuru",
      "rating": null,
      "text": "Great experience, my wife was able to find everything she is looking for in one place. Sandhya was really helpful in showing a lot of items and patiently helped in selection for over 2 days. Great customer service!!",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2053",
      "name": "Vamsi Krishna",
      "rating": null,
      "text": "Have met the sales person (Malikarjuna) when we visited the store. Nicely explained and very friendly in nature. Through out he explained all the minute details of the ornament. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2054",
      "name": "Vamsi Naidu",
      "rating": null,
      "text": "Service was really excellent and they have lot of products. Sales team was very cooperative and helpful especially srikanth and ramakanth",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2055",
      "name": "Vamsi Priya",
      "rating": null,
      "text": "Amazing hospitality with awesome collection. Our associate Riaz khan understand our exact requirement and suggest accordingly. His suggestions are always based on our satisfaction. His patience is commendable.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-2056",
      "name": "Vanaja Sigiri",
      "rating": null,
      "text": "Srilakshmi handled very well with us very good service ❤️ had a great time",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2057",
      "name": "Vandana reddy Dharmagari",
      "rating": null,
      "text": "Store has really amazing collection and designs at Jubilee Hills.special thanks to sai Kumar he is very friendly and very knowledgeable with the selections and pieces they have .Great customer service warm welcome.Had great experience shopping at this store very happy with my purchase.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2058",
      "name": "Vanshika Sharma",
      "rating": null,
      "text": "T Rohit was good showing the products and explaining it , it was a nice experience buying some hud pearl jewellery.",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2059",
      "name": "Vara Laxmi",
      "rating": null,
      "text": "The diamond jewellery collection at krishna jewellers is amazing. There are a lot of unique designs. We got the service from Loknath Dutt. He is very enthusiastic and considerate about customer needs and interests. He patiently showed the …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2060",
      "name": "Varalu Harsha",
      "rating": null,
      "text": "We recently visited krishna Jewelers.They have an amazing collection of diamond jewellery. We are really impressed with the designs and the service they provided. Nisha and Sarvesh helped us very nice to pick the best collections. We highly recommend this place if you are looking for an exclusive diamond pieces.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2061",
      "name": "Varsha Daya",
      "rating": null,
      "text": "Sunitha as dealing with customer nicely, and very nice nature. and shown all collections",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2062",
      "name": "varshitha gaddam",
      "rating": null,
      "text": "Krishna jwellers pearls and gems Jubilee hills branch i am visiting from past 3 years service is too good. Mr.Venkatesh executive has shown us best models and pricing is also good",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2063",
      "name": "Varun P",
      "rating": null,
      "text": "Amazing collection in the jubilee hills branch and staff member Bharat has shown wide variety of collections very patiently",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2064",
      "name": "Varun Rajasekhar",
      "rating": null,
      "text": "Pawan and Dinakar are the real stars here. They helped us from start to end ( until you receive the package). Excellent customer service. Best products and variety of Ornaments are available through out the store. Clearly one of the best services in the city.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2065",
      "name": "Vasavi Gurram",
      "rating": null,
      "text": "Nice designs and good service from SRI LAKSHMI",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2066",
      "name": "Vasu Nekkanti",
      "rating": null,
      "text": "Thank you for your excellent service and wonderful collection, Pavani and Naga sai garu are excellent in terms of patience , showing designs and everything! Thank you Krishna jewellers",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2067",
      "name": "Vedashree Kenche",
      "rating": null,
      "text": "Excellent customer service. Best products and variety of Ornaments are available through out the store. Clearly one of the best services in the city.Fab collection as always and the executive with whom we interacted is , Pawan was brilliant …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2068",
      "name": "Veena A",
      "rating": null,
      "text": "Review on Krishna Jewellers : Iam 100% Satisfied with the Service from Represebtative Riaz . He was very good …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2069",
      "name": "Veeraraju Setti",
      "rating": null,
      "text": "Visited this shop three days back 2 nd time within a span of 6 months. Had very good and memorable experience with the staff member Madam Ganga Bhavani. She grasps within no time that what the customer wants exactly and shows according to …",
      "date": "",
      "displayDate": "Edited 4 years ago",
      "relativeDate": "Edited 4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2070",
      "name": "velaga pramod",
      "rating": null,
      "text": "Swamy gaaru, always you have been great andi. Really happy with the service, design’s you recommend quality and price. Which makes us confident to recommend friends and family. We been coming to you from 12 years hope it keeps going for a long time. Thank you",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2071",
      "name": "Venkat Muvva",
      "rating": null,
      "text": "LALEPPA & M.Raju given excellent service more models good collection good experience in krishna jewellary",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2072",
      "name": "Venkat Reddy",
      "rating": null,
      "text": "We had a good experience with Krishna jewellers today. Sravan rajput is our executive , He patiently explained about different models and their charges..Models are good and prices are affordable..",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2073",
      "name": "Venkata Ramana Mutyam",
      "rating": null,
      "text": "Ramya Pavani was patient enough to handle the entire process. She was very helpful in finalizing the set of our taste.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2074",
      "name": "Venkata Ramarao Jonnalagadda",
      "rating": null,
      "text": "The service here is too good, the items collection is very vast and latest designs are available, sales executive Mr. Rajesh is very passionate in explaining and showing all the different varieties as per the customer needs, he is very …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2075",
      "name": "Venkatesh Mandhapati",
      "rating": null,
      "text": "Good service Sunitha and collections are very good",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2076",
      "name": "venkatesh veerabomma",
      "rating": null,
      "text": "Nice collection and nice sale executive she helpful for selection evening his good",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2077",
      "name": "Venkateshwarlu lade",
      "rating": null,
      "text": "The collection is commendable, the pricing is competitive, the product quality is high, and the service (satish) is excellent.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2078",
      "name": "Venkateswarlu Duggineni",
      "rating": null,
      "text": "Harsh Baradi has pleasing qualities. Attended to our work diligently. In fact made us purchase purchase more than we intented to",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2079",
      "name": "Venkateswarrao bellapu",
      "rating": null,
      "text": "Pavani - Sales person is so straight forward. She understands the choice of the customer and picks the right choice without wasting a moment. She is excellent 👍 done …",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2080",
      "name": "venkatsai reddi",
      "rating": null,
      "text": "Salesman jagnath reddy is amazing.showed a vairety of ornaments.",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2081",
      "name": "venkesthwara rao",
      "rating": null,
      "text": "I have the best experience in krishna Jewellers with awesome collection mainly experience with bheem shown with patience and explained clearly everything I liked everything with heartfully",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2082",
      "name": "Venky Kakarla",
      "rating": null,
      "text": "Exceptional customer service by Loknath, impressed with the exceptional professionalism shown by the staff, loved the quality of the product and overall end up spending 2X money at Krishna jewellers. Foraure recommend and also share the experience with friends and family.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2083",
      "name": "venu gopal mannem",
      "rating": null,
      "text": "The collection at Krishna Jewelers is excellent, and Chandu, the salesperson, provided outstanding guidance in helping us find the perfect item. As always, Krishna Jewelers remains the best in Hyderabad",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2084",
      "name": "Venu gopal reddy",
      "rating": null,
      "text": "Awesome collection.... Especially executive SRAVAN was awesome he understands wat we want really purchased.... He is so comfortable. Actually he has a special talent he convince me fastly and also selected ornaments very nice way. Tat is …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2085",
      "name": "Vidhya Madhavi Deevi",
      "rating": null,
      "text": "The jewellery at this store is excellent and Meenakshi showed us so many varieties of jewellery,she made the selection easy by suggesting models",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-2086",
      "name": "vidhya reddy",
      "rating": null,
      "text": "Hi , Yadav has helped me and showed lot of patience and he has very great customer …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2087",
      "name": "Vidya Bhosle",
      "rating": null,
      "text": "Awesome collection and Excellent service by the staff.They are very kind and have patience Mr.Bheem are very good in showing the latest and trendy collection",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2088",
      "name": "Vidya Velpula",
      "rating": null,
      "text": "The experience was good.. comparision with Kalyan jewellers price here in Krishna jwellers is good and low. Mr Bheem Kanse garu treated very well and shown all the jwellery with so much patience and finally we felt satisfied.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2089",
      "name": "Vignaraj Madyastha",
      "rating": null,
      "text": "I am purchase this shop lot of time and book online also .giving good quality product and shop staff pooja mem giving good respect and give update point to point on online order. Thank you very much",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2090",
      "name": "Vijay byra",
      "rating": null,
      "text": "(Update Review after experiencing unprofessional attitude from staff while redeeming the loyalty voucher) Good Service by Namdev but misguided about the loyalty voucher for future …",
      "date": "",
      "displayDate": "Edited 2 years ago",
      "relativeDate": "Edited 2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2091",
      "name": "Vijay Gunda",
      "rating": null,
      "text": "“We loved the collection, and the salesperson Sunita was extremely knowledgeable and patient while showing us a wide range of options. She truly ensured customer satisfaction.”",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2092",
      "name": "vijay gunnam",
      "rating": null,
      "text": "Good service and excellent product and very patience",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2093",
      "name": "Vijay Jain",
      "rating": null,
      "text": "This is one of the best shop for your jewellery needs... I would like to make a special mention about the sales person Sandeep for his patience in showing each and every item based on your needs and explaining in detail. Really appreciate it. Looking forward to visit again.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2094",
      "name": "Vijay Kumar",
      "rating": null,
      "text": "Nice collection Good service by Govind",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2095",
      "name": "vijay ravula",
      "rating": null,
      "text": "K. Rajesh has been excellent and he showed many varieties to us. He has been very generous and gave good description of prices. We are very satisfied with the experience",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2096",
      "name": "Vijaya K",
      "rating": null,
      "text": "Great collection. Yadav provided excellent customer service and made our experience very pleasant.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2097",
      "name": "Vijaya Lakshmi",
      "rating": null,
      "text": "Place has a very good ambience. Hospitality is good. Nitesh helped us to find the right choice for us. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2098",
      "name": "Vijaya Maddamsetti",
      "rating": null,
      "text": "Nice collection and quick response , whole team was so helpful and very friendly. Very happy with the purchase and whole process. Special thanks to Riaz for helping me very patiently.",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2099",
      "name": "Vijaya Namburi",
      "rating": null,
      "text": "We always buy jewelry from Krishna Jewlers. This time Pavani helped us. Pavani is very patient and helpful. She tried to give us the best product and a best deal . We are very satisfied with her service. Thank you so much Pavani .",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2100",
      "name": "vikesh reddy .m",
      "rating": null,
      "text": "Very unique designs,the service was very good especially sai kumar so humble and shown us the models with patience",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2101",
      "name": "Vikram V",
      "rating": null,
      "text": "Pavan is Reliable, disciplined, and committed to his work.",
      "date": "",
      "displayDate": "5 months ago",
      "relativeDate": "5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2102",
      "name": "Vilasitha Dandamudi",
      "rating": null,
      "text": "Good Collection, Pavani has showed latest collections and having patience with smiling face Thank u Pavani",
      "date": "",
      "displayDate": "Edited a year ago",
      "relativeDate": "Edited a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2103",
      "name": "VINAI BABU",
      "rating": null,
      "text": "We had a Very Graceful Experience with the premises and good quality of time and suggestions given by the Sales Executive Mrs.Krishna Chaitanya in choosing and finalizing the The Best Jewelleries. …",
      "date": "",
      "displayDate": "5 years ago",
      "relativeDate": "5 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2104",
      "name": "Vineel Kanth",
      "rating": null,
      "text": "Excellent reception from the team. A trendy models and wide range of varieties in all kinds of stuff. Highly recommend people to visit this place for best stuff. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2105",
      "name": "Vineela Jecksani",
      "rating": null,
      "text": "Loknath has provided exceptional service. He has given us the best possible price for the purchase we made. He was very curteous and patient and showed us the collection based on our taste.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2106",
      "name": "Vinita Lahoti",
      "rating": null,
      "text": "Sarvesh was our PoS person and he was absolutely amazing. He showed us a lot of pieces in different combinations and gave us enough information about the price/ finish/design/difference and also whats in trend with different crowds. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2107",
      "name": "Vinod Madana",
      "rating": null,
      "text": "I had a wonderful experience at Krishna jewellers by S.Bharat",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2108",
      "name": "vinodd godha",
      "rating": null,
      "text": "Ramadevi good service ,nice designs",
      "date": "",
      "displayDate": "6 months ago",
      "relativeDate": "6 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2109",
      "name": "vinodhini thangavel",
      "rating": null,
      "text": "Visited Krishna jwellers all the ways from tamilnadu...... diamond gold collection is good.felt stone related costs were a bit high.... overall good and services were really good.Ramadevi attended us and was very patient showing all the designs",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2110",
      "name": "vinoth kumar",
      "rating": null,
      "text": "Ramesh is so helpful and finding out the Excellent products. Gentle and Polite .",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2111",
      "name": "Vipul Aggarwal",
      "rating": null,
      "text": "Very well attended and service provided by M Satish at the store",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2112",
      "name": "Virender Singh Thakur",
      "rating": null,
      "text": "Fab collection as always and the executive with whom we interacted, Sravan was brilliant with great hospitality skills and lots of patience. Thank you Krishna Jewellers for always providing us top notch products. Would also like to thank Mr Nayeem Saab who is always been as a family and handles things with extreme grace.",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2113",
      "name": "Vish R",
      "rating": null,
      "text": "Was an awesome experience buying jewellery from Krishna Jewellers, Jubilee Hills. Need to appreciate Shiva the sales rep who helped us with the purchase . Lot of designs to chose from at reasonable prices",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2114",
      "name": "Vishakha T",
      "rating": null,
      "text": "I have a good experience with Krishna Jewellers. They have very good collection of jewelries and all the designs are unique. …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2115",
      "name": "Vishnu Biradar",
      "rating": null,
      "text": "Good collection and good service,nice staff friendly environment,and salesman Mr.bharat is so polite, patients he showed different types of jewellery must visit...",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2116",
      "name": "Vishnu Priya Reddy Lomada",
      "rating": null,
      "text": "Products r gud at the reasonable price Diamonds resigns r gud and quality is gud Srikanth Anna took his time n shown all the model Peacefully",
      "date": "",
      "displayDate": "4 months ago",
      "relativeDate": "4 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2117",
      "name": "vishnu priyanka",
      "rating": null,
      "text": "I recently bought some silver items from krishna jewellers jubliee hills branch.The quality and service is excellent.They have got exclusive designs in silver. Mr.kunal and rajashree are really patient and helpful. Thanks to them for …",
      "date": "",
      "displayDate": "4 years ago",
      "relativeDate": "4 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2118",
      "name": "VISHNU VANDANA K",
      "rating": null,
      "text": "We are first time buyers at Krishna Jewellers Pearls and Gems. We got to know about exhibition in tirupati through Instagram live. The store has wide range of unique collections. Special thanks to khusal sir who made our purchase experience …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-2119",
      "name": "vishnu vardhan reddy",
      "rating": null,
      "text": "i visited this store few days ago the staff are extremely lovely and welcoming which makes me feel more comfortable.Without much waste of time, they showed us exactly what we needed which made the selection process very easy. Also gave the …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2120",
      "name": "Vivek Varanasi",
      "rating": null,
      "text": "At Krishna Jewellery, I discovered a haven of sophistication. The warm welcome enveloped me as I stepped inside. Ms. Pavani, the sales executive, was our guiding star. She patiently understood our preferences and helped us select the …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2121",
      "name": "Vj",
      "rating": null,
      "text": "Had a very nice experience at the jewelry shop. Mr. Bheem provided helpful service during the selection, and there was a wide range of options to choose from.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2122",
      "name": "VSK Reddy",
      "rating": null,
      "text": "Absolutely stunning collection. We are very pleased with the overall experience of buying jewellery at Krishna Jewellers. Thanks to Mrs Rama devi and Mr Nayeem for their exceptional service.",
      "date": "",
      "displayDate": "Edited 11 months ago",
      "relativeDate": "Edited 11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2123",
      "name": "Vyshnavi Edara",
      "rating": null,
      "text": "The experience was great, sales man Namdev helped me to choose the best designs according to my requirements. I highly recommend Sri Krishna Jeweles",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2124",
      "name": "Vyshnavi Reddy",
      "rating": null,
      "text": "I always got the best and unique designs from Krishna jewellers; Sales executive Sandhya has helped and explained every aspect of the desire pieces.antique and diamond jewellery are best over here",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2125",
      "name": "Vyshnavi Rishita Penmetsha",
      "rating": null,
      "text": "Meenakshi garu has showed us a wide collection of necklaces ,earrings and tikkas and we liked it a lot and will refer this place to our beloved ones.",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2126",
      "name": "Waldo Cheung",
      "rating": null,
      "text": "Thank you for the great service from Kashinath and his colleagues for the procured pearls!",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2127",
      "name": "William Sam",
      "rating": null,
      "text": "Very good customer service. Available on video/audio calls for shopping any time. Representative Ganga Bhavani is very friendly and helpful for providing more details.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2128",
      "name": "yadagiri martha",
      "rating": null,
      "text": "Collection is good we purchased jumkas pavani shw very patientce thank you",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2129",
      "name": "Yagnam Naidu",
      "rating": null,
      "text": "Very good collection nice model's & good service for Sri Lakshmi 🙏 …",
      "date": "",
      "displayDate": "7 months ago",
      "relativeDate": "7 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2130",
      "name": "yamuna v",
      "rating": null,
      "text": "It was great talking to the supervisor Mr.Yadav, who has good and healthy conversation. He gave good deal with the price and he showed us lot of models without any hesitation.",
      "date": "",
      "displayDate": "11 months ago",
      "relativeDate": "11 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2131",
      "name": "yashasvi koma",
      "rating": null,
      "text": "Great And beautiful collection. Malik Arjun has patiently showed us multiple options. He understood our preferences and showed us accordingly. Definitely recommend checking out at Krishna Jewellers",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery"
      ]
    },
    {
      "id": "stream-2132",
      "name": "Yashaswi Valluripalli",
      "rating": null,
      "text": "This was our first time visiting this store, they have good collection. What I liked the most was how Sandeep made us feel comfortable and explained everything in detail based on our needs which gave us the confidence to shop with them.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom"
      ]
    },
    {
      "id": "stream-2133",
      "name": "Yashvir Singh",
      "rating": null,
      "text": "We had to contact them over a phone call as we didn't have enough time to travel to the store. Mr Sarvesh was very kind to send us the photos of the jewelleries that met our requirements. The next day we visited the store and purchased the …",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-2134",
      "name": "yashwanth reddy",
      "rating": null,
      "text": "Good place for modern polki diamond models. Mr Sarvesh was very helpful.",
      "date": "",
      "displayDate": "10 months ago",
      "relativeDate": "10 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2135",
      "name": "yashwanth sitamraju",
      "rating": null,
      "text": "R. Satish has been excellent and showed us with utmost patience.",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2136",
      "name": "Yashwantharao Mandava",
      "rating": null,
      "text": "My wife absolutely loved the collection at your store. The variety of options is truly impressive. The sales team is warm and customer-friendly, especially Ms. Sandhya Rani, who went above and beyond to show us an amazing selection. We …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2137",
      "name": "yassu harry",
      "rating": null,
      "text": "We recently made a purchase at Krishna Jewellers, Sandeep who works there has really helped us in bringing latest collection to us which made us buy beautiful pieces. The quality of the pieces are really good and we definitely would like to come back.",
      "date": "",
      "displayDate": "3 years ago",
      "relativeDate": "3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2138",
      "name": "yaswanth dumpa",
      "rating": null,
      "text": "We had a great experience exploring their wide range of engagement ring models. The collection is impressive, and the ambience of the store is very pleasant and welcoming. Special thanks to Mr. Bheem for his excellent support in helping us …",
      "date": "",
      "displayDate": "a year ago",
      "relativeDate": "a year ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2139",
      "name": "Yendreddy SivaPriyanka",
      "rating": null,
      "text": "Need to improvise customer services. Especially for the abroad orders, once the item is reached to the customer, please do follow up. …",
      "date": "",
      "displayDate": "Edited 3 years ago",
      "relativeDate": "Edited 3 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    },
    {
      "id": "stream-2140",
      "name": "Yerram Sanjay",
      "rating": null,
      "text": "Repair work of bangal- Loknath at Jubilee Hills branch was quite help full . Thanks",
      "date": "",
      "displayDate": "8 months ago",
      "relativeDate": "8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "showroom"
      ]
    },
    {
      "id": "stream-2141",
      "name": "Yeshwanth Ainala",
      "rating": null,
      "text": "Krishna Jewellery, a place to value for Items they provide to end customers, gold, silver, gems and diamonds. And their representative are very well groomed, knowledgeable on product to explain and deliver. Ms Kaliwalr Rekha she has very …",
      "date": "",
      "displayDate": "Edited 8 months ago",
      "relativeDate": "Edited 8 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2142",
      "name": "Ysn Chowdary",
      "rating": null,
      "text": "Visited Krishna jewellers and sri Laxmi was helpful and showed best collection",
      "date": "",
      "displayDate": "9 months ago",
      "relativeDate": "9 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "showroom",
        "service"
      ]
    },
    {
      "id": "stream-2143",
      "name": "Zeba Hassan",
      "rating": null,
      "text": "Loved their collection! Been buying jewellery from them since 2013. Pavani has been very patient and helpful she helped me and my sister in law with a lot of patience today",
      "date": "",
      "displayDate": "Edited 5 months ago",
      "relativeDate": "Edited 5 months ago",
      "source": "google (1).xlsx",
      "tags": [
        "jewellery",
        "service"
      ]
    },
    {
      "id": "stream-2144",
      "name": "Zubiya Mirza",
      "rating": null,
      "text": "Krishna jewellers are most loyal and trusted jewellers in hyderabad. Great service to the customer . We appreciate for your reliability. Nayeem sir is outstanding person huge asset to Krishna jewellers..he is a very honest person constantly …",
      "date": "",
      "displayDate": "2 years ago",
      "relativeDate": "2 years ago",
      "source": "google (1).xlsx",
      "tags": [
        "service"
      ]
    }
  ]
};
